(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire09ee"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire09ee"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("78SJf", function(module, exports) {
/*
 * Copyright (C) 2013 CloudBees Inc.
 *
 * All rights reserved.
 */ 

var $8BojJ = parcelRequire("8BojJ");

// Register all controllers...
$8BojJ.register((parcelRequire("1ors2")));

$8BojJ.register((parcelRequire("7pxLN")));

$8BojJ.register((parcelRequire("elt6T")));

$8BojJ.register((parcelRequire("ho5eN")));

$8BojJ.register((parcelRequire("96ru2")));

$8BojJ.register((parcelRequire("hdMkT")));

$8BojJ.register((parcelRequire("C1XXF")));

$8BojJ.register((parcelRequire("e2mdv")));

$8BojJ.register((parcelRequire("fcpbd")));

$8BojJ.register((parcelRequire("k7uzs")));

var $b3FBw = parcelRequire("b3FBw");

var $gZ5Q1 = parcelRequire("gZ5Q1");
var $ = $gZ5Q1.getJQuery();

$(function() {
    if ($b3FBw()) // In a test env, we do not want async rendering delays... just makes the
    // tests more complicated. Doing this for now and we'll see
    // if it's a good or bad idea :)
    (parcelRequire("qLOFg")).setMaxDelay(0);
    $8BojJ.applyControllers();
});

var $84kLD = parcelRequire("84kLD");

var $5GBlv = parcelRequire("5GBlv");
// Expose an API that will allow other plugins to contribute to the
// stage view. We make this exposed API "look" like that of 'jenkins-js-extp/API'
// so that we can mock an ExtensionPointContainer API on other plugins during dev,
// and then wire in the external/real Stage View ExtensionPointContainer instance
// at runtime.
module.exports = $5GBlv;
// and overwrite the extensionPointContainer with the Stage View specific
// instance. This may eventually be a page level object, containing all
// extension points on the page.
module.exports.extensionPointContainer = $84kLD.extensionPointContainer;

(parcelRequire("2eByE")).exportModule("pipeline-stage-view", "stageview", module);

});
parcelRegister("8BojJ", function(module, exports) {

$parcel$export(module.exports, "register", () => $6434a457ffc69a8d$export$6503ec6e8aabbaf, (v) => $6434a457ffc69a8d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "isRegistered", () => $6434a457ffc69a8d$export$bd9a8eae248cc953, (v) => $6434a457ffc69a8d$export$bd9a8eae248cc953 = v);
$parcel$export(module.exports, "applyControllers", () => $6434a457ffc69a8d$export$c760182355b982b1, (v) => $6434a457ffc69a8d$export$c760182355b982b1 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Register a controller.
 * @param controller The controller to be registered.
 */ var $6434a457ffc69a8d$export$6503ec6e8aabbaf;
/**
 * Is the named controller already registered.
 * @param controllerName The name of the controller.
 * @return true if the controller is registered, otherwise false.
 */ var $6434a457ffc69a8d$export$bd9a8eae248cc953;
/**
 * Apply controllers.
 */ var $6434a457ffc69a8d$export$c760182355b982b1;
var $6434a457ffc69a8d$export$9c8109a5e9b15a79;

var $gZ5Q1 = parcelRequire("gZ5Q1");
/**
 * Lightweight MVC.
 */ var $6434a457ffc69a8d$var$controllers = {};
$6434a457ffc69a8d$export$6503ec6e8aabbaf = function(controller) {
    var controllerName = controller.getName();
    if ($6434a457ffc69a8d$export$bd9a8eae248cc953(controllerName)) throw "A controller named '" + controllerName + "' is already registered.";
    $6434a457ffc69a8d$var$controllers[controllerName] = controller;
};
$6434a457ffc69a8d$export$bd9a8eae248cc953 = function(controllerName) {
    return $6434a457ffc69a8d$var$controllers.hasOwnProperty(controllerName);
};
$6434a457ffc69a8d$export$c760182355b982b1 = function(onElement, allowReapply) {
    var targetEls = $gZ5Q1.getWidgets(onElement);
    $gZ5Q1.forEachElement(targetEls, function(targetEl) {
        if (allowReapply || !targetEl.hasClass("cbwf-controller-applied")) {
            var controllerName = targetEl.attr("cbwf-controller");
            if (controllerName) {
                var controller = $6434a457ffc69a8d$var$controllers[controllerName];
                if (controller) {
                    var model = controller.getModel();
                    var view = controller.getView();
                    var mvcContext = new $6434a457ffc69a8d$var$MVCContext(controllerName, targetEl);
                    targetEl.addClass("cbwf-widget");
                    targetEl.addClass("cbwf-controller-applied");
                    targetEl.addClass(controllerName);
                    model.getModelData.call(mvcContext, function(modelData) {
                        view.render.call(mvcContext, modelData, targetEl);
                    });
                } else console.error("No controller named '" + controllerName + "'.");
            } else console.error("'widget-element' must define 'controller'.");
        }
    });
};
$6434a457ffc69a8d$export$9c8109a5e9b15a79 = function(controllerName, targetEl) {
    return new $6434a457ffc69a8d$var$MVCContext(controllerName, targetEl);
};
function $6434a457ffc69a8d$var$MVCContext(controllerName, targetEl) {
    if (!controllerName) throw "No 'controllerName' supplied to MVCContext.";
    if (!targetEl || targetEl.length === 0) throw "No 'targetEl' name supplied to MVCContext.";
    this.targetEl = targetEl;
    this.controllerName = controllerName;
}
$6434a457ffc69a8d$var$MVCContext.prototype.getControllerName = function() {
    return this.controllerName;
};
$6434a457ffc69a8d$var$MVCContext.prototype.getTargetElement = function() {
    return this.targetEl;
};
$6434a457ffc69a8d$var$MVCContext.prototype.attr = function(attributeName, defaultVal) {
    var attrVal = this.targetEl.attr(attributeName);
    if (attrVal) return attrVal;
    else return defaultVal;
};
$6434a457ffc69a8d$var$MVCContext.prototype.requiredAttr = function(attributeName) {
    var attrVal = this.targetEl.attr(attributeName);
    if (!attrVal) throw "Required attribute '" + attributeName + "' not defined on MVC controller '" + this.controllerName + "' element.";
    return attrVal;
};
$6434a457ffc69a8d$var$MVCContext.prototype.onModelChange = function(callback) {
    this.targetEl.on("cbwfModelChange", callback);
};
$6434a457ffc69a8d$var$MVCContext.prototype.modelChange = function(modelData) {
    this.targetEl.trigger({
        type: "cbwfModelChange",
        modelData: modelData
    });
};

});
parcelRegister("gZ5Q1", function(module, exports) {

$parcel$export(module.exports, "getJQuery", () => $c5d6df23fd2f68ec$export$7232a6dc780f9887, (v) => $c5d6df23fd2f68ec$export$7232a6dc780f9887 = v);
$parcel$export(module.exports, "getWidgets", () => $c5d6df23fd2f68ec$export$31b9ab97df168df9, (v) => $c5d6df23fd2f68ec$export$31b9ab97df168df9 = v);
$parcel$export(module.exports, "forEachElement", () => $c5d6df23fd2f68ec$export$1545a9d43bb569ac, (v) => $c5d6df23fd2f68ec$export$1545a9d43bb569ac = v);
$parcel$export(module.exports, "isCoordInBox", () => $c5d6df23fd2f68ec$export$aaf1843bfa8ca7a7, (v) => $c5d6df23fd2f68ec$export$aaf1843bfa8ca7a7 = v);
$parcel$export(module.exports, "getElementBoxCoords", () => $c5d6df23fd2f68ec$export$4bb348b57dcc8127, (v) => $c5d6df23fd2f68ec$export$4bb348b57dcc8127 = v);
$parcel$export(module.exports, "getElementsEnclosingBoxCoords", () => $c5d6df23fd2f68ec$export$bcb811db9cde4a1e, (v) => $c5d6df23fd2f68ec$export$bcb811db9cde4a1e = v);
$parcel$export(module.exports, "stretchBoxCoords", () => $c5d6df23fd2f68ec$export$9342519d7dca0988, (v) => $c5d6df23fd2f68ec$export$9342519d7dca0988 = v);
$parcel$export(module.exports, "attrToObject", () => $c5d6df23fd2f68ec$export$f57a5b3cd783a2d7, (v) => $c5d6df23fd2f68ec$export$f57a5b3cd783a2d7 = v);
$parcel$export(module.exports, "getMouseTracker", () => $c5d6df23fd2f68ec$export$eed44f221a6417ca, (v) => $c5d6df23fd2f68ec$export$eed44f221a6417ca = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * jQuery wrapper module.  Other modules should access jQuery via this module (i.e. never access the 'jquery'
 * module directly).  That allows us to inject the jQuery function (aka dollar) to be used by modules during
 * testing etc.
 */ /**
 * Get the jQuery function (aka dollar).
 * @returns The jQuery function (aka dollar).
 */ var $c5d6df23fd2f68ec$export$7232a6dc780f9887;
/**
 * Get all widgets in the specified element, or full document if inElement is not specified.
 * @param inElement The element to search for.  If undefined, the whole document is searched.
 */ var $c5d6df23fd2f68ec$export$31b9ab97df168df9;
/**
 * jQuery .each() wrapper.
 * @param elementList The element list to iterate.
 * @param func The function to apply to the elements.
 */ var $c5d6df23fd2f68ec$export$1545a9d43bb569ac;
/**
 * Is the specified x and y coordinate "over" the supplied box coordinates.
 * <p/>
 * Useful for testing if the mouse pointer is inside a region on the page.
 * Use getElementsEnclosingBoxCoords to get the enclosing box.
 *
 * @param x The X coordinate.
 * @param y The Y coordinate.
 * @param boxCoords The box coordinates to check against.
 */ var $c5d6df23fd2f68ec$export$aaf1843bfa8ca7a7;
/**
 * Get the box coordinates for an element.
 * <p/>
 * X and Y coordinates for each of the four corners, rounded up and down so as to get
 * the "outside" of the box.
 * @param element The element.
 * @returns The element's box coordinates.
 */ var $c5d6df23fd2f68ec$export$4bb348b57dcc8127;
/**
 * Get the coordinates of a box that encloses all the supplied elements
 * @param elements The elements.
 */ var $c5d6df23fd2f68ec$export$bcb811db9cde4a1e;
/**
 * Stretch the supplied boxCoords in the specified direction.
 * @param boxCoords The box coordinates to stretch.
 * @param direction The direction in which to stretch.  One of 'left', 'right',
 * 'up' or 'down'.
 * @param to The x or y coordinate to which the box is to be stretched.  The interpretation
 * of this depends on the 'direction' parameter.
 */ var $c5d6df23fd2f68ec$export$9342519d7dca0988;
/**
 * Extract the element attributes as a JSON object.
 * @param element The element from which to extract an object.
 * @param requiredAttrs The element attributes to be mapped, or a function to be
 * called to get the list of attributes.
 */ var $c5d6df23fd2f68ec$export$697e4a1b90752ce2;
/**
 * Map a single attribute value to the supplied object
 * @param element The element from which to extract the attribute value.
 * @param attrName The name of the attribute whose value is to be mapped.
 * @param object The target object.
 * @return True if a value is mapped to the target object, otherwise false.
 */ var $c5d6df23fd2f68ec$export$f57a5b3cd783a2d7;
var $c5d6df23fd2f68ec$export$eed44f221a6417ca;

$c5d6df23fd2f68ec$export$7232a6dc780f9887 = function() {
    return (parcelRequire("iUSsr"));
};
$c5d6df23fd2f68ec$export$31b9ab97df168df9 = function(inElement) {
    if (inElement) return $c5d6df23fd2f68ec$export$7232a6dc780f9887()("[cbwf-controller]", inElement);
    else return $c5d6df23fd2f68ec$export$7232a6dc780f9887()("[cbwf-controller]");
};
$c5d6df23fd2f68ec$export$1545a9d43bb569ac = function(elementList, func) {
    elementList.each(function() {
        func($c5d6df23fd2f68ec$export$7232a6dc780f9887()(this));
    });
};
function $c5d6df23fd2f68ec$var$roundUp(number) {
    // only round up if there's a decimal part, otherwise return the number
    if (Math.floor(number) === number) return number;
    return Math.floor(number + 1);
}
function $c5d6df23fd2f68ec$var$roundDown(number) {
    return Math.floor(number);
}
$c5d6df23fd2f68ec$export$aaf1843bfa8ca7a7 = function(x, y, boxCoords) {
    if (x < boxCoords.topLeft.x) // to the left
    return false;
    if (y < boxCoords.topLeft.y) // above
    return false;
    if (x > boxCoords.topRight.x) // to the right
    return false;
    if (y > boxCoords.bottomLeft.y) // below
    return false;
    return true;
};
$c5d6df23fd2f68ec$export$4bb348b57dcc8127 = function(element) {
    var elementOffset = element.offset();
    var topLeft = {
        x: $c5d6df23fd2f68ec$var$roundDown(elementOffset.left),
        y: $c5d6df23fd2f68ec$var$roundDown(elementOffset.top)
    };
    var bottomLeft = {
        x: topLeft.x,
        y: $c5d6df23fd2f68ec$var$roundUp(elementOffset.top + element.height())
    };
    var topRight = {
        x: $c5d6df23fd2f68ec$var$roundUp(elementOffset.left + element.width()),
        y: topLeft.y
    };
    var bottomRight = {
        x: topRight.x,
        y: bottomLeft.y
    };
    return {
        topLeft: topLeft,
        bottomLeft: bottomLeft,
        topRight: topRight,
        bottomRight: bottomRight
    };
};
$c5d6df23fd2f68ec$export$bcb811db9cde4a1e = function(elements) {
    var boxCoords = $c5d6df23fd2f68ec$export$4bb348b57dcc8127(elements[0]);
    for(var i = 1; i < elements.length; i++){
        var nextElCoords = $c5d6df23fd2f68ec$export$4bb348b57dcc8127(elements[i]);
        boxCoords.topLeft.x = Math.min(boxCoords.topLeft.x, nextElCoords.topLeft.x);
        boxCoords.topLeft.y = Math.min(boxCoords.topLeft.y, nextElCoords.topLeft.y);
        boxCoords.bottomLeft.x = boxCoords.topLeft.x;
        boxCoords.bottomLeft.y = Math.max(boxCoords.bottomLeft.y, nextElCoords.bottomLeft.y);
        boxCoords.topRight.x = Math.max(boxCoords.topRight.x, nextElCoords.topRight.x);
        boxCoords.topRight.y = boxCoords.topLeft.y;
        boxCoords.bottomRight.x = boxCoords.topRight.x;
        boxCoords.bottomRight.y = boxCoords.bottomLeft.y;
    }
    return boxCoords;
};
$c5d6df23fd2f68ec$export$9342519d7dca0988 = function(boxCoords, direction, to) {
    if (direction === "left") {
        // 'to' is a x coordinate
        boxCoords.topLeft.x = to;
        boxCoords.bottomLeft.x = to;
    } else if (direction === "right") {
        // 'to' is a x coordinate
        boxCoords.topRight.x = to;
        boxCoords.bottomRight.x = to;
    } else if (direction === "up") {
        // 'to' is a y coordinate
        boxCoords.topLeft.y = to;
        boxCoords.topRight.y = to;
    } else if (direction === "down") {
        // 'to' is a y coordinate
        boxCoords.bottomLeft.y = to;
        boxCoords.bottomRight.y = to;
    }
};
$c5d6df23fd2f68ec$export$697e4a1b90752ce2 = function(element, requiredAttrs) {
    var object = {};
    if (requiredAttrs !== undefined) {
        if (typeof requiredAttrs === "function") requiredAttrs = requiredAttrs();
        for(var i = 0; i < requiredAttrs.length; i++)if (!$c5d6df23fd2f68ec$export$f57a5b3cd783a2d7(element, requiredAttrs[i], object)) console.error("Required attribute '" + requiredAttrs[i] + "' not defined on element.");
    }
    return object;
};
$c5d6df23fd2f68ec$export$f57a5b3cd783a2d7 = function(element, attrName, object) {
    var attrVal = element.attr(attrName);
    if (!attrVal) return false;
    object[attrName] = attrVal;
    return true;
};
/**
 * Provide the ability to find out where the mouse is.
 */ var $c5d6df23fd2f68ec$var$lastKnownXY = {
    x: undefined,
    y: undefined
};
$c5d6df23fd2f68ec$export$eed44f221a6417ca = function() {
    if ($c5d6df23fd2f68ec$var$lastKnownXY.x === undefined) $c5d6df23fd2f68ec$export$7232a6dc780f9887()("body").mousemove(function(event) {
        $c5d6df23fd2f68ec$var$lastKnownXY.x = event.pageX;
        $c5d6df23fd2f68ec$var$lastKnownXY.y = event.pageY;
    });
    return $c5d6df23fd2f68ec$var$lastKnownXY;
};

});
parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.5.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2020-05-04T22:49Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket #14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        return typeof obj === "function" && typeof obj.nodeType !== "number";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.5.1", // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.3.5
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2020-03-14
 */ function(window1) {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
        setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
        expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, // Instance methods
        hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, pushNative = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
        // https://jsperf.com/thor-indexof-vs-for/5
        indexOf = function(list, elem) {
            var i = 0, len = list.length;
            for(; i < len; i++){
                if (list[i] === elem) return i;
            }
            return -1;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]", // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5]
        // or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            "ID": new RegExp("^#(" + identifier + ")"),
            "CLASS": new RegExp("^\\.(" + identifier + ")"),
            "TAG": new RegExp("^(" + identifier + "|[*])"),
            "ATTR": new RegExp("^" + attributes),
            "PSEUDO": new RegExp("^" + pseudos),
            "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            "bool": new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rhtml = /HTML$/i, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            return nonHex ? // Strip the backslash prefix from a non-hex escape sequence
            nonHex : // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // CSS string/identifier serialization
        // https://drafts.csswg.org/cssom/#common-serializing-idioms
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\0") return "\uFFFD";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        }, // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android<4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: arr.length ? // Leverage slice if possible
                function(target, els) {
                    pushNative.apply(target, slice.call(els));
                } : // Support: IE<9
                // Otherwise append directly
                function(target, els) {
                    var j = target.length, i = 0;
                    // Can't trust NodeList.length
                    while(target[j++] = els[i++]);
                    target.length = j - 1;
                }
            };
        }
        function Sizzle(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                results.push(elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && // Support: IE 8 only
                    // Exclude object elements
                    (nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rcombinators.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            if (newContext !== context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = nid.replace(rcssescape, fcssescape);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrim, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
            var arr = attrs.split("|"), i = arr.length;
            while(i--)Expr.attrHandle[arr[i]] = handler;
        }
        /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
            var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
            // Use IE sourceIndex if available on both nodes
            if (diff) return diff;
            // Check if b follows a
            if (cur) while(cur = cur.nextSibling){
                if (cur === b) return -1;
            }
            return a ? 1 : -1;
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        /* jshint -W018 */ elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        // Expose support vars for convenience
        support = Sizzle.support = {};
        /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function(elem) {
            var namespace = elem.namespaceURI, docElem = (elem.ownerDocument || elem).documentElement;
            // Support: IE <=8
            // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
            // https://bugs.jquery.com/ticket/4833
            return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
        };
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function(node) {
            var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            docElem = document.documentElement;
            documentIsHTML = !isXML(document);
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) subWindow.addEventListener("unload", unloadHandler, false);
                else if (subWindow.attachEvent) subWindow.attachEvent("onunload", unloadHandler);
            }
            // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
            // Safari 4 - 5 only, Opera <=11.6 - 12.x only
            // IE/Edge & older browsers don't support the :scope pseudo-class.
            // Support: Safari 6.0 only
            // Safari 6.0 supports :scope but it's an alias of :root there.
            support.scope = assert(function(el) {
                docElem.appendChild(el).appendChild(document.createElement("div"));
                return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
            });
            /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
            // Verify that getAttribute really returns attributes and not properties
            // (excepting IE8 booleans)
            support.attributes = assert(function(el) {
                el.className = "i";
                return !el.getAttribute("className");
            });
            /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
            support.getElementsByTagName = assert(function(el) {
                el.appendChild(document.createComment(""));
                return !el.getElementsByTagName("*").length;
            });
            // Support: IE<9
            support.getElementsByClassName = rnative.test(document.getElementsByClassName);
            // Support: IE<10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                docElem.appendChild(el).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else if (support.qsa) return context.querySelectorAll(tag);
            } : function(tag, context) {
                var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                results = context.getElementsByTagName(tag);
                // Filter out possible comments
                if (tag === "*") {
                    while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                    return tmp;
                }
                return results;
            };
            // Class
            Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
            rbuggyMatches = [];
            // qSa(:focus) reports false when true (Chrome 21)
            // We allow this because of a bug in IE8/9 that throws an error
            // whenever `document.activeElement` is accessed on an iframe
            // So, we allow :focus to pass through QSA all the time to avoid the IE error
            // See https://bugs.jquery.com/ticket/13378
            rbuggyQSA = [];
            if (support.qsa = rnative.test(document.querySelectorAll)) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function(el) {
                    var input;
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                });
                assert(function(el) {
                    el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");
                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                });
            }
            if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(el) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9)
                support.disconnectedMatch = matches.call(el, "*");
                // This should fail with an exception
                // Gecko does not error, returns false instead
                matches.call(el, "[s!='']:x");
                rbuggyMatches.push("!=", pseudos);
            });
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
            // Element contains another
            // Purposefully self-exclusive
            // As in, an element does not contain itself
            contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
            } : function(a, b) {
                if (b) while(b = b.parentNode){
                    if (b === a) return true;
                }
                return false;
            };
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = hasCompare ? function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            } : function(a, b) {
                // Exit early if the nodes are identical
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                    a
                ], bp = [
                    b
                ];
                // Parentless nodes are either documents or disconnected
                if (!aup || !bup) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ return a == document ? -1 : b == document ? 1 : /* eslint-enable eqeqeq */ aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                else if (aup === bup) return siblingCheck(a, b);
                // Otherwise we need full lists of their ancestors for comparison
                cur = a;
                while(cur = cur.parentNode)ap.unshift(cur);
                cur = b;
                while(cur = cur.parentNode)bp.unshift(cur);
                // Walk down the tree looking for a discrepancy
                while(ap[i] === bp[i])i++;
                return i ? // Do a sibling check if the nodes have a common ancestor
                siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 : /* eslint-enable eqeqeq */ 0;
            };
            return document;
        };
        Sizzle.matches = function(expr, elements) {
            return Sizzle(expr, null, null, elements);
        };
        Sizzle.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return Sizzle(expr, document, null, [
                elem
            ]).length > 0;
        };
        Sizzle.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return contains(context, elem);
        };
        Sizzle.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        };
        Sizzle.escape = function(sel) {
            return (sel + "").replace(rcssescape, fcssescape);
        };
        Sizzle.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && results.slice(0);
            results.sort(sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)results.splice(duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += getText(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === "string") return elem.textContent;
                else // Traverse its children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
            } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        };
        Expr = Sizzle.selectors = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                "CHILD": function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) Sizzle.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) Sizzle.error(match[0]);
                    return match;
                },
                "PSEUDO": function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr["CHILD"].test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                "TAG": function(nodeNameSelector) {
                    var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                    };
                },
                "CLASS": function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                "ATTR": function(name, operator, check) {
                    return function(elem) {
                        var result = Sizzle.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        /* eslint-disable max-len */ return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                    /* eslint-enable max-len */ };
                },
                "CHILD": function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                // ...in a gzip-friendly way
                                node = parent;
                                outerCache = node[expando] || (node[expando] = {});
                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    uniqueCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    // ...in a gzip-friendly way
                                    node = elem;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            uniqueCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                "PSEUDO": function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                "has": markFunction(function(selector) {
                    return function(elem) {
                        return Sizzle(selector, elem).length > 0;
                    };
                }),
                "contains": markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || getText(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                "target": function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                    return elem === docElem;
                },
                "focus": function(elem) {
                    return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": createDisabledPseudo(false),
                "disabled": createDisabledPseudo(true),
                "checked": function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                "parent": function(elem) {
                    return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                    return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE<8
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                "last": createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                "eq": createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument > length ? length : argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rcombinators.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        };
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, uniqueCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                        if (skip && skip === elem.nodeName.toLowerCase()) elem = elem[dir] || elem;
                        else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)Sizzle(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results : matcherIn;
                // Find primary matches
                if (matcher) matcher(matcherIn, matcherOut, context, xml);
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        compile = Sizzle.compile = function(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        };
        /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        };
        // One-time assignments
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Support: Chrome 14-35+
        // Always assume duplicates if they aren't passed to the comparison function
        support.detectDuplicates = !!hasDuplicate;
        // Initialize against the default document
        setDocument();
        // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        // Support: IE<8
        // Prevent attribute/property "interpolation"
        // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
        if (!assert(function(el) {
            el.innerHTML = "<a href='#'></a>";
            return el.firstChild.getAttribute("href") === "#";
        })) addHandle("type|href|height|width", function(elem, name, isXML) {
            if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        });
        // Support: IE<9
        // Use defaultValue in place of getAttribute("value")
        if (!support.attributes || !assert(function(el) {
            el.innerHTML = "<input/>";
            el.firstChild.setAttribute("value", "");
            return el.firstChild.getAttribute("value") === "";
        })) addHandle("value", function(elem, _name, isXML) {
            if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
        });
        // Support: IE<9
        // Use getAttributeNode to fetch booleans when getAttribute lies
        if (!assert(function(el) {
            return el.getAttribute("disabled") == null;
        })) addHandle(booleans, function(elem, name, isXML) {
            var val;
            if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        });
        return Sizzle;
    }(window1);
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
    // Strict HTML recognition (#11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the stack, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getStackHook) process.stackTrace = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the master Deferred
            master = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) master.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (master.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return master.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), master.reject);
            return master.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, stack) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See #6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (#9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see #8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (#14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (#11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (#14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (#13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (#15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (#12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rkeyEvent = /^key/, rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Support: IE <=9 - 11+
    // focus() and blur() are asynchronous, except when they are no-op.
    // So expect focus to be synchronous when the element is already active,
    // and blur to be synchronous when the element is not already active.
    // (focus and blur are always synchronous in other supported browsers,
    // this just defines when we can count on it).
    function expectSync(elem, type) {
        return elem === safeActiveElement() === (type === "focus");
    }
    // Support: IE <=9 only
    // Accessing document.activeElement can throw unexpectedly
    // https://bugs.jquery.com/ticket/13393
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (#13208)
                // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (#13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, expectSync) {
        // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
        if (!expectSync) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var notAsync, result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    // Saved data should be false in such cases, but might be a leftover capture object
                    // from an async native handler (gh-4350)
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        // Support: IE <=9 - 11+
                        // focus() and blur() are asynchronous
                        notAsync = expectSync(this, type);
                        this[type]();
                        result = dataPriv.get(this, type);
                        if (saved !== result || notAsync) dataPriv.set(this, type, false);
                        else result = {};
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(// Support: IE <=9 - 11+
                        // Extend with the prototype to reset the above stopImmediatePropagation()
                        jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
                    });
                    // Abort handling of the native event
                    event.stopImmediatePropagation();
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (#504, #13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: function(event) {
            var button = event.button;
            // Add which for key events
            if (event.which == null && rkeyEvent.test(event.type)) return event.charCode != null ? event.charCode : event.keyCode;
            // Add which for click: 1 === left; 2 === middle; 3 === right
            if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
                if (button & 1) return 1;
                if (button & 2) return 3;
                if (button & 4) return 2;
                return 0;
            }
            return event.which;
        }
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, expectSync);
                // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (#8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px";
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height) > 3;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, #12537)
        //   .css('--customProperty) (#3144)
        if (computed) {
            ret = computed.getPropertyValue(name) || computed[name];
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, rcustomProp = /^--/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            if (box === "margin") delta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "gridArea": true,
            "gridColumn": true,
            "gridColumnEnd": true,
            "gridColumnStart": true,
            "gridRow": true,
            "gridRowEnd": true,
            "gridRowStart": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (#7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug #9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (#7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                    // Use proper attribute retrieval(#12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classes = classesToArray(value);
            if (classes.length) while(elem = this[i++]){
                curValue = getClass(elem);
                cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    j = 0;
                    while(clazz = classes[j++])if (cur.indexOf(" " + clazz + " ") < 0) cur += clazz + " ";
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) elem.setAttribute("class", finalValue);
                }
            }
            return this;
        },
        removeClass: function(value) {
            var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classes = classesToArray(value);
            if (classes.length) while(elem = this[i++]){
                curValue = getClass(elem);
                // This expression is here for better compressibility (see addClass)
                cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    j = 0;
                    while(clazz = classes[j++])// Remove *all* instances
                    while(cur.indexOf(" " + clazz + " ") > -1)cur = cur.replace(" " + clazz + " ", " ");
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) elem.setAttribute("class", finalValue);
                }
            }
            return this;
        },
        toggleClass: function(value, stateVal) {
            var type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            return this.each(function() {
                var className, i, self, classNames;
                if (isValidValue) {
                    // Toggle individual class names
                    i = 0;
                    self = jQuery(this);
                    classNames = classesToArray(value);
                    while(className = classNames[i++])// Check each className given, space separated list
                    if (self.hasClass(className)) self.removeClass(className);
                    else self.addClass(className);
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (#14686, #14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (#2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    support.focusin = "onfocusin" in window1;
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (#9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (#6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if (!support.focusin) jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(orig, fix) {
        // Attach a single capturing handler on the document while someone wants focusin/focusout
        var handler = function(event) {
            jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
        };
        jQuery.event.special[fix] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix);
                if (!attaches) doc.addEventListener(orig, handler, true);
                dataPriv.access(doc, fix, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix) - 1;
                if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    dataPriv.remove(doc, fix);
                } else dataPriv.access(doc, fix, attaches);
            }
        };
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {
            xml = undefined;
        }
        if (!xml || xml.getElementsByTagName("parsererror").length) jQuery.error("Invalid XML: " + data);
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // #7653, #8125, #8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes #9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (#10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket #12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // #9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (#11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // #1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see #8605, #14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // #14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else {
                if (typeof props.top === "number") props.top += "px";
                if (typeof props.left === "number") props.left += "px";
                curElem.css(props);
            }
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (#13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});



parcelRegister("1ors2", function(module, exports) {

$parcel$export(module.exports, "getName", () => $103d5390baf757fd$export$7d9f7e9c1c02b41e, (v) => $103d5390baf757fd$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getModel", () => $103d5390baf757fd$export$289ca1c318c0384, (v) => $103d5390baf757fd$export$289ca1c318c0384 = v);
$parcel$export(module.exports, "getView", () => $103d5390baf757fd$export$513f42987b822fd7, (v) => $103d5390baf757fd$export$513f42987b822fd7 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $103d5390baf757fd$export$7d9f7e9c1c02b41e;
var $103d5390baf757fd$export$289ca1c318c0384;
var $103d5390baf757fd$export$513f42987b822fd7;

var $3Eq7A = parcelRequire("3Eq7A");

var $84kLD = parcelRequire("84kLD");
$103d5390baf757fd$export$7d9f7e9c1c02b41e = function() {
    return "pipeline-staged";
};
$103d5390baf757fd$export$289ca1c318c0384 = function() {
    return $3Eq7A;
};
$103d5390baf757fd$export$513f42987b822fd7 = function() {
    return $84kLD;
};

});
parcelRegister("3Eq7A", function(module, exports) {

$parcel$export(module.exports, "getModelData", () => $2a895eaf409e248c$export$b077627fdbee10b0, (v) => $2a895eaf409e248c$export$b077627fdbee10b0 = v);
$parcel$export(module.exports, "setMaxRunsPerRunGroup", () => $2a895eaf409e248c$export$24f9ce72418a3464, (v) => $2a895eaf409e248c$export$24f9ce72418a3464 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $2a895eaf409e248c$export$b077627fdbee10b0;
var $2a895eaf409e248c$export$24f9ce72418a3464;

var $hB9eP = parcelRequire("hB9eP");

var $gZ5Q1 = parcelRequire("gZ5Q1");

var $ewE9T = parcelRequire("ewE9T");
/**
 * Code for producing a model containing Workflow Job runs grouped by matching stage names.
 * <p/>
 * Multiple groups will occur where stages have been reordered, renamed or inserted.
 */ var $2a895eaf409e248c$var$maxRunsPerRunGroup = 5;
$2a895eaf409e248c$export$b077627fdbee10b0 = function(callback) {
    var mvcContext = this;
    var jobUrl = mvcContext.requiredAttr("objectUrl");
    $ewE9T.listen(jobUrl, function(jobRunsData) {
        if (!jobRunsData) // TODO: come up with an error passing scheme
        return callback(undefined);
        var jobRunGroups = $2a895eaf409e248c$var$mashupRunData(jobRunsData);
        // This callback can get called multiple times.  The first time it is called is for the initial data load.
        // Subsequent calls are for when the model changes. We only want to call the getModelData callback once
        // (the initial data load).  After that (for model changes), we fire a 'modelChange' event in the context
        // and anything that's listening can handle it.
        if (callback) {
            callback(jobRunGroups);
            callback = undefined; // blank it so we don't call it again
        } else mvcContext.modelChange(jobRunGroups);
    });
};
$2a895eaf409e248c$export$24f9ce72418a3464 = function(max) {
    $2a895eaf409e248c$var$maxRunsPerRunGroup = max;
};
function $2a895eaf409e248c$var$mashupRunData(jobRunsData) {
    var $ = $gZ5Q1.getJQuery();
    var jobRunGroups = {
        runs: [].concat(jobRunsData)
    };
    // Total up timings etc
    $2a895eaf409e248c$var$addStageTotals(jobRunGroups);
    // Add end times before applying the template....
    $2a895eaf409e248c$var$addEndTimes(jobRunGroups);
    // Sort the runs into groups based on the stage names
    // and the number of runs
    $2a895eaf409e248c$var$createRunGroups(jobRunGroups);
    return jobRunGroups;
}
function $2a895eaf409e248c$var$getStageData(stageName, runGroup) {
    if (runGroup && runGroup.stageData) for(var i = 0; i < runGroup.stageData.length; i++){
        var stageData = runGroup.stageData[i];
        if (stageData.name === stageName) return stageData;
    }
    return undefined;
}
function $2a895eaf409e248c$var$addStageTotals(runGroup) {
    if (runGroup.stageData === undefined) runGroup.stageData = [];
    if (runGroup.runs === undefined || runGroup.runs.length === 0) return;
    runGroup.numRuns = 0;
    runGroup.numStages = 0;
    runGroup.durationMillis = 0;
    runGroup.durationMillisNoPause = 0;
    runGroup.avgDurationMillis = 0;
    runGroup.avgDurationMillisNoPause = 0;
    // Maybe add this to the model?
    var endToEndRuns = 0;
    // Calc top level run and stage timings...
    for(var i = 0; i < runGroup.runs.length; i++){
        var run = runGroup.runs[i];
        run.durationMillisNoPause = run.durationMillis - run.pauseDurationMillis;
        // For the top level run timings, only use successfully completed runs.
        if (run.status === "SUCCESS") {
            runGroup.numRuns++;
            // When calculating run time averages, only include runs where every stage has been executed,
            // otherwise the times get skewed. We could get fancier here in time.
            if (run.stages && run.stages.length > 0 && run.stages[0].status !== "NOT_EXECUTED") {
                endToEndRuns++;
                runGroup.durationMillis += run.durationMillis;
                runGroup.durationMillisNoPause += run.durationMillisNoPause;
                if (endToEndRuns > 0) {
                    runGroup.avgDurationMillis = Math.floor(runGroup.durationMillis / endToEndRuns);
                    runGroup.avgDurationMillisNoPause = Math.floor(runGroup.durationMillisNoPause / endToEndRuns);
                } else {
                    runGroup.avgDurationMillis = 0;
                    runGroup.avgDurationMillisNoPause = 0;
                }
            }
        }
        if (run.stages) for(var ii = 0; ii < run.stages.length; ii++){
            var stage = run.stages[ii];
            runGroup.numStages++;
            if (stage.status !== "NOT_EXECUTED") {
                var stageData = $2a895eaf409e248c$var$getStageData(stage.name, runGroup);
                if (!stageData) {
                    stageData = {
                        name: stage.name
                    };
                    runGroup.stageData.push(stageData);
                }
                if (stageData.runs === undefined) {
                    stageData.runs = 0;
                    stageData.durationMillis = 0;
                    stageData.durationMillisNoPause = 0;
                    stageData.avgDurationMillis = 0;
                }
                stage.durationMillisNoPause = stage.durationMillis - stage.pauseDurationMillis;
                stageData.runs++;
                stageData.durationMillis += stage.durationMillis;
                stageData.durationMillisNoPause += stage.durationMillisNoPause;
                stageData.avgDurationMillis = Math.floor(stageData.durationMillis / stageData.runs);
                stageData.avgDurationMillisNoPause = Math.floor(stageData.durationMillisNoPause / stageData.runs);
                // console.log(stage.durationMillis);
                // this will give us a number between 1 and 1.5
                stage.emphasise = stage.durationMillisNoPause / run.durationMillisNoPause / 2 + 1;
                stage.emphasise = Math.min(stage.emphasise, 1.5);
            }
        }
    }
    // Run per stage calc's that require data from top level calc's (above)...
    for(var i = 0; i < runGroup.runs.length; i++){
        var run = runGroup.runs[i];
        if (run.stages && (run.status === "IN_PROGRESS" || run.status === "PAUSED_PENDING_INPUT")) {
            $2a895eaf409e248c$var$addCompletionEstimates(run, runGroup.avgDurationMillisNoPause, runGroup.runs.length);
            for(var ii = 0; ii < run.stages.length; ii++){
                var stage = run.stages[ii];
                var stageData = $2a895eaf409e248c$var$getStageData(stage.name, runGroup);
                if (stage.percentCompleteEstimate === undefined) {
                    if (stage.status === "IN_PROGRESS" || stage.status === "PAUSED_PENDING_INPUT") $2a895eaf409e248c$var$addCompletionEstimates(stage, stageData.avgDurationMillisNoPause, runGroup.runs.length);
                }
            }
        }
    }
}
function $2a895eaf409e248c$var$createRunGroups(jobRunsData) {
    jobRunsData.runGroups = [];
    function addRunGroup(runGroupGenerator) {
        $2a895eaf409e248c$var$addStageTotals(runGroupGenerator.getModelData());
        runGroupGenerator.addPendingStages();
        jobRunsData.runGroups.push(runGroupGenerator.getModelData());
    }
    var curRunGroup = new $2a895eaf409e248c$var$RunGroupGenerator($2a895eaf409e248c$var$maxRunsPerRunGroup);
    for(var i = 0; i < jobRunsData.runs.length; i++){
        var run = jobRunsData.runs[i];
        if (!curRunGroup.addRun(run)) {
            // current rungroup is full... create a new one...
            addRunGroup(curRunGroup);
            curRunGroup = new $2a895eaf409e248c$var$RunGroupGenerator();
            curRunGroup.addRun(run);
        }
    }
    addRunGroup(curRunGroup);
    delete jobRunsData.runs;
}
function $2a895eaf409e248c$var$addEndTimes(jobRunsData) {
    for(var i = 0; i < jobRunsData.runs.length; i++){
        var run = jobRunsData.runs[i];
        $hB9eP.setEndTime(run);
        if (run.stages) for(var ii = 0; ii < run.stages.length; ii++)$hB9eP.setEndTime(run.stages[ii]);
    }
}
/**
 * Add completion estimates to a timedObject.
 * <p/>
 * Basically anything with 'durationMillis', 'avgDurationMillis' etc
 * (i.e. a run, a runGroup or a stage).
 */ function $2a895eaf409e248c$var$addCompletionEstimates(timedObject, avgDurationMillis, averagedOver) {
    if (averagedOver === 0) // If no runs have completed yet, then we can't make an estimate, so just mark it at 50%.
    timedObject.percentCompleteEstimate = 50;
    else {
        timedObject.percentCompleteEstimate = timedObject.durationMillisNoPause / avgDurationMillis * 100;
        // Don't show an estimate of more than 98%, otherwise it will look as though
        // things should be completed when they might not be.
        timedObject.percentCompleteEstimate = Math.min(98, timedObject.percentCompleteEstimate);
        timedObject.percentCompleteEstimate = Math.max(1, timedObject.percentCompleteEstimate);
        timedObject.percentCompleteEstimate = Math.floor(timedObject.percentCompleteEstimate);
        var timeRemainingEstimate = Math.max(0, avgDurationMillis - timedObject.durationMillisNoPause);
        if (timeRemainingEstimate > 0) timedObject.timeRemainingEstimate = timeRemainingEstimate;
    }
}
function $2a895eaf409e248c$var$RunGroupGenerator(maxRuns) {
    this.stageData = [];
    this.runs = [];
}
$2a895eaf409e248c$var$RunGroupGenerator.prototype.addRun = function(run) {
    // Make sure the stage name ordering matches
    for(var i = 0; i < run.stages.length; i++){
        var stage = run.stages[i];
        if (this.stageData.length > i) {
            if (stage.name !== this.stageData[i].name) // Stages have been changed - reordered or
            // new ones inserted.  Can't add to this group.
            return false;
        } else // Add the stage name to the list for the group
        this.stageData.push({
            name: stage.name
        });
    }
    this.runs.push(run);
    return true;
};
$2a895eaf409e248c$var$RunGroupGenerator.prototype.addPendingStages = function() {
    for(var i = 0; i < this.runs.length; i++){
        var run = this.runs[i];
        // fill out the stages in the run if the stages are not all started yet
        if (run.stages.length < this.stageData.length) for(var ii = run.stages.length; ii < this.stageData.length; ii++)run.stages.push({
            name: this.stageData[ii].name,
            status: "NOT_EXECUTED",
            startTimeMillis: 0,
            endTimeMillis: 0,
            durationMillis: 0,
            emphasise: 1
        });
    }
};
$2a895eaf409e248c$var$RunGroupGenerator.prototype.getModelData = function() {
    if (this.modelData) return this.modelData;
    this.modelData = {};
    this.modelData.stageData = this.stageData;
    this.modelData.runs = this.runs;
    return this.modelData;
};

});
parcelRegister("hB9eP", function(module, exports) {

$parcel$export(module.exports, "setEndTime", () => $ccfd0ee2e60ea6ca$export$83236af409e71cac, (v) => $ccfd0ee2e60ea6ca$export$83236af409e71cac = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $ccfd0ee2e60ea6ca$export$83236af409e71cac;
$ccfd0ee2e60ea6ca$export$83236af409e71cac = function(obj) {
    //console.log('setEndTime: '+ obj.durationMillis);
    if (obj.startTimeMillis && obj.durationMillis) obj.endTimeMillis = obj.startTimeMillis + obj.durationMillis;
};

});

parcelRegister("ewE9T", function(module, exports) {

$parcel$export(module.exports, "listen", () => $a9333485d6984b28$export$63174c828edd6ff8, (v) => $a9333485d6984b28$export$63174c828edd6ff8 = v);
$parcel$export(module.exports, "schedulePoll", () => $a9333485d6984b28$export$2fad8b7cfad3cac3, (v) => $a9333485d6984b28$export$2fad8b7cfad3cac3 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $a9333485d6984b28$export$63174c828edd6ff8;
var $a9333485d6984b28$export$2fad8b7cfad3cac3;

var $d51jt = parcelRequire("d51jt");
$a9333485d6984b28$export$63174c828edd6ff8 = function(jobUrl, callback) {
    $d51jt.getJobRuns(jobUrl, function(jobRunsData) {
        callback(jobRunsData);
        $a9333485d6984b28$var$setupJobPoll(jobUrl, callback, jobRunsData);
    }, {
        fullStages: "true"
    });
};
$a9333485d6984b28$export$2fad8b7cfad3cac3 = function(callback) {
    // Tests can mock this function for testing.
    setTimeout(callback, 5000);
};
function $a9333485d6984b28$var$setupJobPoll(jobUrl, callback, jobRunsData) {
    function findSinceRunParam() {
        // console.log('findSinceRunParam');
        // Find the name of the oldest build that has an in progress type status.
        // If there's none that fit that, use the latest build.
        var i = jobRunsData.length - 1;
        for(; i >= 0; i--){
            var runStatus = jobRunsData[i].status;
            if (runStatus === "IN_PROGRESS" || runStatus === "PAUSED_PENDING_INPUT") return jobRunsData[i].name;
        }
        if (jobRunsData.length > 0) return jobRunsData[0].name;
        else return undefined;
    }
    function findRunIndex(id) {
        for(var i = 0; i < jobRunsData.length; i++){
            if (jobRunsData[i].id === id) return i;
        }
        return -1;
    }
    function addRun(run) {
        jobRunsData = [
            run
        ].concat(jobRunsData);
    }
    function pollJobRuns() {
        $d51jt.getJobRuns(jobUrl, function(sinceJobRunsData) {
            // console.log('job-progress......');
            try {
                var notifyListeners = false;
                // reverse iterate the returned set and see if there's anything new
                // or potentially changed...
                for(var i = sinceJobRunsData.length - 1; i >= 0; i--){
                    var aSinceRun = sinceJobRunsData[i];
                    var knownRunIndex = findRunIndex(aSinceRun.id);
                    if (knownRunIndex === -1) {
                        // We don't know this run... it's a new one.  Add it to the start.
                        notifyListeners = true;
                        addRun(aSinceRun);
                    } else {
                        // We know this run... has it changed?
                        var knownRun = jobRunsData[knownRunIndex];
                        if (aSinceRun.status !== knownRun.status) // status has changed
                        notifyListeners = true;
                        else if (aSinceRun.status === "IN_PROGRESS" || aSinceRun.status === "PAUSED_PENDING_INPUT") // it's in an in progress state of some sort...
                        notifyListeners = true;
                        jobRunsData[knownRunIndex] = aSinceRun;
                    }
                }
                // TODO: what about jobs that have been deleted?
                if (notifyListeners) callback(jobRunsData);
            } finally{
                $a9333485d6984b28$export$2fad8b7cfad3cac3(pollJobRuns);
            }
        }, {
            since: findSinceRunParam(),
            fullStages: "true"
        });
    }
    // Kick it ...
    $a9333485d6984b28$export$2fad8b7cfad3cac3(pollJobRuns);
}

});
parcelRegister("d51jt", function(module, exports) {

$parcel$export(module.exports, "getJobRuns", () => $985cc2c02c7cd1be$export$d392a9f6cd32e4d5, (v) => $985cc2c02c7cd1be$export$d392a9f6cd32e4d5 = v);
$parcel$export(module.exports, "getDescription", () => $985cc2c02c7cd1be$export$67580b1c13935958, (v) => $985cc2c02c7cd1be$export$67580b1c13935958 = v);
$parcel$export(module.exports, "getPendingActions", () => $985cc2c02c7cd1be$export$bb5acf29d811142d, (v) => $985cc2c02c7cd1be$export$bb5acf29d811142d = v);
$parcel$export(module.exports, "getObject", () => $985cc2c02c7cd1be$export$93534728ecb2e7b9, (v) => $985cc2c02c7cd1be$export$93534728ecb2e7b9 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $985cc2c02c7cd1be$export$d392a9f6cd32e4d5;
var $985cc2c02c7cd1be$export$67580b1c13935958;
var $985cc2c02c7cd1be$export$bb5acf29d811142d;
var $985cc2c02c7cd1be$export$93534728ecb2e7b9;

var $iKZD3 = parcelRequire("iKZD3");
/**
 * Workflow REST API
 */ var $985cc2c02c7cd1be$var$cache = {};
function $985cc2c02c7cd1be$var$addCacheEntry(key, ob) {
    if (typeof ob === "object") {
        if (ob.status && (ob.status === "SUCCESS" || ob.status === "ABORTED" || ob.status === "FAILED" || ob.status === "UNSTABLE")) $985cc2c02c7cd1be$var$cache[key] = ob;
    }
}
// Cache the stage data if it's eligible for caching
function $985cc2c02c7cd1be$var$cacheRunStages(run) {
    if (run && run.stages) for(var j = 0; j < run.stages.length; j++){
        var stage = run.stages[j];
        try {
            $985cc2c02c7cd1be$var$addCacheEntry(stage._links.self.href, stage);
        } catch (e) {
            console.error("Stage with no link to it");
        }
    }
}
$985cc2c02c7cd1be$export$d392a9f6cd32e4d5 = function(jobUrl, success, params) {
    $iKZD3.execAsyncGET([
        jobUrl,
        "wfapi",
        "runs"
    ], function(obj) {
        // Cache the stages for the run
        for(var i = 0; i < obj.length; i++)$985cc2c02c7cd1be$var$cacheRunStages(obj[i]);
        success(obj);
    }, params);
};
$985cc2c02c7cd1be$export$67580b1c13935958 = function(of, success) {
    var url;
    if (typeof of === "string") url = of;
    else if (typeof of === "object") {
        if (!of._links) url = of._links.self.href;
    } else {
        console.error("Request to get description using a type other than 'string' or 'object'.");
        return;
    }
    // Use existing cache if possible, otherwise make a request
    var cacheEntry = $985cc2c02c7cd1be$var$cache[url];
    if (cacheEntry) success(cacheEntry);
    else $iKZD3.execAsyncGET([
        url
    ], function(ob) {
        // Cache the details for the object: this can greatly reduce the number of REST calls to the Jenkins backend.
        $985cc2c02c7cd1be$var$addCacheEntry(url, ob);
        success(ob);
    });
};
$985cc2c02c7cd1be$export$bb5acf29d811142d = function(url, success) {
    $iKZD3.execAsyncGET([
        url
    ], success);
};
$985cc2c02c7cd1be$export$93534728ecb2e7b9 = function(url, success) {
    $iKZD3.execAsyncGET([
        url
    ], success);
};

});
parcelRegister("iKZD3", function(module, exports) {

$parcel$export(module.exports, "execAsyncGET", () => $da7c54114cd19647$export$a3d7a658ba6c3a35, (v) => $da7c54114cd19647$export$a3d7a658ba6c3a35 = v);
$parcel$export(module.exports, "jenkinsAjaxPOST", () => $da7c54114cd19647$export$480011e7c1aca648, (v) => $da7c54114cd19647$export$480011e7c1aca648 = v);
$parcel$export(module.exports, "jenkinsAjaxPOSTURLEncoded", () => $da7c54114cd19647$export$930f4b26f1471df2, (v) => $da7c54114cd19647$export$930f4b26f1471df2 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $da7c54114cd19647$export$a3d7a658ba6c3a35;
var $da7c54114cd19647$export$5aa454c4e9333b3b;
var $da7c54114cd19647$export$480011e7c1aca648;
var $da7c54114cd19647$export$930f4b26f1471df2;

var $dp5vm = parcelRequire("dp5vm");

var $gZ5Q1 = parcelRequire("gZ5Q1");
$da7c54114cd19647$export$a3d7a658ba6c3a35 = function(resPathTokens, success, params) {
    var $ = $gZ5Q1.getJQuery();
    $.ajax({
        url: $dp5vm.concatPathTokens(resPathTokens),
        type: "get",
        dataType: "json",
        data: params,
        cache: false,
        success: success
    });
};
$da7c54114cd19647$export$5aa454c4e9333b3b = function(path, success) {
    fetch(path, {
        cache: "no-cache"
    }).then((rsp)=>{
        if (rsp.ok) success();
    });
};
$da7c54114cd19647$export$480011e7c1aca648 = function() {
    var path = arguments[0];
    if (arguments.length === 3) {
        var data = arguments[1];
        var success = arguments[2];
        if (typeof data !== "string") data = JSON.stringify(data);
        fetch(path, {
            method: "post",
            headers: crumb.wrap({
                "Content-Type": "application/json; charset=UTF-8"
            }),
            body: data
        }).then((rsp)=>{
            if (rsp.ok) success();
        });
    } else {
        var success = arguments[1];
        fetch(path, {
            method: "post",
            headers: crumb.wrap({
                "Content-Type": "application/json"
            })
        }).then((rsp)=>{
            if (rsp.ok) success();
        });
    }
};
$da7c54114cd19647$export$930f4b26f1471df2 = function(path, parameters, success) {
    fetch(path, {
        method: "post",
        headers: crumb.wrap({
            "Content-Type": "application/x-www-form-urlencoded"
        }),
        body: new URLSearchParams(parameters)
    }).then((rsp)=>{
        if (rsp.ok) success();
    });
};

});
parcelRegister("dp5vm", function(module, exports) {

$parcel$export(module.exports, "concatPathTokens", () => $9c21e14dc6e7a1e5$export$c2054f842e85292, (v) => $9c21e14dc6e7a1e5$export$c2054f842e85292 = v);
$parcel$export(module.exports, "trimTrailingSlashes", () => $9c21e14dc6e7a1e5$export$c030627577dc7423, (v) => $9c21e14dc6e7a1e5$export$c030627577dc7423 = v);
$parcel$export(module.exports, "trimLeadingSlashes", () => $9c21e14dc6e7a1e5$export$afa2b67d9ac9aaae, (v) => $9c21e14dc6e7a1e5$export$afa2b67d9ac9aaae = v);
$parcel$export(module.exports, "trimSlashes", () => $9c21e14dc6e7a1e5$export$8b97e33bf4f60b5a, (v) => $9c21e14dc6e7a1e5$export$8b97e33bf4f60b5a = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $9c21e14dc6e7a1e5$export$c2054f842e85292;
var $9c21e14dc6e7a1e5$export$afa2b67d9ac9aaae;
var $9c21e14dc6e7a1e5$export$c030627577dc7423;
var $9c21e14dc6e7a1e5$export$8b97e33bf4f60b5a;
$9c21e14dc6e7a1e5$export$c2054f842e85292 = function(tokens) {
    if (typeof tokens === "string") return tokens;
    else {
        var concatedString = "";
        for(var index = 0; index < tokens.length; index++){
            if (index === 0) concatedString += $9c21e14dc6e7a1e5$export$c030627577dc7423(tokens[index]);
            else if (index === tokens.length - 1) concatedString += "/" + $9c21e14dc6e7a1e5$export$afa2b67d9ac9aaae(tokens[index]);
            else concatedString += "/" + $9c21e14dc6e7a1e5$export$8b97e33bf4f60b5a(tokens[index]);
        }
        return concatedString;
    }
};
$9c21e14dc6e7a1e5$export$afa2b67d9ac9aaae = function(string) {
    return string.replace(/^\/+/g, "");
};
$9c21e14dc6e7a1e5$export$c030627577dc7423 = function(string) {
    return string.replace(/\/+$/g, "");
};
$9c21e14dc6e7a1e5$export$8b97e33bf4f60b5a = function(string) {
    return $9c21e14dc6e7a1e5$export$afa2b67d9ac9aaae($9c21e14dc6e7a1e5$export$c030627577dc7423(string));
};

});





parcelRegister("84kLD", function(module, exports) {

$parcel$export(module.exports, "extensionPointContainer", () => $5dfece67df6742de$export$3a5617a533a14290, (v) => $5dfece67df6742de$export$3a5617a533a14290 = v);
$parcel$export(module.exports, "render", () => $5dfece67df6742de$export$b3890eb0ae9dca99, (v) => $5dfece67df6742de$export$b3890eb0ae9dca99 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $5dfece67df6742de$export$3a5617a533a14290;
var $5dfece67df6742de$export$b3890eb0ae9dca99;

var $gZ5Q1 = parcelRequire("gZ5Q1");

var $hMs0M = parcelRequire("hMs0M");

var $kFBze = parcelRequire("kFBze");

var $kiPKr = parcelRequire("kiPKr");

var $5GBlv = parcelRequire("5GBlv");
var $5dfece67df6742de$var$ExtensionPointContainer = $5GBlv.ExtensionPointContainer;
var $5dfece67df6742de$var$ExtensionPoint = $5GBlv.ExtensionPoint;
var $5dfece67df6742de$var$extensionPointContainer = new $5dfece67df6742de$var$ExtensionPointContainer();
$5dfece67df6742de$export$3a5617a533a14290 = $5dfece67df6742de$var$extensionPointContainer;
$5dfece67df6742de$export$b3890eb0ae9dca99 = function(jobRunsData, onElement) {
    var mvcContext = this;
    var fragCaption = mvcContext.attr("fragCaption");
    $5dfece67df6742de$var$_render(jobRunsData, onElement, fragCaption);
    // listen for changes to the model...
    this.onModelChange(function(event) {
        $5dfece67df6742de$var$_render(event.modelData, onElement, fragCaption);
    });
};
function $5dfece67df6742de$var$_render(jobRunsData, onElement, fragCaption) {
    // If looking for an example of the model consumed by this view, see the "*_expected_*.json"
    // files in ui/src/test/resources/model/runs_stage_grouped/getModelData.
    // Of course, you can also just use console.log(jobRunsData).
    // The expected model is that produced by ui/src/main/js/model/runs-stage-grouped.js
    if (jobRunsData.runGroups && jobRunsData.runGroups.length > 0) {
        var $ = $gZ5Q1.getJQuery();
        var runGroup = jobRunsData.runGroups[0];
        runGroup.fragCaption = fragCaption;
        runGroup.maxTableEms = runGroup.stageData.length * 10;
        var pipelineStagedDom = $kiPKr.apply("pipeline-staged", runGroup);
        $5dfece67df6742de$var$addLaneCharts(pipelineStagedDom, runGroup);
        var viewPort = $("div.table-viewPort");
        if (viewPort && viewPort.length > 0) {
            var leftScroll = viewPort[0].scrollLeft; // This way we can jump back to the previous scroll position
            onElement.empty().append(pipelineStagedDom); // With many stages, the DOM change scrolls us back to start if we don't reset scroll.
            viewPort = $("div.table-viewPort")[0]; // Re-fetched because the DOM has changed in above.
            if (leftScroll < viewPort.scrollWidth) viewPort.scrollLeft = leftScroll;
        } else onElement.empty().append(pipelineStagedDom);
        $5dfece67df6742de$var$addExtensionPoints(onElement, runGroup);
    }
}
function $5dfece67df6742de$var$addLaneCharts(jQueryDom, runGroup) {
    var $ = $gZ5Q1.getJQuery();
    var stageData = runGroup.stageData;
    var avgStageTimes = [];
    for(var i = 0; i < stageData.length; i++)avgStageTimes.push(stageData[i].avgDurationMillisNoPause);
    var stackedBarChartAnchorEls = $(".totals .stackedBarChart", jQueryDom);
    // Should be the same number of these as there are array elements in stageData
    if (stackedBarChartAnchorEls.length !== avgStageTimes.length) {
        console.log("Unexpected problem.  Template failed to generate a lane header for all stages. " + stackedBarChartAnchorEls.length + " != " + avgStageTimes.length);
        return;
    }
    for(var i = 0; i < stackedBarChartAnchorEls.length; i++){
        var stackedBarChartAnchorEl = $(stackedBarChartAnchorEls.get(i));
        var stackedBarChart = $hMs0M.stackedBarChart(avgStageTimes, i);
        stackedBarChartAnchorEl.append(stackedBarChart);
    }
}
function $5dfece67df6742de$var$addExtensionPoints(onElement, runGroupData) {
    var $ = $gZ5Q1.getJQuery();
    // We need to clear and recreate every time here because of how the stage
    // is in a continuous re-render mode (polling). Having push notifications
    // will clean up a lot of this.
    // Clear the last set of ExtensionPoint instances.
    $5dfece67df6742de$var$extensionPointContainer.remove();
    function addExtensionPoint(extensionPoint) {
        $5dfece67df6742de$var$extensionPointContainer.add(extensionPoint);
        extensionPoint.oncontribute(function() {
            var theContribution = this;
            if (theContribution.activatorContentType !== "className") throw "Jenkins Pipeline Stage View only support CSS className activation widget types.";
            // Add the activator to the dock.
            var activatorDock = $(extensionPoint.dock);
            var activatorWidget = $('<span class="extension">');
            activatorWidget.addClass(theContribution.activatorContent);
            activatorWidget.attr("title", theContribution.caption);
            activatorDock.append(activatorWidget);
            activatorWidget.click(function() {
                // Display the extension content in a dialog.
                var content = $("<div>");
                content.append(theContribution.content);
                var dialog = $kFBze.show(theContribution.caption, content);
                theContribution.onHide(function() {
                    dialog.hide();
                });
                theContribution.show(content.get());
            });
        });
    }
    // Find all runs.
    var runs = $(".job", onElement);
    runs.each(function() {
        var run = $(this);
        var runId = run.attr("data-runId");
        if (!runId) {
            console.warn('No "data-runId" on run.');
            return;
        }
        var runObj = $5dfece67df6742de$var$getRun(runId, runGroupData);
        // Run level extension points...
        var stageEndIcons = $(".stage-start .stage-end-icons", run);
        var extensionPoint = new $5dfece67df6742de$var$ExtensionPoint("jenkins.pipeline.run", runId, stageEndIcons.get());
        addExtensionPoint(extensionPoint);
        // Tack on the REST API links associated with the run.
        // Putting them in private for now so as discourage external use.
        extensionPoint._private._links = runObj._links;
        // Add ExtensionPoint instances for each stage in the run.
        var stages = $(".stage-cell", run);
        stages.each(function() {
            var stage = $(this);
            var stageId = stage.attr("data-stageId");
            if (!stageId) {
                console.warn('No "data-stageId" on stage.');
                return;
            }
            var stageObj = $5dfece67df6742de$var$getStage(runId, stageId, runGroupData);
            var extensionPointID = runId + ":" + stageId;
            var extensionDock = $(".extension-dock", stage);
            var extensionPoint = new $5dfece67df6742de$var$ExtensionPoint("jenkins.pipeline.run.stage", extensionPointID, extensionDock.get());
            // When other plugins contribute to the stage view, we add a little activation
            // widget to the stage in the ExtensionPoint dock area.
            addExtensionPoint(extensionPoint);
            // Tack on the REST API links associated with the stage.
            // Putting them in private for now so as discourage external use.
            extensionPoint._private._links = stageObj._links;
        });
    });
    // We've changed the set of ExtensionPoints, so notify anyone
    // that's interested.
    $5dfece67df6742de$var$extensionPointContainer.notifyOnChange();
}
function $5dfece67df6742de$var$getRun(runId, runGroupData) {
    for(var i = 0; i < runGroupData.runs.length; i++){
        var run = runGroupData.runs[i];
        if (run.id === runId) return run;
    }
    return undefined;
}
function $5dfece67df6742de$var$getStage(runId, stageId, runGroupData) {
    var run = $5dfece67df6742de$var$getRun(runId, runGroupData);
    if (run) for(var i = 0; i < run.stages.length; i++){
        var stage = run.stages[i];
        if (stage.id === stageId) return stage;
    }
    return undefined;
}

});
parcelRegister("hMs0M", function(module, exports) {

$parcel$export(module.exports, "stackedBarChart", () => $cf1ca5db48a7f67d$export$977e8e2757aa577f, (v) => $cf1ca5db48a7f67d$export$977e8e2757aa577f = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $cf1ca5db48a7f67d$export$977e8e2757aa577f;

var $gZ5Q1 = parcelRequire("gZ5Q1");
$cf1ca5db48a7f67d$export$977e8e2757aa577f = function(values, highlightIdx) {
    if (highlightIdx !== undefined && highlightIdx < 0 || highlightIdx > values.length - 1) throw '"highlightIdx" of ' + highlightIdx + " is not valid for a value array of length " + values.length;
    var stackedBarChart = $gZ5Q1.getJQuery()('<div class="stackedBarChart inner clearfix" />');
    var valueSum = 0;
    // Calc value sum
    for(var i = 0; i < values.length; i++)valueSum += values[i];
    // Calc percentages
    var percentages = [];
    for(var i = 0; i < values.length; i++)percentages.push(values[i] / valueSum * 100);
    // Add cells based on percentages
    for(var i = 0; i < percentages.length; i++){
        var cell = $gZ5Q1.getJQuery()('<div class="bar" />');
        cell.css("width", percentages[i] + "%");
        if (highlightIdx !== undefined) {
            if (i < highlightIdx) cell.addClass("prehighlight");
            else if (i === highlightIdx) cell.addClass("highlight");
            else cell.addClass("posthighlight");
        }
        stackedBarChart.append(cell);
    }
    stackedBarChart.append('<div class="clearfix" />');
    return stackedBarChart;
};

});

parcelRegister("kFBze", function(module, exports) {

$parcel$export(module.exports, "show", () => $f0c4c70e51d2b707$export$57bf213be019eeb0, (v) => $f0c4c70e51d2b707$export$57bf213be019eeb0 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $f0c4c70e51d2b707$export$57bf213be019eeb0;
var $f0c4c70e51d2b707$export$fe8985bb6374093c;

var $gZ5Q1 = parcelRequire("gZ5Q1");

var $kiPKr = parcelRequire("kiPKr");

var $bhAAh = parcelRequire("bhAAh");

$f0c4c70e51d2b707$export$57bf213be019eeb0 = function(title, body, options) {
    if (!options) options = {};
    var dialog = $kiPKr.apply("dialog", {
        title: title,
        options: options
    });
    var $ = $gZ5Q1.getJQuery();
    var theWindow = (parcelRequire("2ZEsn")).getWindow();
    var headerEl = $(".header", dialog);
    var bodyEl = $(".body", dialog);
    if (options.height) dialog.css("height", options.height);
    else {
        var winHeight = $(theWindow).height();
        var popoverHeight = Math.min(600, winHeight * 0.7);
        dialog.css("max-height", popoverHeight);
    }
    bodyEl.append(body);
    options.modal = true;
    // Undefined for the onElement makes it in the window center, otherwise it needs it for positioning
    var popover = $bhAAh.newPopover(title, dialog, options.onElement, options);
    popover.show();
    if (options.onshow) options.onshow();
    return popover;
};
$f0c4c70e51d2b707$export$fe8985bb6374093c = function(dialog) {
    $bhAAh.hide(dialog);
};

});
parcelRegister("kiPKr", function(module, exports) {

$parcel$export(module.exports, "apply", () => $ec7da126652b29f4$export$5635d7ef4b8fee1c, (v) => $ec7da126652b29f4$export$5635d7ef4b8fee1c = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Get a template from the template cache.
 * @param templateName The template name.
 * @returns The template instance.
 */ var $ec7da126652b29f4$export$3988ae62b71be9a3;
/**
 * Apply the named template to the provided data model.
 * @param templateName The name of the template.
 * @param dataModel The data model to which the template is to be applied.
 * @param divWrap Flag indicating whether the templating result is to be wrapped in a div
 * element (default true).  Needed if the html produced by the template contains text nodes
 * at the root level.
 * @returns jQuery DOM.
 */ var $ec7da126652b29f4$export$5635d7ef4b8fee1c;
/**
 * Turn template date formatting on/off.
 * <p/>
 * Useful for testing.
 * @param on Formatting on off flag.  True to turn formatting on (default),
 * otherwise false.
 */ var $ec7da126652b29f4$export$e2fad40ffee1c6bd;

var $8BojJ = parcelRequire("8BojJ");

var $8Ostr = parcelRequire("8Ostr");

var $gZ5Q1 = parcelRequire("gZ5Q1");

var $7nfBz = parcelRequire("7nfBz");











/**
 * Templating support.
 */ // Create the template cache..
var $ec7da126652b29f4$var$templateCache = {
    "info-action-popover": (parcelRequire("jZSGY")),
    "dialog": (parcelRequire("jlxc9")),
    "pipeline-staged": (parcelRequire("40VB7")),
    "menu-popout": (parcelRequire("3iNqj")),
    "stage-logs": (parcelRequire("isNC3")),
    "node-log": (parcelRequire("2kuwV")),
    "run-input-required": (parcelRequire("8LLi5")),
    "run-input-required-redirect": (parcelRequire("1qDvM")),
    "build-artifacts": (parcelRequire("fohB0")),
    "run-changesets": (parcelRequire("crb4g")),
    "run-changeset": (parcelRequire("j92Lq"))
};
// Initialise handlebars with helpers
var $ec7da126652b29f4$var$dateFormattingOn = true;
function $ec7da126652b29f4$var$registerHBSHelper(name, helper) {
    $8Ostr.registerHelper(name, helper);
}
$ec7da126652b29f4$var$registerHBSHelper("breaklines", function(text) {
    text = $8Ostr.escapeExpression(text);
    text = text.replace(/(\r\n|\n|\r)/gm, "<br>");
    return new $8Ostr.SafeString(text);
});
$ec7da126652b29f4$var$registerHBSHelper("dumpObj", function(object) {
    return JSON.stringify(object, undefined, 4);
});
$ec7da126652b29f4$var$registerHBSHelper("formatMem", function(amount) {
    return $7nfBz.memory(amount);
});
$ec7da126652b29f4$var$registerHBSHelper("formatTime", function(millis, numUnitsDisplayed) {
    return $7nfBz.time(millis, numUnitsDisplayed);
});
$ec7da126652b29f4$var$registerHBSHelper("formatDate", function(date, toFormat) {
    if (!$ec7da126652b29f4$var$dateFormattingOn) // Just return as is...
    return date;
    var theDate = new Date(date);
    var now = new Date();
    var diff = now - theDate; // Difference in milliseconds
    var oneDay = 86400000; // milliseconds in one day
    var oneYear = 365 * oneDay; // milliseconds in one year
    let userLocale;
    if (navigator.languages && navigator.languages.length) userLocale = navigator.languages[0];
    else userLocale = navigator.language;
    var options = {};
    // Determine which components to display based on the age of the job
    var showYear = diff >= oneYear;
    var showDate = diff >= oneDay;
    var showTime = true; // Always show time if requested
    if (toFormat === "month") {
        if (showDate) options.month = "short";
        else return ""; // Do not display month
    } else if (toFormat === "dom") {
        if (showDate) options.day = "2-digit";
        else return ""; // Do not display day
    } else if (toFormat === "year") {
        if (showYear) options.year = "numeric";
        else return ""; // Do not display year
    } else if (toFormat === "time") {
        if (showTime) {
            options.hour = "2-digit";
            options.minute = "2-digit";
            options.hour12 = false;
        } else return ""; // This case won't occur since we always show time
    } else // Default case: return full date if needed
    return theDate.toLocaleString(userLocale);
    return theDate.toLocaleString(userLocale, options);
});
/**
 * A simple helper that converts an emphasise value (between 1.0 and 1.5) to an opacity value
 * between 0.5 and 1.0.
 */ $ec7da126652b29f4$var$registerHBSHelper("emphasiseToOpacity", function(emphasiseVal) {
    // first make sure the value is between 1 and 1.5
    emphasiseVal = Math.max(emphasiseVal, 1.0);
    emphasiseVal = Math.min(emphasiseVal, 1.5);
    // convert to opacity by just subtracting 0.5 :)
    return emphasiseVal - 0.5;
});
$ec7da126652b29f4$var$registerHBSHelper("ifCond", function(v1, operator, v2, options) {
    switch(operator){
        case "==":
            return v1 === v2 ? options.fn(this) : options.inverse(this);
        case "===":
            return v1 === v2 ? options.fn(this) : options.inverse(this);
        case "!=":
            return v1 !== v2 ? options.fn(this) : options.inverse(this);
        case "!==":
            return v1 !== v2 ? options.fn(this) : options.inverse(this);
        case "<":
            return v1 < v2 ? options.fn(this) : options.inverse(this);
        case "<=":
            return v1 <= v2 ? options.fn(this) : options.inverse(this);
        case ">":
            return v1 > v2 ? options.fn(this) : options.inverse(this);
        case ">=":
            return v1 >= v2 ? options.fn(this) : options.inverse(this);
        case "&&":
            return v1 && v2 ? options.fn(this) : options.inverse(this);
        case "||":
            return v1 || v2 ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
});
function $ec7da126652b29f4$var$getTemplate(templateName) {
    var templateInstance = $ec7da126652b29f4$var$templateCache[templateName];
    if (!templateInstance) throw 'No template by the name "' + templateName + '".  Check ui/src/main/js/view/templates/index.js and make sure the template is registered in the templateCache.';
    // handles precompiled and compiled templates
    return templateInstance.default || templateInstance;
}
$ec7da126652b29f4$export$3988ae62b71be9a3 = function(templateName) {
    return $ec7da126652b29f4$var$getTemplate(templateName);
};
$ec7da126652b29f4$export$5635d7ef4b8fee1c = function(templateName, dataModel, divWrap) {
    var templateInstance = $ec7da126652b29f4$var$getTemplate(templateName);
    var html = templateInstance(dataModel);
    var jQueryDom;
    if (divWrap === undefined || divWrap) jQueryDom = $gZ5Q1.getJQuery()("<div>" + html + "</div>");
    else jQueryDom = $gZ5Q1.getJQuery()(html);
    // Apply all controllers before returning...
    $8BojJ.applyControllers(jQueryDom);
    return jQueryDom;
};
$ec7da126652b29f4$export$e2fad40ffee1c6bd = function(on) {
    $ec7da126652b29f4$var$dateFormattingOn = on;
};

});
parcelRegister("8Ostr", function(module, exports) {
// USAGE:
// var handlebars = require('handlebars');
/* eslint-disable no-var */ // var local = handlebars.create();

var $8Lhqe = parcelRequire("8Lhqe");
var $66a91490842ff618$var$handlebars = $8Lhqe.default;

var $67UTJ = parcelRequire("67UTJ");
$66a91490842ff618$var$handlebars.PrintVisitor = $67UTJ.PrintVisitor;
$66a91490842ff618$var$handlebars.print = $67UTJ.print;
module.exports = $66a91490842ff618$var$handlebars;

// Publish a Node.js require() handler for .handlebars and .hbs files
function $66a91490842ff618$var$extension(module1, filename) {
    var fs = (parcelRequire("foUwZ"));
    var templateString = fs.readFileSync(filename, "utf8");
    module1.exports = $66a91490842ff618$var$handlebars.compile(templateString);
}
/* istanbul ignore else */ if (0, undefined) {
    undefined[".handlebars"] = $66a91490842ff618$var$extension;
    undefined[".hbs"] = $66a91490842ff618$var$extension;
}

});
parcelRegister("8Lhqe", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $66103a312a0d7af5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $6n2sU = parcelRequire("6n2sU");
var $66103a312a0d7af5$var$_handlebarsRuntime2 = $66103a312a0d7af5$var$_interopRequireDefault($6n2sU);

var $f3bnw = parcelRequire("f3bnw");
var $66103a312a0d7af5$var$_handlebarsCompilerAst2 = $66103a312a0d7af5$var$_interopRequireDefault($f3bnw);

var $7b7Dc = parcelRequire("7b7Dc");

var $8at4e = parcelRequire("8at4e");

var $12tfC = parcelRequire("12tfC");
var $66103a312a0d7af5$var$_handlebarsCompilerJavascriptCompiler2 = $66103a312a0d7af5$var$_interopRequireDefault($12tfC);

var $bCnBd = parcelRequire("bCnBd");
var $66103a312a0d7af5$var$_handlebarsCompilerVisitor2 = $66103a312a0d7af5$var$_interopRequireDefault($bCnBd);

var $dmOFM = parcelRequire("dmOFM");
var $66103a312a0d7af5$var$_handlebarsNoConflict2 = $66103a312a0d7af5$var$_interopRequireDefault($dmOFM);
var $66103a312a0d7af5$var$_create = $66103a312a0d7af5$var$_handlebarsRuntime2["default"].create;
function $66103a312a0d7af5$var$create() {
    var hb = $66103a312a0d7af5$var$_create();
    hb.compile = function(input, options) {
        return $8at4e.compile(input, options, hb);
    };
    hb.precompile = function(input, options) {
        return $8at4e.precompile(input, options, hb);
    };
    hb.AST = $66103a312a0d7af5$var$_handlebarsCompilerAst2["default"];
    hb.Compiler = $8at4e.Compiler;
    hb.JavaScriptCompiler = $66103a312a0d7af5$var$_handlebarsCompilerJavascriptCompiler2["default"];
    hb.Parser = $7b7Dc.parser;
    hb.parse = $7b7Dc.parse;
    hb.parseWithoutProcessing = $7b7Dc.parseWithoutProcessing;
    return hb;
}
var $66103a312a0d7af5$var$inst = $66103a312a0d7af5$var$create();
$66103a312a0d7af5$var$inst.create = $66103a312a0d7af5$var$create;
$66103a312a0d7af5$var$_handlebarsNoConflict2["default"]($66103a312a0d7af5$var$inst);
$66103a312a0d7af5$var$inst.Visitor = $66103a312a0d7af5$var$_handlebarsCompilerVisitor2["default"];
$66103a312a0d7af5$var$inst["default"] = $66103a312a0d7af5$var$inst;
module.exports["default"] = $66103a312a0d7af5$var$inst;
module.exports = module.exports["default"];

});
parcelRegister("6n2sU", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $4a36cd9956b46d4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
// istanbul ignore next
function $4a36cd9956b46d4b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}

var $aohyl = parcelRequire("aohyl");
var $4a36cd9956b46d4b$var$base = $4a36cd9956b46d4b$var$_interopRequireWildcard($aohyl);

var $5JmdM = parcelRequire("5JmdM");
var $4a36cd9956b46d4b$var$_handlebarsSafeString2 = $4a36cd9956b46d4b$var$_interopRequireDefault($5JmdM);

var $2TDIg = parcelRequire("2TDIg");
var $4a36cd9956b46d4b$var$_handlebarsException2 = $4a36cd9956b46d4b$var$_interopRequireDefault($2TDIg);

var $lA5sn = parcelRequire("lA5sn");
var $4a36cd9956b46d4b$var$Utils = $4a36cd9956b46d4b$var$_interopRequireWildcard($lA5sn);

var $ayGzB = parcelRequire("ayGzB");
var $4a36cd9956b46d4b$var$runtime = $4a36cd9956b46d4b$var$_interopRequireWildcard($ayGzB);

var $dmOFM = parcelRequire("dmOFM");
var $4a36cd9956b46d4b$var$_handlebarsNoConflict2 = $4a36cd9956b46d4b$var$_interopRequireDefault($dmOFM);
// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function $4a36cd9956b46d4b$var$create() {
    var hb = new $4a36cd9956b46d4b$var$base.HandlebarsEnvironment();
    $4a36cd9956b46d4b$var$Utils.extend(hb, $4a36cd9956b46d4b$var$base);
    hb.SafeString = $4a36cd9956b46d4b$var$_handlebarsSafeString2["default"];
    hb.Exception = $4a36cd9956b46d4b$var$_handlebarsException2["default"];
    hb.Utils = $4a36cd9956b46d4b$var$Utils;
    hb.escapeExpression = $4a36cd9956b46d4b$var$Utils.escapeExpression;
    hb.VM = $4a36cd9956b46d4b$var$runtime;
    hb.template = function(spec) {
        return $4a36cd9956b46d4b$var$runtime.template(spec, hb);
    };
    return hb;
}
var $4a36cd9956b46d4b$var$inst = $4a36cd9956b46d4b$var$create();
$4a36cd9956b46d4b$var$inst.create = $4a36cd9956b46d4b$var$create;
$4a36cd9956b46d4b$var$_handlebarsNoConflict2["default"]($4a36cd9956b46d4b$var$inst);
$4a36cd9956b46d4b$var$inst["default"] = $4a36cd9956b46d4b$var$inst;
module.exports["default"] = $4a36cd9956b46d4b$var$inst;
module.exports = module.exports["default"];

});
parcelRegister("aohyl", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $7909c2eaf1c12e12$export$1e511d4a378977f5, (v) => $7909c2eaf1c12e12$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "HandlebarsEnvironment", () => $7909c2eaf1c12e12$export$5d1b9d3ad24c13f9, (v) => $7909c2eaf1c12e12$export$5d1b9d3ad24c13f9 = v);
$parcel$export(module.exports, "VERSION", () => $7909c2eaf1c12e12$export$a4ad2735b021c132, (v) => $7909c2eaf1c12e12$export$a4ad2735b021c132 = v);
$parcel$export(module.exports, "COMPILER_REVISION", () => $7909c2eaf1c12e12$export$682db5a6f2fa1046, (v) => $7909c2eaf1c12e12$export$682db5a6f2fa1046 = v);
$parcel$export(module.exports, "LAST_COMPATIBLE_COMPILER_REVISION", () => $7909c2eaf1c12e12$export$b416520f9fd5c520, (v) => $7909c2eaf1c12e12$export$b416520f9fd5c520 = v);
$parcel$export(module.exports, "REVISION_CHANGES", () => $7909c2eaf1c12e12$export$534648964353ca81, (v) => $7909c2eaf1c12e12$export$534648964353ca81 = v);
$parcel$export(module.exports, "log", () => $7909c2eaf1c12e12$export$bef1f36f5486a6a3, (v) => $7909c2eaf1c12e12$export$bef1f36f5486a6a3 = v);
$parcel$export(module.exports, "createFrame", () => $7909c2eaf1c12e12$export$52b3fe9f41f5650c, (v) => $7909c2eaf1c12e12$export$52b3fe9f41f5650c = v);
$parcel$export(module.exports, "logger", () => $7909c2eaf1c12e12$export$af88d00dbe7f521, (v) => $7909c2eaf1c12e12$export$af88d00dbe7f521 = v);
var $7909c2eaf1c12e12$export$1e511d4a378977f5;
var $7909c2eaf1c12e12$export$5d1b9d3ad24c13f9;
var $7909c2eaf1c12e12$export$a4ad2735b021c132;
var $7909c2eaf1c12e12$export$682db5a6f2fa1046;
var $7909c2eaf1c12e12$export$b416520f9fd5c520;
var $7909c2eaf1c12e12$export$534648964353ca81;
var $7909c2eaf1c12e12$export$bef1f36f5486a6a3;
var $7909c2eaf1c12e12$export$52b3fe9f41f5650c;
var $7909c2eaf1c12e12$export$af88d00dbe7f521;
"use strict";
$7909c2eaf1c12e12$export$1e511d4a378977f5 = true;
$7909c2eaf1c12e12$export$5d1b9d3ad24c13f9 = $7909c2eaf1c12e12$var$HandlebarsEnvironment;
// istanbul ignore next
function $7909c2eaf1c12e12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $lA5sn = parcelRequire("lA5sn");

var $2TDIg = parcelRequire("2TDIg");
var $7909c2eaf1c12e12$var$_exception2 = $7909c2eaf1c12e12$var$_interopRequireDefault($2TDIg);

var $8rLbJ = parcelRequire("8rLbJ");

var $9QXtw = parcelRequire("9QXtw");

var $cj4iV = parcelRequire("cj4iV");
var $7909c2eaf1c12e12$var$_logger2 = $7909c2eaf1c12e12$var$_interopRequireDefault($cj4iV);

var $bPPTo = parcelRequire("bPPTo");
var $7909c2eaf1c12e12$var$VERSION = "4.7.7";
$7909c2eaf1c12e12$export$a4ad2735b021c132 = $7909c2eaf1c12e12$var$VERSION;
var $7909c2eaf1c12e12$var$COMPILER_REVISION = 8;
$7909c2eaf1c12e12$export$682db5a6f2fa1046 = $7909c2eaf1c12e12$var$COMPILER_REVISION;
var $7909c2eaf1c12e12$var$LAST_COMPATIBLE_COMPILER_REVISION = 7;
$7909c2eaf1c12e12$export$b416520f9fd5c520 = $7909c2eaf1c12e12$var$LAST_COMPATIBLE_COMPILER_REVISION;
var $7909c2eaf1c12e12$var$REVISION_CHANGES = {
    1: "<= 1.0.rc.2",
    2: "== 1.0.0-rc.3",
    3: "== 1.0.0-rc.4",
    4: "== 1.x.x",
    5: "== 2.0.0-alpha.x",
    6: ">= 2.0.0-beta.1",
    7: ">= 4.0.0 <4.3.0",
    8: ">= 4.3.0"
};
$7909c2eaf1c12e12$export$534648964353ca81 = $7909c2eaf1c12e12$var$REVISION_CHANGES;
var $7909c2eaf1c12e12$var$objectType = "[object Object]";
function $7909c2eaf1c12e12$var$HandlebarsEnvironment(helpers, partials, decorators) {
    this.helpers = helpers || {};
    this.partials = partials || {};
    this.decorators = decorators || {};
    $8rLbJ.registerDefaultHelpers(this);
    $9QXtw.registerDefaultDecorators(this);
}
$7909c2eaf1c12e12$var$HandlebarsEnvironment.prototype = {
    constructor: $7909c2eaf1c12e12$var$HandlebarsEnvironment,
    logger: $7909c2eaf1c12e12$var$_logger2["default"],
    log: $7909c2eaf1c12e12$var$_logger2["default"].log,
    registerHelper: function registerHelper(name, fn) {
        if ($lA5sn.toString.call(name) === $7909c2eaf1c12e12$var$objectType) {
            if (fn) throw new $7909c2eaf1c12e12$var$_exception2["default"]("Arg not supported with multiple helpers");
            $lA5sn.extend(this.helpers, name);
        } else this.helpers[name] = fn;
    },
    unregisterHelper: function unregisterHelper(name) {
        delete this.helpers[name];
    },
    registerPartial: function registerPartial(name, partial) {
        if ($lA5sn.toString.call(name) === $7909c2eaf1c12e12$var$objectType) $lA5sn.extend(this.partials, name);
        else {
            if (typeof partial === "undefined") throw new $7909c2eaf1c12e12$var$_exception2["default"]('Attempting to register a partial called "' + name + '" as undefined');
            this.partials[name] = partial;
        }
    },
    unregisterPartial: function unregisterPartial(name) {
        delete this.partials[name];
    },
    registerDecorator: function registerDecorator(name, fn) {
        if ($lA5sn.toString.call(name) === $7909c2eaf1c12e12$var$objectType) {
            if (fn) throw new $7909c2eaf1c12e12$var$_exception2["default"]("Arg not supported with multiple decorators");
            $lA5sn.extend(this.decorators, name);
        } else this.decorators[name] = fn;
    },
    unregisterDecorator: function unregisterDecorator(name) {
        delete this.decorators[name];
    },
    /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */ resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
        $bPPTo.resetLoggedProperties();
    }
};
var $7909c2eaf1c12e12$var$log = $7909c2eaf1c12e12$var$_logger2["default"].log;
$7909c2eaf1c12e12$export$bef1f36f5486a6a3 = $7909c2eaf1c12e12$var$log;
$7909c2eaf1c12e12$export$52b3fe9f41f5650c = $lA5sn.createFrame;
$7909c2eaf1c12e12$export$af88d00dbe7f521 = $7909c2eaf1c12e12$var$_logger2["default"];

});
parcelRegister("lA5sn", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $fb6131570d02c6e9$export$1e511d4a378977f5, (v) => $fb6131570d02c6e9$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "extend", () => $fb6131570d02c6e9$export$8b58be045bf06082, (v) => $fb6131570d02c6e9$export$8b58be045bf06082 = v);
$parcel$export(module.exports, "indexOf", () => $fb6131570d02c6e9$export$305f7d4e9d4624f2, (v) => $fb6131570d02c6e9$export$305f7d4e9d4624f2 = v);
$parcel$export(module.exports, "escapeExpression", () => $fb6131570d02c6e9$export$e6d4483b22f6b058, (v) => $fb6131570d02c6e9$export$e6d4483b22f6b058 = v);
$parcel$export(module.exports, "isEmpty", () => $fb6131570d02c6e9$export$dd1bc94b04021eeb, (v) => $fb6131570d02c6e9$export$dd1bc94b04021eeb = v);
$parcel$export(module.exports, "createFrame", () => $fb6131570d02c6e9$export$52b3fe9f41f5650c, (v) => $fb6131570d02c6e9$export$52b3fe9f41f5650c = v);
$parcel$export(module.exports, "blockParams", () => $fb6131570d02c6e9$export$b0cad7e592dd4356, (v) => $fb6131570d02c6e9$export$b0cad7e592dd4356 = v);
$parcel$export(module.exports, "appendContextPath", () => $fb6131570d02c6e9$export$e0253507f826725a, (v) => $fb6131570d02c6e9$export$e0253507f826725a = v);
$parcel$export(module.exports, "toString", () => $fb6131570d02c6e9$export$f84e8e69fd4488a5, (v) => $fb6131570d02c6e9$export$f84e8e69fd4488a5 = v);
$parcel$export(module.exports, "isFunction", () => $fb6131570d02c6e9$export$f6e2535fb5126e54, (v) => $fb6131570d02c6e9$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isArray", () => $fb6131570d02c6e9$export$43bee75e5e14138e, (v) => $fb6131570d02c6e9$export$43bee75e5e14138e = v);
var $fb6131570d02c6e9$export$1e511d4a378977f5;
var $fb6131570d02c6e9$export$8b58be045bf06082;
var $fb6131570d02c6e9$export$305f7d4e9d4624f2;
var $fb6131570d02c6e9$export$e6d4483b22f6b058;
var $fb6131570d02c6e9$export$dd1bc94b04021eeb;
var $fb6131570d02c6e9$export$52b3fe9f41f5650c;
var $fb6131570d02c6e9$export$b0cad7e592dd4356;
var $fb6131570d02c6e9$export$e0253507f826725a;
var $fb6131570d02c6e9$export$f84e8e69fd4488a5;
var $fb6131570d02c6e9$export$f6e2535fb5126e54;
var $fb6131570d02c6e9$export$43bee75e5e14138e;
"use strict";
$fb6131570d02c6e9$export$1e511d4a378977f5 = true;
$fb6131570d02c6e9$export$8b58be045bf06082 = $fb6131570d02c6e9$var$extend;
$fb6131570d02c6e9$export$305f7d4e9d4624f2 = $fb6131570d02c6e9$var$indexOf;
$fb6131570d02c6e9$export$e6d4483b22f6b058 = $fb6131570d02c6e9$var$escapeExpression;
$fb6131570d02c6e9$export$dd1bc94b04021eeb = $fb6131570d02c6e9$var$isEmpty;
$fb6131570d02c6e9$export$52b3fe9f41f5650c = $fb6131570d02c6e9$var$createFrame;
$fb6131570d02c6e9$export$b0cad7e592dd4356 = $fb6131570d02c6e9$var$blockParams;
$fb6131570d02c6e9$export$e0253507f826725a = $fb6131570d02c6e9$var$appendContextPath;
var $fb6131570d02c6e9$var$escape = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;",
    "=": "&#x3D;"
};
var $fb6131570d02c6e9$var$badChars = /[&<>"'`=]/g, $fb6131570d02c6e9$var$possible = /[&<>"'`=]/;
function $fb6131570d02c6e9$var$escapeChar(chr) {
    return $fb6131570d02c6e9$var$escape[chr];
}
function $fb6131570d02c6e9$var$extend(obj /* , ...source */ ) {
    for(var i = 1; i < arguments.length; i++){
        for(var key in arguments[i])if (Object.prototype.hasOwnProperty.call(arguments[i], key)) obj[key] = arguments[i][key];
    }
    return obj;
}
var $fb6131570d02c6e9$var$toString = Object.prototype.toString;
$fb6131570d02c6e9$export$f84e8e69fd4488a5 = $fb6131570d02c6e9$var$toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */ var $fb6131570d02c6e9$var$isFunction = function isFunction(value) {
    return typeof value === "function";
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */ if ($fb6131570d02c6e9$var$isFunction(/x/)) $fb6131570d02c6e9$export$f6e2535fb5126e54 = $fb6131570d02c6e9$var$isFunction = function(value) {
    return typeof value === "function" && $fb6131570d02c6e9$var$toString.call(value) === "[object Function]";
};
$fb6131570d02c6e9$export$f6e2535fb5126e54 = $fb6131570d02c6e9$var$isFunction;
/* eslint-enable func-style */ /* istanbul ignore next */ var $fb6131570d02c6e9$var$isArray = Array.isArray || function(value) {
    return value && typeof value === "object" ? $fb6131570d02c6e9$var$toString.call(value) === "[object Array]" : false;
};
$fb6131570d02c6e9$export$43bee75e5e14138e = $fb6131570d02c6e9$var$isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.
function $fb6131570d02c6e9$var$indexOf(array, value) {
    for(var i = 0, len = array.length; i < len; i++){
        if (array[i] === value) return i;
    }
    return -1;
}
function $fb6131570d02c6e9$var$escapeExpression(string) {
    if (typeof string !== "string") {
        // don't escape SafeStrings, since they're already safe
        if (string && string.toHTML) return string.toHTML();
        else if (string == null) return "";
        else if (!string) return string + "";
        // Force a string conversion as this will be done by the append regardless and
        // the regex test will do this transparently behind the scenes, causing issues if
        // an object's to string has escaped characters in it.
        string = "" + string;
    }
    if (!$fb6131570d02c6e9$var$possible.test(string)) return string;
    return string.replace($fb6131570d02c6e9$var$badChars, $fb6131570d02c6e9$var$escapeChar);
}
function $fb6131570d02c6e9$var$isEmpty(value) {
    if (!value && value !== 0) return true;
    else if ($fb6131570d02c6e9$var$isArray(value) && value.length === 0) return true;
    else return false;
}
function $fb6131570d02c6e9$var$createFrame(object) {
    var frame = $fb6131570d02c6e9$var$extend({}, object);
    frame._parent = object;
    return frame;
}
function $fb6131570d02c6e9$var$blockParams(params, ids) {
    params.path = ids;
    return params;
}
function $fb6131570d02c6e9$var$appendContextPath(contextPath, id) {
    return (contextPath ? contextPath + "." : "") + id;
}

});

parcelRegister("2TDIg", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $21bf85fdaf8980f6$var$errorProps = [
    "description",
    "fileName",
    "lineNumber",
    "endLineNumber",
    "message",
    "name",
    "number",
    "stack"
];
function $21bf85fdaf8980f6$var$Exception(message, node) {
    var loc = node && node.loc, line = undefined, endLineNumber = undefined, column = undefined, endColumn = undefined;
    if (loc) {
        line = loc.start.line;
        endLineNumber = loc.end.line;
        column = loc.start.column;
        endColumn = loc.end.column;
        message += " - " + line + ":" + column;
    }
    var tmp = Error.prototype.constructor.call(this, message);
    // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
    for(var idx = 0; idx < $21bf85fdaf8980f6$var$errorProps.length; idx++)this[$21bf85fdaf8980f6$var$errorProps[idx]] = tmp[$21bf85fdaf8980f6$var$errorProps[idx]];
    /* istanbul ignore else */ if (Error.captureStackTrace) Error.captureStackTrace(this, $21bf85fdaf8980f6$var$Exception);
    try {
        if (loc) {
            this.lineNumber = line;
            this.endLineNumber = endLineNumber;
            // Work around issue under safari where we can't directly set the column value
            /* istanbul ignore next */ if (Object.defineProperty) {
                Object.defineProperty(this, "column", {
                    value: column,
                    enumerable: true
                });
                Object.defineProperty(this, "endColumn", {
                    value: endColumn,
                    enumerable: true
                });
            } else {
                this.column = column;
                this.endColumn = endColumn;
            }
        }
    } catch (nop) {
    /* Ignore if the browser is very particular */ }
}
$21bf85fdaf8980f6$var$Exception.prototype = new Error();
module.exports["default"] = $21bf85fdaf8980f6$var$Exception;
module.exports = module.exports["default"];

});

parcelRegister("8rLbJ", function(module, exports) {

$parcel$export(module.exports, "registerDefaultHelpers", () => $626572f6eda5a976$export$bdf7582f74746f6b, (v) => $626572f6eda5a976$export$bdf7582f74746f6b = v);
$parcel$export(module.exports, "moveHelperToHooks", () => $626572f6eda5a976$export$a8e22c3e8a03ea7e, (v) => $626572f6eda5a976$export$a8e22c3e8a03ea7e = v);
var $626572f6eda5a976$export$1e511d4a378977f5;
var $626572f6eda5a976$export$bdf7582f74746f6b;
var $626572f6eda5a976$export$a8e22c3e8a03ea7e;
"use strict";
$626572f6eda5a976$export$1e511d4a378977f5 = true;
$626572f6eda5a976$export$bdf7582f74746f6b = $626572f6eda5a976$var$registerDefaultHelpers;
$626572f6eda5a976$export$a8e22c3e8a03ea7e = $626572f6eda5a976$var$moveHelperToHooks;
// istanbul ignore next
function $626572f6eda5a976$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $kwuHK = parcelRequire("kwuHK");
var $626572f6eda5a976$var$_helpersBlockHelperMissing2 = $626572f6eda5a976$var$_interopRequireDefault($kwuHK);

var $5JwCw = parcelRequire("5JwCw");
var $626572f6eda5a976$var$_helpersEach2 = $626572f6eda5a976$var$_interopRequireDefault($5JwCw);

var $kcOdQ = parcelRequire("kcOdQ");
var $626572f6eda5a976$var$_helpersHelperMissing2 = $626572f6eda5a976$var$_interopRequireDefault($kcOdQ);

var $hucRi = parcelRequire("hucRi");
var $626572f6eda5a976$var$_helpersIf2 = $626572f6eda5a976$var$_interopRequireDefault($hucRi);

var $d5XoV = parcelRequire("d5XoV");
var $626572f6eda5a976$var$_helpersLog2 = $626572f6eda5a976$var$_interopRequireDefault($d5XoV);

var $fxg9p = parcelRequire("fxg9p");
var $626572f6eda5a976$var$_helpersLookup2 = $626572f6eda5a976$var$_interopRequireDefault($fxg9p);

var $fiiYF = parcelRequire("fiiYF");
var $626572f6eda5a976$var$_helpersWith2 = $626572f6eda5a976$var$_interopRequireDefault($fiiYF);
function $626572f6eda5a976$var$registerDefaultHelpers(instance) {
    $626572f6eda5a976$var$_helpersBlockHelperMissing2["default"](instance);
    $626572f6eda5a976$var$_helpersEach2["default"](instance);
    $626572f6eda5a976$var$_helpersHelperMissing2["default"](instance);
    $626572f6eda5a976$var$_helpersIf2["default"](instance);
    $626572f6eda5a976$var$_helpersLog2["default"](instance);
    $626572f6eda5a976$var$_helpersLookup2["default"](instance);
    $626572f6eda5a976$var$_helpersWith2["default"](instance);
}
function $626572f6eda5a976$var$moveHelperToHooks(instance, helperName, keepHelper) {
    if (instance.helpers[helperName]) {
        instance.hooks[helperName] = instance.helpers[helperName];
        if (!keepHelper) delete instance.helpers[helperName];
    }
}

});
parcelRegister("kwuHK", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $lA5sn = parcelRequire("lA5sn");
module.exports["default"] = function(instance) {
    instance.registerHelper("blockHelperMissing", function(context, options) {
        var inverse = options.inverse, fn = options.fn;
        if (context === true) return fn(this);
        else if (context === false || context == null) return inverse(this);
        else if ($lA5sn.isArray(context)) {
            if (context.length > 0) {
                if (options.ids) options.ids = [
                    options.name
                ];
                return instance.helpers.each(context, options);
            } else return inverse(this);
        } else {
            if (options.data && options.ids) {
                var data = $lA5sn.createFrame(options.data);
                data.contextPath = $lA5sn.appendContextPath(options.data.contextPath, options.name);
                options = {
                    data: data
                };
            }
            return fn(context, options);
        }
    });
};
module.exports = module.exports["default"];

});

parcelRegister("5JwCw", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $42ca757369e6c961$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $lA5sn = parcelRequire("lA5sn");

var $2TDIg = parcelRequire("2TDIg");
var $42ca757369e6c961$var$_exception2 = $42ca757369e6c961$var$_interopRequireDefault($2TDIg);
module.exports["default"] = function(instance) {
    instance.registerHelper("each", function(context, options) {
        if (!options) throw new $42ca757369e6c961$var$_exception2["default"]("Must pass iterator to #each");
        var fn = options.fn, inverse = options.inverse, i = 0, ret = "", data = undefined, contextPath = undefined;
        if (options.data && options.ids) contextPath = $lA5sn.appendContextPath(options.data.contextPath, options.ids[0]) + ".";
        if ($lA5sn.isFunction(context)) context = context.call(this);
        if (options.data) data = $lA5sn.createFrame(options.data);
        function execIteration(field, index, last) {
            if (data) {
                data.key = field;
                data.index = index;
                data.first = index === 0;
                data.last = !!last;
                if (contextPath) data.contextPath = contextPath + field;
            }
            ret = ret + fn(context[field], {
                data: data,
                blockParams: $lA5sn.blockParams([
                    context[field],
                    field
                ], [
                    contextPath + field,
                    null
                ])
            });
        }
        if (context && typeof context === "object") {
            if ($lA5sn.isArray(context)) {
                for(var j = context.length; i < j; i++)if (i in context) execIteration(i, i, i === context.length - 1);
            } else if ($parcel$global.Symbol && context[$parcel$global.Symbol.iterator]) {
                var newContext = [];
                var iterator = context[$parcel$global.Symbol.iterator]();
                for(var it = iterator.next(); !it.done; it = iterator.next())newContext.push(it.value);
                context = newContext;
                for(var j = context.length; i < j; i++)execIteration(i, i, i === context.length - 1);
            } else (function() {
                var priorKey = undefined;
                Object.keys(context).forEach(function(key) {
                    // We're running the iterations one step out of sync so we can detect
                    // the last iteration without have to scan the object twice and create
                    // an itermediate keys array.
                    if (priorKey !== undefined) execIteration(priorKey, i - 1);
                    priorKey = key;
                    i++;
                });
                if (priorKey !== undefined) execIteration(priorKey, i - 1, true);
            })();
        }
        if (i === 0) ret = inverse(this);
        return ret;
    });
};
module.exports = module.exports["default"];

});

parcelRegister("kcOdQ", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $eb5be2be4f7c7bfa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $2TDIg = parcelRequire("2TDIg");
var $eb5be2be4f7c7bfa$var$_exception2 = $eb5be2be4f7c7bfa$var$_interopRequireDefault($2TDIg);
module.exports["default"] = function(instance) {
    instance.registerHelper("helperMissing", function() /* [args, ]options */ {
        if (arguments.length === 1) // A missing field in a {{foo}} construct.
        return undefined;
        else // Someone is actually trying to call something, blow up.
        throw new $eb5be2be4f7c7bfa$var$_exception2["default"]('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    });
};
module.exports = module.exports["default"];

});

parcelRegister("hucRi", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $cbaf36706814b7b3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $lA5sn = parcelRequire("lA5sn");

var $2TDIg = parcelRequire("2TDIg");
var $cbaf36706814b7b3$var$_exception2 = $cbaf36706814b7b3$var$_interopRequireDefault($2TDIg);
module.exports["default"] = function(instance) {
    instance.registerHelper("if", function(conditional, options) {
        if (arguments.length != 2) throw new $cbaf36706814b7b3$var$_exception2["default"]("#if requires exactly one argument");
        if ($lA5sn.isFunction(conditional)) conditional = conditional.call(this);
        // Default behavior is to render the positive path if the value is truthy and not empty.
        // The `includeZero` option may be set to treat the condtional as purely not empty based on the
        // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
        if (!options.hash.includeZero && !conditional || $lA5sn.isEmpty(conditional)) return options.inverse(this);
        else return options.fn(this);
    });
    instance.registerHelper("unless", function(conditional, options) {
        if (arguments.length != 2) throw new $cbaf36706814b7b3$var$_exception2["default"]("#unless requires exactly one argument");
        return instance.helpers["if"].call(this, conditional, {
            fn: options.inverse,
            inverse: options.fn,
            hash: options.hash
        });
    });
};
module.exports = module.exports["default"];

});

parcelRegister("d5XoV", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = function(instance) {
    instance.registerHelper("log", function() /* message, options */ {
        var args = [
            undefined
        ], options = arguments[arguments.length - 1];
        for(var i = 0; i < arguments.length - 1; i++)args.push(arguments[i]);
        var level = 1;
        if (options.hash.level != null) level = options.hash.level;
        else if (options.data && options.data.level != null) level = options.data.level;
        args[0] = level;
        instance.log.apply(instance, args);
    });
};
module.exports = module.exports["default"];

});

parcelRegister("fxg9p", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = function(instance) {
    instance.registerHelper("lookup", function(obj, field, options) {
        if (!obj) // Note for 5.0: Change to "obj == null" in 5.0
        return obj;
        return options.lookupProperty(obj, field);
    });
};
module.exports = module.exports["default"];

});

parcelRegister("fiiYF", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $b22741fa813b6386$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $lA5sn = parcelRequire("lA5sn");

var $2TDIg = parcelRequire("2TDIg");
var $b22741fa813b6386$var$_exception2 = $b22741fa813b6386$var$_interopRequireDefault($2TDIg);
module.exports["default"] = function(instance) {
    instance.registerHelper("with", function(context, options) {
        if (arguments.length != 2) throw new $b22741fa813b6386$var$_exception2["default"]("#with requires exactly one argument");
        if ($lA5sn.isFunction(context)) context = context.call(this);
        var fn = options.fn;
        if (!$lA5sn.isEmpty(context)) {
            var data = options.data;
            if (options.data && options.ids) {
                data = $lA5sn.createFrame(options.data);
                data.contextPath = $lA5sn.appendContextPath(options.data.contextPath, options.ids[0]);
            }
            return fn(context, {
                data: data,
                blockParams: $lA5sn.blockParams([
                    context
                ], [
                    data && data.contextPath
                ])
            });
        } else return options.inverse(this);
    });
};
module.exports = module.exports["default"];

});


parcelRegister("9QXtw", function(module, exports) {

$parcel$export(module.exports, "registerDefaultDecorators", () => $72c71ae441010914$export$7eaca4a3d56dbe6d, (v) => $72c71ae441010914$export$7eaca4a3d56dbe6d = v);
var $72c71ae441010914$export$1e511d4a378977f5;
var $72c71ae441010914$export$7eaca4a3d56dbe6d;
"use strict";
$72c71ae441010914$export$1e511d4a378977f5 = true;
$72c71ae441010914$export$7eaca4a3d56dbe6d = $72c71ae441010914$var$registerDefaultDecorators;
// istanbul ignore next
function $72c71ae441010914$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $z33Zd = parcelRequire("z33Zd");
var $72c71ae441010914$var$_decoratorsInline2 = $72c71ae441010914$var$_interopRequireDefault($z33Zd);
function $72c71ae441010914$var$registerDefaultDecorators(instance) {
    $72c71ae441010914$var$_decoratorsInline2["default"](instance);
}

});
parcelRegister("z33Zd", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $lA5sn = parcelRequire("lA5sn");
module.exports["default"] = function(instance) {
    instance.registerDecorator("inline", function(fn, props, container, options) {
        var ret = fn;
        if (!props.partials) {
            props.partials = {};
            ret = function(context, options) {
                // Create a new partials stack frame prior to exec.
                var original = container.partials;
                container.partials = $lA5sn.extend({}, original, props.partials);
                var ret = fn(context, options);
                container.partials = original;
                return ret;
            };
        }
        props.partials[options.args[0]] = options.fn;
        return ret;
    });
};
module.exports = module.exports["default"];

});


parcelRegister("cj4iV", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $lA5sn = parcelRequire("lA5sn");
var $8f5a992176bc7cdf$var$logger = {
    methodMap: [
        "debug",
        "info",
        "warn",
        "error"
    ],
    level: "info",
    // Maps a given level value to the `methodMap` indexes above.
    lookupLevel: function lookupLevel(level) {
        if (typeof level === "string") {
            var levelMap = $lA5sn.indexOf($8f5a992176bc7cdf$var$logger.methodMap, level.toLowerCase());
            if (levelMap >= 0) level = levelMap;
            else level = parseInt(level, 10);
        }
        return level;
    },
    // Can be overridden in the host environment
    log: function log(level) {
        level = $8f5a992176bc7cdf$var$logger.lookupLevel(level);
        if (typeof console !== "undefined" && $8f5a992176bc7cdf$var$logger.lookupLevel($8f5a992176bc7cdf$var$logger.level) <= level) {
            var method = $8f5a992176bc7cdf$var$logger.methodMap[level];
            // eslint-disable-next-line no-console
            if (!console[method]) method = "log";
            for(var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)message[_key - 1] = arguments[_key];
            console[method].apply(console, message); // eslint-disable-line no-console
        }
    }
};
module.exports["default"] = $8f5a992176bc7cdf$var$logger;
module.exports = module.exports["default"];

});

parcelRegister("bPPTo", function(module, exports) {

$parcel$export(module.exports, "createProtoAccessControl", () => $89dcb5dc863185ef$export$9fc505f5102b04a5, (v) => $89dcb5dc863185ef$export$9fc505f5102b04a5 = v);
$parcel$export(module.exports, "resultIsAllowed", () => $89dcb5dc863185ef$export$8b633651c7cf59b9, (v) => $89dcb5dc863185ef$export$8b633651c7cf59b9 = v);
$parcel$export(module.exports, "resetLoggedProperties", () => $89dcb5dc863185ef$export$419dc2c4b2f2238b, (v) => $89dcb5dc863185ef$export$419dc2c4b2f2238b = v);
var $89dcb5dc863185ef$export$1e511d4a378977f5;
var $89dcb5dc863185ef$export$9fc505f5102b04a5;
var $89dcb5dc863185ef$export$8b633651c7cf59b9;
var $89dcb5dc863185ef$export$419dc2c4b2f2238b;
"use strict";
$89dcb5dc863185ef$export$1e511d4a378977f5 = true;
$89dcb5dc863185ef$export$9fc505f5102b04a5 = $89dcb5dc863185ef$var$createProtoAccessControl;
$89dcb5dc863185ef$export$8b633651c7cf59b9 = $89dcb5dc863185ef$var$resultIsAllowed;
$89dcb5dc863185ef$export$419dc2c4b2f2238b = $89dcb5dc863185ef$var$resetLoggedProperties;
// istanbul ignore next
function $89dcb5dc863185ef$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}

var $gfRxJ = parcelRequire("gfRxJ");

var $cj4iV = parcelRequire("cj4iV");
var $89dcb5dc863185ef$var$logger = $89dcb5dc863185ef$var$_interopRequireWildcard($cj4iV);
var $89dcb5dc863185ef$var$loggedProperties = Object.create(null);
function $89dcb5dc863185ef$var$createProtoAccessControl(runtimeOptions) {
    var defaultMethodWhiteList = Object.create(null);
    defaultMethodWhiteList["constructor"] = false;
    defaultMethodWhiteList["__defineGetter__"] = false;
    defaultMethodWhiteList["__defineSetter__"] = false;
    defaultMethodWhiteList["__lookupGetter__"] = false;
    var defaultPropertyWhiteList = Object.create(null);
    // eslint-disable-next-line no-proto
    defaultPropertyWhiteList["__proto__"] = false;
    return {
        properties: {
            whitelist: $gfRxJ.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
            defaultValue: runtimeOptions.allowProtoPropertiesByDefault
        },
        methods: {
            whitelist: $gfRxJ.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
            defaultValue: runtimeOptions.allowProtoMethodsByDefault
        }
    };
}
function $89dcb5dc863185ef$var$resultIsAllowed(result, protoAccessControl, propertyName) {
    if (typeof result === "function") return $89dcb5dc863185ef$var$checkWhiteList(protoAccessControl.methods, propertyName);
    else return $89dcb5dc863185ef$var$checkWhiteList(protoAccessControl.properties, propertyName);
}
function $89dcb5dc863185ef$var$checkWhiteList(protoAccessControlForType, propertyName) {
    if (protoAccessControlForType.whitelist[propertyName] !== undefined) return protoAccessControlForType.whitelist[propertyName] === true;
    if (protoAccessControlForType.defaultValue !== undefined) return protoAccessControlForType.defaultValue;
    $89dcb5dc863185ef$var$logUnexpecedPropertyAccessOnce(propertyName);
    return false;
}
function $89dcb5dc863185ef$var$logUnexpecedPropertyAccessOnce(propertyName) {
    if ($89dcb5dc863185ef$var$loggedProperties[propertyName] !== true) {
        $89dcb5dc863185ef$var$loggedProperties[propertyName] = true;
        $89dcb5dc863185ef$var$logger.log("error", 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + "You can add a runtime option to disable the check or this warning:\n" + "See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details");
    }
}
function $89dcb5dc863185ef$var$resetLoggedProperties() {
    Object.keys($89dcb5dc863185ef$var$loggedProperties).forEach(function(propertyName) {
        delete $89dcb5dc863185ef$var$loggedProperties[propertyName];
    });
}

});
parcelRegister("gfRxJ", function(module, exports) {

$parcel$export(module.exports, "createNewLookupObject", () => $bd57949b80fc0f09$export$ec2932ee0c0e8dcc, (v) => $bd57949b80fc0f09$export$ec2932ee0c0e8dcc = v);
var $bd57949b80fc0f09$export$1e511d4a378977f5;
var $bd57949b80fc0f09$export$ec2932ee0c0e8dcc;
"use strict";
$bd57949b80fc0f09$export$1e511d4a378977f5 = true;
$bd57949b80fc0f09$export$ec2932ee0c0e8dcc = $bd57949b80fc0f09$var$createNewLookupObject;

var $lA5sn = parcelRequire("lA5sn");
/**
 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
 * The resulting object can be used with "object[property]" to check if a property exists
 * @param {...object} sources a varargs parameter of source objects that will be merged
 * @returns {object}
 */ function $bd57949b80fc0f09$var$createNewLookupObject() {
    for(var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    return $lA5sn.extend.apply(undefined, [
        Object.create(null)
    ].concat(sources));
}

});



parcelRegister("5JmdM", function(module, exports) {
// Build out our basic SafeString type
"use strict";
module.exports.__esModule = true;
function $42c2646598ac55c2$var$SafeString(string) {
    this.string = string;
}
$42c2646598ac55c2$var$SafeString.prototype.toString = $42c2646598ac55c2$var$SafeString.prototype.toHTML = function() {
    return "" + this.string;
};
module.exports["default"] = $42c2646598ac55c2$var$SafeString;
module.exports = module.exports["default"];

});

parcelRegister("ayGzB", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $7afe1a83f827bf55$export$1e511d4a378977f5, (v) => $7afe1a83f827bf55$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "checkRevision", () => $7afe1a83f827bf55$export$1a97de37fc44aecb, (v) => $7afe1a83f827bf55$export$1a97de37fc44aecb = v);
$parcel$export(module.exports, "template", () => $7afe1a83f827bf55$export$ce69bd05624d0c48, (v) => $7afe1a83f827bf55$export$ce69bd05624d0c48 = v);
$parcel$export(module.exports, "wrapProgram", () => $7afe1a83f827bf55$export$3976c39aa34be3b, (v) => $7afe1a83f827bf55$export$3976c39aa34be3b = v);
$parcel$export(module.exports, "resolvePartial", () => $7afe1a83f827bf55$export$ee54384c867bf98e, (v) => $7afe1a83f827bf55$export$ee54384c867bf98e = v);
$parcel$export(module.exports, "invokePartial", () => $7afe1a83f827bf55$export$6c4303200e44071a, (v) => $7afe1a83f827bf55$export$6c4303200e44071a = v);
$parcel$export(module.exports, "noop", () => $7afe1a83f827bf55$export$8793edee2d425525, (v) => $7afe1a83f827bf55$export$8793edee2d425525 = v);
var $7afe1a83f827bf55$export$1e511d4a378977f5;
var $7afe1a83f827bf55$export$1a97de37fc44aecb;
var $7afe1a83f827bf55$export$ce69bd05624d0c48;
var $7afe1a83f827bf55$export$3976c39aa34be3b;
var $7afe1a83f827bf55$export$ee54384c867bf98e;
var $7afe1a83f827bf55$export$6c4303200e44071a;
var $7afe1a83f827bf55$export$8793edee2d425525;
"use strict";
$7afe1a83f827bf55$export$1e511d4a378977f5 = true;
$7afe1a83f827bf55$export$1a97de37fc44aecb = $7afe1a83f827bf55$var$checkRevision;
$7afe1a83f827bf55$export$ce69bd05624d0c48 = $7afe1a83f827bf55$var$template;
$7afe1a83f827bf55$export$3976c39aa34be3b = $7afe1a83f827bf55$var$wrapProgram;
$7afe1a83f827bf55$export$ee54384c867bf98e = $7afe1a83f827bf55$var$resolvePartial;
$7afe1a83f827bf55$export$6c4303200e44071a = $7afe1a83f827bf55$var$invokePartial;
$7afe1a83f827bf55$export$8793edee2d425525 = $7afe1a83f827bf55$var$noop;
// istanbul ignore next
function $7afe1a83f827bf55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
// istanbul ignore next
function $7afe1a83f827bf55$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}

var $lA5sn = parcelRequire("lA5sn");
var $7afe1a83f827bf55$var$Utils = $7afe1a83f827bf55$var$_interopRequireWildcard($lA5sn);

var $2TDIg = parcelRequire("2TDIg");
var $7afe1a83f827bf55$var$_exception2 = $7afe1a83f827bf55$var$_interopRequireDefault($2TDIg);

var $aohyl = parcelRequire("aohyl");

var $8rLbJ = parcelRequire("8rLbJ");

var $aRd40 = parcelRequire("aRd40");

var $bPPTo = parcelRequire("bPPTo");
function $7afe1a83f827bf55$var$checkRevision(compilerInfo) {
    var compilerRevision = compilerInfo && compilerInfo[0] || 1, currentRevision = $aohyl.COMPILER_REVISION;
    if (compilerRevision >= $aohyl.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= $aohyl.COMPILER_REVISION) return;
    if (compilerRevision < $aohyl.LAST_COMPATIBLE_COMPILER_REVISION) {
        var runtimeVersions = $aohyl.REVISION_CHANGES[currentRevision], compilerVersions = $aohyl.REVISION_CHANGES[compilerRevision];
        throw new $7afe1a83f827bf55$var$_exception2["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + runtimeVersions + ") or downgrade your runtime to an older version (" + compilerVersions + ").");
    } else // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new $7afe1a83f827bf55$var$_exception2["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + compilerInfo[1] + ").");
}
function $7afe1a83f827bf55$var$template(templateSpec, env) {
    /* istanbul ignore next */ if (!env) throw new $7afe1a83f827bf55$var$_exception2["default"]("No environment passed to template");
    if (!templateSpec || !templateSpec.main) throw new $7afe1a83f827bf55$var$_exception2["default"]("Unknown template object: " + typeof templateSpec);
    templateSpec.main.decorator = templateSpec.main_d;
    // Note: Using env.VM references rather than local var references throughout this section to allow
    // for external users to override these as pseudo-supported APIs.
    env.VM.checkRevision(templateSpec.compiler);
    // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
    var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;
    function invokePartialWrapper(partial, context, options) {
        if (options.hash) {
            context = $7afe1a83f827bf55$var$Utils.extend({}, context, options.hash);
            if (options.ids) options.ids[0] = true;
        }
        partial = env.VM.resolvePartial.call(this, partial, context, options);
        var extendedOptions = $7afe1a83f827bf55$var$Utils.extend({}, options, {
            hooks: this.hooks,
            protoAccessControl: this.protoAccessControl
        });
        var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);
        if (result == null && env.compile) {
            options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
            result = options.partials[options.name](context, extendedOptions);
        }
        if (result != null) {
            if (options.indent) {
                var lines = result.split("\n");
                for(var i = 0, l = lines.length; i < l; i++){
                    if (!lines[i] && i + 1 === l) break;
                    lines[i] = options.indent + lines[i];
                }
                result = lines.join("\n");
            }
            return result;
        } else throw new $7afe1a83f827bf55$var$_exception2["default"]("The partial " + options.name + " could not be compiled when running in runtime-only mode");
    }
    // Just add water
    var container = {
        strict: function strict(obj, name, loc) {
            if (!obj || !(name in obj)) throw new $7afe1a83f827bf55$var$_exception2["default"]('"' + name + '" not defined in ' + obj, {
                loc: loc
            });
            return container.lookupProperty(obj, name);
        },
        lookupProperty: function lookupProperty(parent, propertyName) {
            var result = parent[propertyName];
            if (result == null) return result;
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return result;
            if ($bPPTo.resultIsAllowed(result, container.protoAccessControl, propertyName)) return result;
            return undefined;
        },
        lookup: function lookup(depths, name) {
            var len = depths.length;
            for(var i = 0; i < len; i++){
                var result = depths[i] && container.lookupProperty(depths[i], name);
                if (result != null) return depths[i][name];
            }
        },
        lambda: function lambda(current, context) {
            return typeof current === "function" ? current.call(context) : current;
        },
        escapeExpression: $7afe1a83f827bf55$var$Utils.escapeExpression,
        invokePartial: invokePartialWrapper,
        fn: function fn(i) {
            var ret = templateSpec[i];
            ret.decorator = templateSpec[i + "_d"];
            return ret;
        },
        programs: [],
        program: function program(i, data, declaredBlockParams, blockParams, depths) {
            var programWrapper = this.programs[i], fn = this.fn(i);
            if (data || depths || blockParams || declaredBlockParams) programWrapper = $7afe1a83f827bf55$var$wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
            else if (!programWrapper) programWrapper = this.programs[i] = $7afe1a83f827bf55$var$wrapProgram(this, i, fn);
            return programWrapper;
        },
        data: function data(value, depth) {
            while(value && depth--)value = value._parent;
            return value;
        },
        mergeIfNeeded: function mergeIfNeeded(param, common) {
            var obj = param || common;
            if (param && common && param !== common) obj = $7afe1a83f827bf55$var$Utils.extend({}, common, param);
            return obj;
        },
        // An empty object to use as replacement for null-contexts
        nullContext: Object.seal({}),
        noop: env.VM.noop,
        compilerInfo: templateSpec.compiler
    };
    function ret(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var data = options.data;
        ret._setup(options);
        if (!options.partial && templateSpec.useData) data = $7afe1a83f827bf55$var$initData(context, data);
        var depths = undefined, blockParams = templateSpec.useBlockParams ? [] : undefined;
        if (templateSpec.useDepths) {
            if (options.depths) depths = context != options.depths[0] ? [
                context
            ].concat(options.depths) : options.depths;
            else depths = [
                context
            ];
        }
        function main(context /*, options*/ ) {
            return "" + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
        }
        main = $7afe1a83f827bf55$var$executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
        return main(context, options);
    }
    ret.isTop = true;
    ret._setup = function(options) {
        if (!options.partial) {
            var mergedHelpers = $7afe1a83f827bf55$var$Utils.extend({}, env.helpers, options.helpers);
            $7afe1a83f827bf55$var$wrapHelpersToPassLookupProperty(mergedHelpers, container);
            container.helpers = mergedHelpers;
            if (templateSpec.usePartial) // Use mergeIfNeeded here to prevent compiling global partials multiple times
            container.partials = container.mergeIfNeeded(options.partials, env.partials);
            if (templateSpec.usePartial || templateSpec.useDecorators) container.decorators = $7afe1a83f827bf55$var$Utils.extend({}, env.decorators, options.decorators);
            container.hooks = {};
            container.protoAccessControl = $bPPTo.createProtoAccessControl(options);
            var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
            $8rLbJ.moveHelperToHooks(container, "helperMissing", keepHelperInHelpers);
            $8rLbJ.moveHelperToHooks(container, "blockHelperMissing", keepHelperInHelpers);
        } else {
            container.protoAccessControl = options.protoAccessControl; // internal option
            container.helpers = options.helpers;
            container.partials = options.partials;
            container.decorators = options.decorators;
            container.hooks = options.hooks;
        }
    };
    ret._child = function(i, data, blockParams, depths) {
        if (templateSpec.useBlockParams && !blockParams) throw new $7afe1a83f827bf55$var$_exception2["default"]("must pass block params");
        if (templateSpec.useDepths && !depths) throw new $7afe1a83f827bf55$var$_exception2["default"]("must pass parent depths");
        return $7afe1a83f827bf55$var$wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
    };
    return ret;
}
function $7afe1a83f827bf55$var$wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
    function prog(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var currentDepths = depths;
        if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) currentDepths = [
            context
        ].concat(depths);
        return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [
            options.blockParams
        ].concat(blockParams), currentDepths);
    }
    prog = $7afe1a83f827bf55$var$executeDecorators(fn, prog, container, depths, data, blockParams);
    prog.program = i;
    prog.depth = depths ? depths.length : 0;
    prog.blockParams = declaredBlockParams || 0;
    return prog;
}
/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */ function $7afe1a83f827bf55$var$resolvePartial(partial, context, options) {
    if (!partial) {
        if (options.name === "@partial-block") partial = options.data["partial-block"];
        else partial = options.partials[options.name];
    } else if (!partial.call && !options.name) {
        // This is a dynamic partial that returned a string
        options.name = partial;
        partial = options.partials[partial];
    }
    return partial;
}
function $7afe1a83f827bf55$var$invokePartial(partial, context, options) {
    // Use the current closure context to save the partial-block if this partial
    var currentPartialBlock = options.data && options.data["partial-block"];
    options.partial = true;
    if (options.ids) options.data.contextPath = options.ids[0] || options.data.contextPath;
    var partialBlock = undefined;
    if (options.fn && options.fn !== $7afe1a83f827bf55$var$noop) (function() {
        options.data = $aohyl.createFrame(options.data);
        // Wrapper function to get access to currentPartialBlock from the closure
        var fn = options.fn;
        partialBlock = options.data["partial-block"] = function partialBlockWrapper(context) {
            var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
            // Restore the partial-block from the closure for the execution of the block
            // i.e. the part inside the block of the partial call.
            options.data = $aohyl.createFrame(options.data);
            options.data["partial-block"] = currentPartialBlock;
            return fn(context, options);
        };
        if (fn.partials) options.partials = $7afe1a83f827bf55$var$Utils.extend({}, options.partials, fn.partials);
    })();
    if (partial === undefined && partialBlock) partial = partialBlock;
    if (partial === undefined) throw new $7afe1a83f827bf55$var$_exception2["default"]("The partial " + options.name + " could not be found");
    else if (partial instanceof Function) return partial(context, options);
}
function $7afe1a83f827bf55$var$noop() {
    return "";
}
function $7afe1a83f827bf55$var$initData(context, data) {
    if (!data || !("root" in data)) {
        data = data ? $aohyl.createFrame(data) : {};
        data.root = context;
    }
    return data;
}
function $7afe1a83f827bf55$var$executeDecorators(fn, prog, container, depths, data, blockParams) {
    if (fn.decorator) {
        var props = {};
        prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
        $7afe1a83f827bf55$var$Utils.extend(prog, props);
    }
    return prog;
}
function $7afe1a83f827bf55$var$wrapHelpersToPassLookupProperty(mergedHelpers, container) {
    Object.keys(mergedHelpers).forEach(function(helperName) {
        var helper = mergedHelpers[helperName];
        mergedHelpers[helperName] = $7afe1a83f827bf55$var$passLookupPropertyOption(helper, container);
    });
}
function $7afe1a83f827bf55$var$passLookupPropertyOption(helper, container) {
    var lookupProperty = container.lookupProperty;
    return $aRd40.wrapHelper(helper, function(options) {
        return $7afe1a83f827bf55$var$Utils.extend({
            lookupProperty: lookupProperty
        }, options);
    });
}

});
parcelRegister("aRd40", function(module, exports) {

$parcel$export(module.exports, "wrapHelper", () => $7e78fcc61b738fcb$export$34b84bc8884ca465, (v) => $7e78fcc61b738fcb$export$34b84bc8884ca465 = v);
var $7e78fcc61b738fcb$export$1e511d4a378977f5;
var $7e78fcc61b738fcb$export$34b84bc8884ca465;
"use strict";
$7e78fcc61b738fcb$export$1e511d4a378977f5 = true;
$7e78fcc61b738fcb$export$34b84bc8884ca465 = $7e78fcc61b738fcb$var$wrapHelper;
function $7e78fcc61b738fcb$var$wrapHelper(helper, transformOptionsFn) {
    if (typeof helper !== "function") // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
    var wrapper = function wrapper() /* dynamic arguments */ {
        var options = arguments[arguments.length - 1];
        arguments[arguments.length - 1] = transformOptionsFn(options);
        return helper.apply(this, arguments);
    };
    return wrapper;
}

});


parcelRegister("dmOFM", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = function(Handlebars) {
    /* istanbul ignore next */ var root = typeof $parcel$global !== "undefined" ? $parcel$global : window, $Handlebars = root.Handlebars;
    /* istanbul ignore next */ Handlebars.noConflict = function() {
        if (root.Handlebars === Handlebars) root.Handlebars = $Handlebars;
        return Handlebars;
    };
};
module.exports = module.exports["default"];

});


parcelRegister("f3bnw", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $af4ff658e748bc6a$var$AST = {
    // Public API used to evaluate derived attributes regarding AST nodes
    helpers: {
        // a mustache is definitely a helper if:
        // * it is an eligible helper, and
        // * it has at least one parameter or hash segment
        helperExpression: function helperExpression(node) {
            return node.type === "SubExpression" || (node.type === "MustacheStatement" || node.type === "BlockStatement") && !!(node.params && node.params.length || node.hash);
        },
        scopedId: function scopedId(path) {
            return /^\.|this\b/.test(path.original);
        },
        // an ID is simple if it only has one part, and that part is not
        // `..` or `this`.
        simpleId: function simpleId(path) {
            return path.parts.length === 1 && !$af4ff658e748bc6a$var$AST.helpers.scopedId(path) && !path.depth;
        }
    }
};
// Must be exported as an object rather than the root of the module as the jison lexer
// must modify the object to operate properly.
module.exports["default"] = $af4ff658e748bc6a$var$AST;
module.exports = module.exports["default"];

});

parcelRegister("7b7Dc", function(module, exports) {

$parcel$export(module.exports, "parseWithoutProcessing", () => $539f7ae7fe344951$export$fc85b2c4462e0bc6, (v) => $539f7ae7fe344951$export$fc85b2c4462e0bc6 = v);
$parcel$export(module.exports, "parse", () => $539f7ae7fe344951$export$98e6a39c04603d36, (v) => $539f7ae7fe344951$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "parser", () => $539f7ae7fe344951$export$8f49e4af10703ce3, (v) => $539f7ae7fe344951$export$8f49e4af10703ce3 = v);
var $539f7ae7fe344951$export$1e511d4a378977f5;
var $539f7ae7fe344951$export$fc85b2c4462e0bc6;
var $539f7ae7fe344951$export$98e6a39c04603d36;
var $539f7ae7fe344951$export$8f49e4af10703ce3;
"use strict";
$539f7ae7fe344951$export$1e511d4a378977f5 = true;
$539f7ae7fe344951$export$fc85b2c4462e0bc6 = $539f7ae7fe344951$var$parseWithoutProcessing;
$539f7ae7fe344951$export$98e6a39c04603d36 = $539f7ae7fe344951$var$parse;
// istanbul ignore next
function $539f7ae7fe344951$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}
// istanbul ignore next
function $539f7ae7fe344951$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $6P6DT = parcelRequire("6P6DT");
var $539f7ae7fe344951$var$_parser2 = $539f7ae7fe344951$var$_interopRequireDefault($6P6DT);

var $2ta45 = parcelRequire("2ta45");
var $539f7ae7fe344951$var$_whitespaceControl2 = $539f7ae7fe344951$var$_interopRequireDefault($2ta45);

var $jKdLQ = parcelRequire("jKdLQ");
var $539f7ae7fe344951$var$Helpers = $539f7ae7fe344951$var$_interopRequireWildcard($jKdLQ);

var $lA5sn = parcelRequire("lA5sn");
$539f7ae7fe344951$export$8f49e4af10703ce3 = $539f7ae7fe344951$var$_parser2["default"];
var $539f7ae7fe344951$var$yy = {};
$lA5sn.extend($539f7ae7fe344951$var$yy, $539f7ae7fe344951$var$Helpers);
function $539f7ae7fe344951$var$parseWithoutProcessing(input, options) {
    // Just return if an already-compiled AST was passed in.
    if (input.type === "Program") return input;
    $539f7ae7fe344951$var$_parser2["default"].yy = $539f7ae7fe344951$var$yy;
    // Altering the shared object here, but this is ok as parser is a sync operation
    $539f7ae7fe344951$var$yy.locInfo = function(locInfo) {
        return new $539f7ae7fe344951$var$yy.SourceLocation(options && options.srcName, locInfo);
    };
    var ast = $539f7ae7fe344951$var$_parser2["default"].parse(input);
    return ast;
}
function $539f7ae7fe344951$var$parse(input, options) {
    var ast = $539f7ae7fe344951$var$parseWithoutProcessing(input, options);
    var strip = new $539f7ae7fe344951$var$_whitespaceControl2["default"](options);
    return strip.accept(ast);
}

});
parcelRegister("6P6DT", function(module, exports) {
// File ignored in coverage tests via setting in .istanbul.yml
/* Jison generated parser */ "use strict";
module.exports.__esModule = true;
var $4f7ca891fbeee017$var$handlebars = function() {
    var parser = {
        trace: function trace() {},
        yy: {},
        symbols_: {
            "error": 2,
            "root": 3,
            "program": 4,
            "EOF": 5,
            "program_repetition0": 6,
            "statement": 7,
            "mustache": 8,
            "block": 9,
            "rawBlock": 10,
            "partial": 11,
            "partialBlock": 12,
            "content": 13,
            "COMMENT": 14,
            "CONTENT": 15,
            "openRawBlock": 16,
            "rawBlock_repetition0": 17,
            "END_RAW_BLOCK": 18,
            "OPEN_RAW_BLOCK": 19,
            "helperName": 20,
            "openRawBlock_repetition0": 21,
            "openRawBlock_option0": 22,
            "CLOSE_RAW_BLOCK": 23,
            "openBlock": 24,
            "block_option0": 25,
            "closeBlock": 26,
            "openInverse": 27,
            "block_option1": 28,
            "OPEN_BLOCK": 29,
            "openBlock_repetition0": 30,
            "openBlock_option0": 31,
            "openBlock_option1": 32,
            "CLOSE": 33,
            "OPEN_INVERSE": 34,
            "openInverse_repetition0": 35,
            "openInverse_option0": 36,
            "openInverse_option1": 37,
            "openInverseChain": 38,
            "OPEN_INVERSE_CHAIN": 39,
            "openInverseChain_repetition0": 40,
            "openInverseChain_option0": 41,
            "openInverseChain_option1": 42,
            "inverseAndProgram": 43,
            "INVERSE": 44,
            "inverseChain": 45,
            "inverseChain_option0": 46,
            "OPEN_ENDBLOCK": 47,
            "OPEN": 48,
            "mustache_repetition0": 49,
            "mustache_option0": 50,
            "OPEN_UNESCAPED": 51,
            "mustache_repetition1": 52,
            "mustache_option1": 53,
            "CLOSE_UNESCAPED": 54,
            "OPEN_PARTIAL": 55,
            "partialName": 56,
            "partial_repetition0": 57,
            "partial_option0": 58,
            "openPartialBlock": 59,
            "OPEN_PARTIAL_BLOCK": 60,
            "openPartialBlock_repetition0": 61,
            "openPartialBlock_option0": 62,
            "param": 63,
            "sexpr": 64,
            "OPEN_SEXPR": 65,
            "sexpr_repetition0": 66,
            "sexpr_option0": 67,
            "CLOSE_SEXPR": 68,
            "hash": 69,
            "hash_repetition_plus0": 70,
            "hashSegment": 71,
            "ID": 72,
            "EQUALS": 73,
            "blockParams": 74,
            "OPEN_BLOCK_PARAMS": 75,
            "blockParams_repetition_plus0": 76,
            "CLOSE_BLOCK_PARAMS": 77,
            "path": 78,
            "dataName": 79,
            "STRING": 80,
            "NUMBER": 81,
            "BOOLEAN": 82,
            "UNDEFINED": 83,
            "NULL": 84,
            "DATA": 85,
            "pathSegments": 86,
            "SEP": 87,
            "$accept": 0,
            "$end": 1
        },
        terminals_: {
            2: "error",
            5: "EOF",
            14: "COMMENT",
            15: "CONTENT",
            18: "END_RAW_BLOCK",
            19: "OPEN_RAW_BLOCK",
            23: "CLOSE_RAW_BLOCK",
            29: "OPEN_BLOCK",
            33: "CLOSE",
            34: "OPEN_INVERSE",
            39: "OPEN_INVERSE_CHAIN",
            44: "INVERSE",
            47: "OPEN_ENDBLOCK",
            48: "OPEN",
            51: "OPEN_UNESCAPED",
            54: "CLOSE_UNESCAPED",
            55: "OPEN_PARTIAL",
            60: "OPEN_PARTIAL_BLOCK",
            65: "OPEN_SEXPR",
            68: "CLOSE_SEXPR",
            72: "ID",
            73: "EQUALS",
            75: "OPEN_BLOCK_PARAMS",
            77: "CLOSE_BLOCK_PARAMS",
            80: "STRING",
            81: "NUMBER",
            82: "BOOLEAN",
            83: "UNDEFINED",
            84: "NULL",
            85: "DATA",
            87: "SEP"
        },
        productions_: [
            0,
            [
                3,
                2
            ],
            [
                4,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                13,
                1
            ],
            [
                10,
                3
            ],
            [
                16,
                5
            ],
            [
                9,
                4
            ],
            [
                9,
                4
            ],
            [
                24,
                6
            ],
            [
                27,
                6
            ],
            [
                38,
                6
            ],
            [
                43,
                2
            ],
            [
                45,
                3
            ],
            [
                45,
                1
            ],
            [
                26,
                3
            ],
            [
                8,
                5
            ],
            [
                8,
                5
            ],
            [
                11,
                5
            ],
            [
                12,
                3
            ],
            [
                59,
                5
            ],
            [
                63,
                1
            ],
            [
                63,
                1
            ],
            [
                64,
                5
            ],
            [
                69,
                1
            ],
            [
                71,
                3
            ],
            [
                74,
                3
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                56,
                1
            ],
            [
                56,
                1
            ],
            [
                79,
                2
            ],
            [
                78,
                1
            ],
            [
                86,
                3
            ],
            [
                86,
                1
            ],
            [
                6,
                0
            ],
            [
                6,
                2
            ],
            [
                17,
                0
            ],
            [
                17,
                2
            ],
            [
                21,
                0
            ],
            [
                21,
                2
            ],
            [
                22,
                0
            ],
            [
                22,
                1
            ],
            [
                25,
                0
            ],
            [
                25,
                1
            ],
            [
                28,
                0
            ],
            [
                28,
                1
            ],
            [
                30,
                0
            ],
            [
                30,
                2
            ],
            [
                31,
                0
            ],
            [
                31,
                1
            ],
            [
                32,
                0
            ],
            [
                32,
                1
            ],
            [
                35,
                0
            ],
            [
                35,
                2
            ],
            [
                36,
                0
            ],
            [
                36,
                1
            ],
            [
                37,
                0
            ],
            [
                37,
                1
            ],
            [
                40,
                0
            ],
            [
                40,
                2
            ],
            [
                41,
                0
            ],
            [
                41,
                1
            ],
            [
                42,
                0
            ],
            [
                42,
                1
            ],
            [
                46,
                0
            ],
            [
                46,
                1
            ],
            [
                49,
                0
            ],
            [
                49,
                2
            ],
            [
                50,
                0
            ],
            [
                50,
                1
            ],
            [
                52,
                0
            ],
            [
                52,
                2
            ],
            [
                53,
                0
            ],
            [
                53,
                1
            ],
            [
                57,
                0
            ],
            [
                57,
                2
            ],
            [
                58,
                0
            ],
            [
                58,
                1
            ],
            [
                61,
                0
            ],
            [
                61,
                2
            ],
            [
                62,
                0
            ],
            [
                62,
                1
            ],
            [
                66,
                0
            ],
            [
                66,
                2
            ],
            [
                67,
                0
            ],
            [
                67,
                1
            ],
            [
                70,
                1
            ],
            [
                70,
                2
            ],
            [
                76,
                1
            ],
            [
                76,
                2
            ]
        ],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {
            var $0 = $$.length - 1;
            switch(yystate){
                case 1:
                    return $$[$0 - 1];
                case 2:
                    this.$ = yy.prepareProgram($$[$0]);
                    break;
                case 3:
                    this.$ = $$[$0];
                    break;
                case 4:
                    this.$ = $$[$0];
                    break;
                case 5:
                    this.$ = $$[$0];
                    break;
                case 6:
                    this.$ = $$[$0];
                    break;
                case 7:
                    this.$ = $$[$0];
                    break;
                case 8:
                    this.$ = $$[$0];
                    break;
                case 9:
                    this.$ = {
                        type: "CommentStatement",
                        value: yy.stripComment($$[$0]),
                        strip: yy.stripFlags($$[$0], $$[$0]),
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 10:
                    this.$ = {
                        type: "ContentStatement",
                        original: $$[$0],
                        value: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 11:
                    this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
                    break;
                case 12:
                    this.$ = {
                        path: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1]
                    };
                    break;
                case 13:
                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
                    break;
                case 14:
                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
                    break;
                case 15:
                    this.$ = {
                        open: $$[$0 - 5],
                        path: $$[$0 - 4],
                        params: $$[$0 - 3],
                        hash: $$[$0 - 2],
                        blockParams: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 5], $$[$0])
                    };
                    break;
                case 16:
                    this.$ = {
                        path: $$[$0 - 4],
                        params: $$[$0 - 3],
                        hash: $$[$0 - 2],
                        blockParams: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 5], $$[$0])
                    };
                    break;
                case 17:
                    this.$ = {
                        path: $$[$0 - 4],
                        params: $$[$0 - 3],
                        hash: $$[$0 - 2],
                        blockParams: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 5], $$[$0])
                    };
                    break;
                case 18:
                    this.$ = {
                        strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]),
                        program: $$[$0]
                    };
                    break;
                case 19:
                    var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$), program = yy.prepareProgram([
                        inverse
                    ], $$[$0 - 1].loc);
                    program.chained = true;
                    this.$ = {
                        strip: $$[$0 - 2].strip,
                        program: program,
                        chain: true
                    };
                    break;
                case 20:
                    this.$ = $$[$0];
                    break;
                case 21:
                    this.$ = {
                        path: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 2], $$[$0])
                    };
                    break;
                case 22:
                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
                    break;
                case 23:
                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
                    break;
                case 24:
                    this.$ = {
                        type: "PartialStatement",
                        name: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        indent: "",
                        strip: yy.stripFlags($$[$0 - 4], $$[$0]),
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 25:
                    this.$ = yy.preparePartialBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
                    break;
                case 26:
                    this.$ = {
                        path: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 4], $$[$0])
                    };
                    break;
                case 27:
                    this.$ = $$[$0];
                    break;
                case 28:
                    this.$ = $$[$0];
                    break;
                case 29:
                    this.$ = {
                        type: "SubExpression",
                        path: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 30:
                    this.$ = {
                        type: "Hash",
                        pairs: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 31:
                    this.$ = {
                        type: "HashPair",
                        key: yy.id($$[$0 - 2]),
                        value: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 32:
                    this.$ = yy.id($$[$0 - 1]);
                    break;
                case 33:
                    this.$ = $$[$0];
                    break;
                case 34:
                    this.$ = $$[$0];
                    break;
                case 35:
                    this.$ = {
                        type: "StringLiteral",
                        value: $$[$0],
                        original: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 36:
                    this.$ = {
                        type: "NumberLiteral",
                        value: Number($$[$0]),
                        original: Number($$[$0]),
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 37:
                    this.$ = {
                        type: "BooleanLiteral",
                        value: $$[$0] === "true",
                        original: $$[$0] === "true",
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 38:
                    this.$ = {
                        type: "UndefinedLiteral",
                        original: undefined,
                        value: undefined,
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 39:
                    this.$ = {
                        type: "NullLiteral",
                        original: null,
                        value: null,
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 40:
                    this.$ = $$[$0];
                    break;
                case 41:
                    this.$ = $$[$0];
                    break;
                case 42:
                    this.$ = yy.preparePath(true, $$[$0], this._$);
                    break;
                case 43:
                    this.$ = yy.preparePath(false, $$[$0], this._$);
                    break;
                case 44:
                    $$[$0 - 2].push({
                        part: yy.id($$[$0]),
                        original: $$[$0],
                        separator: $$[$0 - 1]
                    });
                    this.$ = $$[$0 - 2];
                    break;
                case 45:
                    this.$ = [
                        {
                            part: yy.id($$[$0]),
                            original: $$[$0]
                        }
                    ];
                    break;
                case 46:
                    this.$ = [];
                    break;
                case 47:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 48:
                    this.$ = [];
                    break;
                case 49:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 50:
                    this.$ = [];
                    break;
                case 51:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 58:
                    this.$ = [];
                    break;
                case 59:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 64:
                    this.$ = [];
                    break;
                case 65:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 70:
                    this.$ = [];
                    break;
                case 71:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 78:
                    this.$ = [];
                    break;
                case 79:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 82:
                    this.$ = [];
                    break;
                case 83:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 86:
                    this.$ = [];
                    break;
                case 87:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 90:
                    this.$ = [];
                    break;
                case 91:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 94:
                    this.$ = [];
                    break;
                case 95:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 98:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 99:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 100:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 101:
                    $$[$0 - 1].push($$[$0]);
                    break;
            }
        },
        table: [
            {
                3: 1,
                4: 2,
                5: [
                    2,
                    46
                ],
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                1: [
                    3
                ]
            },
            {
                5: [
                    1,
                    4
                ]
            },
            {
                5: [
                    2,
                    2
                ],
                7: 5,
                8: 6,
                9: 7,
                10: 8,
                11: 9,
                12: 10,
                13: 11,
                14: [
                    1,
                    12
                ],
                15: [
                    1,
                    20
                ],
                16: 17,
                19: [
                    1,
                    23
                ],
                24: 15,
                27: 16,
                29: [
                    1,
                    21
                ],
                34: [
                    1,
                    22
                ],
                39: [
                    2,
                    2
                ],
                44: [
                    2,
                    2
                ],
                47: [
                    2,
                    2
                ],
                48: [
                    1,
                    13
                ],
                51: [
                    1,
                    14
                ],
                55: [
                    1,
                    18
                ],
                59: 19,
                60: [
                    1,
                    24
                ]
            },
            {
                1: [
                    2,
                    1
                ]
            },
            {
                5: [
                    2,
                    47
                ],
                14: [
                    2,
                    47
                ],
                15: [
                    2,
                    47
                ],
                19: [
                    2,
                    47
                ],
                29: [
                    2,
                    47
                ],
                34: [
                    2,
                    47
                ],
                39: [
                    2,
                    47
                ],
                44: [
                    2,
                    47
                ],
                47: [
                    2,
                    47
                ],
                48: [
                    2,
                    47
                ],
                51: [
                    2,
                    47
                ],
                55: [
                    2,
                    47
                ],
                60: [
                    2,
                    47
                ]
            },
            {
                5: [
                    2,
                    3
                ],
                14: [
                    2,
                    3
                ],
                15: [
                    2,
                    3
                ],
                19: [
                    2,
                    3
                ],
                29: [
                    2,
                    3
                ],
                34: [
                    2,
                    3
                ],
                39: [
                    2,
                    3
                ],
                44: [
                    2,
                    3
                ],
                47: [
                    2,
                    3
                ],
                48: [
                    2,
                    3
                ],
                51: [
                    2,
                    3
                ],
                55: [
                    2,
                    3
                ],
                60: [
                    2,
                    3
                ]
            },
            {
                5: [
                    2,
                    4
                ],
                14: [
                    2,
                    4
                ],
                15: [
                    2,
                    4
                ],
                19: [
                    2,
                    4
                ],
                29: [
                    2,
                    4
                ],
                34: [
                    2,
                    4
                ],
                39: [
                    2,
                    4
                ],
                44: [
                    2,
                    4
                ],
                47: [
                    2,
                    4
                ],
                48: [
                    2,
                    4
                ],
                51: [
                    2,
                    4
                ],
                55: [
                    2,
                    4
                ],
                60: [
                    2,
                    4
                ]
            },
            {
                5: [
                    2,
                    5
                ],
                14: [
                    2,
                    5
                ],
                15: [
                    2,
                    5
                ],
                19: [
                    2,
                    5
                ],
                29: [
                    2,
                    5
                ],
                34: [
                    2,
                    5
                ],
                39: [
                    2,
                    5
                ],
                44: [
                    2,
                    5
                ],
                47: [
                    2,
                    5
                ],
                48: [
                    2,
                    5
                ],
                51: [
                    2,
                    5
                ],
                55: [
                    2,
                    5
                ],
                60: [
                    2,
                    5
                ]
            },
            {
                5: [
                    2,
                    6
                ],
                14: [
                    2,
                    6
                ],
                15: [
                    2,
                    6
                ],
                19: [
                    2,
                    6
                ],
                29: [
                    2,
                    6
                ],
                34: [
                    2,
                    6
                ],
                39: [
                    2,
                    6
                ],
                44: [
                    2,
                    6
                ],
                47: [
                    2,
                    6
                ],
                48: [
                    2,
                    6
                ],
                51: [
                    2,
                    6
                ],
                55: [
                    2,
                    6
                ],
                60: [
                    2,
                    6
                ]
            },
            {
                5: [
                    2,
                    7
                ],
                14: [
                    2,
                    7
                ],
                15: [
                    2,
                    7
                ],
                19: [
                    2,
                    7
                ],
                29: [
                    2,
                    7
                ],
                34: [
                    2,
                    7
                ],
                39: [
                    2,
                    7
                ],
                44: [
                    2,
                    7
                ],
                47: [
                    2,
                    7
                ],
                48: [
                    2,
                    7
                ],
                51: [
                    2,
                    7
                ],
                55: [
                    2,
                    7
                ],
                60: [
                    2,
                    7
                ]
            },
            {
                5: [
                    2,
                    8
                ],
                14: [
                    2,
                    8
                ],
                15: [
                    2,
                    8
                ],
                19: [
                    2,
                    8
                ],
                29: [
                    2,
                    8
                ],
                34: [
                    2,
                    8
                ],
                39: [
                    2,
                    8
                ],
                44: [
                    2,
                    8
                ],
                47: [
                    2,
                    8
                ],
                48: [
                    2,
                    8
                ],
                51: [
                    2,
                    8
                ],
                55: [
                    2,
                    8
                ],
                60: [
                    2,
                    8
                ]
            },
            {
                5: [
                    2,
                    9
                ],
                14: [
                    2,
                    9
                ],
                15: [
                    2,
                    9
                ],
                19: [
                    2,
                    9
                ],
                29: [
                    2,
                    9
                ],
                34: [
                    2,
                    9
                ],
                39: [
                    2,
                    9
                ],
                44: [
                    2,
                    9
                ],
                47: [
                    2,
                    9
                ],
                48: [
                    2,
                    9
                ],
                51: [
                    2,
                    9
                ],
                55: [
                    2,
                    9
                ],
                60: [
                    2,
                    9
                ]
            },
            {
                20: 25,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 36,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                4: 37,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                39: [
                    2,
                    46
                ],
                44: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                4: 38,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                44: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                15: [
                    2,
                    48
                ],
                17: 39,
                18: [
                    2,
                    48
                ]
            },
            {
                20: 41,
                56: 40,
                64: 42,
                65: [
                    1,
                    43
                ],
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                4: 44,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                5: [
                    2,
                    10
                ],
                14: [
                    2,
                    10
                ],
                15: [
                    2,
                    10
                ],
                18: [
                    2,
                    10
                ],
                19: [
                    2,
                    10
                ],
                29: [
                    2,
                    10
                ],
                34: [
                    2,
                    10
                ],
                39: [
                    2,
                    10
                ],
                44: [
                    2,
                    10
                ],
                47: [
                    2,
                    10
                ],
                48: [
                    2,
                    10
                ],
                51: [
                    2,
                    10
                ],
                55: [
                    2,
                    10
                ],
                60: [
                    2,
                    10
                ]
            },
            {
                20: 45,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 46,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 47,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 41,
                56: 48,
                64: 42,
                65: [
                    1,
                    43
                ],
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                33: [
                    2,
                    78
                ],
                49: 49,
                65: [
                    2,
                    78
                ],
                72: [
                    2,
                    78
                ],
                80: [
                    2,
                    78
                ],
                81: [
                    2,
                    78
                ],
                82: [
                    2,
                    78
                ],
                83: [
                    2,
                    78
                ],
                84: [
                    2,
                    78
                ],
                85: [
                    2,
                    78
                ]
            },
            {
                23: [
                    2,
                    33
                ],
                33: [
                    2,
                    33
                ],
                54: [
                    2,
                    33
                ],
                65: [
                    2,
                    33
                ],
                68: [
                    2,
                    33
                ],
                72: [
                    2,
                    33
                ],
                75: [
                    2,
                    33
                ],
                80: [
                    2,
                    33
                ],
                81: [
                    2,
                    33
                ],
                82: [
                    2,
                    33
                ],
                83: [
                    2,
                    33
                ],
                84: [
                    2,
                    33
                ],
                85: [
                    2,
                    33
                ]
            },
            {
                23: [
                    2,
                    34
                ],
                33: [
                    2,
                    34
                ],
                54: [
                    2,
                    34
                ],
                65: [
                    2,
                    34
                ],
                68: [
                    2,
                    34
                ],
                72: [
                    2,
                    34
                ],
                75: [
                    2,
                    34
                ],
                80: [
                    2,
                    34
                ],
                81: [
                    2,
                    34
                ],
                82: [
                    2,
                    34
                ],
                83: [
                    2,
                    34
                ],
                84: [
                    2,
                    34
                ],
                85: [
                    2,
                    34
                ]
            },
            {
                23: [
                    2,
                    35
                ],
                33: [
                    2,
                    35
                ],
                54: [
                    2,
                    35
                ],
                65: [
                    2,
                    35
                ],
                68: [
                    2,
                    35
                ],
                72: [
                    2,
                    35
                ],
                75: [
                    2,
                    35
                ],
                80: [
                    2,
                    35
                ],
                81: [
                    2,
                    35
                ],
                82: [
                    2,
                    35
                ],
                83: [
                    2,
                    35
                ],
                84: [
                    2,
                    35
                ],
                85: [
                    2,
                    35
                ]
            },
            {
                23: [
                    2,
                    36
                ],
                33: [
                    2,
                    36
                ],
                54: [
                    2,
                    36
                ],
                65: [
                    2,
                    36
                ],
                68: [
                    2,
                    36
                ],
                72: [
                    2,
                    36
                ],
                75: [
                    2,
                    36
                ],
                80: [
                    2,
                    36
                ],
                81: [
                    2,
                    36
                ],
                82: [
                    2,
                    36
                ],
                83: [
                    2,
                    36
                ],
                84: [
                    2,
                    36
                ],
                85: [
                    2,
                    36
                ]
            },
            {
                23: [
                    2,
                    37
                ],
                33: [
                    2,
                    37
                ],
                54: [
                    2,
                    37
                ],
                65: [
                    2,
                    37
                ],
                68: [
                    2,
                    37
                ],
                72: [
                    2,
                    37
                ],
                75: [
                    2,
                    37
                ],
                80: [
                    2,
                    37
                ],
                81: [
                    2,
                    37
                ],
                82: [
                    2,
                    37
                ],
                83: [
                    2,
                    37
                ],
                84: [
                    2,
                    37
                ],
                85: [
                    2,
                    37
                ]
            },
            {
                23: [
                    2,
                    38
                ],
                33: [
                    2,
                    38
                ],
                54: [
                    2,
                    38
                ],
                65: [
                    2,
                    38
                ],
                68: [
                    2,
                    38
                ],
                72: [
                    2,
                    38
                ],
                75: [
                    2,
                    38
                ],
                80: [
                    2,
                    38
                ],
                81: [
                    2,
                    38
                ],
                82: [
                    2,
                    38
                ],
                83: [
                    2,
                    38
                ],
                84: [
                    2,
                    38
                ],
                85: [
                    2,
                    38
                ]
            },
            {
                23: [
                    2,
                    39
                ],
                33: [
                    2,
                    39
                ],
                54: [
                    2,
                    39
                ],
                65: [
                    2,
                    39
                ],
                68: [
                    2,
                    39
                ],
                72: [
                    2,
                    39
                ],
                75: [
                    2,
                    39
                ],
                80: [
                    2,
                    39
                ],
                81: [
                    2,
                    39
                ],
                82: [
                    2,
                    39
                ],
                83: [
                    2,
                    39
                ],
                84: [
                    2,
                    39
                ],
                85: [
                    2,
                    39
                ]
            },
            {
                23: [
                    2,
                    43
                ],
                33: [
                    2,
                    43
                ],
                54: [
                    2,
                    43
                ],
                65: [
                    2,
                    43
                ],
                68: [
                    2,
                    43
                ],
                72: [
                    2,
                    43
                ],
                75: [
                    2,
                    43
                ],
                80: [
                    2,
                    43
                ],
                81: [
                    2,
                    43
                ],
                82: [
                    2,
                    43
                ],
                83: [
                    2,
                    43
                ],
                84: [
                    2,
                    43
                ],
                85: [
                    2,
                    43
                ],
                87: [
                    1,
                    50
                ]
            },
            {
                72: [
                    1,
                    35
                ],
                86: 51
            },
            {
                23: [
                    2,
                    45
                ],
                33: [
                    2,
                    45
                ],
                54: [
                    2,
                    45
                ],
                65: [
                    2,
                    45
                ],
                68: [
                    2,
                    45
                ],
                72: [
                    2,
                    45
                ],
                75: [
                    2,
                    45
                ],
                80: [
                    2,
                    45
                ],
                81: [
                    2,
                    45
                ],
                82: [
                    2,
                    45
                ],
                83: [
                    2,
                    45
                ],
                84: [
                    2,
                    45
                ],
                85: [
                    2,
                    45
                ],
                87: [
                    2,
                    45
                ]
            },
            {
                52: 52,
                54: [
                    2,
                    82
                ],
                65: [
                    2,
                    82
                ],
                72: [
                    2,
                    82
                ],
                80: [
                    2,
                    82
                ],
                81: [
                    2,
                    82
                ],
                82: [
                    2,
                    82
                ],
                83: [
                    2,
                    82
                ],
                84: [
                    2,
                    82
                ],
                85: [
                    2,
                    82
                ]
            },
            {
                25: 53,
                38: 55,
                39: [
                    1,
                    57
                ],
                43: 56,
                44: [
                    1,
                    58
                ],
                45: 54,
                47: [
                    2,
                    54
                ]
            },
            {
                28: 59,
                43: 60,
                44: [
                    1,
                    58
                ],
                47: [
                    2,
                    56
                ]
            },
            {
                13: 62,
                15: [
                    1,
                    20
                ],
                18: [
                    1,
                    61
                ]
            },
            {
                33: [
                    2,
                    86
                ],
                57: 63,
                65: [
                    2,
                    86
                ],
                72: [
                    2,
                    86
                ],
                80: [
                    2,
                    86
                ],
                81: [
                    2,
                    86
                ],
                82: [
                    2,
                    86
                ],
                83: [
                    2,
                    86
                ],
                84: [
                    2,
                    86
                ],
                85: [
                    2,
                    86
                ]
            },
            {
                33: [
                    2,
                    40
                ],
                65: [
                    2,
                    40
                ],
                72: [
                    2,
                    40
                ],
                80: [
                    2,
                    40
                ],
                81: [
                    2,
                    40
                ],
                82: [
                    2,
                    40
                ],
                83: [
                    2,
                    40
                ],
                84: [
                    2,
                    40
                ],
                85: [
                    2,
                    40
                ]
            },
            {
                33: [
                    2,
                    41
                ],
                65: [
                    2,
                    41
                ],
                72: [
                    2,
                    41
                ],
                80: [
                    2,
                    41
                ],
                81: [
                    2,
                    41
                ],
                82: [
                    2,
                    41
                ],
                83: [
                    2,
                    41
                ],
                84: [
                    2,
                    41
                ],
                85: [
                    2,
                    41
                ]
            },
            {
                20: 64,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                26: 65,
                47: [
                    1,
                    66
                ]
            },
            {
                30: 67,
                33: [
                    2,
                    58
                ],
                65: [
                    2,
                    58
                ],
                72: [
                    2,
                    58
                ],
                75: [
                    2,
                    58
                ],
                80: [
                    2,
                    58
                ],
                81: [
                    2,
                    58
                ],
                82: [
                    2,
                    58
                ],
                83: [
                    2,
                    58
                ],
                84: [
                    2,
                    58
                ],
                85: [
                    2,
                    58
                ]
            },
            {
                33: [
                    2,
                    64
                ],
                35: 68,
                65: [
                    2,
                    64
                ],
                72: [
                    2,
                    64
                ],
                75: [
                    2,
                    64
                ],
                80: [
                    2,
                    64
                ],
                81: [
                    2,
                    64
                ],
                82: [
                    2,
                    64
                ],
                83: [
                    2,
                    64
                ],
                84: [
                    2,
                    64
                ],
                85: [
                    2,
                    64
                ]
            },
            {
                21: 69,
                23: [
                    2,
                    50
                ],
                65: [
                    2,
                    50
                ],
                72: [
                    2,
                    50
                ],
                80: [
                    2,
                    50
                ],
                81: [
                    2,
                    50
                ],
                82: [
                    2,
                    50
                ],
                83: [
                    2,
                    50
                ],
                84: [
                    2,
                    50
                ],
                85: [
                    2,
                    50
                ]
            },
            {
                33: [
                    2,
                    90
                ],
                61: 70,
                65: [
                    2,
                    90
                ],
                72: [
                    2,
                    90
                ],
                80: [
                    2,
                    90
                ],
                81: [
                    2,
                    90
                ],
                82: [
                    2,
                    90
                ],
                83: [
                    2,
                    90
                ],
                84: [
                    2,
                    90
                ],
                85: [
                    2,
                    90
                ]
            },
            {
                20: 74,
                33: [
                    2,
                    80
                ],
                50: 71,
                63: 72,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 73,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                72: [
                    1,
                    79
                ]
            },
            {
                23: [
                    2,
                    42
                ],
                33: [
                    2,
                    42
                ],
                54: [
                    2,
                    42
                ],
                65: [
                    2,
                    42
                ],
                68: [
                    2,
                    42
                ],
                72: [
                    2,
                    42
                ],
                75: [
                    2,
                    42
                ],
                80: [
                    2,
                    42
                ],
                81: [
                    2,
                    42
                ],
                82: [
                    2,
                    42
                ],
                83: [
                    2,
                    42
                ],
                84: [
                    2,
                    42
                ],
                85: [
                    2,
                    42
                ],
                87: [
                    1,
                    50
                ]
            },
            {
                20: 74,
                53: 80,
                54: [
                    2,
                    84
                ],
                63: 81,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 82,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                26: 83,
                47: [
                    1,
                    66
                ]
            },
            {
                47: [
                    2,
                    55
                ]
            },
            {
                4: 84,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                39: [
                    2,
                    46
                ],
                44: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                47: [
                    2,
                    20
                ]
            },
            {
                20: 85,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                4: 86,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                26: 87,
                47: [
                    1,
                    66
                ]
            },
            {
                47: [
                    2,
                    57
                ]
            },
            {
                5: [
                    2,
                    11
                ],
                14: [
                    2,
                    11
                ],
                15: [
                    2,
                    11
                ],
                19: [
                    2,
                    11
                ],
                29: [
                    2,
                    11
                ],
                34: [
                    2,
                    11
                ],
                39: [
                    2,
                    11
                ],
                44: [
                    2,
                    11
                ],
                47: [
                    2,
                    11
                ],
                48: [
                    2,
                    11
                ],
                51: [
                    2,
                    11
                ],
                55: [
                    2,
                    11
                ],
                60: [
                    2,
                    11
                ]
            },
            {
                15: [
                    2,
                    49
                ],
                18: [
                    2,
                    49
                ]
            },
            {
                20: 74,
                33: [
                    2,
                    88
                ],
                58: 88,
                63: 89,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 90,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                65: [
                    2,
                    94
                ],
                66: 91,
                68: [
                    2,
                    94
                ],
                72: [
                    2,
                    94
                ],
                80: [
                    2,
                    94
                ],
                81: [
                    2,
                    94
                ],
                82: [
                    2,
                    94
                ],
                83: [
                    2,
                    94
                ],
                84: [
                    2,
                    94
                ],
                85: [
                    2,
                    94
                ]
            },
            {
                5: [
                    2,
                    25
                ],
                14: [
                    2,
                    25
                ],
                15: [
                    2,
                    25
                ],
                19: [
                    2,
                    25
                ],
                29: [
                    2,
                    25
                ],
                34: [
                    2,
                    25
                ],
                39: [
                    2,
                    25
                ],
                44: [
                    2,
                    25
                ],
                47: [
                    2,
                    25
                ],
                48: [
                    2,
                    25
                ],
                51: [
                    2,
                    25
                ],
                55: [
                    2,
                    25
                ],
                60: [
                    2,
                    25
                ]
            },
            {
                20: 92,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                31: 93,
                33: [
                    2,
                    60
                ],
                63: 94,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 95,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                75: [
                    2,
                    60
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                33: [
                    2,
                    66
                ],
                36: 96,
                63: 97,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 98,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                75: [
                    2,
                    66
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                22: 99,
                23: [
                    2,
                    52
                ],
                63: 100,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 101,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                33: [
                    2,
                    92
                ],
                62: 102,
                63: 103,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 104,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                33: [
                    1,
                    105
                ]
            },
            {
                33: [
                    2,
                    79
                ],
                65: [
                    2,
                    79
                ],
                72: [
                    2,
                    79
                ],
                80: [
                    2,
                    79
                ],
                81: [
                    2,
                    79
                ],
                82: [
                    2,
                    79
                ],
                83: [
                    2,
                    79
                ],
                84: [
                    2,
                    79
                ],
                85: [
                    2,
                    79
                ]
            },
            {
                33: [
                    2,
                    81
                ]
            },
            {
                23: [
                    2,
                    27
                ],
                33: [
                    2,
                    27
                ],
                54: [
                    2,
                    27
                ],
                65: [
                    2,
                    27
                ],
                68: [
                    2,
                    27
                ],
                72: [
                    2,
                    27
                ],
                75: [
                    2,
                    27
                ],
                80: [
                    2,
                    27
                ],
                81: [
                    2,
                    27
                ],
                82: [
                    2,
                    27
                ],
                83: [
                    2,
                    27
                ],
                84: [
                    2,
                    27
                ],
                85: [
                    2,
                    27
                ]
            },
            {
                23: [
                    2,
                    28
                ],
                33: [
                    2,
                    28
                ],
                54: [
                    2,
                    28
                ],
                65: [
                    2,
                    28
                ],
                68: [
                    2,
                    28
                ],
                72: [
                    2,
                    28
                ],
                75: [
                    2,
                    28
                ],
                80: [
                    2,
                    28
                ],
                81: [
                    2,
                    28
                ],
                82: [
                    2,
                    28
                ],
                83: [
                    2,
                    28
                ],
                84: [
                    2,
                    28
                ],
                85: [
                    2,
                    28
                ]
            },
            {
                23: [
                    2,
                    30
                ],
                33: [
                    2,
                    30
                ],
                54: [
                    2,
                    30
                ],
                68: [
                    2,
                    30
                ],
                71: 106,
                72: [
                    1,
                    107
                ],
                75: [
                    2,
                    30
                ]
            },
            {
                23: [
                    2,
                    98
                ],
                33: [
                    2,
                    98
                ],
                54: [
                    2,
                    98
                ],
                68: [
                    2,
                    98
                ],
                72: [
                    2,
                    98
                ],
                75: [
                    2,
                    98
                ]
            },
            {
                23: [
                    2,
                    45
                ],
                33: [
                    2,
                    45
                ],
                54: [
                    2,
                    45
                ],
                65: [
                    2,
                    45
                ],
                68: [
                    2,
                    45
                ],
                72: [
                    2,
                    45
                ],
                73: [
                    1,
                    108
                ],
                75: [
                    2,
                    45
                ],
                80: [
                    2,
                    45
                ],
                81: [
                    2,
                    45
                ],
                82: [
                    2,
                    45
                ],
                83: [
                    2,
                    45
                ],
                84: [
                    2,
                    45
                ],
                85: [
                    2,
                    45
                ],
                87: [
                    2,
                    45
                ]
            },
            {
                23: [
                    2,
                    44
                ],
                33: [
                    2,
                    44
                ],
                54: [
                    2,
                    44
                ],
                65: [
                    2,
                    44
                ],
                68: [
                    2,
                    44
                ],
                72: [
                    2,
                    44
                ],
                75: [
                    2,
                    44
                ],
                80: [
                    2,
                    44
                ],
                81: [
                    2,
                    44
                ],
                82: [
                    2,
                    44
                ],
                83: [
                    2,
                    44
                ],
                84: [
                    2,
                    44
                ],
                85: [
                    2,
                    44
                ],
                87: [
                    2,
                    44
                ]
            },
            {
                54: [
                    1,
                    109
                ]
            },
            {
                54: [
                    2,
                    83
                ],
                65: [
                    2,
                    83
                ],
                72: [
                    2,
                    83
                ],
                80: [
                    2,
                    83
                ],
                81: [
                    2,
                    83
                ],
                82: [
                    2,
                    83
                ],
                83: [
                    2,
                    83
                ],
                84: [
                    2,
                    83
                ],
                85: [
                    2,
                    83
                ]
            },
            {
                54: [
                    2,
                    85
                ]
            },
            {
                5: [
                    2,
                    13
                ],
                14: [
                    2,
                    13
                ],
                15: [
                    2,
                    13
                ],
                19: [
                    2,
                    13
                ],
                29: [
                    2,
                    13
                ],
                34: [
                    2,
                    13
                ],
                39: [
                    2,
                    13
                ],
                44: [
                    2,
                    13
                ],
                47: [
                    2,
                    13
                ],
                48: [
                    2,
                    13
                ],
                51: [
                    2,
                    13
                ],
                55: [
                    2,
                    13
                ],
                60: [
                    2,
                    13
                ]
            },
            {
                38: 55,
                39: [
                    1,
                    57
                ],
                43: 56,
                44: [
                    1,
                    58
                ],
                45: 111,
                46: 110,
                47: [
                    2,
                    76
                ]
            },
            {
                33: [
                    2,
                    70
                ],
                40: 112,
                65: [
                    2,
                    70
                ],
                72: [
                    2,
                    70
                ],
                75: [
                    2,
                    70
                ],
                80: [
                    2,
                    70
                ],
                81: [
                    2,
                    70
                ],
                82: [
                    2,
                    70
                ],
                83: [
                    2,
                    70
                ],
                84: [
                    2,
                    70
                ],
                85: [
                    2,
                    70
                ]
            },
            {
                47: [
                    2,
                    18
                ]
            },
            {
                5: [
                    2,
                    14
                ],
                14: [
                    2,
                    14
                ],
                15: [
                    2,
                    14
                ],
                19: [
                    2,
                    14
                ],
                29: [
                    2,
                    14
                ],
                34: [
                    2,
                    14
                ],
                39: [
                    2,
                    14
                ],
                44: [
                    2,
                    14
                ],
                47: [
                    2,
                    14
                ],
                48: [
                    2,
                    14
                ],
                51: [
                    2,
                    14
                ],
                55: [
                    2,
                    14
                ],
                60: [
                    2,
                    14
                ]
            },
            {
                33: [
                    1,
                    113
                ]
            },
            {
                33: [
                    2,
                    87
                ],
                65: [
                    2,
                    87
                ],
                72: [
                    2,
                    87
                ],
                80: [
                    2,
                    87
                ],
                81: [
                    2,
                    87
                ],
                82: [
                    2,
                    87
                ],
                83: [
                    2,
                    87
                ],
                84: [
                    2,
                    87
                ],
                85: [
                    2,
                    87
                ]
            },
            {
                33: [
                    2,
                    89
                ]
            },
            {
                20: 74,
                63: 115,
                64: 75,
                65: [
                    1,
                    43
                ],
                67: 114,
                68: [
                    2,
                    96
                ],
                69: 116,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                33: [
                    1,
                    117
                ]
            },
            {
                32: 118,
                33: [
                    2,
                    62
                ],
                74: 119,
                75: [
                    1,
                    120
                ]
            },
            {
                33: [
                    2,
                    59
                ],
                65: [
                    2,
                    59
                ],
                72: [
                    2,
                    59
                ],
                75: [
                    2,
                    59
                ],
                80: [
                    2,
                    59
                ],
                81: [
                    2,
                    59
                ],
                82: [
                    2,
                    59
                ],
                83: [
                    2,
                    59
                ],
                84: [
                    2,
                    59
                ],
                85: [
                    2,
                    59
                ]
            },
            {
                33: [
                    2,
                    61
                ],
                75: [
                    2,
                    61
                ]
            },
            {
                33: [
                    2,
                    68
                ],
                37: 121,
                74: 122,
                75: [
                    1,
                    120
                ]
            },
            {
                33: [
                    2,
                    65
                ],
                65: [
                    2,
                    65
                ],
                72: [
                    2,
                    65
                ],
                75: [
                    2,
                    65
                ],
                80: [
                    2,
                    65
                ],
                81: [
                    2,
                    65
                ],
                82: [
                    2,
                    65
                ],
                83: [
                    2,
                    65
                ],
                84: [
                    2,
                    65
                ],
                85: [
                    2,
                    65
                ]
            },
            {
                33: [
                    2,
                    67
                ],
                75: [
                    2,
                    67
                ]
            },
            {
                23: [
                    1,
                    123
                ]
            },
            {
                23: [
                    2,
                    51
                ],
                65: [
                    2,
                    51
                ],
                72: [
                    2,
                    51
                ],
                80: [
                    2,
                    51
                ],
                81: [
                    2,
                    51
                ],
                82: [
                    2,
                    51
                ],
                83: [
                    2,
                    51
                ],
                84: [
                    2,
                    51
                ],
                85: [
                    2,
                    51
                ]
            },
            {
                23: [
                    2,
                    53
                ]
            },
            {
                33: [
                    1,
                    124
                ]
            },
            {
                33: [
                    2,
                    91
                ],
                65: [
                    2,
                    91
                ],
                72: [
                    2,
                    91
                ],
                80: [
                    2,
                    91
                ],
                81: [
                    2,
                    91
                ],
                82: [
                    2,
                    91
                ],
                83: [
                    2,
                    91
                ],
                84: [
                    2,
                    91
                ],
                85: [
                    2,
                    91
                ]
            },
            {
                33: [
                    2,
                    93
                ]
            },
            {
                5: [
                    2,
                    22
                ],
                14: [
                    2,
                    22
                ],
                15: [
                    2,
                    22
                ],
                19: [
                    2,
                    22
                ],
                29: [
                    2,
                    22
                ],
                34: [
                    2,
                    22
                ],
                39: [
                    2,
                    22
                ],
                44: [
                    2,
                    22
                ],
                47: [
                    2,
                    22
                ],
                48: [
                    2,
                    22
                ],
                51: [
                    2,
                    22
                ],
                55: [
                    2,
                    22
                ],
                60: [
                    2,
                    22
                ]
            },
            {
                23: [
                    2,
                    99
                ],
                33: [
                    2,
                    99
                ],
                54: [
                    2,
                    99
                ],
                68: [
                    2,
                    99
                ],
                72: [
                    2,
                    99
                ],
                75: [
                    2,
                    99
                ]
            },
            {
                73: [
                    1,
                    108
                ]
            },
            {
                20: 74,
                63: 125,
                64: 75,
                65: [
                    1,
                    43
                ],
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                5: [
                    2,
                    23
                ],
                14: [
                    2,
                    23
                ],
                15: [
                    2,
                    23
                ],
                19: [
                    2,
                    23
                ],
                29: [
                    2,
                    23
                ],
                34: [
                    2,
                    23
                ],
                39: [
                    2,
                    23
                ],
                44: [
                    2,
                    23
                ],
                47: [
                    2,
                    23
                ],
                48: [
                    2,
                    23
                ],
                51: [
                    2,
                    23
                ],
                55: [
                    2,
                    23
                ],
                60: [
                    2,
                    23
                ]
            },
            {
                47: [
                    2,
                    19
                ]
            },
            {
                47: [
                    2,
                    77
                ]
            },
            {
                20: 74,
                33: [
                    2,
                    72
                ],
                41: 126,
                63: 127,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 128,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                75: [
                    2,
                    72
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                5: [
                    2,
                    24
                ],
                14: [
                    2,
                    24
                ],
                15: [
                    2,
                    24
                ],
                19: [
                    2,
                    24
                ],
                29: [
                    2,
                    24
                ],
                34: [
                    2,
                    24
                ],
                39: [
                    2,
                    24
                ],
                44: [
                    2,
                    24
                ],
                47: [
                    2,
                    24
                ],
                48: [
                    2,
                    24
                ],
                51: [
                    2,
                    24
                ],
                55: [
                    2,
                    24
                ],
                60: [
                    2,
                    24
                ]
            },
            {
                68: [
                    1,
                    129
                ]
            },
            {
                65: [
                    2,
                    95
                ],
                68: [
                    2,
                    95
                ],
                72: [
                    2,
                    95
                ],
                80: [
                    2,
                    95
                ],
                81: [
                    2,
                    95
                ],
                82: [
                    2,
                    95
                ],
                83: [
                    2,
                    95
                ],
                84: [
                    2,
                    95
                ],
                85: [
                    2,
                    95
                ]
            },
            {
                68: [
                    2,
                    97
                ]
            },
            {
                5: [
                    2,
                    21
                ],
                14: [
                    2,
                    21
                ],
                15: [
                    2,
                    21
                ],
                19: [
                    2,
                    21
                ],
                29: [
                    2,
                    21
                ],
                34: [
                    2,
                    21
                ],
                39: [
                    2,
                    21
                ],
                44: [
                    2,
                    21
                ],
                47: [
                    2,
                    21
                ],
                48: [
                    2,
                    21
                ],
                51: [
                    2,
                    21
                ],
                55: [
                    2,
                    21
                ],
                60: [
                    2,
                    21
                ]
            },
            {
                33: [
                    1,
                    130
                ]
            },
            {
                33: [
                    2,
                    63
                ]
            },
            {
                72: [
                    1,
                    132
                ],
                76: 131
            },
            {
                33: [
                    1,
                    133
                ]
            },
            {
                33: [
                    2,
                    69
                ]
            },
            {
                15: [
                    2,
                    12
                ],
                18: [
                    2,
                    12
                ]
            },
            {
                14: [
                    2,
                    26
                ],
                15: [
                    2,
                    26
                ],
                19: [
                    2,
                    26
                ],
                29: [
                    2,
                    26
                ],
                34: [
                    2,
                    26
                ],
                47: [
                    2,
                    26
                ],
                48: [
                    2,
                    26
                ],
                51: [
                    2,
                    26
                ],
                55: [
                    2,
                    26
                ],
                60: [
                    2,
                    26
                ]
            },
            {
                23: [
                    2,
                    31
                ],
                33: [
                    2,
                    31
                ],
                54: [
                    2,
                    31
                ],
                68: [
                    2,
                    31
                ],
                72: [
                    2,
                    31
                ],
                75: [
                    2,
                    31
                ]
            },
            {
                33: [
                    2,
                    74
                ],
                42: 134,
                74: 135,
                75: [
                    1,
                    120
                ]
            },
            {
                33: [
                    2,
                    71
                ],
                65: [
                    2,
                    71
                ],
                72: [
                    2,
                    71
                ],
                75: [
                    2,
                    71
                ],
                80: [
                    2,
                    71
                ],
                81: [
                    2,
                    71
                ],
                82: [
                    2,
                    71
                ],
                83: [
                    2,
                    71
                ],
                84: [
                    2,
                    71
                ],
                85: [
                    2,
                    71
                ]
            },
            {
                33: [
                    2,
                    73
                ],
                75: [
                    2,
                    73
                ]
            },
            {
                23: [
                    2,
                    29
                ],
                33: [
                    2,
                    29
                ],
                54: [
                    2,
                    29
                ],
                65: [
                    2,
                    29
                ],
                68: [
                    2,
                    29
                ],
                72: [
                    2,
                    29
                ],
                75: [
                    2,
                    29
                ],
                80: [
                    2,
                    29
                ],
                81: [
                    2,
                    29
                ],
                82: [
                    2,
                    29
                ],
                83: [
                    2,
                    29
                ],
                84: [
                    2,
                    29
                ],
                85: [
                    2,
                    29
                ]
            },
            {
                14: [
                    2,
                    15
                ],
                15: [
                    2,
                    15
                ],
                19: [
                    2,
                    15
                ],
                29: [
                    2,
                    15
                ],
                34: [
                    2,
                    15
                ],
                39: [
                    2,
                    15
                ],
                44: [
                    2,
                    15
                ],
                47: [
                    2,
                    15
                ],
                48: [
                    2,
                    15
                ],
                51: [
                    2,
                    15
                ],
                55: [
                    2,
                    15
                ],
                60: [
                    2,
                    15
                ]
            },
            {
                72: [
                    1,
                    137
                ],
                77: [
                    1,
                    136
                ]
            },
            {
                72: [
                    2,
                    100
                ],
                77: [
                    2,
                    100
                ]
            },
            {
                14: [
                    2,
                    16
                ],
                15: [
                    2,
                    16
                ],
                19: [
                    2,
                    16
                ],
                29: [
                    2,
                    16
                ],
                34: [
                    2,
                    16
                ],
                44: [
                    2,
                    16
                ],
                47: [
                    2,
                    16
                ],
                48: [
                    2,
                    16
                ],
                51: [
                    2,
                    16
                ],
                55: [
                    2,
                    16
                ],
                60: [
                    2,
                    16
                ]
            },
            {
                33: [
                    1,
                    138
                ]
            },
            {
                33: [
                    2,
                    75
                ]
            },
            {
                33: [
                    2,
                    32
                ]
            },
            {
                72: [
                    2,
                    101
                ],
                77: [
                    2,
                    101
                ]
            },
            {
                14: [
                    2,
                    17
                ],
                15: [
                    2,
                    17
                ],
                19: [
                    2,
                    17
                ],
                29: [
                    2,
                    17
                ],
                34: [
                    2,
                    17
                ],
                39: [
                    2,
                    17
                ],
                44: [
                    2,
                    17
                ],
                47: [
                    2,
                    17
                ],
                48: [
                    2,
                    17
                ],
                51: [
                    2,
                    17
                ],
                55: [
                    2,
                    17
                ],
                60: [
                    2,
                    17
                ]
            }
        ],
        defaultActions: {
            4: [
                2,
                1
            ],
            54: [
                2,
                55
            ],
            56: [
                2,
                20
            ],
            60: [
                2,
                57
            ],
            73: [
                2,
                81
            ],
            82: [
                2,
                85
            ],
            86: [
                2,
                18
            ],
            90: [
                2,
                89
            ],
            101: [
                2,
                53
            ],
            104: [
                2,
                93
            ],
            110: [
                2,
                19
            ],
            111: [
                2,
                77
            ],
            116: [
                2,
                97
            ],
            119: [
                2,
                63
            ],
            122: [
                2,
                69
            ],
            135: [
                2,
                75
            ],
            136: [
                2,
                32
            ]
        },
        parseError: function parseError(str, hash) {
            throw new Error(str);
        },
        parse: function parse(input) {
            var self = this, stack = [
                0
            ], vstack = [
                null
            ], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            this.lexer.setInput(input);
            this.lexer.yy = this.yy;
            this.yy.lexer = this.lexer;
            this.yy.parser = this;
            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
            var yyloc = this.lexer.yylloc;
            lstack.push(yyloc);
            var ranges = this.lexer.options && this.lexer.options.ranges;
            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            function lex() {
                var token;
                token = self.lexer.lex() || 1;
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token;
            }
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while(true){
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) action = this.defaultActions[state];
                else {
                    if (symbol === null || typeof symbol == "undefined") symbol = lex();
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === "undefined" || !action.length || !action[0]) {
                    var errStr = "";
                    if (!recovering) {
                        expected = [];
                        for(p in table[state])if (this.terminals_[p] && p > 2) expected.push("'" + this.terminals_[p] + "'");
                        if (this.lexer.showPosition) errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                        else errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
                        this.parseError(errStr, {
                            text: this.lexer.match,
                            token: this.terminals_[symbol] || symbol,
                            line: this.lexer.yylineno,
                            loc: yyloc,
                            expected: expected
                        });
                    }
                }
                if (action[0] instanceof Array && action.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
                switch(action[0]){
                    case 1:
                        stack.push(symbol);
                        vstack.push(this.lexer.yytext);
                        lstack.push(this.lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = this.lexer.yyleng;
                            yytext = this.lexer.yytext;
                            yylineno = this.lexer.yylineno;
                            yyloc = this.lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) yyval._$.range = [
                            lstack[lstack.length - (len || 1)].range[0],
                            lstack[lstack.length - 1].range[1]
                        ];
                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
                        if (typeof r !== "undefined") return r;
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /* Jison generated lexer */ var lexer = function() {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) this.yy.parser.parseError(str, hash);
                else throw new Error(str);
            },
            setInput: function setInput(input) {
                this._input = input;
                this._more = this._less = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = "";
                this.conditionStack = [
                    "INITIAL"
                ];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) this.yylloc.range = [
                    0,
                    0
                ];
                this.offset = 0;
                return this;
            },
            input: function input() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else this.yylloc.last_column++;
                if (this.options.ranges) this.yylloc.range[1]++;
                this._input = this._input.slice(1);
                return ch;
            },
            unput: function unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };
                if (this.options.ranges) this.yylloc.range = [
                    r[0],
                    r[0] + this.yyleng - len
                ];
                return this;
            },
            more: function more() {
                this._more = true;
                return this;
            },
            less: function less(n) {
                this.unput(this.match.slice(n));
            },
            pastInput: function pastInput() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? "..." : "") + past.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
                var next = this.match;
                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                return (next.substr(0, 20) + (next.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            next: function next() {
                if (this.done) return this.EOF;
                if (!this._input) this.done = true;
                var token, match, tempMatch, index, col, lines;
                if (!this._more) {
                    this.yytext = "";
                    this.match = "";
                }
                var rules = this._currentRules();
                for(var i = 0; i < rules.length; i++){
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (!this.options.flex) break;
                    }
                }
                if (match) {
                    lines = match[0].match(/(?:\r\n?|\n).*/g);
                    if (lines) this.yylineno += lines.length;
                    this.yylloc = {
                        first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                    };
                    this.yytext += match[0];
                    this.match += match[0];
                    this.matches = match;
                    this.yyleng = this.yytext.length;
                    if (this.options.ranges) this.yylloc.range = [
                        this.offset,
                        this.offset += this.yyleng
                    ];
                    this._more = false;
                    this._input = this._input.slice(match[0].length);
                    this.matched += match[0];
                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
                    if (this.done && this._input) this.done = false;
                    if (token) return token;
                    else return;
                }
                if (this._input === "") return this.EOF;
                else return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
            },
            lex: function lex() {
                var r = this.next();
                if (typeof r !== "undefined") return r;
                else return this.lex();
            },
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            popState: function popState() {
                return this.conditionStack.pop();
            },
            _currentRules: function _currentRules() {
                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
            },
            topState: function topState() {
                return this.conditionStack[this.conditionStack.length - 2];
            },
            pushState: function begin(condition) {
                this.begin(condition);
            }
        };
        lexer.options = {};
        lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
            function strip(start, end) {
                return yy_.yytext = yy_.yytext.substring(start, yy_.yyleng - end + start);
            }
            var YYSTATE = YY_START;
            switch($avoiding_name_collisions){
                case 0:
                    if (yy_.yytext.slice(-2) === "\\\\") {
                        strip(0, 1);
                        this.begin("mu");
                    } else if (yy_.yytext.slice(-1) === "\\") {
                        strip(0, 1);
                        this.begin("emu");
                    } else this.begin("mu");
                    if (yy_.yytext) return 15;
                    break;
                case 1:
                    return 15;
                case 2:
                    this.popState();
                    return 15;
                case 3:
                    this.begin("raw");
                    return 15;
                case 4:
                    this.popState();
                    // Should be using `this.topState()` below, but it currently
                    // returns the second top instead of the first top. Opened an
                    // issue about it at https://github.com/zaach/jison/issues/291
                    if (this.conditionStack[this.conditionStack.length - 1] === "raw") return 15;
                    else {
                        strip(5, 9);
                        return "END_RAW_BLOCK";
                    }
                    break;
                case 5:
                    return 15;
                case 6:
                    this.popState();
                    return 14;
                case 7:
                    return 65;
                case 8:
                    return 68;
                case 9:
                    return 19;
                case 10:
                    this.popState();
                    this.begin("raw");
                    return 23;
                case 11:
                    return 55;
                case 12:
                    return 60;
                case 13:
                    return 29;
                case 14:
                    return 47;
                case 15:
                    this.popState();
                    return 44;
                case 16:
                    this.popState();
                    return 44;
                case 17:
                    return 34;
                case 18:
                    return 39;
                case 19:
                    return 51;
                case 20:
                    return 48;
                case 21:
                    this.unput(yy_.yytext);
                    this.popState();
                    this.begin("com");
                    break;
                case 22:
                    this.popState();
                    return 14;
                case 23:
                    return 48;
                case 24:
                    return 73;
                case 25:
                    return 72;
                case 26:
                    return 72;
                case 27:
                    return 87;
                case 28:
                    break;
                case 29:
                    this.popState();
                    return 54;
                case 30:
                    this.popState();
                    return 33;
                case 31:
                    yy_.yytext = strip(1, 2).replace(/\\"/g, '"');
                    return 80;
                case 32:
                    yy_.yytext = strip(1, 2).replace(/\\'/g, "'");
                    return 80;
                case 33:
                    return 85;
                case 34:
                    return 82;
                case 35:
                    return 82;
                case 36:
                    return 83;
                case 37:
                    return 84;
                case 38:
                    return 81;
                case 39:
                    return 75;
                case 40:
                    return 77;
                case 41:
                    return 72;
                case 42:
                    yy_.yytext = yy_.yytext.replace(/\\([\\\]])/g, "$1");
                    return 72;
                case 43:
                    return "INVALID";
                case 44:
                    return 5;
            }
        };
        lexer.rules = [
            /^(?:[^\x00]*?(?=(\{\{)))/,
            /^(?:[^\x00]+)/,
            /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
            /^(?:\{\{\{\{(?=[^\/]))/,
            /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
            /^(?:[^\x00]+?(?=(\{\{\{\{)))/,
            /^(?:[\s\S]*?--(~)?\}\})/,
            /^(?:\()/,
            /^(?:\))/,
            /^(?:\{\{\{\{)/,
            /^(?:\}\}\}\})/,
            /^(?:\{\{(~)?>)/,
            /^(?:\{\{(~)?#>)/,
            /^(?:\{\{(~)?#\*?)/,
            /^(?:\{\{(~)?\/)/,
            /^(?:\{\{(~)?\^\s*(~)?\}\})/,
            /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
            /^(?:\{\{(~)?\^)/,
            /^(?:\{\{(~)?\s*else\b)/,
            /^(?:\{\{(~)?\{)/,
            /^(?:\{\{(~)?&)/,
            /^(?:\{\{(~)?!--)/,
            /^(?:\{\{(~)?![\s\S]*?\}\})/,
            /^(?:\{\{(~)?\*?)/,
            /^(?:=)/,
            /^(?:\.\.)/,
            /^(?:\.(?=([=~}\s\/.)|])))/,
            /^(?:[\/.])/,
            /^(?:\s+)/,
            /^(?:\}(~)?\}\})/,
            /^(?:(~)?\}\})/,
            /^(?:"(\\["]|[^"])*")/,
            /^(?:'(\\[']|[^'])*')/,
            /^(?:@)/,
            /^(?:true(?=([~}\s)])))/,
            /^(?:false(?=([~}\s)])))/,
            /^(?:undefined(?=([~}\s)])))/,
            /^(?:null(?=([~}\s)])))/,
            /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
            /^(?:as\s+\|)/,
            /^(?:\|)/,
            /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
            /^(?:\[(\\\]|[^\]])*\])/,
            /^(?:.)/,
            /^(?:$)/
        ];
        lexer.conditions = {
            "mu": {
                "rules": [
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44
                ],
                "inclusive": false
            },
            "emu": {
                "rules": [
                    2
                ],
                "inclusive": false
            },
            "com": {
                "rules": [
                    6
                ],
                "inclusive": false
            },
            "raw": {
                "rules": [
                    3,
                    4,
                    5
                ],
                "inclusive": false
            },
            "INITIAL": {
                "rules": [
                    0,
                    1,
                    44
                ],
                "inclusive": true
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
module.exports["default"] = $4f7ca891fbeee017$var$handlebars;
module.exports = module.exports["default"];

});

parcelRegister("2ta45", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $1cc618e447a419cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $bCnBd = parcelRequire("bCnBd");
var $1cc618e447a419cf$var$_visitor2 = $1cc618e447a419cf$var$_interopRequireDefault($bCnBd);
function $1cc618e447a419cf$var$WhitespaceControl() {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    this.options = options;
}
$1cc618e447a419cf$var$WhitespaceControl.prototype = new $1cc618e447a419cf$var$_visitor2["default"]();
$1cc618e447a419cf$var$WhitespaceControl.prototype.Program = function(program) {
    var doStandalone = !this.options.ignoreStandalone;
    var isRoot = !this.isRootSeen;
    this.isRootSeen = true;
    var body = program.body;
    for(var i = 0, l = body.length; i < l; i++){
        var current = body[i], strip = this.accept(current);
        if (!strip) continue;
        var _isPrevWhitespace = $1cc618e447a419cf$var$isPrevWhitespace(body, i, isRoot), _isNextWhitespace = $1cc618e447a419cf$var$isNextWhitespace(body, i, isRoot), openStandalone = strip.openStandalone && _isPrevWhitespace, closeStandalone = strip.closeStandalone && _isNextWhitespace, inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;
        if (strip.close) $1cc618e447a419cf$var$omitRight(body, i, true);
        if (strip.open) $1cc618e447a419cf$var$omitLeft(body, i, true);
        if (doStandalone && inlineStandalone) {
            $1cc618e447a419cf$var$omitRight(body, i);
            if ($1cc618e447a419cf$var$omitLeft(body, i)) // If we are on a standalone node, save the indent info for partials
            {
                if (current.type === "PartialStatement") // Pull out the whitespace from the final line
                current.indent = /([ \t]+$)/.exec(body[i - 1].original)[1];
            }
        }
        if (doStandalone && openStandalone) {
            $1cc618e447a419cf$var$omitRight((current.program || current.inverse).body);
            // Strip out the previous content node if it's whitespace only
            $1cc618e447a419cf$var$omitLeft(body, i);
        }
        if (doStandalone && closeStandalone) {
            // Always strip the next node
            $1cc618e447a419cf$var$omitRight(body, i);
            $1cc618e447a419cf$var$omitLeft((current.inverse || current.program).body);
        }
    }
    return program;
};
$1cc618e447a419cf$var$WhitespaceControl.prototype.BlockStatement = $1cc618e447a419cf$var$WhitespaceControl.prototype.DecoratorBlock = $1cc618e447a419cf$var$WhitespaceControl.prototype.PartialBlockStatement = function(block) {
    this.accept(block.program);
    this.accept(block.inverse);
    // Find the inverse program that is involed with whitespace stripping.
    var program = block.program || block.inverse, inverse = block.program && block.inverse, firstInverse = inverse, lastInverse = inverse;
    if (inverse && inverse.chained) {
        firstInverse = inverse.body[0].program;
        // Walk the inverse chain to find the last inverse that is actually in the chain.
        while(lastInverse.chained)lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
    }
    var strip = {
        open: block.openStrip.open,
        close: block.closeStrip.close,
        // Determine the standalone candiacy. Basically flag our content as being possibly standalone
        // so our parent can determine if we actually are standalone
        openStandalone: $1cc618e447a419cf$var$isNextWhitespace(program.body),
        closeStandalone: $1cc618e447a419cf$var$isPrevWhitespace((firstInverse || program).body)
    };
    if (block.openStrip.close) $1cc618e447a419cf$var$omitRight(program.body, null, true);
    if (inverse) {
        var inverseStrip = block.inverseStrip;
        if (inverseStrip.open) $1cc618e447a419cf$var$omitLeft(program.body, null, true);
        if (inverseStrip.close) $1cc618e447a419cf$var$omitRight(firstInverse.body, null, true);
        if (block.closeStrip.open) $1cc618e447a419cf$var$omitLeft(lastInverse.body, null, true);
        // Find standalone else statments
        if (!this.options.ignoreStandalone && $1cc618e447a419cf$var$isPrevWhitespace(program.body) && $1cc618e447a419cf$var$isNextWhitespace(firstInverse.body)) {
            $1cc618e447a419cf$var$omitLeft(program.body);
            $1cc618e447a419cf$var$omitRight(firstInverse.body);
        }
    } else if (block.closeStrip.open) $1cc618e447a419cf$var$omitLeft(program.body, null, true);
    return strip;
};
$1cc618e447a419cf$var$WhitespaceControl.prototype.Decorator = $1cc618e447a419cf$var$WhitespaceControl.prototype.MustacheStatement = function(mustache) {
    return mustache.strip;
};
$1cc618e447a419cf$var$WhitespaceControl.prototype.PartialStatement = $1cc618e447a419cf$var$WhitespaceControl.prototype.CommentStatement = function(node) {
    /* istanbul ignore next */ var strip = node.strip || {};
    return {
        inlineStandalone: true,
        open: strip.open,
        close: strip.close
    };
};
function $1cc618e447a419cf$var$isPrevWhitespace(body, i, isRoot) {
    if (i === undefined) i = body.length;
    // Nodes that end with newlines are considered whitespace (but are special
    // cased for strip operations)
    var prev = body[i - 1], sibling = body[i - 2];
    if (!prev) return isRoot;
    if (prev.type === "ContentStatement") return (sibling || !isRoot ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(prev.original);
}
function $1cc618e447a419cf$var$isNextWhitespace(body, i, isRoot) {
    if (i === undefined) i = -1;
    var next = body[i + 1], sibling = body[i + 2];
    if (!next) return isRoot;
    if (next.type === "ContentStatement") return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
}
// Marks the node to the right of the position as omitted.
// I.e. {{foo}}' ' will mark the ' ' node as omitted.
//
// If i is undefined, then the first child will be marked as such.
//
// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
// content is met.
function $1cc618e447a419cf$var$omitRight(body, i, multiple) {
    var current = body[i == null ? 0 : i + 1];
    if (!current || current.type !== "ContentStatement" || !multiple && current.rightStripped) return;
    var original = current.value;
    current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, "");
    current.rightStripped = current.value !== original;
}
// Marks the node to the left of the position as omitted.
// I.e. ' '{{foo}} will mark the ' ' node as omitted.
//
// If i is undefined then the last child will be marked as such.
//
// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
// content is met.
function $1cc618e447a419cf$var$omitLeft(body, i, multiple) {
    var current = body[i == null ? body.length - 1 : i - 1];
    if (!current || current.type !== "ContentStatement" || !multiple && current.leftStripped) return;
    // We omit the last node if it's whitespace only and not preceded by a non-content node.
    var original = current.value;
    current.value = current.value.replace(multiple ? /\s+$/ : /[ \t]+$/, "");
    current.leftStripped = current.value !== original;
    return current.leftStripped;
}
module.exports["default"] = $1cc618e447a419cf$var$WhitespaceControl;
module.exports = module.exports["default"];

});
parcelRegister("bCnBd", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $87558c9d884ea22f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $2TDIg = parcelRequire("2TDIg");
var $87558c9d884ea22f$var$_exception2 = $87558c9d884ea22f$var$_interopRequireDefault($2TDIg);
function $87558c9d884ea22f$var$Visitor() {
    this.parents = [];
}
$87558c9d884ea22f$var$Visitor.prototype = {
    constructor: $87558c9d884ea22f$var$Visitor,
    mutating: false,
    // Visits a given value. If mutating, will replace the value if necessary.
    acceptKey: function acceptKey(node, name) {
        var value = this.accept(node[name]);
        if (this.mutating) {
            // Hacky sanity check: This may have a few false positives for type for the helper
            // methods but will generally do the right thing without a lot of overhead.
            if (value && !$87558c9d884ea22f$var$Visitor.prototype[value.type]) throw new $87558c9d884ea22f$var$_exception2["default"]('Unexpected node type "' + value.type + '" found when accepting ' + name + " on " + node.type);
            node[name] = value;
        }
    },
    // Performs an accept operation with added sanity check to ensure
    // required keys are not removed.
    acceptRequired: function acceptRequired(node, name) {
        this.acceptKey(node, name);
        if (!node[name]) throw new $87558c9d884ea22f$var$_exception2["default"](node.type + " requires " + name);
    },
    // Traverses a given array. If mutating, empty respnses will be removed
    // for child elements.
    acceptArray: function acceptArray(array) {
        for(var i = 0, l = array.length; i < l; i++){
            this.acceptKey(array, i);
            if (!array[i]) {
                array.splice(i, 1);
                i--;
                l--;
            }
        }
    },
    accept: function accept(object) {
        if (!object) return;
        /* istanbul ignore next: Sanity code */ if (!this[object.type]) throw new $87558c9d884ea22f$var$_exception2["default"]("Unknown type: " + object.type, object);
        if (this.current) this.parents.unshift(this.current);
        this.current = object;
        var ret = this[object.type](object);
        this.current = this.parents.shift();
        if (!this.mutating || ret) return ret;
        else if (ret !== false) return object;
    },
    Program: function Program(program) {
        this.acceptArray(program.body);
    },
    MustacheStatement: $87558c9d884ea22f$var$visitSubExpression,
    Decorator: $87558c9d884ea22f$var$visitSubExpression,
    BlockStatement: $87558c9d884ea22f$var$visitBlock,
    DecoratorBlock: $87558c9d884ea22f$var$visitBlock,
    PartialStatement: $87558c9d884ea22f$var$visitPartial,
    PartialBlockStatement: function PartialBlockStatement(partial) {
        $87558c9d884ea22f$var$visitPartial.call(this, partial);
        this.acceptKey(partial, "program");
    },
    ContentStatement: function ContentStatement() /* content */ {},
    CommentStatement: function CommentStatement() /* comment */ {},
    SubExpression: $87558c9d884ea22f$var$visitSubExpression,
    PathExpression: function PathExpression() /* path */ {},
    StringLiteral: function StringLiteral() /* string */ {},
    NumberLiteral: function NumberLiteral() /* number */ {},
    BooleanLiteral: function BooleanLiteral() /* bool */ {},
    UndefinedLiteral: function UndefinedLiteral() /* literal */ {},
    NullLiteral: function NullLiteral() /* literal */ {},
    Hash: function Hash(hash) {
        this.acceptArray(hash.pairs);
    },
    HashPair: function HashPair(pair) {
        this.acceptRequired(pair, "value");
    }
};
function $87558c9d884ea22f$var$visitSubExpression(mustache) {
    this.acceptRequired(mustache, "path");
    this.acceptArray(mustache.params);
    this.acceptKey(mustache, "hash");
}
function $87558c9d884ea22f$var$visitBlock(block) {
    $87558c9d884ea22f$var$visitSubExpression.call(this, block);
    this.acceptKey(block, "program");
    this.acceptKey(block, "inverse");
}
function $87558c9d884ea22f$var$visitPartial(partial) {
    this.acceptRequired(partial, "name");
    this.acceptArray(partial.params);
    this.acceptKey(partial, "hash");
}
module.exports["default"] = $87558c9d884ea22f$var$Visitor;
module.exports = module.exports["default"];

});


parcelRegister("jKdLQ", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $e5fcfec73990ab01$export$1e511d4a378977f5, (v) => $e5fcfec73990ab01$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "SourceLocation", () => $e5fcfec73990ab01$export$7387db7caf96fcdb, (v) => $e5fcfec73990ab01$export$7387db7caf96fcdb = v);
$parcel$export(module.exports, "id", () => $e5fcfec73990ab01$export$d560c7e4a29451c2, (v) => $e5fcfec73990ab01$export$d560c7e4a29451c2 = v);
$parcel$export(module.exports, "stripFlags", () => $e5fcfec73990ab01$export$a56883f706fd4153, (v) => $e5fcfec73990ab01$export$a56883f706fd4153 = v);
$parcel$export(module.exports, "stripComment", () => $e5fcfec73990ab01$export$b0ad15fcf54729ff, (v) => $e5fcfec73990ab01$export$b0ad15fcf54729ff = v);
$parcel$export(module.exports, "preparePath", () => $e5fcfec73990ab01$export$ea68d0dfa0ba072f, (v) => $e5fcfec73990ab01$export$ea68d0dfa0ba072f = v);
$parcel$export(module.exports, "prepareMustache", () => $e5fcfec73990ab01$export$6b8089a1dfd22498, (v) => $e5fcfec73990ab01$export$6b8089a1dfd22498 = v);
$parcel$export(module.exports, "prepareRawBlock", () => $e5fcfec73990ab01$export$c642052fcb02035b, (v) => $e5fcfec73990ab01$export$c642052fcb02035b = v);
$parcel$export(module.exports, "prepareBlock", () => $e5fcfec73990ab01$export$9814855d713f4497, (v) => $e5fcfec73990ab01$export$9814855d713f4497 = v);
$parcel$export(module.exports, "prepareProgram", () => $e5fcfec73990ab01$export$6e1c63ef90231a66, (v) => $e5fcfec73990ab01$export$6e1c63ef90231a66 = v);
$parcel$export(module.exports, "preparePartialBlock", () => $e5fcfec73990ab01$export$8b47bc71272f067a, (v) => $e5fcfec73990ab01$export$8b47bc71272f067a = v);
var $e5fcfec73990ab01$export$1e511d4a378977f5;
var $e5fcfec73990ab01$export$7387db7caf96fcdb;
var $e5fcfec73990ab01$export$d560c7e4a29451c2;
var $e5fcfec73990ab01$export$a56883f706fd4153;
var $e5fcfec73990ab01$export$b0ad15fcf54729ff;
var $e5fcfec73990ab01$export$ea68d0dfa0ba072f;
var $e5fcfec73990ab01$export$6b8089a1dfd22498;
var $e5fcfec73990ab01$export$c642052fcb02035b;
var $e5fcfec73990ab01$export$9814855d713f4497;
var $e5fcfec73990ab01$export$6e1c63ef90231a66;
var $e5fcfec73990ab01$export$8b47bc71272f067a;
"use strict";
$e5fcfec73990ab01$export$1e511d4a378977f5 = true;
$e5fcfec73990ab01$export$7387db7caf96fcdb = $e5fcfec73990ab01$var$SourceLocation;
$e5fcfec73990ab01$export$d560c7e4a29451c2 = $e5fcfec73990ab01$var$id;
$e5fcfec73990ab01$export$a56883f706fd4153 = $e5fcfec73990ab01$var$stripFlags;
$e5fcfec73990ab01$export$b0ad15fcf54729ff = $e5fcfec73990ab01$var$stripComment;
$e5fcfec73990ab01$export$ea68d0dfa0ba072f = $e5fcfec73990ab01$var$preparePath;
$e5fcfec73990ab01$export$6b8089a1dfd22498 = $e5fcfec73990ab01$var$prepareMustache;
$e5fcfec73990ab01$export$c642052fcb02035b = $e5fcfec73990ab01$var$prepareRawBlock;
$e5fcfec73990ab01$export$9814855d713f4497 = $e5fcfec73990ab01$var$prepareBlock;
$e5fcfec73990ab01$export$6e1c63ef90231a66 = $e5fcfec73990ab01$var$prepareProgram;
$e5fcfec73990ab01$export$8b47bc71272f067a = $e5fcfec73990ab01$var$preparePartialBlock;
// istanbul ignore next
function $e5fcfec73990ab01$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $2TDIg = parcelRequire("2TDIg");
var $e5fcfec73990ab01$var$_exception2 = $e5fcfec73990ab01$var$_interopRequireDefault($2TDIg);
function $e5fcfec73990ab01$var$validateClose(open, close) {
    close = close.path ? close.path.original : close;
    if (open.path.original !== close) {
        var errorNode = {
            loc: open.path.loc
        };
        throw new $e5fcfec73990ab01$var$_exception2["default"](open.path.original + " doesn't match " + close, errorNode);
    }
}
function $e5fcfec73990ab01$var$SourceLocation(source, locInfo) {
    this.source = source;
    this.start = {
        line: locInfo.first_line,
        column: locInfo.first_column
    };
    this.end = {
        line: locInfo.last_line,
        column: locInfo.last_column
    };
}
function $e5fcfec73990ab01$var$id(token) {
    if (/^\[.*\]$/.test(token)) return token.substring(1, token.length - 1);
    else return token;
}
function $e5fcfec73990ab01$var$stripFlags(open, close) {
    return {
        open: open.charAt(2) === "~",
        close: close.charAt(close.length - 3) === "~"
    };
}
function $e5fcfec73990ab01$var$stripComment(comment) {
    return comment.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
}
function $e5fcfec73990ab01$var$preparePath(data, parts, loc) {
    loc = this.locInfo(loc);
    var original = data ? "@" : "", dig = [], depth = 0;
    for(var i = 0, l = parts.length; i < l; i++){
        var part = parts[i].part, // If we have [] syntax then we do not treat path references as operators,
        // i.e. foo.[this] resolves to approximately context.foo['this']
        isLiteral = parts[i].original !== part;
        original += (parts[i].separator || "") + part;
        if (!isLiteral && (part === ".." || part === "." || part === "this")) {
            if (dig.length > 0) throw new $e5fcfec73990ab01$var$_exception2["default"]("Invalid path: " + original, {
                loc: loc
            });
            else if (part === "..") depth++;
        } else dig.push(part);
    }
    return {
        type: "PathExpression",
        data: data,
        depth: depth,
        parts: dig,
        original: original,
        loc: loc
    };
}
function $e5fcfec73990ab01$var$prepareMustache(path, params, hash, open, strip, locInfo) {
    // Must use charAt to support IE pre-10
    var escapeFlag = open.charAt(3) || open.charAt(2), escaped = escapeFlag !== "{" && escapeFlag !== "&";
    var decorator = /\*/.test(open);
    return {
        type: decorator ? "Decorator" : "MustacheStatement",
        path: path,
        params: params,
        hash: hash,
        escaped: escaped,
        strip: strip,
        loc: this.locInfo(locInfo)
    };
}
function $e5fcfec73990ab01$var$prepareRawBlock(openRawBlock, contents, close, locInfo) {
    $e5fcfec73990ab01$var$validateClose(openRawBlock, close);
    locInfo = this.locInfo(locInfo);
    var program = {
        type: "Program",
        body: contents,
        strip: {},
        loc: locInfo
    };
    return {
        type: "BlockStatement",
        path: openRawBlock.path,
        params: openRawBlock.params,
        hash: openRawBlock.hash,
        program: program,
        openStrip: {},
        inverseStrip: {},
        closeStrip: {},
        loc: locInfo
    };
}
function $e5fcfec73990ab01$var$prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
    if (close && close.path) $e5fcfec73990ab01$var$validateClose(openBlock, close);
    var decorator = /\*/.test(openBlock.open);
    program.blockParams = openBlock.blockParams;
    var inverse = undefined, inverseStrip = undefined;
    if (inverseAndProgram) {
        if (decorator) throw new $e5fcfec73990ab01$var$_exception2["default"]("Unexpected inverse block on decorator", inverseAndProgram);
        if (inverseAndProgram.chain) inverseAndProgram.program.body[0].closeStrip = close.strip;
        inverseStrip = inverseAndProgram.strip;
        inverse = inverseAndProgram.program;
    }
    if (inverted) {
        inverted = inverse;
        inverse = program;
        program = inverted;
    }
    return {
        type: decorator ? "DecoratorBlock" : "BlockStatement",
        path: openBlock.path,
        params: openBlock.params,
        hash: openBlock.hash,
        program: program,
        inverse: inverse,
        openStrip: openBlock.strip,
        inverseStrip: inverseStrip,
        closeStrip: close && close.strip,
        loc: this.locInfo(locInfo)
    };
}
function $e5fcfec73990ab01$var$prepareProgram(statements, loc) {
    if (!loc && statements.length) {
        var firstLoc = statements[0].loc, lastLoc = statements[statements.length - 1].loc;
        /* istanbul ignore else */ if (firstLoc && lastLoc) loc = {
            source: firstLoc.source,
            start: {
                line: firstLoc.start.line,
                column: firstLoc.start.column
            },
            end: {
                line: lastLoc.end.line,
                column: lastLoc.end.column
            }
        };
    }
    return {
        type: "Program",
        body: statements,
        strip: {},
        loc: loc
    };
}
function $e5fcfec73990ab01$var$preparePartialBlock(open, program, close, locInfo) {
    $e5fcfec73990ab01$var$validateClose(open, close);
    return {
        type: "PartialBlockStatement",
        name: open.path,
        params: open.params,
        hash: open.hash,
        program: program,
        openStrip: open.strip,
        closeStrip: close && close.strip,
        loc: this.locInfo(locInfo)
    };
}

});


parcelRegister("8at4e", function(module, exports) {

$parcel$export(module.exports, "Compiler", () => $5f25ce10aa04cdd3$export$3a6335acfcf707c9, (v) => $5f25ce10aa04cdd3$export$3a6335acfcf707c9 = v);
$parcel$export(module.exports, "precompile", () => $5f25ce10aa04cdd3$export$cfb9e0f1330f9bbd, (v) => $5f25ce10aa04cdd3$export$cfb9e0f1330f9bbd = v);
$parcel$export(module.exports, "compile", () => $5f25ce10aa04cdd3$export$ef7acd7185315e22, (v) => $5f25ce10aa04cdd3$export$ef7acd7185315e22 = v);
/* eslint-disable new-cap */ var $5f25ce10aa04cdd3$export$1e511d4a378977f5;
var $5f25ce10aa04cdd3$export$3a6335acfcf707c9;
var $5f25ce10aa04cdd3$export$cfb9e0f1330f9bbd;
var $5f25ce10aa04cdd3$export$ef7acd7185315e22;
"use strict";
$5f25ce10aa04cdd3$export$1e511d4a378977f5 = true;
$5f25ce10aa04cdd3$export$3a6335acfcf707c9 = $5f25ce10aa04cdd3$var$Compiler;
$5f25ce10aa04cdd3$export$cfb9e0f1330f9bbd = $5f25ce10aa04cdd3$var$precompile;
$5f25ce10aa04cdd3$export$ef7acd7185315e22 = $5f25ce10aa04cdd3$var$compile;
// istanbul ignore next
function $5f25ce10aa04cdd3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $2TDIg = parcelRequire("2TDIg");
var $5f25ce10aa04cdd3$var$_exception2 = $5f25ce10aa04cdd3$var$_interopRequireDefault($2TDIg);

var $lA5sn = parcelRequire("lA5sn");

var $f3bnw = parcelRequire("f3bnw");
var $5f25ce10aa04cdd3$var$_ast2 = $5f25ce10aa04cdd3$var$_interopRequireDefault($f3bnw);
var $5f25ce10aa04cdd3$var$slice = [].slice;
function $5f25ce10aa04cdd3$var$Compiler() {}
// the foundHelper register will disambiguate helper lookup from finding a
// function in a context. This is necessary for mustache compatibility, which
// requires that context functions in blocks are evaluated by blockHelperMissing,
// and then proceed as if the resulting value was provided to blockHelperMissing.
$5f25ce10aa04cdd3$var$Compiler.prototype = {
    compiler: $5f25ce10aa04cdd3$var$Compiler,
    equals: function equals(other) {
        var len = this.opcodes.length;
        if (other.opcodes.length !== len) return false;
        for(var i = 0; i < len; i++){
            var opcode = this.opcodes[i], otherOpcode = other.opcodes[i];
            if (opcode.opcode !== otherOpcode.opcode || !$5f25ce10aa04cdd3$var$argEquals(opcode.args, otherOpcode.args)) return false;
        }
        // We know that length is the same between the two arrays because they are directly tied
        // to the opcode behavior above.
        len = this.children.length;
        for(var i = 0; i < len; i++){
            if (!this.children[i].equals(other.children[i])) return false;
        }
        return true;
    },
    guid: 0,
    compile: function compile(program, options) {
        this.sourceNode = [];
        this.opcodes = [];
        this.children = [];
        this.options = options;
        this.stringParams = options.stringParams;
        this.trackIds = options.trackIds;
        options.blockParams = options.blockParams || [];
        options.knownHelpers = $lA5sn.extend(Object.create(null), {
            helperMissing: true,
            blockHelperMissing: true,
            each: true,
            "if": true,
            unless: true,
            "with": true,
            log: true,
            lookup: true
        }, options.knownHelpers);
        return this.accept(program);
    },
    compileProgram: function compileProgram(program) {
        var childCompiler = new this.compiler(), // eslint-disable-line new-cap
        result = childCompiler.compile(program, this.options), guid = this.guid++;
        this.usePartial = this.usePartial || result.usePartial;
        this.children[guid] = result;
        this.useDepths = this.useDepths || result.useDepths;
        return guid;
    },
    accept: function accept(node) {
        /* istanbul ignore next: Sanity code */ if (!this[node.type]) throw new $5f25ce10aa04cdd3$var$_exception2["default"]("Unknown type: " + node.type, node);
        this.sourceNode.unshift(node);
        var ret = this[node.type](node);
        this.sourceNode.shift();
        return ret;
    },
    Program: function Program(program) {
        this.options.blockParams.unshift(program.blockParams);
        var body = program.body, bodyLength = body.length;
        for(var i = 0; i < bodyLength; i++)this.accept(body[i]);
        this.options.blockParams.shift();
        this.isSimple = bodyLength === 1;
        this.blockParams = program.blockParams ? program.blockParams.length : 0;
        return this;
    },
    BlockStatement: function BlockStatement(block) {
        $5f25ce10aa04cdd3$var$transformLiteralToPath(block);
        var program = block.program, inverse = block.inverse;
        program = program && this.compileProgram(program);
        inverse = inverse && this.compileProgram(inverse);
        var type = this.classifySexpr(block);
        if (type === "helper") this.helperSexpr(block, program, inverse);
        else if (type === "simple") {
            this.simpleSexpr(block);
            // now that the simple mustache is resolved, we need to
            // evaluate it by executing `blockHelperMissing`
            this.opcode("pushProgram", program);
            this.opcode("pushProgram", inverse);
            this.opcode("emptyHash");
            this.opcode("blockValue", block.path.original);
        } else {
            this.ambiguousSexpr(block, program, inverse);
            // now that the simple mustache is resolved, we need to
            // evaluate it by executing `blockHelperMissing`
            this.opcode("pushProgram", program);
            this.opcode("pushProgram", inverse);
            this.opcode("emptyHash");
            this.opcode("ambiguousBlockValue");
        }
        this.opcode("append");
    },
    DecoratorBlock: function DecoratorBlock(decorator) {
        var program = decorator.program && this.compileProgram(decorator.program);
        var params = this.setupFullMustacheParams(decorator, program, undefined), path = decorator.path;
        this.useDecorators = true;
        this.opcode("registerDecorator", params.length, path.original);
    },
    PartialStatement: function PartialStatement(partial) {
        this.usePartial = true;
        var program = partial.program;
        if (program) program = this.compileProgram(partial.program);
        var params = partial.params;
        if (params.length > 1) throw new $5f25ce10aa04cdd3$var$_exception2["default"]("Unsupported number of partial arguments: " + params.length, partial);
        else if (!params.length) {
            if (this.options.explicitPartialContext) this.opcode("pushLiteral", "undefined");
            else params.push({
                type: "PathExpression",
                parts: [],
                depth: 0
            });
        }
        var partialName = partial.name.original, isDynamic = partial.name.type === "SubExpression";
        if (isDynamic) this.accept(partial.name);
        this.setupFullMustacheParams(partial, program, undefined, true);
        var indent = partial.indent || "";
        if (this.options.preventIndent && indent) {
            this.opcode("appendContent", indent);
            indent = "";
        }
        this.opcode("invokePartial", isDynamic, partialName, indent);
        this.opcode("append");
    },
    PartialBlockStatement: function PartialBlockStatement(partialBlock) {
        this.PartialStatement(partialBlock);
    },
    MustacheStatement: function MustacheStatement(mustache) {
        this.SubExpression(mustache);
        if (mustache.escaped && !this.options.noEscape) this.opcode("appendEscaped");
        else this.opcode("append");
    },
    Decorator: function Decorator(decorator) {
        this.DecoratorBlock(decorator);
    },
    ContentStatement: function ContentStatement(content) {
        if (content.value) this.opcode("appendContent", content.value);
    },
    CommentStatement: function CommentStatement() {},
    SubExpression: function SubExpression(sexpr) {
        $5f25ce10aa04cdd3$var$transformLiteralToPath(sexpr);
        var type = this.classifySexpr(sexpr);
        if (type === "simple") this.simpleSexpr(sexpr);
        else if (type === "helper") this.helperSexpr(sexpr);
        else this.ambiguousSexpr(sexpr);
    },
    ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
        var path = sexpr.path, name = path.parts[0], isBlock = program != null || inverse != null;
        this.opcode("getContext", path.depth);
        this.opcode("pushProgram", program);
        this.opcode("pushProgram", inverse);
        path.strict = true;
        this.accept(path);
        this.opcode("invokeAmbiguous", name, isBlock);
    },
    simpleSexpr: function simpleSexpr(sexpr) {
        var path = sexpr.path;
        path.strict = true;
        this.accept(path);
        this.opcode("resolvePossibleLambda");
    },
    helperSexpr: function helperSexpr(sexpr, program, inverse) {
        var params = this.setupFullMustacheParams(sexpr, program, inverse), path = sexpr.path, name = path.parts[0];
        if (this.options.knownHelpers[name]) this.opcode("invokeKnownHelper", params.length, name);
        else if (this.options.knownHelpersOnly) throw new $5f25ce10aa04cdd3$var$_exception2["default"]("You specified knownHelpersOnly, but used the unknown helper " + name, sexpr);
        else {
            path.strict = true;
            path.falsy = true;
            this.accept(path);
            this.opcode("invokeHelper", params.length, path.original, $5f25ce10aa04cdd3$var$_ast2["default"].helpers.simpleId(path));
        }
    },
    PathExpression: function PathExpression(path) {
        this.addDepth(path.depth);
        this.opcode("getContext", path.depth);
        var name = path.parts[0], scoped = $5f25ce10aa04cdd3$var$_ast2["default"].helpers.scopedId(path), blockParamId = !path.depth && !scoped && this.blockParamIndex(name);
        if (blockParamId) this.opcode("lookupBlockParam", blockParamId, path.parts);
        else if (!name) // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
        this.opcode("pushContext");
        else if (path.data) {
            this.options.data = true;
            this.opcode("lookupData", path.depth, path.parts, path.strict);
        } else this.opcode("lookupOnContext", path.parts, path.falsy, path.strict, scoped);
    },
    StringLiteral: function StringLiteral(string) {
        this.opcode("pushString", string.value);
    },
    NumberLiteral: function NumberLiteral(number) {
        this.opcode("pushLiteral", number.value);
    },
    BooleanLiteral: function BooleanLiteral(bool) {
        this.opcode("pushLiteral", bool.value);
    },
    UndefinedLiteral: function UndefinedLiteral() {
        this.opcode("pushLiteral", "undefined");
    },
    NullLiteral: function NullLiteral() {
        this.opcode("pushLiteral", "null");
    },
    Hash: function Hash(hash) {
        var pairs = hash.pairs, i = 0, l = pairs.length;
        this.opcode("pushHash");
        for(; i < l; i++)this.pushParam(pairs[i].value);
        while(i--)this.opcode("assignToHash", pairs[i].key);
        this.opcode("popHash");
    },
    // HELPERS
    opcode: function opcode(name) {
        this.opcodes.push({
            opcode: name,
            args: $5f25ce10aa04cdd3$var$slice.call(arguments, 1),
            loc: this.sourceNode[0].loc
        });
    },
    addDepth: function addDepth(depth) {
        if (!depth) return;
        this.useDepths = true;
    },
    classifySexpr: function classifySexpr(sexpr) {
        var isSimple = $5f25ce10aa04cdd3$var$_ast2["default"].helpers.simpleId(sexpr.path);
        var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]);
        // a mustache is an eligible helper if:
        // * its id is simple (a single part, not `this` or `..`)
        var isHelper = !isBlockParam && $5f25ce10aa04cdd3$var$_ast2["default"].helpers.helperExpression(sexpr);
        // if a mustache is an eligible helper but not a definite
        // helper, it is ambiguous, and will be resolved in a later
        // pass or at runtime.
        var isEligible = !isBlockParam && (isHelper || isSimple);
        // if ambiguous, we can possibly resolve the ambiguity now
        // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
        if (isEligible && !isHelper) {
            var _name = sexpr.path.parts[0], options = this.options;
            if (options.knownHelpers[_name]) isHelper = true;
            else if (options.knownHelpersOnly) isEligible = false;
        }
        if (isHelper) return "helper";
        else if (isEligible) return "ambiguous";
        else return "simple";
    },
    pushParams: function pushParams(params) {
        for(var i = 0, l = params.length; i < l; i++)this.pushParam(params[i]);
    },
    pushParam: function pushParam(val) {
        var value = val.value != null ? val.value : val.original || "";
        if (this.stringParams) {
            if (value.replace) value = value.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".");
            if (val.depth) this.addDepth(val.depth);
            this.opcode("getContext", val.depth || 0);
            this.opcode("pushStringParam", value, val.type);
            if (val.type === "SubExpression") // SubExpressions get evaluated and passed in
            // in string params mode.
            this.accept(val);
        } else {
            if (this.trackIds) {
                var blockParamIndex = undefined;
                if (val.parts && !$5f25ce10aa04cdd3$var$_ast2["default"].helpers.scopedId(val) && !val.depth) blockParamIndex = this.blockParamIndex(val.parts[0]);
                if (blockParamIndex) {
                    var blockParamChild = val.parts.slice(1).join(".");
                    this.opcode("pushId", "BlockParam", blockParamIndex, blockParamChild);
                } else {
                    value = val.original || value;
                    if (value.replace) value = value.replace(/^this(?:\.|$)/, "").replace(/^\.\//, "").replace(/^\.$/, "");
                    this.opcode("pushId", val.type, value);
                }
            }
            this.accept(val);
        }
    },
    setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
        var params = sexpr.params;
        this.pushParams(params);
        this.opcode("pushProgram", program);
        this.opcode("pushProgram", inverse);
        if (sexpr.hash) this.accept(sexpr.hash);
        else this.opcode("emptyHash", omitEmpty);
        return params;
    },
    blockParamIndex: function blockParamIndex(name) {
        for(var depth = 0, len = this.options.blockParams.length; depth < len; depth++){
            var blockParams = this.options.blockParams[depth], param = blockParams && $lA5sn.indexOf(blockParams, name);
            if (blockParams && param >= 0) return [
                depth,
                param
            ];
        }
    }
};
function $5f25ce10aa04cdd3$var$precompile(input, options, env) {
    if (input == null || typeof input !== "string" && input.type !== "Program") throw new $5f25ce10aa04cdd3$var$_exception2["default"]("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + input);
    options = options || {};
    if (!("data" in options)) options.data = true;
    if (options.compat) options.useDepths = true;
    var ast = env.parse(input, options), environment = new env.Compiler().compile(ast, options);
    return new env.JavaScriptCompiler().compile(environment, options);
}
function $5f25ce10aa04cdd3$var$compile(input, options, env) {
    if (options === undefined) options = {};
    if (input == null || typeof input !== "string" && input.type !== "Program") throw new $5f25ce10aa04cdd3$var$_exception2["default"]("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + input);
    options = $lA5sn.extend({}, options);
    if (!("data" in options)) options.data = true;
    if (options.compat) options.useDepths = true;
    var compiled = undefined;
    function compileInput() {
        var ast = env.parse(input, options), environment = new env.Compiler().compile(ast, options), templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
        return env.template(templateSpec);
    }
    // Template is only compiled on first use and cached after that point.
    function ret(context, execOptions) {
        if (!compiled) compiled = compileInput();
        return compiled.call(this, context, execOptions);
    }
    ret._setup = function(setupOptions) {
        if (!compiled) compiled = compileInput();
        return compiled._setup(setupOptions);
    };
    ret._child = function(i, data, blockParams, depths) {
        if (!compiled) compiled = compileInput();
        return compiled._child(i, data, blockParams, depths);
    };
    return ret;
}
function $5f25ce10aa04cdd3$var$argEquals(a, b) {
    if (a === b) return true;
    if ($lA5sn.isArray(a) && $lA5sn.isArray(b) && a.length === b.length) {
        for(var i = 0; i < a.length; i++){
            if (!$5f25ce10aa04cdd3$var$argEquals(a[i], b[i])) return false;
        }
        return true;
    }
}
function $5f25ce10aa04cdd3$var$transformLiteralToPath(sexpr) {
    if (!sexpr.path.parts) {
        var literal = sexpr.path;
        // Casting to string here to make false and 0 literal values play nicely with the rest
        // of the system.
        sexpr.path = {
            type: "PathExpression",
            data: false,
            depth: 0,
            parts: [
                literal.original + ""
            ],
            original: literal.original + "",
            loc: literal.loc
        };
    }
}

});

parcelRegister("12tfC", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $0c1caaf853316a84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $aohyl = parcelRequire("aohyl");

var $2TDIg = parcelRequire("2TDIg");
var $0c1caaf853316a84$var$_exception2 = $0c1caaf853316a84$var$_interopRequireDefault($2TDIg);

var $lA5sn = parcelRequire("lA5sn");

var $m9DmI = parcelRequire("m9DmI");
var $0c1caaf853316a84$var$_codeGen2 = $0c1caaf853316a84$var$_interopRequireDefault($m9DmI);
function $0c1caaf853316a84$var$Literal(value) {
    this.value = value;
}
function $0c1caaf853316a84$var$JavaScriptCompiler() {}
$0c1caaf853316a84$var$JavaScriptCompiler.prototype = {
    // PUBLIC API: You can override these methods in a subclass to provide
    // alternative compiled forms for name lookup and buffering semantics
    nameLookup: function nameLookup(parent, name /*,  type */ ) {
        return this.internalNameLookup(parent, name);
    },
    depthedLookup: function depthedLookup(name) {
        return [
            this.aliasable("container.lookup"),
            "(depths, ",
            JSON.stringify(name),
            ")"
        ];
    },
    compilerInfo: function compilerInfo() {
        var revision = $aohyl.COMPILER_REVISION, versions = $aohyl.REVISION_CHANGES[revision];
        return [
            revision,
            versions
        ];
    },
    appendToBuffer: function appendToBuffer(source, location, explicit) {
        // Force a source as this simplifies the merge logic.
        if (!$lA5sn.isArray(source)) source = [
            source
        ];
        source = this.source.wrap(source, location);
        if (this.environment.isSimple) return [
            "return ",
            source,
            ";"
        ];
        else if (explicit) // This is a case where the buffer operation occurs as a child of another
        // construct, generally braces. We have to explicitly output these buffer
        // operations to ensure that the emitted code goes in the correct location.
        return [
            "buffer += ",
            source,
            ";"
        ];
        else {
            source.appendToBuffer = true;
            return source;
        }
    },
    initializeBuffer: function initializeBuffer() {
        return this.quotedString("");
    },
    // END PUBLIC API
    internalNameLookup: function internalNameLookup(parent, name) {
        this.lookupPropertyFunctionIsUsed = true;
        return [
            "lookupProperty(",
            parent,
            ",",
            JSON.stringify(name),
            ")"
        ];
    },
    lookupPropertyFunctionIsUsed: false,
    compile: function compile(environment, options, context, asObject) {
        this.environment = environment;
        this.options = options;
        this.stringParams = this.options.stringParams;
        this.trackIds = this.options.trackIds;
        this.precompile = !asObject;
        this.name = this.environment.name;
        this.isChild = !!context;
        this.context = context || {
            decorators: [],
            programs: [],
            environments: []
        };
        this.preamble();
        this.stackSlot = 0;
        this.stackVars = [];
        this.aliases = {};
        this.registers = {
            list: []
        };
        this.hashes = [];
        this.compileStack = [];
        this.inlineStack = [];
        this.blockParams = [];
        this.compileChildren(environment, options);
        this.useDepths = this.useDepths || environment.useDepths || environment.useDecorators || this.options.compat;
        this.useBlockParams = this.useBlockParams || environment.useBlockParams;
        var opcodes = environment.opcodes, opcode = undefined, firstLoc = undefined, i = undefined, l = undefined;
        for(i = 0, l = opcodes.length; i < l; i++){
            opcode = opcodes[i];
            this.source.currentLocation = opcode.loc;
            firstLoc = firstLoc || opcode.loc;
            this[opcode.opcode].apply(this, opcode.args);
        }
        // Flush any trailing content that might be pending.
        this.source.currentLocation = firstLoc;
        this.pushSource("");
        /* istanbul ignore next */ if (this.stackSlot || this.inlineStack.length || this.compileStack.length) throw new $0c1caaf853316a84$var$_exception2["default"]("Compile completed with content left on stack");
        if (!this.decorators.isEmpty()) {
            this.useDecorators = true;
            this.decorators.prepend([
                "var decorators = container.decorators, ",
                this.lookupPropertyFunctionVarDeclaration(),
                ";\n"
            ]);
            this.decorators.push("return fn;");
            if (asObject) this.decorators = Function.apply(this, [
                "fn",
                "props",
                "container",
                "depth0",
                "data",
                "blockParams",
                "depths",
                this.decorators.merge()
            ]);
            else {
                this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n");
                this.decorators.push("}\n");
                this.decorators = this.decorators.merge();
            }
        } else this.decorators = undefined;
        var fn = this.createFunctionContext(asObject);
        if (!this.isChild) {
            var ret = {
                compiler: this.compilerInfo(),
                main: fn
            };
            if (this.decorators) {
                ret.main_d = this.decorators; // eslint-disable-line camelcase
                ret.useDecorators = true;
            }
            var _context = this.context;
            var programs = _context.programs;
            var decorators = _context.decorators;
            for(i = 0, l = programs.length; i < l; i++)if (programs[i]) {
                ret[i] = programs[i];
                if (decorators[i]) {
                    ret[i + "_d"] = decorators[i];
                    ret.useDecorators = true;
                }
            }
            if (this.environment.usePartial) ret.usePartial = true;
            if (this.options.data) ret.useData = true;
            if (this.useDepths) ret.useDepths = true;
            if (this.useBlockParams) ret.useBlockParams = true;
            if (this.options.compat) ret.compat = true;
            if (!asObject) {
                ret.compiler = JSON.stringify(ret.compiler);
                this.source.currentLocation = {
                    start: {
                        line: 1,
                        column: 0
                    }
                };
                ret = this.objectLiteral(ret);
                if (options.srcName) {
                    ret = ret.toStringWithSourceMap({
                        file: options.destName
                    });
                    ret.map = ret.map && ret.map.toString();
                } else ret = ret.toString();
            } else ret.compilerOptions = this.options;
            return ret;
        } else return fn;
    },
    preamble: function preamble() {
        // track the last context pushed into place to allow skipping the
        // getContext opcode when it would be a noop
        this.lastContext = 0;
        this.source = new $0c1caaf853316a84$var$_codeGen2["default"](this.options.srcName);
        this.decorators = new $0c1caaf853316a84$var$_codeGen2["default"](this.options.srcName);
    },
    createFunctionContext: function createFunctionContext(asObject) {
        // istanbul ignore next
        var _this = this;
        var varDeclarations = "";
        var locals = this.stackVars.concat(this.registers.list);
        if (locals.length > 0) varDeclarations += ", " + locals.join(", ");
        // Generate minimizer alias mappings
        //
        // When using true SourceNodes, this will update all references to the given alias
        // as the source nodes are reused in situ. For the non-source node compilation mode,
        // aliases will not be used, but this case is already being run on the client and
        // we aren't concern about minimizing the template size.
        var aliasCount = 0;
        Object.keys(this.aliases).forEach(function(alias) {
            var node = _this.aliases[alias];
            if (node.children && node.referenceCount > 1) {
                varDeclarations += ", alias" + ++aliasCount + "=" + alias;
                node.children[0] = "alias" + aliasCount;
            }
        });
        if (this.lookupPropertyFunctionIsUsed) varDeclarations += ", " + this.lookupPropertyFunctionVarDeclaration();
        var params = [
            "container",
            "depth0",
            "helpers",
            "partials",
            "data"
        ];
        if (this.useBlockParams || this.useDepths) params.push("blockParams");
        if (this.useDepths) params.push("depths");
        // Perform a second pass over the output to merge content when possible
        var source = this.mergeSource(varDeclarations);
        if (asObject) {
            params.push(source);
            return Function.apply(this, params);
        } else return this.source.wrap([
            "function(",
            params.join(","),
            ") {\n  ",
            source,
            "}"
        ]);
    },
    mergeSource: function mergeSource(varDeclarations) {
        var isSimple = this.environment.isSimple, appendOnly = !this.forceBuffer, appendFirst = undefined, sourceSeen = undefined, bufferStart = undefined, bufferEnd = undefined;
        this.source.each(function(line) {
            if (line.appendToBuffer) {
                if (bufferStart) line.prepend("  + ");
                else bufferStart = line;
                bufferEnd = line;
            } else {
                if (bufferStart) {
                    if (!sourceSeen) appendFirst = true;
                    else bufferStart.prepend("buffer += ");
                    bufferEnd.add(";");
                    bufferStart = bufferEnd = undefined;
                }
                sourceSeen = true;
                if (!isSimple) appendOnly = false;
            }
        });
        if (appendOnly) {
            if (bufferStart) {
                bufferStart.prepend("return ");
                bufferEnd.add(";");
            } else if (!sourceSeen) this.source.push('return "";');
        } else {
            varDeclarations += ", buffer = " + (appendFirst ? "" : this.initializeBuffer());
            if (bufferStart) {
                bufferStart.prepend("return buffer + ");
                bufferEnd.add(";");
            } else this.source.push("return buffer;");
        }
        if (varDeclarations) this.source.prepend("var " + varDeclarations.substring(2) + (appendFirst ? "" : ";\n"));
        return this.source.merge();
    },
    lookupPropertyFunctionVarDeclaration: function lookupPropertyFunctionVarDeclaration() {
        return "\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim();
    },
    // [blockValue]
    //
    // On stack, before: hash, inverse, program, value
    // On stack, after: return value of blockHelperMissing
    //
    // The purpose of this opcode is to take a block of the form
    // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
    // replace it on the stack with the result of properly
    // invoking blockHelperMissing.
    blockValue: function blockValue(name) {
        var blockHelperMissing = this.aliasable("container.hooks.blockHelperMissing"), params = [
            this.contextName(0)
        ];
        this.setupHelperArgs(name, 0, params);
        var blockName = this.popStack();
        params.splice(1, 0, blockName);
        this.push(this.source.functionCall(blockHelperMissing, "call", params));
    },
    // [ambiguousBlockValue]
    //
    // On stack, before: hash, inverse, program, value
    // Compiler value, before: lastHelper=value of last found helper, if any
    // On stack, after, if no lastHelper: same as [blockValue]
    // On stack, after, if lastHelper: value
    ambiguousBlockValue: function ambiguousBlockValue() {
        // We're being a bit cheeky and reusing the options value from the prior exec
        var blockHelperMissing = this.aliasable("container.hooks.blockHelperMissing"), params = [
            this.contextName(0)
        ];
        this.setupHelperArgs("", 0, params, true);
        this.flushInline();
        var current = this.topStack();
        params.splice(1, 0, current);
        this.pushSource([
            "if (!",
            this.lastHelper,
            ") { ",
            current,
            " = ",
            this.source.functionCall(blockHelperMissing, "call", params),
            "}"
        ]);
    },
    // [appendContent]
    //
    // On stack, before: ...
    // On stack, after: ...
    //
    // Appends the string value of `content` to the current buffer
    appendContent: function appendContent(content) {
        if (this.pendingContent) content = this.pendingContent + content;
        else this.pendingLocation = this.source.currentLocation;
        this.pendingContent = content;
    },
    // [append]
    //
    // On stack, before: value, ...
    // On stack, after: ...
    //
    // Coerces `value` to a String and appends it to the current buffer.
    //
    // If `value` is truthy, or 0, it is coerced into a string and appended
    // Otherwise, the empty string is appended
    append: function append() {
        if (this.isInline()) {
            this.replaceStack(function(current) {
                return [
                    " != null ? ",
                    current,
                    ' : ""'
                ];
            });
            this.pushSource(this.appendToBuffer(this.popStack()));
        } else {
            var local = this.popStack();
            this.pushSource([
                "if (",
                local,
                " != null) { ",
                this.appendToBuffer(local, undefined, true),
                " }"
            ]);
            if (this.environment.isSimple) this.pushSource([
                "else { ",
                this.appendToBuffer("''", undefined, true),
                " }"
            ]);
        }
    },
    // [appendEscaped]
    //
    // On stack, before: value, ...
    // On stack, after: ...
    //
    // Escape `value` and append it to the buffer
    appendEscaped: function appendEscaped() {
        this.pushSource(this.appendToBuffer([
            this.aliasable("container.escapeExpression"),
            "(",
            this.popStack(),
            ")"
        ]));
    },
    // [getContext]
    //
    // On stack, before: ...
    // On stack, after: ...
    // Compiler value, after: lastContext=depth
    //
    // Set the value of the `lastContext` compiler value to the depth
    getContext: function getContext(depth) {
        this.lastContext = depth;
    },
    // [pushContext]
    //
    // On stack, before: ...
    // On stack, after: currentContext, ...
    //
    // Pushes the value of the current context onto the stack.
    pushContext: function pushContext() {
        this.pushStackLiteral(this.contextName(this.lastContext));
    },
    // [lookupOnContext]
    //
    // On stack, before: ...
    // On stack, after: currentContext[name], ...
    //
    // Looks up the value of `name` on the current context and pushes
    // it onto the stack.
    lookupOnContext: function lookupOnContext(parts, falsy, strict, scoped) {
        var i = 0;
        if (!scoped && this.options.compat && !this.lastContext) // The depthed query is expected to handle the undefined logic for the root level that
        // is implemented below, so we evaluate that directly in compat mode
        this.push(this.depthedLookup(parts[i++]));
        else this.pushContext();
        this.resolvePath("context", parts, i, falsy, strict);
    },
    // [lookupBlockParam]
    //
    // On stack, before: ...
    // On stack, after: blockParam[name], ...
    //
    // Looks up the value of `parts` on the given block param and pushes
    // it onto the stack.
    lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
        this.useBlockParams = true;
        this.push([
            "blockParams[",
            blockParamId[0],
            "][",
            blockParamId[1],
            "]"
        ]);
        this.resolvePath("context", parts, 1);
    },
    // [lookupData]
    //
    // On stack, before: ...
    // On stack, after: data, ...
    //
    // Push the data lookup operator
    lookupData: function lookupData(depth, parts, strict) {
        if (!depth) this.pushStackLiteral("data");
        else this.pushStackLiteral("container.data(data, " + depth + ")");
        this.resolvePath("data", parts, 0, true, strict);
    },
    resolvePath: function resolvePath(type, parts, i, falsy, strict) {
        // istanbul ignore next
        var _this2 = this;
        if (this.options.strict || this.options.assumeObjects) {
            this.push($0c1caaf853316a84$var$strictLookup(this.options.strict && strict, this, parts, type));
            return;
        }
        var len = parts.length;
        for(; i < len; i++)/* eslint-disable no-loop-func */ this.replaceStack(function(current) {
            var lookup = _this2.nameLookup(current, parts[i], type);
            // We want to ensure that zero and false are handled properly if the context (falsy flag)
            // needs to have the special handling for these values.
            if (!falsy) return [
                " != null ? ",
                lookup,
                " : ",
                current
            ];
            else // Otherwise we can use generic falsy handling
            return [
                " && ",
                lookup
            ];
        });
    },
    // [resolvePossibleLambda]
    //
    // On stack, before: value, ...
    // On stack, after: resolved value, ...
    //
    // If the `value` is a lambda, replace it on the stack by
    // the return value of the lambda
    resolvePossibleLambda: function resolvePossibleLambda() {
        this.push([
            this.aliasable("container.lambda"),
            "(",
            this.popStack(),
            ", ",
            this.contextName(0),
            ")"
        ]);
    },
    // [pushStringParam]
    //
    // On stack, before: ...
    // On stack, after: string, currentContext, ...
    //
    // This opcode is designed for use in string mode, which
    // provides the string value of a parameter along with its
    // depth rather than resolving it immediately.
    pushStringParam: function pushStringParam(string, type) {
        this.pushContext();
        this.pushString(type);
        // If it's a subexpression, the string result
        // will be pushed after this opcode.
        if (type !== "SubExpression") {
            if (typeof string === "string") this.pushString(string);
            else this.pushStackLiteral(string);
        }
    },
    emptyHash: function emptyHash(omitEmpty) {
        if (this.trackIds) this.push("{}"); // hashIds
        if (this.stringParams) {
            this.push("{}"); // hashContexts
            this.push("{}"); // hashTypes
        }
        this.pushStackLiteral(omitEmpty ? "undefined" : "{}");
    },
    pushHash: function pushHash() {
        if (this.hash) this.hashes.push(this.hash);
        this.hash = {
            values: {},
            types: [],
            contexts: [],
            ids: []
        };
    },
    popHash: function popHash() {
        var hash = this.hash;
        this.hash = this.hashes.pop();
        if (this.trackIds) this.push(this.objectLiteral(hash.ids));
        if (this.stringParams) {
            this.push(this.objectLiteral(hash.contexts));
            this.push(this.objectLiteral(hash.types));
        }
        this.push(this.objectLiteral(hash.values));
    },
    // [pushString]
    //
    // On stack, before: ...
    // On stack, after: quotedString(string), ...
    //
    // Push a quoted version of `string` onto the stack
    pushString: function pushString(string) {
        this.pushStackLiteral(this.quotedString(string));
    },
    // [pushLiteral]
    //
    // On stack, before: ...
    // On stack, after: value, ...
    //
    // Pushes a value onto the stack. This operation prevents
    // the compiler from creating a temporary variable to hold
    // it.
    pushLiteral: function pushLiteral(value) {
        this.pushStackLiteral(value);
    },
    // [pushProgram]
    //
    // On stack, before: ...
    // On stack, after: program(guid), ...
    //
    // Push a program expression onto the stack. This takes
    // a compile-time guid and converts it into a runtime-accessible
    // expression.
    pushProgram: function pushProgram(guid) {
        if (guid != null) this.pushStackLiteral(this.programExpression(guid));
        else this.pushStackLiteral(null);
    },
    // [registerDecorator]
    //
    // On stack, before: hash, program, params..., ...
    // On stack, after: ...
    //
    // Pops off the decorator's parameters, invokes the decorator,
    // and inserts the decorator into the decorators list.
    registerDecorator: function registerDecorator(paramSize, name) {
        var foundDecorator = this.nameLookup("decorators", name, "decorator"), options = this.setupHelperArgs(name, paramSize);
        this.decorators.push([
            "fn = ",
            this.decorators.functionCall(foundDecorator, "", [
                "fn",
                "props",
                "container",
                options
            ]),
            " || fn;"
        ]);
    },
    // [invokeHelper]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of helper invocation
    //
    // Pops off the helper's parameters, invokes the helper,
    // and pushes the helper's return value onto the stack.
    //
    // If the helper is not found, `helperMissing` is called.
    invokeHelper: function invokeHelper(paramSize, name, isSimple) {
        var nonHelper = this.popStack(), helper = this.setupHelper(paramSize, name);
        var possibleFunctionCalls = [];
        if (isSimple) // direct call to helper
        possibleFunctionCalls.push(helper.name);
        // call a function from the input object
        possibleFunctionCalls.push(nonHelper);
        if (!this.options.strict) possibleFunctionCalls.push(this.aliasable("container.hooks.helperMissing"));
        var functionLookupCode = [
            "(",
            this.itemsSeparatedBy(possibleFunctionCalls, "||"),
            ")"
        ];
        var functionCall = this.source.functionCall(functionLookupCode, "call", helper.callParams);
        this.push(functionCall);
    },
    itemsSeparatedBy: function itemsSeparatedBy(items, separator) {
        var result = [];
        result.push(items[0]);
        for(var i = 1; i < items.length; i++)result.push(separator, items[i]);
        return result;
    },
    // [invokeKnownHelper]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of helper invocation
    //
    // This operation is used when the helper is known to exist,
    // so a `helperMissing` fallback is not required.
    invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
        var helper = this.setupHelper(paramSize, name);
        this.push(this.source.functionCall(helper.name, "call", helper.callParams));
    },
    // [invokeAmbiguous]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of disambiguation
    //
    // This operation is used when an expression like `{{foo}}`
    // is provided, but we don't know at compile-time whether it
    // is a helper or a path.
    //
    // This operation emits more code than the other options,
    // and can be avoided by passing the `knownHelpers` and
    // `knownHelpersOnly` flags at compile-time.
    invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
        this.useRegister("helper");
        var nonHelper = this.popStack();
        this.emptyHash();
        var helper = this.setupHelper(0, name, helperCall);
        var helperName = this.lastHelper = this.nameLookup("helpers", name, "helper");
        var lookup = [
            "(",
            "(helper = ",
            helperName,
            " || ",
            nonHelper,
            ")"
        ];
        if (!this.options.strict) {
            lookup[0] = "(helper = ";
            lookup.push(" != null ? helper : ", this.aliasable("container.hooks.helperMissing"));
        }
        this.push([
            "(",
            lookup,
            helper.paramsInit ? [
                "),(",
                helper.paramsInit
            ] : [],
            "),",
            "(typeof helper === ",
            this.aliasable('"function"'),
            " ? ",
            this.source.functionCall("helper", "call", helper.callParams),
            " : helper))"
        ]);
    },
    // [invokePartial]
    //
    // On stack, before: context, ...
    // On stack after: result of partial invocation
    //
    // This operation pops off a context, invokes a partial with that context,
    // and pushes the result of the invocation back.
    invokePartial: function invokePartial(isDynamic, name, indent) {
        var params = [], options = this.setupParams(name, 1, params);
        if (isDynamic) {
            name = this.popStack();
            delete options.name;
        }
        if (indent) options.indent = JSON.stringify(indent);
        options.helpers = "helpers";
        options.partials = "partials";
        options.decorators = "container.decorators";
        if (!isDynamic) params.unshift(this.nameLookup("partials", name, "partial"));
        else params.unshift(name);
        if (this.options.compat) options.depths = "depths";
        options = this.objectLiteral(options);
        params.push(options);
        this.push(this.source.functionCall("container.invokePartial", "", params));
    },
    // [assignToHash]
    //
    // On stack, before: value, ..., hash, ...
    // On stack, after: ..., hash, ...
    //
    // Pops a value off the stack and assigns it to the current hash
    assignToHash: function assignToHash(key) {
        var value = this.popStack(), context = undefined, type = undefined, id = undefined;
        if (this.trackIds) id = this.popStack();
        if (this.stringParams) {
            type = this.popStack();
            context = this.popStack();
        }
        var hash = this.hash;
        if (context) hash.contexts[key] = context;
        if (type) hash.types[key] = type;
        if (id) hash.ids[key] = id;
        hash.values[key] = value;
    },
    pushId: function pushId(type, name, child) {
        if (type === "BlockParam") this.pushStackLiteral("blockParams[" + name[0] + "].path[" + name[1] + "]" + (child ? " + " + JSON.stringify("." + child) : ""));
        else if (type === "PathExpression") this.pushString(name);
        else if (type === "SubExpression") this.pushStackLiteral("true");
        else this.pushStackLiteral("null");
    },
    // HELPERS
    compiler: $0c1caaf853316a84$var$JavaScriptCompiler,
    compileChildren: function compileChildren(environment, options) {
        var children = environment.children, child = undefined, compiler = undefined;
        for(var i = 0, l = children.length; i < l; i++){
            child = children[i];
            compiler = new this.compiler(); // eslint-disable-line new-cap
            var existing = this.matchExistingProgram(child);
            if (existing == null) {
                this.context.programs.push(""); // Placeholder to prevent name conflicts for nested children
                var index = this.context.programs.length;
                child.index = index;
                child.name = "program" + index;
                this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
                this.context.decorators[index] = compiler.decorators;
                this.context.environments[index] = child;
                this.useDepths = this.useDepths || compiler.useDepths;
                this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
                child.useDepths = this.useDepths;
                child.useBlockParams = this.useBlockParams;
            } else {
                child.index = existing.index;
                child.name = "program" + existing.index;
                this.useDepths = this.useDepths || existing.useDepths;
                this.useBlockParams = this.useBlockParams || existing.useBlockParams;
            }
        }
    },
    matchExistingProgram: function matchExistingProgram(child) {
        for(var i = 0, len = this.context.environments.length; i < len; i++){
            var environment = this.context.environments[i];
            if (environment && environment.equals(child)) return environment;
        }
    },
    programExpression: function programExpression(guid) {
        var child = this.environment.children[guid], programParams = [
            child.index,
            "data",
            child.blockParams
        ];
        if (this.useBlockParams || this.useDepths) programParams.push("blockParams");
        if (this.useDepths) programParams.push("depths");
        return "container.program(" + programParams.join(", ") + ")";
    },
    useRegister: function useRegister(name) {
        if (!this.registers[name]) {
            this.registers[name] = true;
            this.registers.list.push(name);
        }
    },
    push: function push(expr) {
        if (!(expr instanceof $0c1caaf853316a84$var$Literal)) expr = this.source.wrap(expr);
        this.inlineStack.push(expr);
        return expr;
    },
    pushStackLiteral: function pushStackLiteral(item) {
        this.push(new $0c1caaf853316a84$var$Literal(item));
    },
    pushSource: function pushSource(source) {
        if (this.pendingContent) {
            this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
            this.pendingContent = undefined;
        }
        if (source) this.source.push(source);
    },
    replaceStack: function replaceStack(callback) {
        var prefix = [
            "("
        ], stack = undefined, createdStack = undefined, usedLiteral = undefined;
        /* istanbul ignore next */ if (!this.isInline()) throw new $0c1caaf853316a84$var$_exception2["default"]("replaceStack on non-inline");
        // We want to merge the inline statement into the replacement statement via ','
        var top = this.popStack(true);
        if (top instanceof $0c1caaf853316a84$var$Literal) {
            // Literals do not need to be inlined
            stack = [
                top.value
            ];
            prefix = [
                "(",
                stack
            ];
            usedLiteral = true;
        } else {
            // Get or create the current stack name for use by the inline
            createdStack = true;
            var _name = this.incrStack();
            prefix = [
                "((",
                this.push(_name),
                " = ",
                top,
                ")"
            ];
            stack = this.topStack();
        }
        var item = callback.call(this, stack);
        if (!usedLiteral) this.popStack();
        if (createdStack) this.stackSlot--;
        this.push(prefix.concat(item, ")"));
    },
    incrStack: function incrStack() {
        this.stackSlot++;
        if (this.stackSlot > this.stackVars.length) this.stackVars.push("stack" + this.stackSlot);
        return this.topStackName();
    },
    topStackName: function topStackName() {
        return "stack" + this.stackSlot;
    },
    flushInline: function flushInline() {
        var inlineStack = this.inlineStack;
        this.inlineStack = [];
        for(var i = 0, len = inlineStack.length; i < len; i++){
            var entry = inlineStack[i];
            /* istanbul ignore if */ if (entry instanceof $0c1caaf853316a84$var$Literal) this.compileStack.push(entry);
            else {
                var stack = this.incrStack();
                this.pushSource([
                    stack,
                    " = ",
                    entry,
                    ";"
                ]);
                this.compileStack.push(stack);
            }
        }
    },
    isInline: function isInline() {
        return this.inlineStack.length;
    },
    popStack: function popStack(wrapped) {
        var inline = this.isInline(), item = (inline ? this.inlineStack : this.compileStack).pop();
        if (!wrapped && item instanceof $0c1caaf853316a84$var$Literal) return item.value;
        else {
            if (!inline) {
                /* istanbul ignore next */ if (!this.stackSlot) throw new $0c1caaf853316a84$var$_exception2["default"]("Invalid stack pop");
                this.stackSlot--;
            }
            return item;
        }
    },
    topStack: function topStack() {
        var stack = this.isInline() ? this.inlineStack : this.compileStack, item = stack[stack.length - 1];
        /* istanbul ignore if */ if (item instanceof $0c1caaf853316a84$var$Literal) return item.value;
        else return item;
    },
    contextName: function contextName(context) {
        if (this.useDepths && context) return "depths[" + context + "]";
        else return "depth" + context;
    },
    quotedString: function quotedString(str) {
        return this.source.quotedString(str);
    },
    objectLiteral: function objectLiteral(obj) {
        return this.source.objectLiteral(obj);
    },
    aliasable: function aliasable(name) {
        var ret = this.aliases[name];
        if (ret) {
            ret.referenceCount++;
            return ret;
        }
        ret = this.aliases[name] = this.source.wrap(name);
        ret.aliasable = true;
        ret.referenceCount = 1;
        return ret;
    },
    setupHelper: function setupHelper(paramSize, name, blockHelper) {
        var params = [], paramsInit = this.setupHelperArgs(name, paramSize, params, blockHelper);
        var foundHelper = this.nameLookup("helpers", name, "helper"), callContext = this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})");
        return {
            params: params,
            paramsInit: paramsInit,
            name: foundHelper,
            callParams: [
                callContext
            ].concat(params)
        };
    },
    setupParams: function setupParams(helper, paramSize, params) {
        var options = {}, contexts = [], types = [], ids = [], objectArgs = !params, param = undefined;
        if (objectArgs) params = [];
        options.name = this.quotedString(helper);
        options.hash = this.popStack();
        if (this.trackIds) options.hashIds = this.popStack();
        if (this.stringParams) {
            options.hashTypes = this.popStack();
            options.hashContexts = this.popStack();
        }
        var inverse = this.popStack(), program = this.popStack();
        // Avoid setting fn and inverse if neither are set. This allows
        // helpers to do a check for `if (options.fn)`
        if (program || inverse) {
            options.fn = program || "container.noop";
            options.inverse = inverse || "container.noop";
        }
        // The parameters go on to the stack in order (making sure that they are evaluated in order)
        // so we need to pop them off the stack in reverse order
        var i = paramSize;
        while(i--){
            param = this.popStack();
            params[i] = param;
            if (this.trackIds) ids[i] = this.popStack();
            if (this.stringParams) {
                types[i] = this.popStack();
                contexts[i] = this.popStack();
            }
        }
        if (objectArgs) options.args = this.source.generateArray(params);
        if (this.trackIds) options.ids = this.source.generateArray(ids);
        if (this.stringParams) {
            options.types = this.source.generateArray(types);
            options.contexts = this.source.generateArray(contexts);
        }
        if (this.options.data) options.data = "data";
        if (this.useBlockParams) options.blockParams = "blockParams";
        return options;
    },
    setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
        var options = this.setupParams(helper, paramSize, params);
        options.loc = JSON.stringify(this.source.currentLocation);
        options = this.objectLiteral(options);
        if (useRegister) {
            this.useRegister("options");
            params.push("options");
            return [
                "options=",
                options
            ];
        } else if (params) {
            params.push(options);
            return "";
        } else return options;
    }
};
(function() {
    var reservedWords = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" ");
    var compilerWords = $0c1caaf853316a84$var$JavaScriptCompiler.RESERVED_WORDS = {};
    for(var i = 0, l = reservedWords.length; i < l; i++)compilerWords[reservedWords[i]] = true;
})();
/**
 * @deprecated May be removed in the next major version
 */ $0c1caaf853316a84$var$JavaScriptCompiler.isValidJavaScriptVariableName = function(name) {
    return !$0c1caaf853316a84$var$JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
};
function $0c1caaf853316a84$var$strictLookup(requireTerminal, compiler, parts, type) {
    var stack = compiler.popStack(), i = 0, len = parts.length;
    if (requireTerminal) len--;
    for(; i < len; i++)stack = compiler.nameLookup(stack, parts[i], type);
    if (requireTerminal) return [
        compiler.aliasable("container.strict"),
        "(",
        stack,
        ", ",
        compiler.quotedString(parts[i]),
        ", ",
        JSON.stringify(compiler.source.currentLocation),
        " )"
    ];
    else return stack;
}
module.exports["default"] = $0c1caaf853316a84$var$JavaScriptCompiler;
module.exports = module.exports["default"];

});
parcelRegister("m9DmI", function(module, exports) {
/* global define */ "use strict";
module.exports.__esModule = true;

var $lA5sn = parcelRequire("lA5sn");
var $0429874917356f75$var$SourceNode = undefined;

try {
    /* istanbul ignore next */ if (typeof define !== "function" || !define.amd) {
        // We don't support this in AMD environments. For these environments, we asusme that
        // they are running on the browser and thus have no need for the source-map library.
        var $0429874917356f75$var$SourceMap = (parcelRequire("4HlCJ"));
        $0429874917356f75$var$SourceNode = $0429874917356f75$var$SourceMap.SourceNode;
    }
} catch (err) {}
/* NOP */ /* istanbul ignore if: tested but not covered in istanbul due to dist build  */ if (!$0429874917356f75$var$SourceNode) {
    $0429874917356f75$var$SourceNode = function(line, column, srcFile, chunks) {
        this.src = "";
        if (chunks) this.add(chunks);
    };
    /* istanbul ignore next */ $0429874917356f75$var$SourceNode.prototype = {
        add: function add(chunks) {
            if ($lA5sn.isArray(chunks)) chunks = chunks.join("");
            this.src += chunks;
        },
        prepend: function prepend(chunks) {
            if ($lA5sn.isArray(chunks)) chunks = chunks.join("");
            this.src = chunks + this.src;
        },
        toStringWithSourceMap: function toStringWithSourceMap() {
            return {
                code: this.toString()
            };
        },
        toString: function toString() {
            return this.src;
        }
    };
}
function $0429874917356f75$var$castChunk(chunk, codeGen, loc) {
    if ($lA5sn.isArray(chunk)) {
        var ret = [];
        for(var i = 0, len = chunk.length; i < len; i++)ret.push(codeGen.wrap(chunk[i], loc));
        return ret;
    } else if (typeof chunk === "boolean" || typeof chunk === "number") // Handle primitives that the SourceNode will throw up on
    return chunk + "";
    return chunk;
}
function $0429874917356f75$var$CodeGen(srcFile) {
    this.srcFile = srcFile;
    this.source = [];
}
$0429874917356f75$var$CodeGen.prototype = {
    isEmpty: function isEmpty() {
        return !this.source.length;
    },
    prepend: function prepend(source, loc) {
        this.source.unshift(this.wrap(source, loc));
    },
    push: function push(source, loc) {
        this.source.push(this.wrap(source, loc));
    },
    merge: function merge() {
        var source = this.empty();
        this.each(function(line) {
            source.add([
                "  ",
                line,
                "\n"
            ]);
        });
        return source;
    },
    each: function each(iter) {
        for(var i = 0, len = this.source.length; i < len; i++)iter(this.source[i]);
    },
    empty: function empty() {
        var loc = this.currentLocation || {
            start: {}
        };
        return new $0429874917356f75$var$SourceNode(loc.start.line, loc.start.column, this.srcFile);
    },
    wrap: function wrap(chunk) {
        var loc = arguments.length <= 1 || arguments[1] === undefined ? this.currentLocation || {
            start: {}
        } : arguments[1];
        if (chunk instanceof $0429874917356f75$var$SourceNode) return chunk;
        chunk = $0429874917356f75$var$castChunk(chunk, this, loc);
        return new $0429874917356f75$var$SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
    },
    functionCall: function functionCall(fn, type, params) {
        params = this.generateList(params);
        return this.wrap([
            fn,
            type ? "." + type + "(" : "(",
            params,
            ")"
        ]);
    },
    quotedString: function quotedString(str) {
        return '"' + (str + "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028") // Per Ecma-262 7.3 + 7.8.4
        .replace(/\u2029/g, "\\u2029") + '"';
    },
    objectLiteral: function objectLiteral(obj) {
        // istanbul ignore next
        var _this = this;
        var pairs = [];
        Object.keys(obj).forEach(function(key) {
            var value = $0429874917356f75$var$castChunk(obj[key], _this);
            if (value !== "undefined") pairs.push([
                _this.quotedString(key),
                ":",
                value
            ]);
        });
        var ret = this.generateList(pairs);
        ret.prepend("{");
        ret.add("}");
        return ret;
    },
    generateList: function generateList(entries) {
        var ret = this.empty();
        for(var i = 0, len = entries.length; i < len; i++){
            if (i) ret.add(",");
            ret.add($0429874917356f75$var$castChunk(entries[i], this));
        }
        return ret;
    },
    generateArray: function generateArray(entries) {
        var ret = this.generateList(entries);
        ret.prepend("[");
        ret.add("]");
        return ret;
    }
};
module.exports["default"] = $0429874917356f75$var$CodeGen;
module.exports = module.exports["default"];

});
parcelRegister("4HlCJ", function(module, exports) {

$parcel$export(module.exports, "SourceMapGenerator", () => $36bbf39a2e31027e$export$4d99f7c30e854ff, (v) => $36bbf39a2e31027e$export$4d99f7c30e854ff = v);
$parcel$export(module.exports, "SourceMapConsumer", () => $36bbf39a2e31027e$export$194e92554d04abdd, (v) => $36bbf39a2e31027e$export$194e92554d04abdd = v);
$parcel$export(module.exports, "SourceNode", () => $36bbf39a2e31027e$export$7e987e8f375d24c2, (v) => $36bbf39a2e31027e$export$7e987e8f375d24c2 = v);
/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $36bbf39a2e31027e$export$4d99f7c30e854ff;
var $36bbf39a2e31027e$export$194e92554d04abdd;
var $36bbf39a2e31027e$export$7e987e8f375d24c2;

$36bbf39a2e31027e$export$4d99f7c30e854ff = (parcelRequire("2Nrdb")).SourceMapGenerator;

$36bbf39a2e31027e$export$194e92554d04abdd = (parcelRequire("cKYfc")).SourceMapConsumer;

$36bbf39a2e31027e$export$7e987e8f375d24c2 = (parcelRequire("cLVN7")).SourceNode;

});
parcelRegister("2Nrdb", function(module, exports) {

$parcel$export(module.exports, "SourceMapGenerator", () => $2095440aca8a34b2$export$4d99f7c30e854ff, (v) => $2095440aca8a34b2$export$4d99f7c30e854ff = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $2095440aca8a34b2$export$4d99f7c30e854ff;

var $1vhVH = parcelRequire("1vhVH");

var $5YHdY = parcelRequire("5YHdY");

var $lY08F = parcelRequire("lY08F");
var $2095440aca8a34b2$require$ArraySet = $lY08F.ArraySet;

var $e4QkW = parcelRequire("e4QkW");
var $2095440aca8a34b2$require$MappingList = $e4QkW.MappingList;
/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */ function $2095440aca8a34b2$var$SourceMapGenerator(aArgs) {
    if (!aArgs) aArgs = {};
    this._file = $5YHdY.getArg(aArgs, "file", null);
    this._sourceRoot = $5YHdY.getArg(aArgs, "sourceRoot", null);
    this._skipValidation = $5YHdY.getArg(aArgs, "skipValidation", false);
    this._sources = new $2095440aca8a34b2$require$ArraySet();
    this._names = new $2095440aca8a34b2$require$ArraySet();
    this._mappings = new $2095440aca8a34b2$require$MappingList();
    this._sourcesContents = null;
}
$2095440aca8a34b2$var$SourceMapGenerator.prototype._version = 3;
/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */ $2095440aca8a34b2$var$SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new $2095440aca8a34b2$var$SourceMapGenerator({
        file: aSourceMapConsumer.file,
        sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function(mapping) {
        var newMapping = {
            generated: {
                line: mapping.generatedLine,
                column: mapping.generatedColumn
            }
        };
        if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) newMapping.source = $5YHdY.relative(sourceRoot, newMapping.source);
            newMapping.original = {
                line: mapping.originalLine,
                column: mapping.originalColumn
            };
            if (mapping.name != null) newMapping.name = mapping.name;
        }
        generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var sourceRelative = sourceFile;
        if (sourceRoot !== null) sourceRelative = $5YHdY.relative(sourceRoot, sourceFile);
        if (!generator._sources.has(sourceRelative)) generator._sources.add(sourceRelative);
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) generator.setSourceContent(sourceFile, content);
    });
    return generator;
};
/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */ $2095440aca8a34b2$var$SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
    var generated = $5YHdY.getArg(aArgs, "generated");
    var original = $5YHdY.getArg(aArgs, "original", null);
    var source = $5YHdY.getArg(aArgs, "source", null);
    var name = $5YHdY.getArg(aArgs, "name", null);
    if (!this._skipValidation) this._validateMapping(generated, original, source, name);
    if (source != null) {
        source = String(source);
        if (!this._sources.has(source)) this._sources.add(source);
    }
    if (name != null) {
        name = String(name);
        if (!this._names.has(name)) this._names.add(name);
    }
    this._mappings.add({
        generatedLine: generated.line,
        generatedColumn: generated.column,
        originalLine: original != null && original.line,
        originalColumn: original != null && original.column,
        source: source,
        name: name
    });
};
/**
 * Set the source content for a source file.
 */ $2095440aca8a34b2$var$SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) source = $5YHdY.relative(this._sourceRoot, source);
    if (aSourceContent != null) {
        // Add the source content to the _sourcesContents map.
        // Create a new _sourcesContents map if the property is null.
        if (!this._sourcesContents) this._sourcesContents = Object.create(null);
        this._sourcesContents[$5YHdY.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
        // Remove the source file from the _sourcesContents map.
        // If the _sourcesContents map is empty, set the property to null.
        delete this._sourcesContents[$5YHdY.toSetString(source)];
        if (Object.keys(this._sourcesContents).length === 0) this._sourcesContents = null;
    }
};
/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */ $2095440aca8a34b2$var$SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
        if (aSourceMapConsumer.file == null) throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');
        sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) sourceFile = $5YHdY.relative(sourceRoot, sourceFile);
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new $2095440aca8a34b2$require$ArraySet();
    var newNames = new $2095440aca8a34b2$require$ArraySet();
    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function(mapping) {
        if (mapping.source === sourceFile && mapping.originalLine != null) {
            // Check if it can be mapped by the source map, then update the mapping.
            var original = aSourceMapConsumer.originalPositionFor({
                line: mapping.originalLine,
                column: mapping.originalColumn
            });
            if (original.source != null) {
                // Copy mapping
                mapping.source = original.source;
                if (aSourceMapPath != null) mapping.source = $5YHdY.join(aSourceMapPath, mapping.source);
                if (sourceRoot != null) mapping.source = $5YHdY.relative(sourceRoot, mapping.source);
                mapping.originalLine = original.line;
                mapping.originalColumn = original.column;
                if (original.name != null) mapping.name = original.name;
            }
        }
        var source = mapping.source;
        if (source != null && !newSources.has(source)) newSources.add(source);
        var name = mapping.name;
        if (name != null && !newNames.has(name)) newNames.add(name);
    }, this);
    this._sources = newSources;
    this._names = newNames;
    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aSourceMapPath != null) sourceFile = $5YHdY.join(aSourceMapPath, sourceFile);
            if (sourceRoot != null) sourceFile = $5YHdY.relative(sourceRoot, sourceFile);
            this.setSourceContent(sourceFile, content);
        }
    }, this);
};
/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */ $2095440aca8a34b2$var$SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== "number" && typeof aOriginal.column !== "number") throw new Error("original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.");
    if (aGenerated && "line" in aGenerated && "column" in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) // Case 1.
    return;
    else if (aGenerated && "line" in aGenerated && "column" in aGenerated && aOriginal && "line" in aOriginal && "column" in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) // Cases 2 and 3.
    return;
    else throw new Error("Invalid mapping: " + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
    }));
};
/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */ $2095440aca8a34b2$var$SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = "";
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;
    var mappings = this._mappings.toArray();
    for(var i = 0, len = mappings.length; i < len; i++){
        mapping = mappings[i];
        next = "";
        if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while(mapping.generatedLine !== previousGeneratedLine){
                next += ";";
                previousGeneratedLine++;
            }
        } else if (i > 0) {
            if (!$5YHdY.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) continue;
            next += ",";
        }
        next += $1vhVH.encode(mapping.generatedColumn - previousGeneratedColumn);
        previousGeneratedColumn = mapping.generatedColumn;
        if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += $1vhVH.encode(sourceIdx - previousSource);
            previousSource = sourceIdx;
            // lines are stored 0-based in SourceMap spec version 3
            next += $1vhVH.encode(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += $1vhVH.encode(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
                nameIdx = this._names.indexOf(mapping.name);
                next += $1vhVH.encode(nameIdx - previousName);
                previousName = nameIdx;
            }
        }
        result += next;
    }
    return result;
};
$2095440aca8a34b2$var$SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function(source) {
        if (!this._sourcesContents) return null;
        if (aSourceRoot != null) source = $5YHdY.relative(aSourceRoot, source);
        var key = $5YHdY.toSetString(source);
        return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
    }, this);
};
/**
 * Externalize the source map.
 */ $2095440aca8a34b2$var$SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
    var map = {
        version: this._version,
        sources: this._sources.toArray(),
        names: this._names.toArray(),
        mappings: this._serializeMappings()
    };
    if (this._file != null) map.file = this._file;
    if (this._sourceRoot != null) map.sourceRoot = this._sourceRoot;
    if (this._sourcesContents) map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    return map;
};
/**
 * Render the source map being generated to a string.
 */ $2095440aca8a34b2$var$SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
};
$2095440aca8a34b2$export$4d99f7c30e854ff = $2095440aca8a34b2$var$SourceMapGenerator;

});
parcelRegister("1vhVH", function(module, exports) {

$parcel$export(module.exports, "encode", () => $118698265f84872c$export$c564cdbbe6da493, (v) => $118698265f84872c$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $118698265f84872c$export$2f872c0f2117be69, (v) => $118698265f84872c$export$2f872c0f2117be69 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * Returns the base 64 VLQ encoded value.
 */ var $118698265f84872c$export$c564cdbbe6da493;
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ var $118698265f84872c$export$2f872c0f2117be69;

var $4Niv3 = parcelRequire("4Niv3");
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var $118698265f84872c$var$VLQ_BASE_SHIFT = 5;
// binary: 100000
var $118698265f84872c$var$VLQ_BASE = 1 << $118698265f84872c$var$VLQ_BASE_SHIFT;
// binary: 011111
var $118698265f84872c$var$VLQ_BASE_MASK = $118698265f84872c$var$VLQ_BASE - 1;
// binary: 100000
var $118698265f84872c$var$VLQ_CONTINUATION_BIT = $118698265f84872c$var$VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function $118698265f84872c$var$toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function $118698265f84872c$var$fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
$118698265f84872c$export$c564cdbbe6da493 = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = $118698265f84872c$var$toVLQSigned(aValue);
    do {
        digit = vlq & $118698265f84872c$var$VLQ_BASE_MASK;
        vlq >>>= $118698265f84872c$var$VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= $118698265f84872c$var$VLQ_CONTINUATION_BIT;
        encoded += $4Niv3.encode(digit);
    }while (vlq > 0);
    return encoded;
};
$118698265f84872c$export$2f872c0f2117be69 = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = $4Niv3.decode(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & $118698265f84872c$var$VLQ_CONTINUATION_BIT);
        digit &= $118698265f84872c$var$VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += $118698265f84872c$var$VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = $118698265f84872c$var$fromVLQSigned(result);
    aOutParam.rest = aIndex;
};

});
parcelRegister("4Niv3", function(module, exports) {

$parcel$export(module.exports, "encode", () => $37da16b8c2e12da8$export$c564cdbbe6da493, (v) => $37da16b8c2e12da8$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $37da16b8c2e12da8$export$2f872c0f2117be69, (v) => $37da16b8c2e12da8$export$2f872c0f2117be69 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ var $37da16b8c2e12da8$export$c564cdbbe6da493;
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ var $37da16b8c2e12da8$export$2f872c0f2117be69;
var $37da16b8c2e12da8$var$intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
$37da16b8c2e12da8$export$c564cdbbe6da493 = function(number) {
    if (0 <= number && number < $37da16b8c2e12da8$var$intToCharMap.length) return $37da16b8c2e12da8$var$intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
$37da16b8c2e12da8$export$2f872c0f2117be69 = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};

});


parcelRegister("5YHdY", function(module, exports) {

$parcel$export(module.exports, "getArg", () => $45a415c8a0ee7163$export$6e45e70adce70bb2, (v) => $45a415c8a0ee7163$export$6e45e70adce70bb2 = v);
$parcel$export(module.exports, "urlParse", () => $45a415c8a0ee7163$export$d6e833647f7f5f17, (v) => $45a415c8a0ee7163$export$d6e833647f7f5f17 = v);
$parcel$export(module.exports, "isAbsolute", () => $45a415c8a0ee7163$export$e434c7255acda994, (v) => $45a415c8a0ee7163$export$e434c7255acda994 = v);
$parcel$export(module.exports, "normalize", () => $45a415c8a0ee7163$export$a3295358bff77e, (v) => $45a415c8a0ee7163$export$a3295358bff77e = v);
$parcel$export(module.exports, "join", () => $45a415c8a0ee7163$export$f7e2c8231c57a8bd, (v) => $45a415c8a0ee7163$export$f7e2c8231c57a8bd = v);
$parcel$export(module.exports, "relative", () => $45a415c8a0ee7163$export$f0e7d1106eeabbe6, (v) => $45a415c8a0ee7163$export$f0e7d1106eeabbe6 = v);
$parcel$export(module.exports, "toSetString", () => $45a415c8a0ee7163$export$be0fa1163fa7a4c, (v) => $45a415c8a0ee7163$export$be0fa1163fa7a4c = v);
$parcel$export(module.exports, "fromSetString", () => $45a415c8a0ee7163$export$1fc47c3d4c3302a1, (v) => $45a415c8a0ee7163$export$1fc47c3d4c3302a1 = v);
$parcel$export(module.exports, "compareByOriginalPositions", () => $45a415c8a0ee7163$export$273077902de92ff2, (v) => $45a415c8a0ee7163$export$273077902de92ff2 = v);
$parcel$export(module.exports, "compareByGeneratedPositionsDeflated", () => $45a415c8a0ee7163$export$b7acf533941302f6, (v) => $45a415c8a0ee7163$export$b7acf533941302f6 = v);
$parcel$export(module.exports, "compareByGeneratedPositionsInflated", () => $45a415c8a0ee7163$export$f9c43907549d61f1, (v) => $45a415c8a0ee7163$export$f9c43907549d61f1 = v);
$parcel$export(module.exports, "parseSourceMapInput", () => $45a415c8a0ee7163$export$b49e2de2ad542732, (v) => $45a415c8a0ee7163$export$b49e2de2ad542732 = v);
$parcel$export(module.exports, "computeSourceURL", () => $45a415c8a0ee7163$export$659a1aa8f1cdc036, (v) => $45a415c8a0ee7163$export$659a1aa8f1cdc036 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ var $45a415c8a0ee7163$export$6e45e70adce70bb2;
var $45a415c8a0ee7163$export$d6e833647f7f5f17;
var $45a415c8a0ee7163$export$2ec9abc2d2cac192;
var $45a415c8a0ee7163$export$a3295358bff77e;
var $45a415c8a0ee7163$export$f7e2c8231c57a8bd;
var $45a415c8a0ee7163$export$e434c7255acda994;
var $45a415c8a0ee7163$export$f0e7d1106eeabbe6;
var $45a415c8a0ee7163$export$be0fa1163fa7a4c;
var $45a415c8a0ee7163$export$1fc47c3d4c3302a1;
var $45a415c8a0ee7163$export$273077902de92ff2;
var $45a415c8a0ee7163$export$b7acf533941302f6;
var $45a415c8a0ee7163$export$f9c43907549d61f1;
var $45a415c8a0ee7163$export$b49e2de2ad542732;
var $45a415c8a0ee7163$export$659a1aa8f1cdc036;
function $45a415c8a0ee7163$var$getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
$45a415c8a0ee7163$export$6e45e70adce70bb2 = $45a415c8a0ee7163$var$getArg;
var $45a415c8a0ee7163$var$urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var $45a415c8a0ee7163$var$dataUrlRegexp = /^data:.+\,.+$/;
function $45a415c8a0ee7163$var$urlParse(aUrl) {
    var match = aUrl.match($45a415c8a0ee7163$var$urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
$45a415c8a0ee7163$export$d6e833647f7f5f17 = $45a415c8a0ee7163$var$urlParse;
function $45a415c8a0ee7163$var$urlGenerate(aParsedUrl) {
    var url = "";
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ":";
    url += "//";
    if (aParsedUrl.auth) url += aParsedUrl.auth + "@";
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
$45a415c8a0ee7163$export$2ec9abc2d2cac192 = $45a415c8a0ee7163$var$urlGenerate;
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ function $45a415c8a0ee7163$var$normalize(aPath) {
    var path = aPath;
    var url = $45a415c8a0ee7163$var$urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = $45a415c8a0ee7163$export$e434c7255acda994(path);
    var parts = path.split(/\/+/);
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === ".") parts.splice(i, 1);
        else if (part === "..") up++;
        else if (up > 0) {
            if (part === "") {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join("/");
    if (path === "") path = isAbsolute ? "/" : ".";
    if (url) {
        url.path = path;
        return $45a415c8a0ee7163$var$urlGenerate(url);
    }
    return path;
}
$45a415c8a0ee7163$export$a3295358bff77e = $45a415c8a0ee7163$var$normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function $45a415c8a0ee7163$var$join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = $45a415c8a0ee7163$var$urlParse(aPath);
    var aRootUrl = $45a415c8a0ee7163$var$urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || "/";
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return $45a415c8a0ee7163$var$urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match($45a415c8a0ee7163$var$dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return $45a415c8a0ee7163$var$urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === "/" ? aPath : $45a415c8a0ee7163$var$normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return $45a415c8a0ee7163$var$urlGenerate(aRootUrl);
    }
    return joined;
}
$45a415c8a0ee7163$export$f7e2c8231c57a8bd = $45a415c8a0ee7163$var$join;
$45a415c8a0ee7163$export$e434c7255acda994 = function(aPath) {
    return aPath.charAt(0) === "/" || $45a415c8a0ee7163$var$urlRegexp.test(aPath);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function $45a415c8a0ee7163$var$relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, "");
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + "/") !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
$45a415c8a0ee7163$export$f0e7d1106eeabbe6 = $45a415c8a0ee7163$var$relative;
var $45a415c8a0ee7163$var$supportsNullProto = function() {
    var obj = Object.create(null);
    return !("__proto__" in obj);
}();
function $45a415c8a0ee7163$var$identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function $45a415c8a0ee7163$var$toSetString(aStr) {
    if ($45a415c8a0ee7163$var$isProtoString(aStr)) return "$" + aStr;
    return aStr;
}
$45a415c8a0ee7163$export$be0fa1163fa7a4c = $45a415c8a0ee7163$var$supportsNullProto ? $45a415c8a0ee7163$var$identity : $45a415c8a0ee7163$var$toSetString;
function $45a415c8a0ee7163$var$fromSetString(aStr) {
    if ($45a415c8a0ee7163$var$isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
$45a415c8a0ee7163$export$1fc47c3d4c3302a1 = $45a415c8a0ee7163$var$supportsNullProto ? $45a415c8a0ee7163$var$identity : $45a415c8a0ee7163$var$fromSetString;
function $45a415c8a0ee7163$var$isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function $45a415c8a0ee7163$var$compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = $45a415c8a0ee7163$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return $45a415c8a0ee7163$var$strcmp(mappingA.name, mappingB.name);
}
$45a415c8a0ee7163$export$273077902de92ff2 = $45a415c8a0ee7163$var$compareByOriginalPositions;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function $45a415c8a0ee7163$var$compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = $45a415c8a0ee7163$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $45a415c8a0ee7163$var$strcmp(mappingA.name, mappingB.name);
}
$45a415c8a0ee7163$export$b7acf533941302f6 = $45a415c8a0ee7163$var$compareByGeneratedPositionsDeflated;
function $45a415c8a0ee7163$var$strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 === null) return 1; // aStr2 !== null
    if (aStr2 === null) return -1; // aStr1 !== null
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function $45a415c8a0ee7163$var$compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = $45a415c8a0ee7163$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $45a415c8a0ee7163$var$strcmp(mappingA.name, mappingB.name);
}
$45a415c8a0ee7163$export$f9c43907549d61f1 = $45a415c8a0ee7163$var$compareByGeneratedPositionsInflated;
/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */ function $45a415c8a0ee7163$var$parseSourceMapInput(str) {
    return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ""));
}
$45a415c8a0ee7163$export$b49e2de2ad542732 = $45a415c8a0ee7163$var$parseSourceMapInput;
/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */ function $45a415c8a0ee7163$var$computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
    sourceURL = sourceURL || "";
    if (sourceRoot) {
        // This follows what Chrome does.
        if (sourceRoot[sourceRoot.length - 1] !== "/" && sourceURL[0] !== "/") sourceRoot += "/";
        // The spec says:
        //   Line 4: An optional source root, useful for relocating source
        //   files on a server or removing repeated values in the
        //   “sources” entry.  This value is prepended to the individual
        //   entries in the “source” field.
        sourceURL = sourceRoot + sourceURL;
    }
    // Historically, SourceMapConsumer did not take the sourceMapURL as
    // a parameter.  This mode is still somewhat supported, which is why
    // this code block is conditional.  However, it's preferable to pass
    // the source map URL to SourceMapConsumer, so that this function
    // can implement the source URL resolution algorithm as outlined in
    // the spec.  This block is basically the equivalent of:
    //    new URL(sourceURL, sourceMapURL).toString()
    // ... except it avoids using URL, which wasn't available in the
    // older releases of node still supported by this library.
    //
    // The spec says:
    //   If the sources are not absolute URLs after prepending of the
    //   “sourceRoot”, the sources are resolved relative to the
    //   SourceMap (like resolving script src in a html document).
    if (sourceMapURL) {
        var parsed = $45a415c8a0ee7163$var$urlParse(sourceMapURL);
        if (!parsed) throw new Error("sourceMapURL could not be parsed");
        if (parsed.path) {
            // Strip the last path component, but keep the "/".
            var index = parsed.path.lastIndexOf("/");
            if (index >= 0) parsed.path = parsed.path.substring(0, index + 1);
        }
        sourceURL = $45a415c8a0ee7163$var$join($45a415c8a0ee7163$var$urlGenerate(parsed), sourceURL);
    }
    return $45a415c8a0ee7163$var$normalize(sourceURL);
}
$45a415c8a0ee7163$export$659a1aa8f1cdc036 = $45a415c8a0ee7163$var$computeSourceURL;

});

parcelRegister("lY08F", function(module, exports) {

$parcel$export(module.exports, "ArraySet", () => $ffdf4f272ae800e2$export$605bbf5ea7b60ba3, (v) => $ffdf4f272ae800e2$export$605bbf5ea7b60ba3 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $ffdf4f272ae800e2$export$605bbf5ea7b60ba3;

var $5YHdY = parcelRequire("5YHdY");
var $ffdf4f272ae800e2$var$has = Object.prototype.hasOwnProperty;
var $ffdf4f272ae800e2$var$hasNativeMap = typeof Map !== "undefined";
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function $ffdf4f272ae800e2$var$ArraySet() {
    this._array = [];
    this._set = $ffdf4f272ae800e2$var$hasNativeMap ? new Map() : Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ $ffdf4f272ae800e2$var$ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new $ffdf4f272ae800e2$var$ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ $ffdf4f272ae800e2$var$ArraySet.prototype.size = function ArraySet_size() {
    return $ffdf4f272ae800e2$var$hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ $ffdf4f272ae800e2$var$ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = $ffdf4f272ae800e2$var$hasNativeMap ? aStr : $5YHdY.toSetString(aStr);
    var isDuplicate = $ffdf4f272ae800e2$var$hasNativeMap ? this.has(aStr) : $ffdf4f272ae800e2$var$has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) {
        if ($ffdf4f272ae800e2$var$hasNativeMap) this._set.set(aStr, idx);
        else this._set[sStr] = idx;
    }
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ $ffdf4f272ae800e2$var$ArraySet.prototype.has = function ArraySet_has(aStr) {
    if ($ffdf4f272ae800e2$var$hasNativeMap) return this._set.has(aStr);
    else {
        var sStr = $5YHdY.toSetString(aStr);
        return $ffdf4f272ae800e2$var$has.call(this._set, sStr);
    }
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ $ffdf4f272ae800e2$var$ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    if ($ffdf4f272ae800e2$var$hasNativeMap) {
        var idx = this._set.get(aStr);
        if (idx >= 0) return idx;
    } else {
        var sStr = $5YHdY.toSetString(aStr);
        if ($ffdf4f272ae800e2$var$has.call(this._set, sStr)) return this._set[sStr];
    }
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ $ffdf4f272ae800e2$var$ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error("No element indexed by " + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ $ffdf4f272ae800e2$var$ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
$ffdf4f272ae800e2$export$605bbf5ea7b60ba3 = $ffdf4f272ae800e2$var$ArraySet;

});

parcelRegister("e4QkW", function(module, exports) {

$parcel$export(module.exports, "MappingList", () => $a3fa096971e63ddc$export$e82e0908843dd951, (v) => $a3fa096971e63ddc$export$e82e0908843dd951 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $a3fa096971e63ddc$export$e82e0908843dd951;

var $5YHdY = parcelRequire("5YHdY");
/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */ function $a3fa096971e63ddc$var$generatedPositionAfter(mappingA, mappingB) {
    // Optimized for most common case
    var lineA = mappingA.generatedLine;
    var lineB = mappingB.generatedLine;
    var columnA = mappingA.generatedColumn;
    var columnB = mappingB.generatedColumn;
    return lineB > lineA || lineB == lineA && columnB >= columnA || $5YHdY.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}
/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */ function $a3fa096971e63ddc$var$MappingList() {
    this._array = [];
    this._sorted = true;
    // Serves as infimum
    this._last = {
        generatedLine: -1,
        generatedColumn: 0
    };
}
/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */ $a3fa096971e63ddc$var$MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
};
/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */ $a3fa096971e63ddc$var$MappingList.prototype.add = function MappingList_add(aMapping) {
    if ($a3fa096971e63ddc$var$generatedPositionAfter(this._last, aMapping)) {
        this._last = aMapping;
        this._array.push(aMapping);
    } else {
        this._sorted = false;
        this._array.push(aMapping);
    }
};
/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */ $a3fa096971e63ddc$var$MappingList.prototype.toArray = function MappingList_toArray() {
    if (!this._sorted) {
        this._array.sort($5YHdY.compareByGeneratedPositionsInflated);
        this._sorted = true;
    }
    return this._array;
};
$a3fa096971e63ddc$export$e82e0908843dd951 = $a3fa096971e63ddc$var$MappingList;

});


parcelRegister("cKYfc", function(module, exports) {

$parcel$export(module.exports, "SourceMapConsumer", () => $949883226cd71155$export$194e92554d04abdd, (v) => $949883226cd71155$export$194e92554d04abdd = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $949883226cd71155$export$194e92554d04abdd;
var $949883226cd71155$export$bef6691594139a79;
var $949883226cd71155$export$823525094e5b803c;

var $5YHdY = parcelRequire("5YHdY");

var $3t4aH = parcelRequire("3t4aH");

var $lY08F = parcelRequire("lY08F");
var $949883226cd71155$require$ArraySet = $lY08F.ArraySet;

var $1vhVH = parcelRequire("1vhVH");

var $2hlLG = parcelRequire("2hlLG");
var $949883226cd71155$require$quickSort = $2hlLG.quickSort;
function $949883226cd71155$var$SourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = $5YHdY.parseSourceMapInput(aSourceMap);
    return sourceMap.sections != null ? new $949883226cd71155$var$IndexedSourceMapConsumer(sourceMap, aSourceMapURL) : new $949883226cd71155$var$BasicSourceMapConsumer(sourceMap, aSourceMapURL);
}
$949883226cd71155$var$SourceMapConsumer.fromSourceMap = function(aSourceMap, aSourceMapURL) {
    return $949883226cd71155$var$BasicSourceMapConsumer.fromSourceMap(aSourceMap, aSourceMapURL);
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $949883226cd71155$var$SourceMapConsumer.prototype._version = 3;
// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.
$949883226cd71155$var$SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty($949883226cd71155$var$SourceMapConsumer.prototype, "_generatedMappings", {
    configurable: true,
    enumerable: true,
    get: function() {
        if (!this.__generatedMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__generatedMappings;
    }
});
$949883226cd71155$var$SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty($949883226cd71155$var$SourceMapConsumer.prototype, "_originalMappings", {
    configurable: true,
    enumerable: true,
    get: function() {
        if (!this.__originalMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__originalMappings;
    }
});
$949883226cd71155$var$SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $949883226cd71155$var$SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
};
$949883226cd71155$var$SourceMapConsumer.GENERATED_ORDER = 1;
$949883226cd71155$var$SourceMapConsumer.ORIGINAL_ORDER = 2;
$949883226cd71155$var$SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
$949883226cd71155$var$SourceMapConsumer.LEAST_UPPER_BOUND = 2;
/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */ $949883226cd71155$var$SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || $949883226cd71155$var$SourceMapConsumer.GENERATED_ORDER;
    var mappings;
    switch(order){
        case $949883226cd71155$var$SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
        case $949883226cd71155$var$SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
        default:
            throw new Error("Unknown order of iteration.");
    }
    var sourceRoot = this.sourceRoot;
    mappings.map(function(mapping) {
        var source = mapping.source === null ? null : this._sources.at(mapping.source);
        source = $5YHdY.computeSourceURL(sourceRoot, source, this._sourceMapURL);
        return {
            source: source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
        };
    }, this).forEach(aCallback, context);
};
/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number is 1-based.
 *   - column: Optional. the column number in the original source.
 *    The column number is 0-based.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *    line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *    The column number is 0-based.
 */ $949883226cd71155$var$SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = $5YHdY.getArg(aArgs, "line");
    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
        source: $5YHdY.getArg(aArgs, "source"),
        originalLine: line,
        originalColumn: $5YHdY.getArg(aArgs, "column", 0)
    };
    needle.source = this._findSourceIndex(needle.source);
    if (needle.source < 0) return [];
    var mappings = [];
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $5YHdY.compareByOriginalPositions, $3t4aH.LEAST_UPPER_BOUND);
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (aArgs.column === undefined) {
            var originalLine = mapping.originalLine;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we found. Since
            // mappings are sorted, this is guaranteed to find all mappings for
            // the line we found.
            while(mapping && mapping.originalLine === originalLine){
                mappings.push({
                    line: $5YHdY.getArg(mapping, "generatedLine", null),
                    column: $5YHdY.getArg(mapping, "generatedColumn", null),
                    lastColumn: $5YHdY.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        } else {
            var originalColumn = mapping.originalColumn;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we were searching for.
            // Since mappings are sorted, this is guaranteed to find all mappings for
            // the line we are searching for.
            while(mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn){
                mappings.push({
                    line: $5YHdY.getArg(mapping, "generatedLine", null),
                    column: $5YHdY.getArg(mapping, "generatedColumn", null),
                    lastColumn: $5YHdY.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        }
    }
    return mappings;
};
$949883226cd71155$export$194e92554d04abdd = $949883226cd71155$var$SourceMapConsumer;
/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The first parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */ function $949883226cd71155$var$BasicSourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = $5YHdY.parseSourceMapInput(aSourceMap);
    var version = $5YHdY.getArg(sourceMap, "version");
    var sources = $5YHdY.getArg(sourceMap, "sources");
    // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
    // requires the array) to play nice here.
    var names = $5YHdY.getArg(sourceMap, "names", []);
    var sourceRoot = $5YHdY.getArg(sourceMap, "sourceRoot", null);
    var sourcesContent = $5YHdY.getArg(sourceMap, "sourcesContent", null);
    var mappings = $5YHdY.getArg(sourceMap, "mappings");
    var file = $5YHdY.getArg(sourceMap, "file", null);
    // Once again, Sass deviates from the spec and supplies the version as a
    // string rather than a number, so we use loose equality checking here.
    if (version != this._version) throw new Error("Unsupported version: " + version);
    if (sourceRoot) sourceRoot = $5YHdY.normalize(sourceRoot);
    sources = sources.map(String)// Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map($5YHdY.normalize)// Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function(source) {
        return sourceRoot && $5YHdY.isAbsolute(sourceRoot) && $5YHdY.isAbsolute(source) ? $5YHdY.relative(sourceRoot, source) : source;
    });
    // Pass `true` below to allow duplicate names and sources. While source maps
    // are intended to be compressed and deduplicated, the TypeScript compiler
    // sometimes generates source maps with duplicates in them. See Github issue
    // #72 and bugzil.la/889492.
    this._names = $949883226cd71155$require$ArraySet.fromArray(names.map(String), true);
    this._sources = $949883226cd71155$require$ArraySet.fromArray(sources, true);
    this._absoluteSources = this._sources.toArray().map(function(s) {
        return $5YHdY.computeSourceURL(sourceRoot, s, aSourceMapURL);
    });
    this.sourceRoot = sourceRoot;
    this.sourcesContent = sourcesContent;
    this._mappings = mappings;
    this._sourceMapURL = aSourceMapURL;
    this.file = file;
}
$949883226cd71155$var$BasicSourceMapConsumer.prototype = Object.create($949883226cd71155$var$SourceMapConsumer.prototype);
$949883226cd71155$var$BasicSourceMapConsumer.prototype.consumer = $949883226cd71155$var$SourceMapConsumer;
/**
 * Utility function to find the index of a source.  Returns -1 if not
 * found.
 */ $949883226cd71155$var$BasicSourceMapConsumer.prototype._findSourceIndex = function(aSource) {
    var relativeSource = aSource;
    if (this.sourceRoot != null) relativeSource = $5YHdY.relative(this.sourceRoot, relativeSource);
    if (this._sources.has(relativeSource)) return this._sources.indexOf(relativeSource);
    // Maybe aSource is an absolute URL as returned by |sources|.  In
    // this case we can't simply undo the transform.
    var i;
    for(i = 0; i < this._absoluteSources.length; ++i){
        if (this._absoluteSources[i] == aSource) return i;
    }
    return -1;
};
/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @param String aSourceMapURL
 *        The URL at which the source map can be found (optional)
 * @returns BasicSourceMapConsumer
 */ $949883226cd71155$var$BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap, aSourceMapURL) {
    var smc = Object.create($949883226cd71155$var$BasicSourceMapConsumer.prototype);
    var names = smc._names = $949883226cd71155$require$ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = $949883226cd71155$require$ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
    smc.file = aSourceMap._file;
    smc._sourceMapURL = aSourceMapURL;
    smc._absoluteSources = smc._sources.toArray().map(function(s) {
        return $5YHdY.computeSourceURL(smc.sourceRoot, s, aSourceMapURL);
    });
    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.
    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];
    for(var i = 0, length = generatedMappings.length; i < length; i++){
        var srcMapping = generatedMappings[i];
        var destMapping = new $949883226cd71155$var$Mapping;
        destMapping.generatedLine = srcMapping.generatedLine;
        destMapping.generatedColumn = srcMapping.generatedColumn;
        if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) destMapping.name = names.indexOf(srcMapping.name);
            destOriginalMappings.push(destMapping);
        }
        destGeneratedMappings.push(destMapping);
    }
    $949883226cd71155$require$quickSort(smc.__originalMappings, $5YHdY.compareByOriginalPositions);
    return smc;
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $949883226cd71155$var$BasicSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($949883226cd71155$var$BasicSourceMapConsumer.prototype, "sources", {
    get: function() {
        return this._absoluteSources.slice();
    }
});
/**
 * Provide the JIT with a nice shape / hidden class.
 */ function $949883226cd71155$var$Mapping() {
    this.generatedLine = 0;
    this.generatedColumn = 0;
    this.source = null;
    this.originalLine = null;
    this.originalColumn = null;
    this.name = null;
}
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $949883226cd71155$var$BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;
    while(index < length){
        if (aStr.charAt(index) === ";") {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
        } else if (aStr.charAt(index) === ",") index++;
        else {
            mapping = new $949883226cd71155$var$Mapping();
            mapping.generatedLine = generatedLine;
            // Because each offset is encoded relative to the previous one,
            // many segments often have the same encoding. We can exploit this
            // fact by caching the parsed variable length fields of each segment,
            // allowing us to avoid a second parse if we encounter the same
            // segment again.
            for(end = index; end < length; end++){
                if (this._charIsMappingSeparator(aStr, end)) break;
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) index += str.length;
            else {
                segment = [];
                while(index < end){
                    $1vhVH.decode(aStr, index, temp);
                    value = temp.value;
                    index = temp.rest;
                    segment.push(value);
                }
                if (segment.length === 2) throw new Error("Found a source, but no line and column");
                if (segment.length === 3) throw new Error("Found a source and line, but no column");
                cachedSegments[str] = segment;
            }
            // Generated column.
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
                // Original source.
                mapping.source = previousSource + segment[1];
                previousSource += segment[1];
                // Original line.
                mapping.originalLine = previousOriginalLine + segment[2];
                previousOriginalLine = mapping.originalLine;
                // Lines are stored 0-based
                mapping.originalLine += 1;
                // Original column.
                mapping.originalColumn = previousOriginalColumn + segment[3];
                previousOriginalColumn = mapping.originalColumn;
                if (segment.length > 4) {
                    // Original name.
                    mapping.name = previousName + segment[4];
                    previousName += segment[4];
                }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === "number") originalMappings.push(mapping);
        }
    }
    $949883226cd71155$require$quickSort(generatedMappings, $5YHdY.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;
    $949883226cd71155$require$quickSort(originalMappings, $5YHdY.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
};
/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */ $949883226cd71155$var$BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.
    if (aNeedle[aLineName] <= 0) throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
    if (aNeedle[aColumnName] < 0) throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
    return $3t4aH.search(aNeedle, aMappings, aComparator, aBias);
};
/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */ $949883226cd71155$var$BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
    for(var index = 0; index < this._generatedMappings.length; ++index){
        var mapping = this._generatedMappings[index];
        // Mappings do not contain a field for the last generated columnt. We
        // can come up with an optimistic estimate, however, by assuming that
        // mappings are contiguous (i.e. given two consecutive mappings, the
        // first mapping ends where the second one starts).
        if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
                mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
                continue;
            }
        }
        // The last mapping for each line spans the entire line.
        mapping.lastGeneratedColumn = Infinity;
    }
};
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */ $949883226cd71155$var$BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $5YHdY.getArg(aArgs, "line"),
        generatedColumn: $5YHdY.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", $5YHdY.compareByGeneratedPositionsDeflated, $5YHdY.getArg(aArgs, "bias", $949883226cd71155$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._generatedMappings[index];
        if (mapping.generatedLine === needle.generatedLine) {
            var source = $5YHdY.getArg(mapping, "source", null);
            if (source !== null) {
                source = this._sources.at(source);
                source = $5YHdY.computeSourceURL(this.sourceRoot, source, this._sourceMapURL);
            }
            var name = $5YHdY.getArg(mapping, "name", null);
            if (name !== null) name = this._names.at(name);
            return {
                source: source,
                line: $5YHdY.getArg(mapping, "originalLine", null),
                column: $5YHdY.getArg(mapping, "originalColumn", null),
                name: name
            };
        }
    }
    return {
        source: null,
        line: null,
        column: null,
        name: null
    };
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $949883226cd71155$var$BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) return false;
    return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
        return sc == null;
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $949883226cd71155$var$BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) return null;
    var index = this._findSourceIndex(aSource);
    if (index >= 0) return this.sourcesContent[index];
    var relativeSource = aSource;
    if (this.sourceRoot != null) relativeSource = $5YHdY.relative(this.sourceRoot, relativeSource);
    var url;
    if (this.sourceRoot != null && (url = $5YHdY.urlParse(this.sourceRoot))) {
        // XXX: file:// URIs and absolute paths lead to unexpected behavior for
        // many users. We can help them out when they expect file:// URIs to
        // behave like it would if they were running a local HTTP server. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
        var fileUriAbsPath = relativeSource.replace(/^file:\/\//, "");
        if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
        if ((!url.path || url.path == "/") && this._sources.has("/" + relativeSource)) return this.sourcesContent[this._sources.indexOf("/" + relativeSource)];
    }
    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) return null;
    else throw new Error('"' + relativeSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */ $949883226cd71155$var$BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = $5YHdY.getArg(aArgs, "source");
    source = this._findSourceIndex(source);
    if (source < 0) return {
        line: null,
        column: null,
        lastColumn: null
    };
    var needle = {
        source: source,
        originalLine: $5YHdY.getArg(aArgs, "line"),
        originalColumn: $5YHdY.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $5YHdY.compareByOriginalPositions, $5YHdY.getArg(aArgs, "bias", $949883226cd71155$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (mapping.source === needle.source) return {
            line: $5YHdY.getArg(mapping, "generatedLine", null),
            column: $5YHdY.getArg(mapping, "generatedColumn", null),
            lastColumn: $5YHdY.getArg(mapping, "lastGeneratedColumn", null)
        };
    }
    return {
        line: null,
        column: null,
        lastColumn: null
    };
};
$949883226cd71155$export$bef6691594139a79 = $949883226cd71155$var$BasicSourceMapConsumer;
/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The first parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */ function $949883226cd71155$var$IndexedSourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = $5YHdY.parseSourceMapInput(aSourceMap);
    var version = $5YHdY.getArg(sourceMap, "version");
    var sections = $5YHdY.getArg(sourceMap, "sections");
    if (version != this._version) throw new Error("Unsupported version: " + version);
    this._sources = new $949883226cd71155$require$ArraySet();
    this._names = new $949883226cd71155$require$ArraySet();
    var lastOffset = {
        line: -1,
        column: 0
    };
    this._sections = sections.map(function(s) {
        if (s.url) // The url field will require support for asynchronicity.
        // See https://github.com/mozilla/source-map/issues/16
        throw new Error("Support for url field in sections not implemented.");
        var offset = $5YHdY.getArg(s, "offset");
        var offsetLine = $5YHdY.getArg(offset, "line");
        var offsetColumn = $5YHdY.getArg(offset, "column");
        if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) throw new Error("Section offsets must be ordered and non-overlapping.");
        lastOffset = offset;
        return {
            generatedOffset: {
                // The offset fields are 0-based, but we use 1-based indices when
                // encoding/decoding from VLQ.
                generatedLine: offsetLine + 1,
                generatedColumn: offsetColumn + 1
            },
            consumer: new $949883226cd71155$var$SourceMapConsumer($5YHdY.getArg(s, "map"), aSourceMapURL)
        };
    });
}
$949883226cd71155$var$IndexedSourceMapConsumer.prototype = Object.create($949883226cd71155$var$SourceMapConsumer.prototype);
$949883226cd71155$var$IndexedSourceMapConsumer.prototype.constructor = $949883226cd71155$var$SourceMapConsumer;
/**
 * The version of the source mapping spec that we are consuming.
 */ $949883226cd71155$var$IndexedSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($949883226cd71155$var$IndexedSourceMapConsumer.prototype, "sources", {
    get: function() {
        var sources = [];
        for(var i = 0; i < this._sections.length; i++)for(var j = 0; j < this._sections[i].consumer.sources.length; j++)sources.push(this._sections[i].consumer.sources[j]);
        return sources;
    }
});
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */ $949883226cd71155$var$IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $5YHdY.getArg(aArgs, "line"),
        generatedColumn: $5YHdY.getArg(aArgs, "column")
    };
    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = $3t4aH.search(needle, this._sections, function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) return cmp;
        return needle.generatedColumn - section.generatedOffset.generatedColumn;
    });
    var section = this._sections[sectionIndex];
    if (!section) return {
        source: null,
        line: null,
        column: null,
        name: null
    };
    return section.consumer.originalPositionFor({
        line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
        column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
        bias: aArgs.bias
    });
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $949883226cd71155$var$IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function(s) {
        return s.consumer.hasContentsOfAllSources();
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $949883226cd71155$var$IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var content = section.consumer.sourceContentFor(aSource, true);
        if (content) return content;
    }
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based. 
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */ $949883226cd71155$var$IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        // Only consider this section if the requested source is in the list of
        // sources of the consumer.
        if (section.consumer._findSourceIndex($5YHdY.getArg(aArgs, "source")) === -1) continue;
        var generatedPosition = section.consumer.generatedPositionFor(aArgs);
        if (generatedPosition) {
            var ret = {
                line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
                column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
        }
    }
    return {
        line: null,
        column: null
    };
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $949883226cd71155$var$IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var sectionMappings = section.consumer._generatedMappings;
        for(var j = 0; j < sectionMappings.length; j++){
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            source = $5YHdY.computeSourceURL(section.consumer.sourceRoot, source, this._sourceMapURL);
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = null;
            if (mapping.name) {
                name = section.consumer._names.at(mapping.name);
                this._names.add(name);
                name = this._names.indexOf(name);
            }
            // The mappings coming from the consumer for the section have
            // generated positions relative to the start of the section, so we
            // need to offset them to be relative to the start of the concatenated
            // generated file.
            var adjustedMapping = {
                source: source,
                generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
                generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
                originalLine: mapping.originalLine,
                originalColumn: mapping.originalColumn,
                name: name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === "number") this.__originalMappings.push(adjustedMapping);
        }
    }
    $949883226cd71155$require$quickSort(this.__generatedMappings, $5YHdY.compareByGeneratedPositionsDeflated);
    $949883226cd71155$require$quickSort(this.__originalMappings, $5YHdY.compareByOriginalPositions);
};
$949883226cd71155$export$823525094e5b803c = $949883226cd71155$var$IndexedSourceMapConsumer;

});
parcelRegister("3t4aH", function(module, exports) {

$parcel$export(module.exports, "GREATEST_LOWER_BOUND", () => $286750f03299bc04$export$4ecd616dce182dff, (v) => $286750f03299bc04$export$4ecd616dce182dff = v);
$parcel$export(module.exports, "LEAST_UPPER_BOUND", () => $286750f03299bc04$export$b99fbecff261243, (v) => $286750f03299bc04$export$b99fbecff261243 = v);
$parcel$export(module.exports, "search", () => $286750f03299bc04$export$d76128d007d19019, (v) => $286750f03299bc04$export$d76128d007d19019 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $286750f03299bc04$export$4ecd616dce182dff;
var $286750f03299bc04$export$b99fbecff261243;
/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */ var $286750f03299bc04$export$d76128d007d19019;
$286750f03299bc04$export$4ecd616dce182dff = 1;
$286750f03299bc04$export$b99fbecff261243 = 2;
/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */ function $286750f03299bc04$var$recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
    // This function terminates when one of the following is true:
    //
    //   1. We find the exact element we are looking for.
    //
    //   2. We did not find the exact element, but we can return the index of
    //      the next-closest element.
    //
    //   3. We did not find the exact element, and there is no next-closest
    //      element than the one we are searching for, so we return -1.
    var mid = Math.floor((aHigh - aLow) / 2) + aLow;
    var cmp = aCompare(aNeedle, aHaystack[mid], true);
    if (cmp === 0) // Found the element we are looking for.
    return mid;
    else if (cmp > 0) {
        // Our needle is greater than aHaystack[mid].
        if (aHigh - mid > 1) // The element is in the upper half.
        return $286750f03299bc04$var$recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
        // The exact needle element was not found in this haystack. Determine if
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $286750f03299bc04$export$b99fbecff261243) return aHigh < aHaystack.length ? aHigh : -1;
        else return mid;
    } else {
        // Our needle is less than aHaystack[mid].
        if (mid - aLow > 1) // The element is in the lower half.
        return $286750f03299bc04$var$recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $286750f03299bc04$export$b99fbecff261243) return mid;
        else return aLow < 0 ? -1 : aLow;
    }
}
$286750f03299bc04$export$d76128d007d19019 = function search(aNeedle, aHaystack, aCompare, aBias) {
    if (aHaystack.length === 0) return -1;
    var index = $286750f03299bc04$var$recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || $286750f03299bc04$export$4ecd616dce182dff);
    if (index < 0) return -1;
    // We have found either the exact element, or the next-closest element than
    // the one we are searching for. However, there may be more than one such
    // element. Make sure we always return the smallest of these.
    while(index - 1 >= 0){
        if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) break;
        --index;
    }
    return index;
};

});

parcelRegister("2hlLG", function(module, exports) {

$parcel$export(module.exports, "quickSort", () => $1a8e0df92c202dfd$export$866270269b9544a5, (v) => $1a8e0df92c202dfd$export$866270269b9544a5 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ // It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.
/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */ /**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */ var $1a8e0df92c202dfd$export$866270269b9544a5;
function $1a8e0df92c202dfd$var$swap(ary, x, y) {
    var temp = ary[x];
    ary[x] = ary[y];
    ary[y] = temp;
}
/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */ function $1a8e0df92c202dfd$var$randomIntInRange(low, high) {
    return Math.round(low + Math.random() * (high - low));
}
/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */ function $1a8e0df92c202dfd$var$doQuickSort(ary, comparator, p, r) {
    // If our lower bound is less than our upper bound, we (1) partition the
    // array into two pieces and (2) recurse on each half. If it is not, this is
    // the empty array and our base case.
    if (p < r) {
        // (1) Partitioning.
        //
        // The partitioning chooses a pivot between `p` and `r` and moves all
        // elements that are less than or equal to the pivot to the before it, and
        // all the elements that are greater than it after it. The effect is that
        // once partition is done, the pivot is in the exact place it will be when
        // the array is put in sorted order, and it will not need to be moved
        // again. This runs in O(n) time.
        // Always choose a random pivot so that an input array which is reverse
        // sorted does not cause O(n^2) running time.
        var pivotIndex = $1a8e0df92c202dfd$var$randomIntInRange(p, r);
        var i = p - 1;
        $1a8e0df92c202dfd$var$swap(ary, pivotIndex, r);
        var pivot = ary[r];
        // Immediately after `j` is incremented in this loop, the following hold
        // true:
        //
        //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
        //
        //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
        for(var j = p; j < r; j++)if (comparator(ary[j], pivot) <= 0) {
            i += 1;
            $1a8e0df92c202dfd$var$swap(ary, i, j);
        }
        $1a8e0df92c202dfd$var$swap(ary, i + 1, j);
        var q = i + 1;
        // (2) Recurse on each half.
        $1a8e0df92c202dfd$var$doQuickSort(ary, comparator, p, q - 1);
        $1a8e0df92c202dfd$var$doQuickSort(ary, comparator, q + 1, r);
    }
}
$1a8e0df92c202dfd$export$866270269b9544a5 = function(ary, comparator) {
    $1a8e0df92c202dfd$var$doQuickSort(ary, comparator, 0, ary.length - 1);
};

});


parcelRegister("cLVN7", function(module, exports) {

$parcel$export(module.exports, "SourceNode", () => $94c6b3f1272c04d8$export$7e987e8f375d24c2, (v) => $94c6b3f1272c04d8$export$7e987e8f375d24c2 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $94c6b3f1272c04d8$export$7e987e8f375d24c2;

var $2Nrdb = parcelRequire("2Nrdb");
var $94c6b3f1272c04d8$require$SourceMapGenerator = $2Nrdb.SourceMapGenerator;

var $5YHdY = parcelRequire("5YHdY");
// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).
var $94c6b3f1272c04d8$var$REGEX_NEWLINE = /(\r?\n)/;
// Newline character code for charCodeAt() comparisons
var $94c6b3f1272c04d8$var$NEWLINE_CODE = 10;
// Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!
var $94c6b3f1272c04d8$var$isSourceNode = "$$$isSourceNode$$$";
/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */ function $94c6b3f1272c04d8$var$SourceNode(aLine, aColumn, aSource, aChunks, aName) {
    this.children = [];
    this.sourceContents = {};
    this.line = aLine == null ? null : aLine;
    this.column = aColumn == null ? null : aColumn;
    this.source = aSource == null ? null : aSource;
    this.name = aName == null ? null : aName;
    this[$94c6b3f1272c04d8$var$isSourceNode] = true;
    if (aChunks != null) this.add(aChunks);
}
/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */ $94c6b3f1272c04d8$var$SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
    // The SourceNode we want to fill with the generated code
    // and the SourceMap
    var node = new $94c6b3f1272c04d8$var$SourceNode();
    // All even indices of this array are one line of the generated code,
    // while all odd indices are the newlines between two adjacent lines
    // (since `REGEX_NEWLINE` captures its match).
    // Processed fragments are accessed by calling `shiftNextLine`.
    var remainingLines = aGeneratedCode.split($94c6b3f1272c04d8$var$REGEX_NEWLINE);
    var remainingLinesIndex = 0;
    var shiftNextLine = function() {
        var lineContents = getNextLine();
        // The last line of a file might not have a newline.
        var newLine = getNextLine() || "";
        return lineContents + newLine;
        function getNextLine() {
            return remainingLinesIndex < remainingLines.length ? remainingLines[remainingLinesIndex++] : undefined;
        }
    };
    // We need to remember the position of "remainingLines"
    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
    // The generate SourceNodes we need a code range.
    // To extract it current and last mapping is used.
    // Here we store the last mapping.
    var lastMapping = null;
    aSourceMapConsumer.eachMapping(function(mapping) {
        if (lastMapping !== null) {
            // We add the code from "lastMapping" to "mapping":
            // First check if there is a new line in between.
            if (lastGeneratedLine < mapping.generatedLine) {
                // Associate first line with "lastMapping"
                addMappingWithCode(lastMapping, shiftNextLine());
                lastGeneratedLine++;
                lastGeneratedColumn = 0;
            // The remaining code is added without mapping
            } else {
                // There is no new line in between.
                // Associate the code between "lastGeneratedColumn" and
                // "mapping.generatedColumn" with "lastMapping"
                var nextLine = remainingLines[remainingLinesIndex] || "";
                var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
                remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
                lastGeneratedColumn = mapping.generatedColumn;
                addMappingWithCode(lastMapping, code);
                // No more remaining code, continue
                lastMapping = mapping;
                return;
            }
        }
        // We add the generated code until the first mapping
        // to the SourceNode without any mapping.
        // Each line is added as separate string.
        while(lastGeneratedLine < mapping.generatedLine){
            node.add(shiftNextLine());
            lastGeneratedLine++;
        }
        if (lastGeneratedColumn < mapping.generatedColumn) {
            var nextLine = remainingLines[remainingLinesIndex] || "";
            node.add(nextLine.substr(0, mapping.generatedColumn));
            remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
            lastGeneratedColumn = mapping.generatedColumn;
        }
        lastMapping = mapping;
    }, this);
    // We have processed all mappings.
    if (remainingLinesIndex < remainingLines.length) {
        if (lastMapping) // Associate the remaining code in the current line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
        // and add the remaining lines without any mapping
        node.add(remainingLines.splice(remainingLinesIndex).join(""));
    }
    // Copy sourcesContent into SourceNode
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aRelativePath != null) sourceFile = $5YHdY.join(aRelativePath, sourceFile);
            node.setSourceContent(sourceFile, content);
        }
    });
    return node;
    function addMappingWithCode(mapping, code) {
        if (mapping === null || mapping.source === undefined) node.add(code);
        else {
            var source = aRelativePath ? $5YHdY.join(aRelativePath, mapping.source) : mapping.source;
            node.add(new $94c6b3f1272c04d8$var$SourceNode(mapping.originalLine, mapping.originalColumn, source, code, mapping.name));
        }
    }
};
/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */ $94c6b3f1272c04d8$var$SourceNode.prototype.add = function SourceNode_add(aChunk) {
    if (Array.isArray(aChunk)) aChunk.forEach(function(chunk) {
        this.add(chunk);
    }, this);
    else if (aChunk[$94c6b3f1272c04d8$var$isSourceNode] || typeof aChunk === "string") {
        if (aChunk) this.children.push(aChunk);
    } else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
    return this;
};
/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */ $94c6b3f1272c04d8$var$SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
    if (Array.isArray(aChunk)) for(var i = aChunk.length - 1; i >= 0; i--)this.prepend(aChunk[i]);
    else if (aChunk[$94c6b3f1272c04d8$var$isSourceNode] || typeof aChunk === "string") this.children.unshift(aChunk);
    else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
    return this;
};
/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */ $94c6b3f1272c04d8$var$SourceNode.prototype.walk = function SourceNode_walk(aFn) {
    var chunk;
    for(var i = 0, len = this.children.length; i < len; i++){
        chunk = this.children[i];
        if (chunk[$94c6b3f1272c04d8$var$isSourceNode]) chunk.walk(aFn);
        else if (chunk !== "") aFn(chunk, {
            source: this.source,
            line: this.line,
            column: this.column,
            name: this.name
        });
    }
};
/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */ $94c6b3f1272c04d8$var$SourceNode.prototype.join = function SourceNode_join(aSep) {
    var newChildren;
    var i;
    var len = this.children.length;
    if (len > 0) {
        newChildren = [];
        for(i = 0; i < len - 1; i++){
            newChildren.push(this.children[i]);
            newChildren.push(aSep);
        }
        newChildren.push(this.children[i]);
        this.children = newChildren;
    }
    return this;
};
/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */ $94c6b3f1272c04d8$var$SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
    var lastChild = this.children[this.children.length - 1];
    if (lastChild[$94c6b3f1272c04d8$var$isSourceNode]) lastChild.replaceRight(aPattern, aReplacement);
    else if (typeof lastChild === "string") this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
    else this.children.push("".replace(aPattern, aReplacement));
    return this;
};
/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */ $94c6b3f1272c04d8$var$SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
    this.sourceContents[$5YHdY.toSetString(aSourceFile)] = aSourceContent;
};
/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */ $94c6b3f1272c04d8$var$SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
    for(var i = 0, len = this.children.length; i < len; i++)if (this.children[i][$94c6b3f1272c04d8$var$isSourceNode]) this.children[i].walkSourceContents(aFn);
    var sources = Object.keys(this.sourceContents);
    for(var i = 0, len = sources.length; i < len; i++)aFn($5YHdY.fromSetString(sources[i]), this.sourceContents[sources[i]]);
};
/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */ $94c6b3f1272c04d8$var$SourceNode.prototype.toString = function SourceNode_toString() {
    var str = "";
    this.walk(function(chunk) {
        str += chunk;
    });
    return str;
};
/**
 * Returns the string representation of this source node along with a source
 * map.
 */ $94c6b3f1272c04d8$var$SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
    var generated = {
        code: "",
        line: 1,
        column: 0
    };
    var map = new $94c6b3f1272c04d8$require$SourceMapGenerator(aArgs);
    var sourceMappingActive = false;
    var lastOriginalSource = null;
    var lastOriginalLine = null;
    var lastOriginalColumn = null;
    var lastOriginalName = null;
    this.walk(function(chunk, original) {
        generated.code += chunk;
        if (original.source !== null && original.line !== null && original.column !== null) {
            if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) map.addMapping({
                source: original.source,
                original: {
                    line: original.line,
                    column: original.column
                },
                generated: {
                    line: generated.line,
                    column: generated.column
                },
                name: original.name
            });
            lastOriginalSource = original.source;
            lastOriginalLine = original.line;
            lastOriginalColumn = original.column;
            lastOriginalName = original.name;
            sourceMappingActive = true;
        } else if (sourceMappingActive) {
            map.addMapping({
                generated: {
                    line: generated.line,
                    column: generated.column
                }
            });
            lastOriginalSource = null;
            sourceMappingActive = false;
        }
        for(var idx = 0, length = chunk.length; idx < length; idx++)if (chunk.charCodeAt(idx) === $94c6b3f1272c04d8$var$NEWLINE_CODE) {
            generated.line++;
            generated.column = 0;
            // Mappings end at eol
            if (idx + 1 === length) {
                lastOriginalSource = null;
                sourceMappingActive = false;
            } else if (sourceMappingActive) map.addMapping({
                source: original.source,
                original: {
                    line: original.line,
                    column: original.column
                },
                generated: {
                    line: generated.line,
                    column: generated.column
                },
                name: original.name
            });
        } else generated.column++;
    });
    this.walkSourceContents(function(sourceFile, sourceContent) {
        map.setSourceContent(sourceFile, sourceContent);
    });
    return {
        code: generated.code,
        map: map
    };
};
$94c6b3f1272c04d8$export$7e987e8f375d24c2 = $94c6b3f1272c04d8$var$SourceNode;

});





parcelRegister("67UTJ", function(module, exports) {

$parcel$export(module.exports, "print", () => $475f8845d78839dd$export$c2d084dc44961371, (v) => $475f8845d78839dd$export$c2d084dc44961371 = v);
$parcel$export(module.exports, "PrintVisitor", () => $475f8845d78839dd$export$142230c39e312c23, (v) => $475f8845d78839dd$export$142230c39e312c23 = v);
/* eslint-disable new-cap */ var $475f8845d78839dd$export$1e511d4a378977f5;
var $475f8845d78839dd$export$c2d084dc44961371;
var $475f8845d78839dd$export$142230c39e312c23;
"use strict";
$475f8845d78839dd$export$1e511d4a378977f5 = true;
$475f8845d78839dd$export$c2d084dc44961371 = $475f8845d78839dd$var$print;
$475f8845d78839dd$export$142230c39e312c23 = $475f8845d78839dd$var$PrintVisitor;
// istanbul ignore next
function $475f8845d78839dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $bCnBd = parcelRequire("bCnBd");
var $475f8845d78839dd$var$_visitor2 = $475f8845d78839dd$var$_interopRequireDefault($bCnBd);
function $475f8845d78839dd$var$print(ast) {
    return new $475f8845d78839dd$var$PrintVisitor().accept(ast);
}
function $475f8845d78839dd$var$PrintVisitor() {
    this.padding = 0;
}
$475f8845d78839dd$var$PrintVisitor.prototype = new $475f8845d78839dd$var$_visitor2["default"]();
$475f8845d78839dd$var$PrintVisitor.prototype.pad = function(string) {
    var out = "";
    for(var i = 0, l = this.padding; i < l; i++)out += "  ";
    out += string + "\n";
    return out;
};
$475f8845d78839dd$var$PrintVisitor.prototype.Program = function(program) {
    var out = "", body = program.body, i = undefined, l = undefined;
    if (program.blockParams) {
        var blockParams = "BLOCK PARAMS: [";
        for(i = 0, l = program.blockParams.length; i < l; i++)blockParams += " " + program.blockParams[i];
        blockParams += " ]";
        out += this.pad(blockParams);
    }
    for(i = 0, l = body.length; i < l; i++)out += this.accept(body[i]);
    this.padding--;
    return out;
};
$475f8845d78839dd$var$PrintVisitor.prototype.MustacheStatement = function(mustache) {
    return this.pad("{{ " + this.SubExpression(mustache) + " }}");
};
$475f8845d78839dd$var$PrintVisitor.prototype.Decorator = function(mustache) {
    return this.pad("{{ DIRECTIVE " + this.SubExpression(mustache) + " }}");
};
$475f8845d78839dd$var$PrintVisitor.prototype.BlockStatement = $475f8845d78839dd$var$PrintVisitor.prototype.DecoratorBlock = function(block) {
    var out = "";
    out += this.pad((block.type === "DecoratorBlock" ? "DIRECTIVE " : "") + "BLOCK:");
    this.padding++;
    out += this.pad(this.SubExpression(block));
    if (block.program) {
        out += this.pad("PROGRAM:");
        this.padding++;
        out += this.accept(block.program);
        this.padding--;
    }
    if (block.inverse) {
        if (block.program) this.padding++;
        out += this.pad("{{^}}");
        this.padding++;
        out += this.accept(block.inverse);
        this.padding--;
        if (block.program) this.padding--;
    }
    this.padding--;
    return out;
};
$475f8845d78839dd$var$PrintVisitor.prototype.PartialStatement = function(partial) {
    var content = "PARTIAL:" + partial.name.original;
    if (partial.params[0]) content += " " + this.accept(partial.params[0]);
    if (partial.hash) content += " " + this.accept(partial.hash);
    return this.pad("{{> " + content + " }}");
};
$475f8845d78839dd$var$PrintVisitor.prototype.PartialBlockStatement = function(partial) {
    var content = "PARTIAL BLOCK:" + partial.name.original;
    if (partial.params[0]) content += " " + this.accept(partial.params[0]);
    if (partial.hash) content += " " + this.accept(partial.hash);
    content += " " + this.pad("PROGRAM:");
    this.padding++;
    content += this.accept(partial.program);
    this.padding--;
    return this.pad("{{> " + content + " }}");
};
$475f8845d78839dd$var$PrintVisitor.prototype.ContentStatement = function(content) {
    return this.pad("CONTENT[ '" + content.value + "' ]");
};
$475f8845d78839dd$var$PrintVisitor.prototype.CommentStatement = function(comment) {
    return this.pad("{{! '" + comment.value + "' }}");
};
$475f8845d78839dd$var$PrintVisitor.prototype.SubExpression = function(sexpr) {
    var params = sexpr.params, paramStrings = [], hash = undefined;
    for(var i = 0, l = params.length; i < l; i++)paramStrings.push(this.accept(params[i]));
    params = "[" + paramStrings.join(", ") + "]";
    hash = sexpr.hash ? " " + this.accept(sexpr.hash) : "";
    return this.accept(sexpr.path) + " " + params + hash;
};
$475f8845d78839dd$var$PrintVisitor.prototype.PathExpression = function(id) {
    var path = id.parts.join("/");
    return (id.data ? "@" : "") + "PATH:" + path;
};
$475f8845d78839dd$var$PrintVisitor.prototype.StringLiteral = function(string) {
    return '"' + string.value + '"';
};
$475f8845d78839dd$var$PrintVisitor.prototype.NumberLiteral = function(number) {
    return "NUMBER{" + number.value + "}";
};
$475f8845d78839dd$var$PrintVisitor.prototype.BooleanLiteral = function(bool) {
    return "BOOLEAN{" + bool.value + "}";
};
$475f8845d78839dd$var$PrintVisitor.prototype.UndefinedLiteral = function() {
    return "UNDEFINED";
};
$475f8845d78839dd$var$PrintVisitor.prototype.NullLiteral = function() {
    return "NULL";
};
$475f8845d78839dd$var$PrintVisitor.prototype.Hash = function(hash) {
    var pairs = hash.pairs, joinedPairs = [];
    for(var i = 0, l = pairs.length; i < l; i++)joinedPairs.push(this.accept(pairs[i]));
    return "HASH{" + joinedPairs.join(", ") + "}";
};
$475f8845d78839dd$var$PrintVisitor.prototype.HashPair = function(pair) {
    return pair.key + "=" + this.accept(pair.value);
}; /* eslint-enable new-cap */ 

});

parcelRegister("foUwZ", function(module, exports) {
"use strict";

});


parcelRegister("7nfBz", function(module, exports) {

$parcel$export(module.exports, "memory", () => $55e6c93ad19b706f$export$827b61424e8f52d2, (v) => $55e6c93ad19b706f$export$827b61424e8f52d2 = v);
$parcel$export(module.exports, "time", () => $55e6c93ad19b706f$export$2da9be4cfdb689b1, (v) => $55e6c93ad19b706f$export$2da9be4cfdb689b1 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $55e6c93ad19b706f$export$827b61424e8f52d2;
var $55e6c93ad19b706f$export$2da9be4cfdb689b1;
var $55e6c93ad19b706f$var$KB = 1024;
var $55e6c93ad19b706f$var$MB = $55e6c93ad19b706f$var$KB * 1024;
var $55e6c93ad19b706f$var$GB = $55e6c93ad19b706f$var$MB * 1024;
var $55e6c93ad19b706f$var$TB = $55e6c93ad19b706f$var$GB * 1024;
var $55e6c93ad19b706f$var$sec = 1000;
var $55e6c93ad19b706f$var$min = $55e6c93ad19b706f$var$sec * 60;
var $55e6c93ad19b706f$var$hr = $55e6c93ad19b706f$var$min * 60;
var $55e6c93ad19b706f$var$day = $55e6c93ad19b706f$var$hr * 24;
var $55e6c93ad19b706f$var$yr = $55e6c93ad19b706f$var$day * 365;
$55e6c93ad19b706f$export$827b61424e8f52d2 = function(amount) {
    if (amount > $55e6c93ad19b706f$var$TB) return (amount / $55e6c93ad19b706f$var$TB).toFixed(2) + "TB";
    else if (amount > $55e6c93ad19b706f$var$GB) return (amount / $55e6c93ad19b706f$var$GB).toFixed(2) + "GB";
    else if (amount > $55e6c93ad19b706f$var$MB) return (amount / $55e6c93ad19b706f$var$MB).toFixed(2) + "MB";
    else if (amount > $55e6c93ad19b706f$var$KB) return (amount / $55e6c93ad19b706f$var$KB).toFixed(2) + "KB";
    else return amount + "B";
};
$55e6c93ad19b706f$export$2da9be4cfdb689b1 = function(millis, numUnitsToShow) {
    if (millis <= 0 || isNaN(millis)) return "0ms";
    if (numUnitsToShow === undefined) numUnitsToShow = 3;
    function mod(timeUnit) {
        var numUnits = Math.floor(millis / timeUnit);
        millis = millis % timeUnit;
        return numUnits;
    }
    var years = mod($55e6c93ad19b706f$var$yr);
    var days = mod($55e6c93ad19b706f$var$day);
    var hours = mod($55e6c93ad19b706f$var$hr);
    var minutes = mod($55e6c93ad19b706f$var$min);
    var seconds = mod($55e6c93ad19b706f$var$sec);
    var numUnitsAdded = 0;
    var formattedTime = "";
    function addTimeUnit(value, unit) {
        if (numUnitsAdded === numUnitsToShow) // don't add any more
        return;
        if (value === 0 && numUnitsAdded === 0) // Don't add a leading zero
        return;
        // add this one.
        if (formattedTime === "") formattedTime += value + unit;
        else formattedTime += " " + value + unit;
        numUnitsAdded++;
    }
    addTimeUnit(years, "y");
    addTimeUnit(days, "d");
    addTimeUnit(hours, "h");
    addTimeUnit(minutes, "min");
    addTimeUnit(seconds, "s");
    // Only show millis if the time is below 1 second
    if (seconds === 0) addTimeUnit(millis, "ms");
    return formattedTime;
};

});

parcelRegister("jZSGY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e8ee238cdf9e89ad$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $e8ee238cdf9e89ad$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "1": function(container, depth0, helpers, partials, data) {
        return '<div class="remove"><span class="glyphicon glyphicon-remove"></span></div>';
    },
    "3": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="caption">' + container.escapeExpression((helper = (helper = lookupProperty(helpers, "caption") || (depth0 != null ? lookupProperty(depth0, "caption") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "caption",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 3,
                    "column": 40
                },
                "end": {
                    "line": 3,
                    "column": 51
                }
            }
        }) : helper)) + "</div>";
    },
    "5": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '    <table class="errors">\n' + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "errors") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(6, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 6,
                    "column": 8
                },
                "end": {
                    "line": 11,
                    "column": 17
                }
            }
        })) != null ? stack1 : "") + "    </table>\n";
    },
    "6": function(container, depth0, helpers, partials, data) {
        var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "        <tr>\n            <td>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "label") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(7, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 8,
                    "column": 16
                },
                "end": {
                    "line": 8,
                    "column": 95
                }
            }
        })) != null ? stack1 : "") + "</td>\n            <td>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "message") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(9, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 9,
                    "column": 16
                },
                "end": {
                    "line": 9,
                    "column": 88
                }
            }
        })) != null ? stack1 : "") + "</td>\n        </tr>\n";
    },
    "7": function(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<span class="label label-danger">' + container.escapeExpression(container.lambda(depth0 != null ? lookupProperty(depth0, "label") : depth0, depth0)) + "</span>";
    },
    "9": function(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<span class="message">' + container.escapeExpression(container.lambda(depth0 != null ? lookupProperty(depth0, "message") : depth0, depth0)) + "</span>";
    },
    "11": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="footer">' + container.escapeExpression((helper = (helper = lookupProperty(helpers, "footer") || (depth0 != null ? lookupProperty(depth0, "footer") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "footer",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 14,
                    "column": 38
                },
                "end": {
                    "line": 14,
                    "column": 48
                }
            }
        }) : helper)) + "</div>";
    },
    "13": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var alias1 = container.lambda, alias2 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '        <div class="btn btn-small" cbwf-controller="' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "controller") : depth0, depth0)) + '" descUrl="' + alias2(alias1(depths[1] != null ? lookupProperty(depths[1], "descUrl") : depths[1], depth0)) + '"><span class="glyphicon glyphicon-' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "icon") : depth0, depth0)) + '"></span> ' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "label") : depth0, depth0)) + "</div>\n";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="alert alert-' + alias4((helper = (helper = lookupProperty(helpers, "alert") || (depth0 != null ? lookupProperty(depth0, "alert") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "alert",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 24
                },
                "end": {
                    "line": 1,
                    "column": 33
                }
            }
        }) : helper)) + " cbwf-info-action-popover " + alias4((helper = (helper = lookupProperty(helpers, "alert-classes") || (depth0 != null ? lookupProperty(depth0, "alert-classes") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "alert-classes",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 59
                },
                "end": {
                    "line": 1,
                    "column": 76
                }
            }
        }) : helper)) + '">\n    ' + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "dismissible") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(1, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 2,
                    "column": 4
                },
                "end": {
                    "line": 2,
                    "column": 104
                }
            }
        })) != null ? stack1 : "") + "\n    " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "caption") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(3, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 3,
                    "column": 4
                },
                "end": {
                    "line": 3,
                    "column": 64
                }
            }
        })) != null ? stack1 : "") + "\n" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "errors") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(5, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 4,
                    "column": 4
                },
                "end": {
                    "line": 13,
                    "column": 11
                }
            }
        })) != null ? stack1 : "") + "    " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "footer") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(11, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 14,
                    "column": 4
                },
                "end": {
                    "line": 14,
                    "column": 61
                }
            }
        })) != null ? stack1 : "") + '\n    <div class="cbwf-menu-item btn-toolbar" role="toolbar">\n      <div class="btn-group">\n' + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "options") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(13, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 17,
                    "column": 6
                },
                "end": {
                    "line": 19,
                    "column": 15
                }
            }
        })) != null ? stack1 : "") + "      </div></div>\n\n</div>";
    },
    "useData": true,
    "useDepths": true
});
var $e8ee238cdf9e89ad$export$2e2bcd8739ae039 = $e8ee238cdf9e89ad$var$templateFunction;

});

parcelRegister("jlxc9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e159ba51650c58ce$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $e159ba51650c58ce$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="cbwf-dialog ' + alias1(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "options") : depth0) != null ? lookupProperty(stack1, "classes") : stack1, depth0)) + '">\n    <div class="remove"><span class="glyphicon glyphicon-remove"></span></div>\n    <div class="header">' + alias1((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "title",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 3,
                    "column": 24
                },
                "end": {
                    "line": 3,
                    "column": 33
                }
            }
        }) : helper)) + '</div>\n    <div class="body"></div>\n</div>';
    },
    "useData": true
});
var $e159ba51650c58ce$export$2e2bcd8739ae039 = $e159ba51650c58ce$var$templateFunction;

});

parcelRegister("40VB7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2ec3d73518611c5a$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $2ec3d73518611c5a$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "1": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="table-box"><div class="table-viewPort">\n<table class="jobsTable" style="max-width:' + container.escapeExpression((helper = (helper = lookupProperty(helpers, "maxTableEms") || (depth0 != null ? lookupProperty(depth0, "maxTableEms") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
            "name": "maxTableEms",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 5,
                    "column": 42
                },
                "end": {
                    "line": 5,
                    "column": 57
                }
            }
        }) : helper)) + 'em">\n  <colgroup>\n    <col class="start-group" />\n' + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "stageData") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(2, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 8,
                    "column": 4
                },
                "end": {
                    "line": 10,
                    "column": 13
                }
            }
        })) != null ? stack1 : "") + '  </colgroup>\n    <thead>\n    <tr class="header">\n        <th class="stage-start"></th>\n' + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "stageData") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(4, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 15,
                    "column": 8
                },
                "end": {
                    "line": 17,
                    "column": 17
                }
            }
        })) != null ? stack1 : "") + '    </tr>\n    </thead>\n    <tbody class="totals-box">\n    <tr class="totals">\n        <td class="stage-start"><div class="cell-color">\n          Average stage times:<br />\n' + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "avgDurationMillisNoPause") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(6, data, 0, blockParams, depths),
            "inverse": container.program(8, data, 0, blockParams, depths),
            "data": data,
            "loc": {
                "start": {
                    "line": 24,
                    "column": 10
                },
                "end": {
                    "line": 28,
                    "column": 17
                }
            }
        })) != null ? stack1 : "") + "        </div></td>\n" + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "stageData") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(10, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 30,
                    "column": 8
                },
                "end": {
                    "line": 37,
                    "column": 17
                }
            }
        })) != null ? stack1 : "") + '    </tr>\n  </tbody>\n    <tbody class="tobsTable-body">\n' + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "runs") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(12, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 41,
                    "column": 4
                },
                "end": {
                    "line": 145,
                    "column": 13
                }
            }
        })) != null ? stack1 : "") + "  </tbody>\n\n</table>\n";
    },
    "2": function(container, depth0, helpers, partials, data) {
        return '      <col class="stage-group" style="max-width:10em;" />\n';
    },
    "4": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '        <th class="stage-header-name-' + alias1((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 16,
                    "column": 37
                },
                "end": {
                    "line": 16,
                    "column": 47
                }
            }
        }) : helper)) + '">' + alias1(container.lambda(depth0 != null ? lookupProperty(depth0, "name") : depth0, depth0)) + "</th>\n";
    },
    "6": function(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '          (<span style="text-decoration: underline;" title="builds that run all stages">full</span> run time: ~' + container.escapeExpression((lookupProperty(helpers, "formatTime") || depth0 && lookupProperty(depth0, "formatTime") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "avgDurationMillisNoPause") : depth0, 2, {
            "name": "formatTime",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 25,
                    "column": 111
                },
                "end": {
                    "line": 25,
                    "column": 152
                }
            }
        })) + ")\n";
    },
    "8": function(container, depth0, helpers, partials, data) {
        return "          &nbsp;\n";
    },
    "10": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '        <td class="stage-total-' + alias3((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 31,
                    "column": 31
                },
                "end": {
                    "line": 31,
                    "column": 41
                }
            }
        }) : helper)) + '">\n          <div class="cell-color">\n            <div class="duration">' + alias3((lookupProperty(helpers, "formatTime") || depth0 && lookupProperty(depth0, "formatTime") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "avgDurationMillisNoPause") : depth0, 2, {
            "name": "formatTime",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 33,
                    "column": 34
                },
                "end": {
                    "line": 33,
                    "column": 75
                }
            }
        })) + '</div>\n            <div class="stackedBarChart"></div>\n          </div>\n        </td>\n';
    },
    "12": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, alias1 = container.lambda, alias2 = container.escapeExpression, alias3 = depth0 != null ? depth0 : container.nullContext || {}, alias4 = container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '    <tr class="job ' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "status") : depth0, depth0)) + '" data-runId="' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "id") : depth0, depth0)) + '">\n        <td class="stage-start">\n          <div class="cell-color">\n            <div class="cell-box">\n              <div class="jobName"><span class="badge"><a href="' + ((stack1 = lookupProperty(helpers, "if").call(alias3, depth0 != null ? lookupProperty(depth0, "id") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(13, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 46,
                    "column": 64
                },
                "end": {
                    "line": 46,
                    "column": 98
                }
            }
        })) != null ? stack1 : "") + '">' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "name") : depth0, depth0)) + '</a></span></div>\n              <div class="stage-start-box">\n                <div class="stage-start-time">\n                  <div class="date">' + alias2((lookupProperty(helpers, "formatDate") || depth0 && lookupProperty(depth0, "formatDate") || alias4).call(alias3, depth0 != null ? lookupProperty(depth0, "startTimeMillis") : depth0, "month", {
            "name": "formatDate",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 49,
                    "column": 36
                },
                "end": {
                    "line": 49,
                    "column": 79
                }
            }
        })) + " " + alias2((lookupProperty(helpers, "formatDate") || depth0 && lookupProperty(depth0, "formatDate") || alias4).call(alias3, depth0 != null ? lookupProperty(depth0, "startTimeMillis") : depth0, "dom", {
            "name": "formatDate",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 49,
                    "column": 80
                },
                "end": {
                    "line": 49,
                    "column": 121
                }
            }
        })) + '</div>\n                  <div class="year">' + alias2((lookupProperty(helpers, "formatDate") || depth0 && lookupProperty(depth0, "formatDate") || alias4).call(alias3, depth0 != null ? lookupProperty(depth0, "startTimeMillis") : depth0, "year", {
            "name": "formatDate",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 50,
                    "column": 36
                },
                "end": {
                    "line": 50,
                    "column": 78
                }
            }
        })) + '</div>\n                  <div class="time">' + alias2((lookupProperty(helpers, "formatDate") || depth0 && lookupProperty(depth0, "formatDate") || alias4).call(alias3, depth0 != null ? lookupProperty(depth0, "startTimeMillis") : depth0, "time", {
            "name": "formatDate",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 51,
                    "column": 36
                },
                "end": {
                    "line": 51,
                    "column": 78
                }
            }
        })) + "</div>\n                </div>\n                " + ((stack1 = lookupProperty(helpers, "if").call(alias3, (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "changesets") : stack1, {
            "name": "if",
            "hash": {},
            "fn": container.program(15, data, 0, blockParams, depths),
            "inverse": container.program(17, data, 0, blockParams, depths),
            "data": data,
            "loc": {
                "start": {
                    "line": 53,
                    "column": 16
                },
                "end": {
                    "line": 56,
                    "column": 23
                }
            }
        })) != null ? stack1 : "") + '                <div class="stage-end-icons extension-dock">\n' + ((stack1 = lookupProperty(helpers, "if").call(alias3, (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "artifacts") : stack1, {
            "name": "if",
            "hash": {},
            "fn": container.program(19, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 58,
                    "column": 18
                },
                "end": {
                    "line": 60,
                    "column": 25
                }
            }
        })) != null ? stack1 : "") + '                </div>\n              </div>\n\n              <div class="clearfix"></div>\n\n' + ((stack1 = lookupProperty(helpers, "unless").call(alias3, depth0 != null ? lookupProperty(depth0, "durationMillis") : depth0, {
            "name": "unless",
            "hash": {},
            "fn": container.program(21, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 66,
                    "column": 14
                },
                "end": {
                    "line": 72,
                    "column": 25
                }
            }
        })) != null ? stack1 : "") + "            </div>\n          </div>\n        </td>\n" + ((stack1 = lookupProperty(helpers, "each").call(alias3, depth0 != null ? lookupProperty(depth0, "stages") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(24, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 76,
                    "column": 8
                },
                "end": {
                    "line": 121,
                    "column": 13
                }
            }
        })) != null ? stack1 : "") + "    </tr>\n" + ((stack1 = lookupProperty(helpers, "if").call(alias3, depth0 != null ? lookupProperty(depth0, "durationMillis") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(41, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 123,
                    "column": 4
                },
                "end": {
                    "line": 144,
                    "column": 11
                }
            }
        })) != null ? stack1 : "");
    },
    "13": function(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return container.escapeExpression(container.lambda(depth0 != null ? lookupProperty(depth0, "id") : depth0, depth0)) + "/";
    },
    "15": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="changeset-box" cbwf-controller="run-changesets" objectUrl="' + container.escapeExpression(container.lambda((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "changesets") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '"></div>\n';
    },
    "17": function(container, depth0, helpers, partials, data) {
        return '                <div class="changeset-box no-changes">No Changes</div>\n';
    },
    "19": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                  <div cbwf-controller="build-artifacts-popup" objectUrl="' + container.escapeExpression(container.lambda((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "artifacts") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '"><a class="link"><i class="glyphicon glyphicon-download" title="Download"></i></a></div>\n';
    },
    "21": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return (stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "status") : depth0, "==", "IN_PROGRESS", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(22, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 67,
                    "column": 14
                },
                "end": {
                    "line": 71,
                    "column": 25
                }
            }
        })) != null ? stack1 : "";
    },
    "22": function(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '              <div class="time-in-queue progress" title="waiting in queue">\n                  <div class="progress-bar progress-bar-warning progress-bar-striped active" style="width: 100%">' + container.escapeExpression((lookupProperty(helpers, "formatTime") || depth0 && lookupProperty(depth0, "formatTime") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "queueDurationMillis") : depth0, 2, {
            "name": "formatTime",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 69,
                    "column": 113
                },
                "end": {
                    "line": 69,
                    "column": 154
                }
            }
        })) + "</div>\n              </div>\n";
    },
    "24": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, alias5 = container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '        <td class="stage-cell stage-cell-' + alias4((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 77,
                    "column": 41
                },
                "end": {
                    "line": 77,
                    "column": 51
                }
            }
        }) : helper)) + " " + alias4(alias5(depth0 != null ? lookupProperty(depth0, "status") : depth0, depth0)) + '" data-stageId="' + alias4(alias5(depth0 != null ? lookupProperty(depth0, "id") : depth0, depth0)) + '">\n          <div class="cell-color">\n            <div class="stage-wrapper">\n                <div class="duration" >\n                    <span style="font-size: ' + alias4((helper = (helper = lookupProperty(helpers, "emphasise") || (depth0 != null ? lookupProperty(depth0, "emphasise") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "emphasise",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 81,
                    "column": 44
                },
                "end": {
                    "line": 81,
                    "column": 57
                }
            }
        }) : helper)) + "em; opacity: " + alias4((lookupProperty(helpers, "emphasiseToOpacity") || depth0 && lookupProperty(depth0, "emphasiseToOpacity") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "emphasise") : depth0, {
            "name": "emphasiseToOpacity",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 81,
                    "column": 70
                },
                "end": {
                    "line": 81,
                    "column": 102
                }
            }
        })) + ';">' + alias4((lookupProperty(helpers, "formatTime") || depth0 && lookupProperty(depth0, "formatTime") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "durationMillisNoPause") : depth0, 2, {
            "name": "formatTime",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 81,
                    "column": 105
                },
                "end": {
                    "line": 81,
                    "column": 148
                }
            }
        })) + "</span>\n                </div>\n" + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "status") : depth0, "===", "ABORTED", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(25, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 83,
                    "column": 16
                },
                "end": {
                    "line": 85,
                    "column": 27
                }
            }
        })) != null ? stack1 : "") + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "status") : depth0, "===", "SUCCESS", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(27, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 86,
                    "column": 16
                },
                "end": {
                    "line": 88,
                    "column": 27
                }
            }
        })) != null ? stack1 : "") + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "status") : depth0, "===", "IN_PROGRESS", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(29, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 89,
                    "column": 16
                },
                "end": {
                    "line": 91,
                    "column": 27
                }
            }
        })) != null ? stack1 : "") + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "status") : depth0, "===", "UNSTABLE", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(31, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 92,
                    "column": 16
                },
                "end": {
                    "line": 94,
                    "column": 27
                }
            }
        })) != null ? stack1 : "") + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "status") : depth0, "===", "PAUSED_PENDING_INPUT", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(33, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 95,
                    "column": 16
                },
                "end": {
                    "line": 98,
                    "column": 27
                }
            }
        })) != null ? stack1 : "") + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "status") : depth0, "===", "FAILED", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(35, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 99,
                    "column": 16
                },
                "end": {
                    "line": 102,
                    "column": 27
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "percentCompleteEstimate") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(37, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 103,
                    "column": 16
                },
                "end": {
                    "line": 107,
                    "column": 23
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "pauseDurationMillis") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(39, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 112,
                    "column": 16
                },
                "end": {
                    "line": 116,
                    "column": 23
                }
            }
        })) != null ? stack1 : "") + '                <div class="extension-dock"></div>\n            </div>\n          </div>\n    </td>\n';
    },
    "25": function(container, depth0, helpers, partials, data) {
        return '                    <div class="status">aborted</div>\n';
    },
    "27": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                    <div cbwf-controller="stage-actions-popover" descUrl="' + container.escapeExpression(container.lambda((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "self") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '" notIf="stage-actions-popover,stage-failed-popover" caption="Success"></div>\n';
    },
    "29": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                    <div cbwf-controller="stage-actions-popover" descUrl="' + container.escapeExpression(container.lambda((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "self") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '" notIf="stage-actions-popover,stage-failed-popover" caption="In Progress"></div>\n';
    },
    "31": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                    <div cbwf-controller="stage-actions-popover" descUrl="' + container.escapeExpression(container.lambda((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "self") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '" notIf="stage-actions-popover,stage-failed-popover" caption="Unstable Build"></div>\n';
    },
    "33": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                    <div cbwf-controller="run-input-required" objectUrl="' + container.escapeExpression(container.lambda((stack1 = (stack1 = depths[1] != null ? lookupProperty(depths[1], "_links") : depths[1]) != null ? lookupProperty(stack1, "nextPendingInputAction") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '"></div>\n                    <div class="status">paused</div>\n';
    },
    "35": function(container, depth0, helpers, partials, data) {
        var stack1, alias1 = container.lambda, alias2 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                    <div cbwf-controller="stage-failed-popover" descUrl="' + alias2(alias1((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "self") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '" objectUrl="' + alias2(alias1((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "self") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '" notIf="stage-actions-popover,stage-failed-popover"></div>\n                    <div class="status">failed</div>\n';
    },
    "37": function(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                    <div class="progress">\n                        <div class="progress-bar progress-bar-striped" style="width: ' + container.escapeExpression(container.lambda(depth0 != null ? lookupProperty(depth0, "percentCompleteEstimate") : depth0, depth0)) + '%"></div>\n                    </div>\n';
    },
    "39": function(container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                    <div class="pause-duration">\n                        <span title="paused for ' + alias3((lookupProperty(helpers, "formatTime") || depth0 && lookupProperty(depth0, "formatTime") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "pauseDurationMillis") : depth0, 2, {
            "name": "formatTime",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 114,
                    "column": 48
                },
                "end": {
                    "line": 114,
                    "column": 89
                }
            }
        })) + '">(paused for ' + alias3((lookupProperty(helpers, "formatTime") || depth0 && lookupProperty(depth0, "formatTime") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "pauseDurationMillis") : depth0, 2, {
            "name": "formatTime",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 114,
                    "column": 103
                },
                "end": {
                    "line": 114,
                    "column": 144
                }
            }
        })) + ")</span>\n                    </div>\n";
    },
    "41": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "percentCompleteEstimate") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(42, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 124,
                    "column": 4
                },
                "end": {
                    "line": 143,
                    "column": 11
                }
            }
        })) != null ? stack1 : "";
    },
    "42": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, alias1 = container.lambda, alias2 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '    <tr class="in-progress-run">\n        <td class="stage-start hide-cell"></td>\n        <td class="totalComplete" colspan="' + alias2(alias1((stack1 = depths[1] != null ? lookupProperty(depths[1], "stageData") : depths[1]) != null ? lookupProperty(stack1, "length") : stack1, depth0)) + '">\n            <div class="progress">\n                <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="45"\n                     aria-valuemin="0" aria-valuemax="100"\n                     style="width:' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "percentCompleteEstimate") : depth0, depth0)) + '%">\n                </div>\n' + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depths[3] != null ? lookupProperty(depths[3], "numRuns") : depths[3], ">", 0, {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(43, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 133,
                    "column": 16
                },
                "end": {
                    "line": 139,
                    "column": 27
                }
            }
        })) != null ? stack1 : "") + "            </div>\n        </td>\n    </tr>\n";
    },
    "43": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depths[1] != null ? lookupProperty(depths[1], "timeRemainingEstimate") : depths[1], {
            "name": "if",
            "hash": {},
            "fn": container.program(44, data, 0, blockParams, depths),
            "inverse": container.program(46, data, 0, blockParams, depths),
            "data": data,
            "loc": {
                "start": {
                    "line": 134,
                    "column": 20
                },
                "end": {
                    "line": 138,
                    "column": 27
                }
            }
        })) != null ? stack1 : "";
    },
    "44": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                        <span class="time-remaining">' + container.escapeExpression((lookupProperty(helpers, "formatTime") || depth0 && lookupProperty(depth0, "formatTime") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depths[1] != null ? lookupProperty(depths[1], "timeRemainingEstimate") : depths[1], 2, {
            "name": "formatTime",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 135,
                    "column": 53
                },
                "end": {
                    "line": 135,
                    "column": 94
                }
            }
        })) + "</span>\n";
    },
    "46": function(container, depth0, helpers, partials, data) {
        return '                        <span class="time-remaining">almost complete</span>\n';
    },
    "48": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "numRuns") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(49, data, 0),
            "inverse": container.program(51, data, 0),
            "data": data,
            "loc": {
                "start": {
                    "line": 150,
                    "column": 4
                },
                "end": {
                    "line": 154,
                    "column": 11
                }
            }
        })) != null ? stack1 : "";
    },
    "49": function(container, depth0, helpers, partials, data) {
        return '        <div class="alert alert-warning">This Pipeline has run successfully, but does not define any stages. Please use the <code>stage</code> step to define some stages in this Pipeline.</div>\n';
    },
    "51": function(container, depth0, helpers, partials, data) {
        return '        <div class="alert alert-info">No data available. This Pipeline has not yet run.</div>\n';
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div id="pipeline-box">\n<h2>' + container.escapeExpression((helper = (helper = lookupProperty(helpers, "fragCaption") || (depth0 != null ? lookupProperty(depth0, "fragCaption") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
            "name": "fragCaption",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 2,
                    "column": 4
                },
                "end": {
                    "line": 2,
                    "column": 19
                }
            }
        }) : helper)) + "</h2>\n" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "numStages") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(1, data, 0, blockParams, depths),
            "inverse": container.program(48, data, 0, blockParams, depths),
            "data": data,
            "loc": {
                "start": {
                    "line": 3,
                    "column": 0
                },
                "end": {
                    "line": 155,
                    "column": 7
                }
            }
        })) != null ? stack1 : "") + "</div>\n";
    },
    "useData": true,
    "useDepths": true
});
var $2ec3d73518611c5a$export$2e2bcd8739ae039 = $2ec3d73518611c5a$var$templateFunction;

});

parcelRegister("3iNqj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $267963fd4923883b$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $267963fd4923883b$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "1": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '    <div class="glyphicon glyphicon-align-justify">\n        <div class="cbwf-menu-items">\n' + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "items") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(2, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 5,
                    "column": 12
                },
                "end": {
                    "line": 9,
                    "column": 21
                }
            }
        })) != null ? stack1 : "") + "        </div>\n    </div>\n";
    },
    "2": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var alias1 = container.lambda, alias2 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                <div class="cbwf-menu-item">\n                    <div cbwf-controller="' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "controller") : depth0, depth0)) + '" descUrl="' + alias2(alias1(depths[1] != null ? lookupProperty(depths[1], "descUrl") : depths[1], depth0)) + '"><span class="glyphicon glyphicon-' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "icon") : depth0, depth0)) + '"></span> ' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "label") : depth0, depth0)) + "</div>\n                </div>\n";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="cbwf-popout-menu">\n' + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "items") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(1, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 2,
                    "column": 4
                },
                "end": {
                    "line": 12,
                    "column": 11
                }
            }
        })) != null ? stack1 : "") + "</div>";
    },
    "useData": true,
    "useDepths": true
});
var $267963fd4923883b$export$2e2bcd8739ae039 = $267963fd4923883b$var$templateFunction;

});

parcelRegister("isNC3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d7115390552b7f17$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $d7115390552b7f17$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "1": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return (stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "status") : depth0, "!=", "NOT_EXECUTED", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(2, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 3,
                    "column": 8
                },
                "end": {
                    "line": 23,
                    "column": 19
                }
            }
        })) != null ? stack1 : "";
    },
    "2": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "log") : stack1) != null ? lookupProperty(stack1, "href") : stack1, {
            "name": "if",
            "hash": {},
            "fn": container.program(3, data, 0),
            "inverse": container.program(8, data, 0),
            "data": data,
            "loc": {
                "start": {
                    "line": 4,
                    "column": 8
                },
                "end": {
                    "line": 22,
                    "column": 15
                }
            }
        })) != null ? stack1 : "";
    },
    "3": function(container, depth0, helpers, partials, data) {
        var stack1, alias1 = container.lambda, alias2 = container.escapeExpression, alias3 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '        <div class="node-log-frame ' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "status") : depth0, depth0)) + '" cbwf-controller="node-log" objectUrl="' + alias2(alias1((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "log") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '">\n            <div class="node-name"><span class="glyphicon glyphicon-collapse-down" title="Expand"></span><span class="glyphicon glyphicon-collapse-up" title="Collapse"></span>\n                <a class="log-link" href="' + alias2(alias1((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "console") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '">\n                ' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "name") : depth0, depth0)) + "\n" + ((stack1 = lookupProperty(helpers, "if").call(alias3, depth0 != null ? lookupProperty(depth0, "parameterDescription") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(4, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 9,
                    "column": 16
                },
                "end": {
                    "line": 11,
                    "column": 23
                }
            }
        })) != null ? stack1 : "") + "                </a>\n                " + ((stack1 = lookupProperty(helpers, "if").call(alias3, depth0 != null ? lookupProperty(depth0, "durationMillis") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(6, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 13,
                    "column": 16
                },
                "end": {
                    "line": 13,
                    "column": 97
                }
            }
        })) != null ? stack1 : "") + '\n\n            </div>\n            <div class="log-details"></div>\n        </div>\n';
    },
    "4": function(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "                    -- " + container.escapeExpression(container.lambda(depth0 != null ? lookupProperty(depth0, "parameterDescription") : depth0, depth0)) + "\n";
    },
    "6": function(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return " (self time " + container.escapeExpression((lookupProperty(helpers, "formatTime") || depth0 && lookupProperty(depth0, "formatTime") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "durationMillis") : depth0, {
            "name": "formatTime",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 13,
                    "column": 55
                },
                "end": {
                    "line": 13,
                    "column": 89
                }
            }
        })) + ")";
    },
    "8": function(container, depth0, helpers, partials, data) {
        var stack1, alias1 = container.lambda, alias2 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '        <div class="node-log-frame ' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "status") : depth0, depth0)) + '" objectUrl="' + alias2(alias1((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "_links") : depth0) != null ? lookupProperty(stack1, "self") : stack1) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + '">\n            <div class="node-name">' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "name") : depth0, depth0)) + "  " + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "durationMillis") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(9, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 20,
                    "column": 50
                },
                "end": {
                    "line": 20,
                    "column": 130
                }
            }
        })) != null ? stack1 : "") + "</div>\n        </div>\n";
    },
    "9": function(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "(self time " + container.escapeExpression((lookupProperty(helpers, "formatTime") || depth0 && lookupProperty(depth0, "formatTime") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "durationMillis") : depth0, {
            "name": "formatTime",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 20,
                    "column": 88
                },
                "end": {
                    "line": 20,
                    "column": 122
                }
            }
        })) + ")";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="cbwf-stage-logs">\n' + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "stageFlowNodes") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 2,
                    "column": 4
                },
                "end": {
                    "line": 24,
                    "column": 13
                }
            }
        })) != null ? stack1 : "") + "</div>\n";
    },
    "useData": true
});
var $d7115390552b7f17$export$2e2bcd8739ae039 = $d7115390552b7f17$var$templateFunction;

});

parcelRegister("2kuwV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1b2521a578275257$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $1b2521a578275257$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<pre class="console-output">' + ((stack1 = (helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "text",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 28
                },
                "end": {
                    "line": 1,
                    "column": 38
                }
            }
        }) : helper)) != null ? stack1 : "") + "</pre>";
    },
    "useData": true
});
var $1b2521a578275257$export$2e2bcd8739ae039 = $1b2521a578275257$var$templateFunction;

});

parcelRegister("8LLi5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $66276572e9e3ded2$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $66276572e9e3ded2$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "1": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "type") : depth0, "===", "BooleanParameterDefinition", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(2, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 7,
                    "column": 12
                },
                "end": {
                    "line": 14,
                    "column": 23
                }
            }
        })) != null ? stack1 : "") + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "type") : depth0, "===", "StringParameterDefinition", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(7, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 15,
                    "column": 12
                },
                "end": {
                    "line": 21,
                    "column": 23
                }
            }
        })) != null ? stack1 : "") + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "type") : depth0, "===", "TextParameterDefinition", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(9, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 22,
                    "column": 12
                },
                "end": {
                    "line": 28,
                    "column": 23
                }
            }
        })) != null ? stack1 : "") + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "type") : depth0, "===", "PasswordParameterDefinition", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(11, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 29,
                    "column": 12
                },
                "end": {
                    "line": 35,
                    "column": 23
                }
            }
        })) != null ? stack1 : "") + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "type") : depth0, "===", "ChoiceParameterDefinition", {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(13, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 36,
                    "column": 12
                },
                "end": {
                    "line": 51,
                    "column": 23
                }
            }
        })) != null ? stack1 : "");
    },
    "2": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                <div class="checkbox">\n                    <label>\n                        <input name="' + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 10,
                    "column": 37
                },
                "end": {
                    "line": 10,
                    "column": 45
                }
            }
        }) : helper)) + '" type="checkbox" ' + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "definition") : depth0) != null ? lookupProperty(stack1, "defaultVal") : stack1, {
            "name": "if",
            "hash": {},
            "fn": container.program(3, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 10,
                    "column": 63
                },
                "end": {
                    "line": 10,
                    "column": 116
                }
            }
        })) != null ? stack1 : "") + ">" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 10,
                    "column": 117
                },
                "end": {
                    "line": 10,
                    "column": 125
                }
            }
        }) : helper)) + "\n                    </label>\n                    " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(5, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 12,
                    "column": 20
                },
                "end": {
                    "line": 12,
                    "column": 87
                }
            }
        })) != null ? stack1 : "") + "\n                </div>\n";
    },
    "3": function(container, depth0, helpers, partials, data) {
        return 'checked="checked"';
    },
    "5": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<p class="help-block">' + container.escapeExpression((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "description",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 12,
                    "column": 61
                },
                "end": {
                    "line": 12,
                    "column": 76
                }
            }
        }) : helper)) + "</p>";
    },
    "7": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                <div class="form-group">\n                    <label for="' + alias4((helper = (helper = lookupProperty(helpers, "id") || (depth0 != null ? lookupProperty(depth0, "id") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "id",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 17,
                    "column": 32
                },
                "end": {
                    "line": 17,
                    "column": 38
                }
            }
        }) : helper)) + "-input-" + alias4((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 17,
                    "column": 45
                },
                "end": {
                    "line": 17,
                    "column": 55
                }
            }
        }) : helper)) + '">' + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 17,
                    "column": 57
                },
                "end": {
                    "line": 17,
                    "column": 65
                }
            }
        }) : helper)) + '</label>\n                    <input name="' + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 18,
                    "column": 33
                },
                "end": {
                    "line": 18,
                    "column": 41
                }
            }
        }) : helper)) + '" type="text" class="form-control" id="' + alias4((helper = (helper = lookupProperty(helpers, "id") || (depth0 != null ? lookupProperty(depth0, "id") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "id",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 18,
                    "column": 80
                },
                "end": {
                    "line": 18,
                    "column": 86
                }
            }
        }) : helper)) + "-input-" + alias4((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 18,
                    "column": 93
                },
                "end": {
                    "line": 18,
                    "column": 103
                }
            }
        }) : helper)) + '" value="' + alias4(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "definition") : depth0) != null ? lookupProperty(stack1, "defaultVal") : stack1, depth0)) + '">\n                    ' + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(5, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 19,
                    "column": 20
                },
                "end": {
                    "line": 19,
                    "column": 87
                }
            }
        })) != null ? stack1 : "") + "\n                </div>\n";
    },
    "9": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                <div class="form-group">\n                    <label for="' + alias4((helper = (helper = lookupProperty(helpers, "id") || (depth0 != null ? lookupProperty(depth0, "id") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "id",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 24,
                    "column": 32
                },
                "end": {
                    "line": 24,
                    "column": 38
                }
            }
        }) : helper)) + "-input-" + alias4((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 24,
                    "column": 45
                },
                "end": {
                    "line": 24,
                    "column": 55
                }
            }
        }) : helper)) + '">' + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 24,
                    "column": 57
                },
                "end": {
                    "line": 24,
                    "column": 65
                }
            }
        }) : helper)) + '</label>\n                    <textarea name="' + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 25,
                    "column": 36
                },
                "end": {
                    "line": 25,
                    "column": 44
                }
            }
        }) : helper)) + '" type="text" class="form-control" id="' + alias4((helper = (helper = lookupProperty(helpers, "id") || (depth0 != null ? lookupProperty(depth0, "id") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "id",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 25,
                    "column": 83
                },
                "end": {
                    "line": 25,
                    "column": 89
                }
            }
        }) : helper)) + "-input-" + alias4((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 25,
                    "column": 96
                },
                "end": {
                    "line": 25,
                    "column": 106
                }
            }
        }) : helper)) + '">' + alias4(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "definition") : depth0) != null ? lookupProperty(stack1, "defaultVal") : stack1, depth0)) + "</textarea>\n                    " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(5, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 26,
                    "column": 20
                },
                "end": {
                    "line": 26,
                    "column": 87
                }
            }
        })) != null ? stack1 : "") + "\n                </div>\n";
    },
    "11": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                <div class="form-group">\n                    <label for="' + alias4((helper = (helper = lookupProperty(helpers, "id") || (depth0 != null ? lookupProperty(depth0, "id") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "id",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 31,
                    "column": 32
                },
                "end": {
                    "line": 31,
                    "column": 38
                }
            }
        }) : helper)) + "-input-" + alias4((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 31,
                    "column": 45
                },
                "end": {
                    "line": 31,
                    "column": 55
                }
            }
        }) : helper)) + '">' + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 31,
                    "column": 57
                },
                "end": {
                    "line": 31,
                    "column": 65
                }
            }
        }) : helper)) + '</label>\n                    <input name="' + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 32,
                    "column": 33
                },
                "end": {
                    "line": 32,
                    "column": 41
                }
            }
        }) : helper)) + '" type="password" class="form-control" id="' + alias4((helper = (helper = lookupProperty(helpers, "id") || (depth0 != null ? lookupProperty(depth0, "id") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "id",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 32,
                    "column": 84
                },
                "end": {
                    "line": 32,
                    "column": 90
                }
            }
        }) : helper)) + "-input-" + alias4((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 32,
                    "column": 97
                },
                "end": {
                    "line": 32,
                    "column": 107
                }
            }
        }) : helper)) + '" value="' + alias4(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "definition") : depth0) != null ? lookupProperty(stack1, "defaultVal") : stack1, depth0)) + '" placeholder="Password">\n                    ' + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(5, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 33,
                    "column": 20
                },
                "end": {
                    "line": 33,
                    "column": 87
                }
            }
        })) != null ? stack1 : "") + "\n                </div>\n";
    },
    "13": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                <div class="form-group">\n                    <label for="' + alias4((helper = (helper = lookupProperty(helpers, "id") || (depth0 != null ? lookupProperty(depth0, "id") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "id",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 38,
                    "column": 32
                },
                "end": {
                    "line": 38,
                    "column": 38
                }
            }
        }) : helper)) + "-input-" + alias4((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 38,
                    "column": 45
                },
                "end": {
                    "line": 38,
                    "column": 55
                }
            }
        }) : helper)) + '">' + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 38,
                    "column": 57
                },
                "end": {
                    "line": 38,
                    "column": 65
                }
            }
        }) : helper)) + '</label>\n                    <select name="' + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 39,
                    "column": 34
                },
                "end": {
                    "line": 39,
                    "column": 42
                }
            }
        }) : helper)) + '" class="form-control" id="' + alias4((helper = (helper = lookupProperty(helpers, "id") || (depth0 != null ? lookupProperty(depth0, "id") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "id",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 39,
                    "column": 69
                },
                "end": {
                    "line": 39,
                    "column": 75
                }
            }
        }) : helper)) + "-input-" + alias4((helper = (helper = lookupProperty(helpers, "index") || data && lookupProperty(data, "index")) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "index",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 39,
                    "column": 82
                },
                "end": {
                    "line": 39,
                    "column": 92
                }
            }
        }) : helper)) + '">\n' + ((stack1 = lookupProperty(helpers, "each").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "definition") : depth0) != null ? lookupProperty(stack1, "choices") : stack1, {
            "name": "each",
            "hash": {},
            "fn": container.program(14, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 40,
                    "column": 24
                },
                "end": {
                    "line": 47,
                    "column": 33
                }
            }
        })) != null ? stack1 : "") + "                    </select>\n                    " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(5, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 49,
                    "column": 20
                },
                "end": {
                    "line": 49,
                    "column": 87
                }
            }
        })) != null ? stack1 : "") + "\n                </div>\n";
    },
    "14": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0, "===", depths[1] != null ? lookupProperty(depths[1], "defaultVal") : depths[1], {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(15, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 41,
                    "column": 28
                },
                "end": {
                    "line": 43,
                    "column": 39
                }
            }
        })) != null ? stack1 : "") + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0, "!==", depths[1] != null ? lookupProperty(depths[1], "defaultVal") : depths[1], {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(17, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 44,
                    "column": 28
                },
                "end": {
                    "line": 46,
                    "column": 39
                }
            }
        })) != null ? stack1 : "");
    },
    "15": function(container, depth0, helpers, partials, data) {
        return "                            <option selected>" + container.escapeExpression(container.lambda(depth0, depth0)) + "</option>\n";
    },
    "17": function(container, depth0, helpers, partials, data) {
        return "                            <option>" + container.escapeExpression(container.lambda(depth0, depth0)) + "</option>\n";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="input cbwf-info-action-popover run-input-required">\n    <div class="remove"><span class="glyphicon glyphicon-remove remove"></span></div>\n    <div class="caption">' + alias3((lookupProperty(helpers, "breaklines") || depth0 && lookupProperty(depth0, "breaklines") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "message") : depth0, {
            "name": "breaklines",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 3,
                    "column": 25
                },
                "end": {
                    "line": 3,
                    "column": 47
                }
            }
        })) + '</div>\n    <div class="form">\n        <div class="inputs">\n' + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "inputs") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(1, data, 0, blockParams, depths),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 6,
                    "column": 12
                },
                "end": {
                    "line": 52,
                    "column": 21
                }
            }
        })) != null ? stack1 : "") + '        </div>\n        <div class="buttons">\n            <button type="submit" class="btn btn-primary btn-sm proceed-button">' + alias3((helper = (helper = lookupProperty(helpers, "proceedText") || (depth0 != null ? lookupProperty(depth0, "proceedText") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "proceedText",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 55,
                    "column": 80
                },
                "end": {
                    "line": 55,
                    "column": 95
                }
            }
        }) : helper)) + '</button>\n            <button type="submit" class="btn btn-default btn-sm abort-button">Abort</button>\n        </div>\n    </div>\n\n</div>';
    },
    "useData": true,
    "useDepths": true
});
var $66276572e9e3ded2$export$2e2bcd8739ae039 = $66276572e9e3ded2$var$templateFunction;

});

parcelRegister("1qDvM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $10a6de58638deb4d$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $10a6de58638deb4d$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="input cbwf-info-action-popover run-input-required">\n    <div class="remove"><span class="glyphicon glyphicon-remove remove"></span></div>\n    <div class="caption">' + alias4((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "message",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 3,
                    "column": 25
                },
                "end": {
                    "line": 3,
                    "column": 36
                }
            }
        }) : helper)) + '</div>\n    \n    <div class="has-advanced-inputs">\n        The paused input step uses advanced input options.\n        <a href="' + alias4((helper = (helper = lookupProperty(helpers, "redirectApprovalUrl") || (depth0 != null ? lookupProperty(depth0, "redirectApprovalUrl") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "redirectApprovalUrl",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 7,
                    "column": 17
                },
                "end": {
                    "line": 7,
                    "column": 40
                }
            }
        }) : helper)) + '">Please redirect to approve</a>.\n    </div>\n\n</div>';
    },
    "useData": true
});
var $10a6de58638deb4d$export$2e2bcd8739ae039 = $10a6de58638deb4d$var$templateFunction;

});

parcelRegister("fohB0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b346bf1191f6f814$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $b346bf1191f6f814$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "1": function(container, depth0, helpers, partials, data) {
        var alias1 = container.lambda, alias2 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                <tr class="artifact">\n                    <td class="name"><a href="' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "url") : depth0, depth0)) + '" title="Download"><span class="glyphicon glyphicon-file"></span> ' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "name") : depth0, depth0)) + '</a></td>\n                    <td class="size">(' + alias2((lookupProperty(helpers, "formatMem") || depth0 && lookupProperty(depth0, "formatMem") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "size") : depth0, {
            "name": "formatMem",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 10,
                    "column": 38
                },
                "end": {
                    "line": 10,
                    "column": 61
                }
            }
        })) + ')</td>\n                    <td class="download"><a href="' + alias2(alias1(depth0 != null ? lookupProperty(depth0, "url") : depth0, depth0)) + '" title="Download"><span class="glyphicon glyphicon-download"></span></a></td>\n                </tr>\n';
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="alert alert-info">\n    <div class="header">\n        Produced the following ' + container.escapeExpression(container.lambda(depth0 != null ? lookupProperty(depth0, "length") : depth0, depth0)) + ' artifact(s):\n    </div>\n    <div class="body">\n        <table>\n' + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 7,
                    "column": 12
                },
                "end": {
                    "line": 13,
                    "column": 21
                }
            }
        })) != null ? stack1 : "") + "        </table>\n    </div>\n</div>";
    },
    "useData": true
});
var $b346bf1191f6f814$export$2e2bcd8739ae039 = $b346bf1191f6f814$var$templateFunction;

});

parcelRegister("crb4g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $90e0978028e82923$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $90e0978028e82923$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "1": function(container, depth0, helpers, partials, data) {
        return "s";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="run-changesets">\n    <div class="run-changeset">\n        <strong class="num">' + container.escapeExpression(container.lambda(depth0 != null ? lookupProperty(depth0, "commitCount") : depth0, depth0)) + '</strong>\n        <span class="changes commitLabel">commit' + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "commitCount") : depth0, ">", 1, {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 4,
                    "column": 48
                },
                "end": {
                    "line": 4,
                    "column": 94
                }
            }
        })) != null ? stack1 : "") + "</span>\n    </div>\n</div>";
    },
    "useData": true
});
var $90e0978028e82923$export$2e2bcd8739ae039 = $90e0978028e82923$var$templateFunction;

});

parcelRegister("j92Lq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $df01007695c2fd79$export$2e2bcd8739ae039);

var $8Ostr = parcelRequire("8Ostr");
const $df01007695c2fd79$var$templateFunction = (0, (/*@__PURE__*/$parcel$interopDefault($8Ostr))).template({
    "1": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '    <div class="header">' + alias3((helper = (helper = lookupProperty(helpers, "commitCount") || (depth0 != null ? lookupProperty(depth0, "commitCount") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "commitCount",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 3,
                    "column": 24
                },
                "end": {
                    "line": 3,
                    "column": 39
                }
            }
        }) : helper)) + " commit" + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "commitCount") : depth0, ">", 1, {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(2, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 3,
                    "column": 46
                },
                "end": {
                    "line": 3,
                    "column": 87
                }
            }
        })) != null ? stack1 : "") + ' by <span class="contributor">' + alias3(container.lambda((stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "contributors") : depth0) != null ? lookupProperty(stack1, "0") : stack1) != null ? lookupProperty(stack1, "authorJenkinsId") : stack1, depth0)) + "</span>" + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "contributorCount") : depth0, ">", 1, {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(4, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 3,
                    "column": 158
                },
                "end": {
                    "line": 3,
                    "column": 214
                }
            }
        })) != null ? stack1 : "") + "</div>\n";
    },
    "2": function(container, depth0, helpers, partials, data) {
        return "s";
    },
    "4": function(container, depth0, helpers, partials, data) {
        return " and others";
    },
    "6": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '        <div class="header">' + container.escapeExpression((helper = (helper = lookupProperty(helpers, "commitCount") || (depth0 != null ? lookupProperty(depth0, "commitCount") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "commitCount",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 5,
                    "column": 28
                },
                "end": {
                    "line": 5,
                    "column": 43
                }
            }
        }) : helper)) + " commit" + ((stack1 = (lookupProperty(helpers, "ifCond") || depth0 && lookupProperty(depth0, "ifCond") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "commitCount") : depth0, ">", 1, {
            "name": "ifCond",
            "hash": {},
            "fn": container.program(2, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 5,
                    "column": 50
                },
                "end": {
                    "line": 5,
                    "column": 91
                }
            }
        })) != null ? stack1 : "") + "</div>\n";
    },
    "8": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '            <tr title="' + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "authorJenkinsId") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(9, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 10,
                    "column": 23
                },
                "end": {
                    "line": 10,
                    "column": 78
                }
            }
        })) != null ? stack1 : "") + alias3((lookupProperty(helpers, "formatDate") || depth0 && lookupProperty(depth0, "formatDate") || alias2).call(alias1, depth0 != null ? lookupProperty(depth0, "timestamp") : depth0, "short", {
            "name": "formatDate",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 10,
                    "column": 78
                },
                "end": {
                    "line": 10,
                    "column": 110
                }
            }
        })) + '">\n                <td class="commitId">\n                    <span class="label label-default">\n' + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "commitUrl") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(11, data, 0),
            "inverse": container.program(13, data, 0),
            "data": data,
            "loc": {
                "start": {
                    "line": 13,
                    "column": 24
                },
                "end": {
                    "line": 17,
                    "column": 31
                }
            }
        })) != null ? stack1 : "") + '                    </span>\n                </td>\n                <td class="message">' + alias3((helper = (helper = lookupProperty(helpers, "messageLine1") || (depth0 != null ? lookupProperty(depth0, "messageLine1") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "messageLine1",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 20,
                    "column": 36
                },
                "end": {
                    "line": 20,
                    "column": 52
                }
            }
        }) : helper)) + "</td>\n            </tr>\n";
    },
    "9": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "by " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "authorJenkinsId") || (depth0 != null ? lookupProperty(depth0, "authorJenkinsId") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "authorJenkinsId",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 10,
                    "column": 49
                },
                "end": {
                    "line": 10,
                    "column": 68
                }
            }
        }) : helper)) + " - ";
    },
    "11": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '                        <a href="' + alias4((helper = (helper = lookupProperty(helpers, "commitUrl") || (depth0 != null ? lookupProperty(depth0, "commitUrl") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "commitUrl",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 14,
                    "column": 33
                },
                "end": {
                    "line": 14,
                    "column": 46
                }
            }
        }) : helper)) + '" target="_blank">' + alias4((helper = (helper = lookupProperty(helpers, "commitIdDisplay") || (depth0 != null ? lookupProperty(depth0, "commitIdDisplay") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "commitIdDisplay",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 14,
                    "column": 64
                },
                "end": {
                    "line": 14,
                    "column": 83
                }
            }
        }) : helper)) + "</a>\n";
    },
    "13": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "                        " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "commitIdDisplay") || (depth0 != null ? lookupProperty(depth0, "commitIdDisplay") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "commitIdDisplay",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 16,
                    "column": 24
                },
                "end": {
                    "line": 16,
                    "column": 43
                }
            }
        }) : helper)) + "\n";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return '<div class="alert alert-info run-changeset-details ' + alias4((helper = (helper = lookupProperty(helpers, "kind") || (depth0 != null ? lookupProperty(depth0, "kind") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "kind",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 51
                },
                "end": {
                    "line": 1,
                    "column": 59
                }
            }
        }) : helper)) + '-repo">\n' + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = (stack1 = depth0 != null ? lookupProperty(depth0, "contributors") : depth0) != null ? lookupProperty(stack1, "0") : stack1) != null ? lookupProperty(stack1, "authorJenkinsId") : stack1, {
            "name": "if",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.program(6, data, 0),
            "data": data,
            "loc": {
                "start": {
                    "line": 2,
                    "column": 4
                },
                "end": {
                    "line": 6,
                    "column": 11
                }
            }
        })) != null ? stack1 : "") + '    <div class="body">\n        <table>\n' + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "commits") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(8, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 9,
                    "column": 8
                },
                "end": {
                    "line": 22,
                    "column": 17
                }
            }
        })) != null ? stack1 : "") + '        </table>\n    </div>\n    <div class="footer">\n        <a href="' + alias4((helper = (helper = lookupProperty(helpers, "consoleUrl") || (depth0 != null ? lookupProperty(depth0, "consoleUrl") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "consoleUrl",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 26,
                    "column": 17
                },
                "end": {
                    "line": 26,
                    "column": 31
                }
            }
        }) : helper)) + '" target="_blank">See detail page</a>\n    </div>\n</div>';
    },
    "useData": true
});
var $df01007695c2fd79$export$2e2bcd8739ae039 = $df01007695c2fd79$var$templateFunction;

});


parcelRegister("bhAAh", function(module, exports) {

$parcel$export(module.exports, "newPopover", () => $836da917f17e1098$export$a20cf777e793e80e, (v) => $836da917f17e1098$export$a20cf777e793e80e = v);
$parcel$export(module.exports, "hide", () => $836da917f17e1098$export$fe8985bb6374093c, (v) => $836da917f17e1098$export$fe8985bb6374093c = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $836da917f17e1098$export$a20cf777e793e80e;
var $836da917f17e1098$export$fe8985bb6374093c;

var $gZ5Q1 = parcelRequire("gZ5Q1");

var $8BojJ = parcelRequire("8BojJ");

var $qLOFg = parcelRequire("qLOFg");
var $836da917f17e1098$var$timeoutHandler = $qLOFg.newTimeoutHandler("popovers");
$836da917f17e1098$export$a20cf777e793e80e = function(name, popover, onElement, options) {
    return new $836da917f17e1098$var$Popover(name, popover, onElement, options);
};
$836da917f17e1098$export$fe8985bb6374093c = function(popover) {
    if (!popover) return;
    var $ = $gZ5Q1.getJQuery();
    if (Array.isArray(popover)) {
        // The 'popover' arg is actually an array of popover names
        // that should be hidden.
        var activePopovers = $(".cbwf-popover");
        activePopovers.each(function() {
            var thePopover = $(this);
            var popoverName = thePopover.attr("popover-name");
            if (popover.indexOf(popoverName) !== -1) $836da917f17e1098$export$fe8985bb6374093c(thePopover);
        });
        return;
    } else if (typeof popover === "string") {
        $836da917f17e1098$export$fe8985bb6374093c(popover.split(","));
        return;
    }
    if (popover.escPressListener) {
        $("body").unbind("keydown", popover.escPressListener);
        delete popover.escPressListener;
    }
    popover.remove();
};
function $836da917f17e1098$var$Popover(name, popover, onElement, options) {
    if (!name) throw "Popover must be supplied with a 'name' param.";
    if (options === undefined) options = {
        allowmulti: false
    };
    if (!options.placement) options.placement = "top";
    popover.attr("popover-name", name);
    popover.addClass(name);
    this.name = name;
    this.popover = popover;
    this.onElement = onElement;
    this.options = options;
}

$836da917f17e1098$var$Popover.prototype.show = function() {
    var $ = $gZ5Q1.getJQuery();
    var theWindow = (parcelRequire("2ZEsn")).getWindow();
    var thisPopover = this;
    // If there's a modal popover already visible, don't show this one.
    if ($(".cbwf-popover.cbwf-modal").length > 0) // Don't show.
    return;
    if (!thisPopover.options.allowmulti && $836da917f17e1098$var$isPopupVisible(thisPopover.name)) // Don't show.
    return;
    var notIf = thisPopover.options.notIf;
    if (notIf && $836da917f17e1098$var$isPopupVisible(notIf)) // Don't show.
    return;
    var hidePopups = thisPopover.options.hide;
    if (hidePopups) $836da917f17e1098$export$fe8985bb6374093c(hidePopups);
    thisPopover.popover.addClass("cbwf-widget");
    thisPopover.popover.addClass("cbwf-popover");
    thisPopover.popover.addClass("placement-" + this.options.placement);
    if (thisPopover.options.modal) thisPopover.popover.addClass("cbwf-modal");
    $("body").append(thisPopover.popover);
    thisPopover.applyPlacement();
    // Reapply controllers...
    $8BojJ.applyControllers(thisPopover.popover, true);
    // Handle removal of the popover
    if (this.popover.escPressListener) $(theWindow).unbind("keydown", thisPopover.popover.escPressListener);
    thisPopover.popover.escPressListener = function(keyPressEvent) {
        if (keyPressEvent.which === 27) thisPopover.hide();
    };
    $("body").keydown(thisPopover.popover.escPressListener);
    $(".remove", thisPopover.popover).click(function() {
        thisPopover.hide();
    });
    if (thisPopover.options.onshow) {
        thisPopover.options.onshow();
        thisPopover.applyPlacement();
    }
};
$836da917f17e1098$var$Popover.prototype.hide = function() {
    $836da917f17e1098$export$fe8985bb6374093c(this.popover);
};
$836da917f17e1098$var$Popover.prototype.click = function() {
    var $ = $gZ5Q1.getJQuery();
    var docBody = $("body");
    var thisPopover = this;
    var eventName = "click";
    if (thisPopover.options.namespace) {
        eventName += "." + thisPopover.options.namespace;
        thisPopover.onElement.off(eventName);
    }
    thisPopover.onElement.on(eventName, function() {
        thisPopover.show();
        var boxCoords = $gZ5Q1.getElementsEnclosingBoxCoords([
            thisPopover.onElement,
            thisPopover.popover
        ]);
        function unbindListeners() {
            // We're done... stop listening for mouse move and keypress events and remove the popover.
            docBody.unbind("click", isOverElementListener);
            docBody.unbind("keydown", escPressListener);
            thisPopover.hide();
        }
        var isOverElementChecker = function(mouseX, mouseY) {
            if (!$gZ5Q1.isCoordInBox(mouseX, mouseY, boxCoords)) {
                unbindListeners();
                return false;
            } else return true;
        };
        var isOverElementListener = function(moveEvent) {
            isOverElementChecker(moveEvent.pageX, moveEvent.pageY);
        };
        var escPressListener = function(keyPressEvent) {
            if (keyPressEvent.which === 27) unbindListeners();
        };
        docBody.click(isOverElementListener);
        docBody.keydown(escPressListener);
        $(".remove", thisPopover.popover).click(function() {
            unbindListeners();
        });
    });
};
$836da917f17e1098$var$Popover.prototype.hover = function() {
    var $ = $gZ5Q1.getJQuery();
    var mouseTracker = $gZ5Q1.getMouseTracker();
    var thisPopover = this;
    var hideDelay = thisPopover.options.hideDelay;
    if (hideDelay === undefined) hideDelay = 500;
    // You can use the hover or mouse enter and leave events, but behavior gets interesting
    // when you have multiple popovers on top of each other, with mouse moves entering the "top"
    // one triggering movemove out events on lower ones etc.  Also, interesting things happen
    // just at the element boundaries.  Therefore, we use mouseenter and then mousemove.
    thisPopover.onElement.mouseenter(function() {
        // Don't start listening for mousemove events immediately.  This way, we "skip"
        // events that happen just at the boundary as the mouse is crossing it.
        $836da917f17e1098$var$timeoutHandler.setTimeout(function() {
            var onElementCoords = $gZ5Q1.getElementBoxCoords(thisPopover.onElement);
            var docBody = $("body");
            // If the mouse is no longer in the box then we just return (i.e. ignore).
            if (!$gZ5Q1.isCoordInBox(mouseTracker.x, mouseTracker.y, onElementCoords)) // mouse not in the box... ignore...
            return;
            // Show the popover now.
            thisPopover.show();
            var hoverBoxes = [
                onElementCoords
            ];
            if (thisPopover.options.hoverBoth) {
                var popoverCoords = $gZ5Q1.getElementBoxCoords(thisPopover.popover);
                hoverBoxes.push(popoverCoords);
                // We need to stretch the onElementCoords so the boxes touch.  Direction in which we stretch depends on the
                // placement of the popover..
                if (thisPopover.options.placement === "left") // popover is to the left of the onElement => stretch onElement left to meet the right.x of the popover
                $gZ5Q1.stretchBoxCoords(onElementCoords, "left", popoverCoords.topRight.x);
                else if (thisPopover.options.placement === "right") // popover is to the right of the onElement => stretch onElement right to meet the left.x of the popover
                $gZ5Q1.stretchBoxCoords(onElementCoords, "right", popoverCoords.topLeft.x);
                else if (thisPopover.options.placement === "bottom") // popover is to the bottom of the onElement => stretch onElement down to meet the top.y of the popover
                $gZ5Q1.stretchBoxCoords(onElementCoords, "down", popoverCoords.topLeft.y);
                else // popover is to the top of the onElement => stretch onElement up to meet the bottom.y of the popover
                $gZ5Q1.stretchBoxCoords(onElementCoords, "up", popoverCoords.bottomLeft.y);
            }
            function remove() {
                docBody.unbind("mousemove", mouseMoveListener);
                thisPopover.hide();
            }
            function isMouseInHoverArea() {
                for(var i = 0; i < hoverBoxes.length; i++){
                    if ($gZ5Q1.isCoordInBox(mouseTracker.x, mouseTracker.y, hoverBoxes[i])) return true;
                }
                return false;
            }
            var removePopoverChecker = function(recheck) {
                if (!isMouseInHoverArea()) {
                    if (recheck) {
                        // Perform a recheck before removing the popover i.e. set a timeout
                        // to check are we still outside the hover area.  If at that time we still are
                        // outside, only then remove it. This allows the user to momentarily exit and
                        // re-enter the hover area without the hover disappearing.
                        $836da917f17e1098$var$timeoutHandler.setTimeout(function() {
                            removePopoverChecker(false);
                        }, hideDelay);
                        return;
                    }
                    // We're done... stop listening for mouse move events and remove the popover.
                    remove();
                }
            };
            var mouseMoveListener = function() {
                removePopoverChecker(true);
            };
            // If the mouse is still over the element (might not if the mouse just swiped over),
            // then track mouse moves as a way of deciding whether or not to hide the popover.
            if (isMouseInHoverArea()) {
                docBody.mousemove(mouseMoveListener);
                $(".remove", thisPopover.popover).click(function() {
                    remove();
                });
            }
        }, 250);
    });
};

$836da917f17e1098$var$Popover.prototype.applyPlacement = function() {
    var $ = $gZ5Q1.getJQuery();
    var theWindow = (parcelRequire("2ZEsn")).getWindow();
    var thisPopover = this;
    var placement = thisPopover.options.placement;
    // If there's no anchor element or placement specified, we default
    // the placement to the center of the window.
    if (!thisPopover.onElement) placement = "window-center";
    else if (!placement) placement = "top";
    if (placement === "right") {
        var onElementOffset = thisPopover.onElement.offset();
        thisPopover.popover.css({
            "top": onElementOffset.top,
            "left": onElementOffset.left + thisPopover.onElement.width() + 5
        });
    } else if (placement === "left") {
        var onElementOffset = thisPopover.onElement.offset();
        thisPopover.popover.css({
            "top": onElementOffset.top,
            "left": onElementOffset.left - (thisPopover.popover.width() + 5)
        });
    } else if (placement === "right-inside") {
        var onElementOffset = thisPopover.onElement.offset();
        thisPopover.popover.css({
            "top": onElementOffset.top + Math.round(parseFloat(thisPopover.onElement.css("border-top-width"))),
            "left": onElementOffset.left + thisPopover.onElement.width() - (thisPopover.popover.width() - Math.round(parseFloat(thisPopover.onElement.css("border-left-width"))))
        });
    } else if (placement === "window-center") {
        var winWidth = $(theWindow).width();
        var winHeight = $(theWindow).height();
        var popoverWidth = thisPopover.popover.width();
        var popoverHeight = thisPopover.popover.height();
        var leftPlacement = (winWidth - popoverWidth) / 2;
        var topPlacement = (winHeight - popoverHeight) / 2;
        // try not have the top of the dialog further down from the
        // top thn 1/4 the window height.
        topPlacement = Math.min(topPlacement, winWidth / 4);
        thisPopover.popover.css({
            "top": topPlacement,
            "left": leftPlacement
        });
    } else if (placement === "window-visible-top") {
        var winWidth = $(theWindow).width();
        var popoverWidth = thisPopover.popover.width();
        var leftPlacement = (winWidth - popoverWidth) / 2;
        var topPlacement = 20; // For tests, which don't have a window
        if (typeof window !== "undefined") topPlacement = window.scrollY + 20;
        thisPopover.popover.css({
            "top": topPlacement,
            "left": leftPlacement
        });
    } else {
        // default is top
        var onElementOffset = thisPopover.onElement.offset();
        thisPopover.popover.css({
            "top": onElementOffset.top - (thisPopover.popover.height() + 5),
            "left": onElementOffset.left
        });
    }
};
function $836da917f17e1098$var$isPopupVisible(popupNames) {
    var $ = $gZ5Q1.getJQuery();
    if (Array.isArray(popupNames)) {
        var activePopovers = $(".cbwf-popover");
        var popoverVisible = false;
        activePopovers.each(function() {
            var thePopover = $(this);
            var popoverName = thePopover.attr("popover-name");
            if (popupNames.indexOf(popoverName) !== -1) {
                popoverVisible = true;
                return false; // terminate the loop
            }
        });
        return popoverVisible;
    } else if (typeof popupNames === "string") return $836da917f17e1098$var$isPopupVisible(popupNames.split(","));
    return false;
}

});
parcelRegister("qLOFg", function(module, exports) {

$parcel$export(module.exports, "newTimeoutHandler", () => $0507851e415174c1$export$4ccafdff0aef36ca, (v) => $0507851e415174c1$export$4ccafdff0aef36ca = v);
$parcel$export(module.exports, "setMaxDelay", () => $0507851e415174c1$export$d3b8600576f59bea, (v) => $0507851e415174c1$export$d3b8600576f59bea = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Utility to manage timeouts, making it a bit easier to clear active timeouts. Useful for testing.
 */ var $0507851e415174c1$export$4ccafdff0aef36ca;
var $0507851e415174c1$export$4466e287d2459f37;
var $0507851e415174c1$export$d89658363be37383;
var $0507851e415174c1$export$d3b8600576f59bea;
var $0507851e415174c1$var$activeTimeoutHandlers = {};
var $0507851e415174c1$var$timeoutCounter = 0;
var $0507851e415174c1$var$maxDelay = Number.MAX_VALUE;
$0507851e415174c1$export$4ccafdff0aef36ca = function(handlerName) {
    if (!handlerName) throw "The TimeoutHandler must be given a name.";
    // Clear any timeouts on a handler by this name, if one exists.
    if ($0507851e415174c1$var$activeTimeoutHandlers.hasOwnProperty(handlerName)) $0507851e415174c1$var$activeTimeoutHandlers[handlerName].clearAllTimeouts();
    var timeoutHandler = new $0507851e415174c1$var$TimeoutHandler();
    $0507851e415174c1$var$activeTimeoutHandlers[handlerName] = timeoutHandler;
    return timeoutHandler;
};
$0507851e415174c1$export$4466e287d2459f37 = function() {
    for(var handlerName in $0507851e415174c1$var$activeTimeoutHandlers)if ($0507851e415174c1$var$activeTimeoutHandlers.hasOwnProperty(handlerName)) $0507851e415174c1$var$activeTimeoutHandlers[handlerName].clearAllTimeouts();
};
$0507851e415174c1$export$d89658363be37383 = function() {
    return $0507851e415174c1$var$maxDelay;
};
$0507851e415174c1$export$d3b8600576f59bea = function(newMaxDelay) {
    $0507851e415174c1$var$maxDelay = newMaxDelay;
};
function $0507851e415174c1$var$TimeoutHandler() {
    this.timeouts = {};
    this.timeoutCount = 0;
}
$0507851e415174c1$var$TimeoutHandler.prototype.setTimeout = function(code, delay) {
    if ($0507851e415174c1$var$maxDelay === 0) {
        // There is no delay allowed (e.g. in tests). Run synchronously now.
        code();
        return undefined;
    } else {
        var thisHandler = this;
        function doTimeout(timeoutId) {
            var timeoutObj = setTimeout(function() {
                thisHandler.removeTimeout(timeoutId);
                code();
            }, Math.min(delay, $0507851e415174c1$var$maxDelay));
            thisHandler.timeouts[timeoutId] = timeoutObj;
        }
        var timeoutId = ($0507851e415174c1$var$timeoutCounter++).toString(10);
        doTimeout(timeoutId);
        this.timeoutCount++;
        return timeoutId;
    }
};
$0507851e415174c1$var$TimeoutHandler.prototype.activeTimeoutCount = function() {
    return this.timeoutCount;
};
$0507851e415174c1$var$TimeoutHandler.prototype.getTimeouts = function() {
    return this.timeouts;
};
$0507851e415174c1$var$TimeoutHandler.prototype.removeTimeout = function(timeoutId) {
    delete this.timeouts[timeoutId];
    this.timeoutCount--;
};
$0507851e415174c1$var$TimeoutHandler.prototype.clearTimeout = function(timeoutId) {
    var timeoutObj = this.timeouts[timeoutId];
    clearTimeout(timeoutObj);
    this.removeTimeout(timeoutId);
};
$0507851e415174c1$var$TimeoutHandler.prototype.clearAllTimeouts = function() {
    for(var timeoutId in this.timeouts)this.clearTimeout(timeoutId);
    this.timeouts = {};
    this.timeoutCount = 0;
};

});

parcelRegister("2ZEsn", function(module, exports) {

$parcel$export(module.exports, "getWindow", () => $22e0a91c797722f1$export$38b2d434cce3ea22, (v) => $22e0a91c797722f1$export$38b2d434cce3ea22 = v);
/**
 * Get the global "window" object.
 * @param callback An optional callback that can be used to receive the window asynchronously. Useful when
 * executing in test environment i.e. where the global window object might not exist immediately. 
 * @param timeout The timeout if waiting on the global window to be initialised.
 * @returns {*}
 */ var $22e0a91c797722f1$export$38b2d434cce3ea22;
/**
 * Set the global window e.g. in a test environment.
 * <p>
 * Once called, all callbacks (registered by earlier 'getWindow' calls) will be invoked.
 * 
 * @param newWindow The window.
 */ var $22e0a91c797722f1$export$b4ab31529663b75b;
/**
 * Set the default time to wait for the global window to be set.
 * <p>
 * Default is 10 seconds (10000 ms).
 * 
 * @param millis Milliseconds to wait for the global window to be set.
 */ var $22e0a91c797722f1$export$69a2d719149fc54c;
/**
 * Reset the window handle, clearing callbacks etc.
 */ var $22e0a91c797722f1$export$aad8462122ac592b;
var $22e0a91c797722f1$var$theWindow;
var $22e0a91c797722f1$var$defaultTimeout = 10000;
var $22e0a91c797722f1$var$callbacks = [];
var $22e0a91c797722f1$var$windowSetTimeouts = [];
function $22e0a91c797722f1$var$execCallback(callback, theWindow) {
    if (callback) try {
        callback.call(callback, theWindow);
    } catch (e) {
        console.log("Error invoking window-handle callback.");
        console.log(e.stack);
    }
}
$22e0a91c797722f1$export$38b2d434cce3ea22 = function(callback, timeout) {
    $22e0a91c797722f1$var$callbacks.push(callback);
    if ($22e0a91c797722f1$var$theWindow) {
        $22e0a91c797722f1$var$execCallback(callback, $22e0a91c797722f1$var$theWindow);
        return $22e0a91c797722f1$var$theWindow;
    }
    try {
        if (window) {
            $22e0a91c797722f1$var$execCallback(callback, window);
            return window;
        }
    } catch (e) {
    // no window "yet". This should only ever be the case in a test env.
    // Fall through and use callbacks, if supplied.
    }
    if (callback) {
        function waitForWindow(callback) {
            var windowSetTimeout = setTimeout(function() {
                callback.error = "Timed out waiting on the window to be set.";
                callback.call(callback);
            }, timeout ? timeout : $22e0a91c797722f1$var$defaultTimeout);
            $22e0a91c797722f1$var$windowSetTimeouts.push(windowSetTimeout);
        }
        waitForWindow(callback);
    } else throw new Error("No 'window' available. Consider providing a 'callback' and receiving the 'window' async when available. Typically, this should only be the case in a test environment.");
};
$22e0a91c797722f1$export$b4ab31529663b75b = function(newWindow) {
    for(var i = 0; i < $22e0a91c797722f1$var$windowSetTimeouts.length; i++)clearTimeout($22e0a91c797722f1$var$windowSetTimeouts[i]);
    $22e0a91c797722f1$var$windowSetTimeouts = [];
    $22e0a91c797722f1$var$theWindow = newWindow;
    for(var i = 0; i < $22e0a91c797722f1$var$callbacks.length; i++)$22e0a91c797722f1$var$execCallback($22e0a91c797722f1$var$callbacks[i], $22e0a91c797722f1$var$theWindow);
};
$22e0a91c797722f1$export$69a2d719149fc54c = function(millis) {
    $22e0a91c797722f1$var$defaultTimeout = millis;
};
$22e0a91c797722f1$export$aad8462122ac592b = function() {
    $22e0a91c797722f1$var$callbacks = [];
};

});



parcelRegister("5GBlv", function(module, exports) {

$parcel$export(module.exports, "ExtensionPointContainer", () => $423dd815f2af12be$export$cf964df3ab15dda5, (v) => $423dd815f2af12be$export$cf964df3ab15dda5 = v);
$parcel$export(module.exports, "ExtensionPoint", () => $423dd815f2af12be$export$63d029cf166a1b83, (v) => $423dd815f2af12be$export$63d029cf166a1b83 = v);
$parcel$export(module.exports, "ExtensionPointContribution", () => $423dd815f2af12be$export$57818a69b70735b, (v) => $423dd815f2af12be$export$57818a69b70735b = v);
$parcel$export(module.exports, "extensionPointContainer", () => $423dd815f2af12be$export$3a5617a533a14290, (v) => $423dd815f2af12be$export$3a5617a533a14290 = v);
/**
 * Expose the top level API type constructors.
 */ var $423dd815f2af12be$export$cf964df3ab15dda5;
var $423dd815f2af12be$export$63d029cf166a1b83;
var $423dd815f2af12be$export$57818a69b70735b;
var $423dd815f2af12be$export$3a5617a533a14290;

$423dd815f2af12be$export$cf964df3ab15dda5 = (parcelRequire("cVoi9"));

$423dd815f2af12be$export$63d029cf166a1b83 = (parcelRequire("4ZDzn"));

$423dd815f2af12be$export$57818a69b70735b = (parcelRequire("8asYS"));
$423dd815f2af12be$export$3a5617a533a14290 = new $423dd815f2af12be$export$cf964df3ab15dda5();

});
parcelRegister("cVoi9", function(module, exports) {
/**
 * Represents a UI "part" that contains one or more ExtensionPoint instances. 
 * <p>
 * I guess that, in time, this may morph into a page level construct.
 * <p>
 * See README.md.
 */ // TODO: Refine the docs as we learn more.
module.exports = $968da6c252ac3e51$var$ExtensionPointContainer;

var $4ZDzn = parcelRequire("4ZDzn");
function $968da6c252ac3e51$var$ExtensionPointContainer() {
    // private properties - do not use
    this._private = {};
    this._private.extensionPoints = [];
    this._private.onchangeListeners = [];
}
/**
 * Add an ExtensionPoint.
 * <p>
 * Removal is done by calling <code>this.remove()</code>
 * inside <code>forEach</code>.
 * @param extensionPoint The ExtensionPoint instance.
 */ $968da6c252ac3e51$var$ExtensionPointContainer.prototype.add = function(extensionPoint) {
    if (extensionPoint instanceof $4ZDzn) this._private.extensionPoints.push(extensionPoint);
    else throw '"extensionPoint" must be of type ExtensionPoint.';
};
/**
 * Add an onchange listener.
 * @param listener The listener.
 */ $968da6c252ac3e51$var$ExtensionPointContainer.prototype.onchange = function(listener) {
    this._private.onchangeListeners.push(listener);
};
/**
 * Iterate the ExtensionPoint instance in this container.
 * <p>
 * The context object (<code>this</code>) provided to the callback call
 * contains a <code>remove</code> function.
 * @param callback The callback to call for each ExtensionPoint in the container.
 * The ExtensionPoint instance is supplied as the first argument to the callback. 
 * @param ofType ExtensionPoint type filter.
 */ $968da6c252ac3e51$var$ExtensionPointContainer.prototype.forEach = function(callback, ofType) {
    var extensionPointsToRemove = [];
    var extensionPoint;
    function callCallback(extensionPoint) {
        callback.call({
            remove: function() {
                extensionPointsToRemove.push(extensionPoint);
            }
        }, extensionPoint);
    }
    for(var i = 0; i < this._private.extensionPoints.length; i++){
        extensionPoint = this._private.extensionPoints[i];
        if (!ofType || extensionPoint.type === ofType) callCallback(extensionPoint);
    }
    if (extensionPointsToRemove.length > 0) {
        var isInRemoveList = function(extensionPoint) {
            for(var ii = 0; ii < extensionPointsToRemove.length; ii++){
                if (extensionPointsToRemove[ii] === extensionPoint) return true;
            }
            return false;
        };
        // Create a new list, omitting these extension points.
        var newList = [];
        for(var iii = 0; iii < this._private.extensionPoints.length; iii++){
            extensionPoint = this._private.extensionPoints[iii];
            if (!isInRemoveList(extensionPoint)) newList.push(extensionPoint);
        }
        this._private.extensionPoints = newList;
    }
};
/**
 * Remove all ExtensionPoint instances from this container.
 * @param ofType ExtensionPoint instance type filter (optional).
 */ $968da6c252ac3e51$var$ExtensionPointContainer.prototype.remove = function(ofType) {
    this.forEach(function(extensionPoint) {
        if (!ofType || extensionPoint.type === ofType) this.remove();
    });
};
/**
 * Notify all onchange listeners. This must be called by the
 * ExtensionPointContainer "owner". Intentionally not calling it
 * from add/remove etc because that might result in a flood of unnecessary
 * activity e.g. on batch add/remove.
 */ $968da6c252ac3e51$var$ExtensionPointContainer.prototype.notifyOnChange = function() {
    for(var i = 0; i < this._private.onchangeListeners.length; i++)try {
        this._private.onchangeListeners[i].call(this);
    } catch (e) {
        console.warn(e);
    }
};

});
parcelRegister("4ZDzn", function(module, exports) {
/**
 * Represents an actual "point" in the UI to which "contributions" can be made.
 * <p>
 * See README.md.
 */ // TODO: Refine the docs as we learn more.
module.exports = $3a2b8da43b218bb4$var$ExtensionPoint;

var $8asYS = parcelRequire("8asYS");
/**
 * Create an ExtensionPoint instance.
 * @param type The type.
 * @param id A unique ID for the ExtensionPoint.
 * @param dock Dock element (DOM element).
 * @constructor
 */ function $3a2b8da43b218bb4$var$ExtensionPoint(type, id, dock) {
    if (!type) throw 'You must define an ExtensionPoint "type".';
    if (!id) throw 'You must define an ExtensionPoint "id".';
    this.type = type;
    this.id = id;
    this.dock = dock;
    // private properties - do not use
    this._private = {};
    this._private.oncontributeCallback = undefined;
    this._private.contributions = [];
}
/**
 * Contribute to the Extension Point.
 * <p>
 * An instance of <code>ExtensionPointContribution</code>.
 */ $3a2b8da43b218bb4$var$ExtensionPoint.prototype.contribute = function(contribution) {
    if (contribution instanceof $8asYS) this._private.contributions.push(contribution);
    else throw '"contribution" must be of type ExtensionPointContribution.';
    // Fire the oncontribute callback if one was supplied.
    var extensionPoint = this;
    if (extensionPoint._private.oncontributeCallback) setTimeout(function() {
        extensionPoint._private.oncontributeCallback.call(contribution);
    }, 0);
};
/**
 * Set an contribution registration listener.
 * @param listener Listener function for when a contribution is made via
 * the contribute function.
 */ $3a2b8da43b218bb4$var$ExtensionPoint.prototype.oncontribute = function(listener) {
    this._private.oncontributeCallback = listener;
};

});
parcelRegister("8asYS", function(module, exports) {
/**
 * Represents a "contribution" to an ExtensionPoint.
 * <p>
 * See README.md.
 */ // TODO: Refine the docs as we learn more.
module.exports = $5f25bce6782791e7$var$ExtensionPointContribution;
function $5f25bce6782791e7$var$ExtensionPointContribution() {
    this.activatorContent = undefined;
    this.activatorContentType = "blank"; // or 'markup' or 'className'
    this.caption = undefined;
    this.content = undefined;
    // private properties - do not use
    this._private = {};
    this._private.onshowCallback = undefined;
    this._private.onhideCallback = undefined;
}
/**
 * Set the activator widget content used to activate the contribution content.
 * <p>
 * If the extension point implementation uses activation widgets (e.g. an icon of some sort), then
 * this widget will be dropped in the extension point activation area and then used to trigger the rendering
 * of the extension point.
 * 
 * @param activatorContent A piece of markup, or just a CSS class name. The rules of what are required
 * here depend on the ExtensionPoint implementation i.e. it could be a button or an icon etc. See
 * 'activatorContentType' property.
 */ $5f25bce6782791e7$var$ExtensionPointContribution.prototype.setActivator = function(activatorContent) {
    this.activatorContent = activatorContent;
    if (this.activatorContent) {
        this.activatorContent = this.activatorContent.trim();
        if (this.activatorContent.length > 0) {
            if (this.activatorContent.charAt(0) === "<") this.activatorContentType = "markup";
            else this.activatorContentType = "className";
        }
    }
    return this;
};
/**
 * Set caption text for the contribution.
 */ $5f25bce6782791e7$var$ExtensionPointContribution.prototype.setCaption = function(caption) {
    this.caption = caption;
    return this;
};
/**
 * Set the content to be displayed on activation of the contribution.
 * <p>
 * This can be an "initial" piece of content that is "enriched" by the <code>onShow</code>
 * method e.g. after calling a REST API method.
 * <p>
 * Depending on the ExtensionPoint, activation of this content may be based on user interaction with the
 * "activator widget", or may be from some other mechanism.
 */ $5f25bce6782791e7$var$ExtensionPointContribution.prototype.setContent = function(content) {
    this.content = content;
    return this;
};
/**
 * Set the callback function to be called after the activation content has been displayed.
 * <p>
 * The on <code>onShow</code> context object will be the DOM element that contains the
 * rendered content that was supplied to the <code>setContent</code> function (or an empty element if 
 * <code>setContent</code> was not called).
 */ $5f25bce6782791e7$var$ExtensionPointContribution.prototype.onShow = function(onshow) {
    this._private.onshowCallback = onshow;
    return this;
};
/**
 * Trigger the onShow callback, if one was registered.
 * @param containerElement The DOM element containing the content that was shown.
 */ $5f25bce6782791e7$var$ExtensionPointContribution.prototype.show = function(containerElement) {
    if (!containerElement) throw 'Call to ExtensionPointContribution.show() without specifying a "containerElement".';
    if (this._private.onshowCallback) this._private.onshowCallback.call(containerElement);
    return this;
};
/**
 * Set the callback function to be called after the contribution content is to be "undisplayed".
 */ $5f25bce6782791e7$var$ExtensionPointContribution.prototype.onHide = function(onhide) {
    this._private.onhideCallback = onhide;
    return this;
};
/**
 * Trigger the onHide callback, if one was registered.
 */ $5f25bce6782791e7$var$ExtensionPointContribution.prototype.hide = function() {
    if (this._private.onhideCallback) this._private.onhideCallback.call();
    return this;
};

});






parcelRegister("7pxLN", function(module, exports) {

$parcel$export(module.exports, "getName", () => $5655103a1448056a$export$7d9f7e9c1c02b41e, (v) => $5655103a1448056a$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getModel", () => $5655103a1448056a$export$289ca1c318c0384, (v) => $5655103a1448056a$export$289ca1c318c0384 = v);
$parcel$export(module.exports, "getView", () => $5655103a1448056a$export$513f42987b822fd7, (v) => $5655103a1448056a$export$513f42987b822fd7 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $5655103a1448056a$export$7d9f7e9c1c02b41e;
var $5655103a1448056a$export$289ca1c318c0384;
var $5655103a1448056a$export$513f42987b822fd7;

var $dMGOS = parcelRequire("dMGOS");

var $4KbLe = parcelRequire("4KbLe");
$5655103a1448056a$export$7d9f7e9c1c02b41e = function() {
    return "feature-tbd";
};
$5655103a1448056a$export$289ca1c318c0384 = function() {
    return $dMGOS;
};
$5655103a1448056a$export$513f42987b822fd7 = function() {
    return $4KbLe;
};

});
parcelRegister("dMGOS", function(module, exports) {

$parcel$export(module.exports, "getModelData", () => $a090f9263a9734fb$export$b077627fdbee10b0, (v) => $a090f9263a9734fb$export$b077627fdbee10b0 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $a090f9263a9734fb$export$b077627fdbee10b0;
$a090f9263a9734fb$export$b077627fdbee10b0 = function(callback) {
    callback({
        alert: "info",
        dismissible: true,
        caption: "Not yet implemented",
        footer: "Please check back later",
        "alert-classes": "feature-tbd-alert",
        "activate-on": "click"
    });
};

});

parcelRegister("4KbLe", function(module, exports) {

$parcel$export(module.exports, "render", () => $374494c490279b6f$export$b3890eb0ae9dca99, (v) => $374494c490279b6f$export$b3890eb0ae9dca99 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $374494c490279b6f$export$b3890eb0ae9dca99;

var $kiPKr = parcelRequire("kiPKr");

var $bhAAh = parcelRequire("bhAAh");
$374494c490279b6f$export$b3890eb0ae9dca99 = function(message, onElement) {
    var popoverDom = $kiPKr.apply("info-action-popover", message);
    var activateOn = message["activate-on"];
    var popoverOn = onElement.parent();
    var popoverName = this.getControllerName();
    var notIf = this.attr("notIf");
    var hide = this.attr("hide");
    if (activateOn === undefined || activateOn === "hover") {
        var popover = $bhAAh.newPopover(popoverName, popoverDom, popoverOn, {
            notIf: notIf,
            hide: hide,
            hoverBoth: true
        });
        popover.hover();
    } else if (activateOn === "click") {
        var popover = $bhAAh.newPopover(popoverName, popoverDom, popoverOn);
        popover.click();
    }
    // for testing...
    return popoverDom;
};

});


parcelRegister("elt6T", function(module, exports) {

$parcel$export(module.exports, "getName", () => $a7199b833758b62a$export$7d9f7e9c1c02b41e, (v) => $a7199b833758b62a$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getModel", () => $a7199b833758b62a$export$289ca1c318c0384, (v) => $a7199b833758b62a$export$289ca1c318c0384 = v);
$parcel$export(module.exports, "getView", () => $a7199b833758b62a$export$513f42987b822fd7, (v) => $a7199b833758b62a$export$513f42987b822fd7 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $a7199b833758b62a$export$7d9f7e9c1c02b41e;
var $a7199b833758b62a$export$289ca1c318c0384;
var $a7199b833758b62a$export$513f42987b822fd7;

var $a0fNr = parcelRequire("a0fNr");

var $4KbLe = parcelRequire("4KbLe");
$a7199b833758b62a$export$7d9f7e9c1c02b41e = function() {
    return "stage-failed-popover";
};
$a7199b833758b62a$export$289ca1c318c0384 = function() {
    return $a0fNr;
};
$a7199b833758b62a$export$513f42987b822fd7 = function() {
    return $4KbLe;
};

});
parcelRegister("a0fNr", function(module, exports) {

$parcel$export(module.exports, "getModelData", () => $7486285396c6c32f$export$b077627fdbee10b0, (v) => $7486285396c6c32f$export$b077627fdbee10b0 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $7486285396c6c32f$export$b077627fdbee10b0;

var $d51jt = parcelRequire("d51jt");
$7486285396c6c32f$export$b077627fdbee10b0 = function(callback) {
    var stageDescUrl = this.requiredAttr("objectUrl");
    $d51jt.getDescription(stageDescUrl, function(stageDesc) {
        var aggregatedErrorMessage = {
            alert: "danger",
            caption: "Failed with the following error(s)",
            errors: [],
            footer: "See stage logs for more detail.",
            options: [
                {
                    label: "Logs",
                    icon: "stats",
                    controller: "stage-logs"
                }
            ],
            descUrl: stageDescUrl
        };
        var stageFlowNodes = stageDesc.stageFlowNodes;
        for(var i = 0; i < stageFlowNodes.length; i++){
            var stageFlowNode = stageFlowNodes[i];
            if (stageFlowNode.status === "FAILED") aggregatedErrorMessage.errors.push({
                label: stageFlowNode.name,
                message: stageFlowNode.error.message
            });
        }
        callback(aggregatedErrorMessage);
    });
};

});


parcelRegister("ho5eN", function(module, exports) {

$parcel$export(module.exports, "getName", () => $ca88bd9f37597d81$export$7d9f7e9c1c02b41e, (v) => $ca88bd9f37597d81$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getModel", () => $ca88bd9f37597d81$export$289ca1c318c0384, (v) => $ca88bd9f37597d81$export$289ca1c318c0384 = v);
$parcel$export(module.exports, "getView", () => $ca88bd9f37597d81$export$513f42987b822fd7, (v) => $ca88bd9f37597d81$export$513f42987b822fd7 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $ca88bd9f37597d81$export$7d9f7e9c1c02b41e;
var $ca88bd9f37597d81$export$289ca1c318c0384;
var $ca88bd9f37597d81$export$513f42987b822fd7;

var $3Xw4E = parcelRequire("3Xw4E");

var $4KbLe = parcelRequire("4KbLe");
$ca88bd9f37597d81$export$7d9f7e9c1c02b41e = function() {
    return "stage-actions-popover";
};
$ca88bd9f37597d81$export$289ca1c318c0384 = function() {
    return $3Xw4E;
};
$ca88bd9f37597d81$export$513f42987b822fd7 = function() {
    return $4KbLe;
};

});
parcelRegister("3Xw4E", function(module, exports) {

$parcel$export(module.exports, "getModelData", () => $2e1fc3003593257d$export$b077627fdbee10b0, (v) => $2e1fc3003593257d$export$b077627fdbee10b0 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $2e1fc3003593257d$export$b077627fdbee10b0;
$2e1fc3003593257d$export$b077627fdbee10b0 = function(callback) {
    var caption = this.targetEl.attr("caption");
    var alertType = "success";
    if (!caption) caption = "Success";
    else if (caption == "Unstable Build") alertType = "warning";
    var descUrl = this.requiredAttr("descUrl");
    callback({
        alert: alertType,
        caption: caption,
        errors: [],
        options: [
            {
                label: "Logs",
                icon: "stats",
                controller: "stage-logs"
            }
        ],
        descUrl: descUrl,
        "click-widget-placement": "right-inside",
        "menu-items-placement": "left"
    });
};

});


parcelRegister("96ru2", function(module, exports) {

$parcel$export(module.exports, "getName", () => $6a09fe3c1a92a759$export$7d9f7e9c1c02b41e, (v) => $6a09fe3c1a92a759$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getModel", () => $6a09fe3c1a92a759$export$289ca1c318c0384, (v) => $6a09fe3c1a92a759$export$289ca1c318c0384 = v);
$parcel$export(module.exports, "getView", () => $6a09fe3c1a92a759$export$513f42987b822fd7, (v) => $6a09fe3c1a92a759$export$513f42987b822fd7 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $6a09fe3c1a92a759$export$7d9f7e9c1c02b41e;
var $6a09fe3c1a92a759$export$289ca1c318c0384;
var $6a09fe3c1a92a759$export$513f42987b822fd7;

var $b6XHr = parcelRequire("b6XHr");

var $9Wpcl = parcelRequire("9Wpcl");
$6a09fe3c1a92a759$export$7d9f7e9c1c02b41e = function() {
    return "stage-logs";
};
$6a09fe3c1a92a759$export$289ca1c318c0384 = function() {
    return $b6XHr;
};
$6a09fe3c1a92a759$export$513f42987b822fd7 = function() {
    return $9Wpcl;
};

});
parcelRegister("b6XHr", function(module, exports) {

$parcel$export(module.exports, "getModelData", () => $816e905e0e0638df$export$b077627fdbee10b0, (v) => $816e905e0e0638df$export$b077627fdbee10b0 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $816e905e0e0638df$export$b077627fdbee10b0;

var $d51jt = parcelRequire("d51jt");
$816e905e0e0638df$export$b077627fdbee10b0 = function(callback) {
    var stageDescribeUrl = this.requiredAttr("descUrl");
    $d51jt.getDescription(stageDescribeUrl, function(stageDetails) {
        callback(stageDetails);
    });
};

});

parcelRegister("9Wpcl", function(module, exports) {

$parcel$export(module.exports, "render", () => $73cd13a6d104b027$export$b3890eb0ae9dca99, (v) => $73cd13a6d104b027$export$b3890eb0ae9dca99 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $73cd13a6d104b027$export$b3890eb0ae9dca99;

var $gZ5Q1 = parcelRequire("gZ5Q1");

var $kiPKr = parcelRequire("kiPKr");

var $kFBze = parcelRequire("kFBze");

$73cd13a6d104b027$export$b3890eb0ae9dca99 = function(stageDescription, onElement) {
    var $ = $gZ5Q1.getJQuery();
    var theWindow = (parcelRequire("2ZEsn")).getWindow();
    var stageLogsDom = $kiPKr.apply("stage-logs", stageDescription);
    var winHeight = $(theWindow).height();
    var dialogHeight = Math.min(800, winHeight * 0.7);
    var nodeLogFrames = $(".node-log-frame", stageLogsDom);
    var nodeNameBars = $(".node-name", stageLogsDom);
    stageLogsDom.addClass("stageLogsPopover");
    var clickNSEvent = "click.cbwf-stage-logs";
    onElement.off(clickNSEvent);
    onElement.on(clickNSEvent, function() {
        $kFBze.show("Stage Logs (" + stageDescription.name + ")", stageLogsDom, {
            classes: "cbwf-stage-logs-dialog",
            placement: "window-visible-top",
            onElement: onElement,
            height: dialogHeight,
            onshow: function() {
                var header = $(".cbwf-stage-logs-dialog .header");
                nodeNameBars.click(function() {
                    var nodeNameBar = $(this);
                    var nodeLogFrame = nodeNameBar.parent();
                    var active = nodeLogFrame.hasClass("active");
                    // add active state to the clicked log frame if was previously inactive
                    if (!active) {
                        // Hide any other log box
                        nodeLogFrames.removeClass("active");
                        // Show this one
                        nodeLogFrame.addClass("active");
                    }
                });
                if (nodeNameBars.length === 1) nodeNameBars.click();
            }
        });
    });
    // for testing...
    return stageLogsDom;
};

});


parcelRegister("hdMkT", function(module, exports) {

$parcel$export(module.exports, "getName", () => $c899251b0b3234a5$export$7d9f7e9c1c02b41e, (v) => $c899251b0b3234a5$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getModel", () => $c899251b0b3234a5$export$289ca1c318c0384, (v) => $c899251b0b3234a5$export$289ca1c318c0384 = v);
$parcel$export(module.exports, "getView", () => $c899251b0b3234a5$export$513f42987b822fd7, (v) => $c899251b0b3234a5$export$513f42987b822fd7 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $c899251b0b3234a5$export$7d9f7e9c1c02b41e;
var $c899251b0b3234a5$export$289ca1c318c0384;
var $c899251b0b3234a5$export$513f42987b822fd7;

var $gyMcV = parcelRequire("gyMcV");

var $k03Cp = parcelRequire("k03Cp");
$c899251b0b3234a5$export$7d9f7e9c1c02b41e = function() {
    return "node-log";
};
$c899251b0b3234a5$export$289ca1c318c0384 = function() {
    return $gyMcV;
};
$c899251b0b3234a5$export$513f42987b822fd7 = function() {
    return $k03Cp;
};

});
parcelRegister("gyMcV", function(module, exports) {

$parcel$export(module.exports, "getModelData", () => $c0e53750cbda6e8a$export$b077627fdbee10b0, (v) => $c0e53750cbda6e8a$export$b077627fdbee10b0 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $c0e53750cbda6e8a$export$b077627fdbee10b0;

var $d51jt = parcelRequire("d51jt");
$c0e53750cbda6e8a$export$b077627fdbee10b0 = function(callback) {
    var objectUrl = this.requiredAttr("objectUrl");
    // Lazy loading of an object.  The view code calls the getObject function on the model
    // it receives.  It allows the view to load the real model lazily e.g. only after
    // the user clicks on something.
    var lazyLoadModel = {
        getObject: function(loadCallback) {
            if (lazyLoadModel.cachedObject) loadCallback(lazyLoadModel.cachedObject);
            else $d51jt.getObject(objectUrl, function(object) {
                if (lazyLoadModel.cacheFunc) lazyLoadModel.cacheFunc(object);
                loadCallback(object);
            });
        }
    };
    return callback(lazyLoadModel);
};

});

parcelRegister("k03Cp", function(module, exports) {

$parcel$export(module.exports, "render", () => $e8f69d515cbf62c6$export$b3890eb0ae9dca99, (v) => $e8f69d515cbf62c6$export$b3890eb0ae9dca99 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $e8f69d515cbf62c6$export$b3890eb0ae9dca99;

var $gZ5Q1 = parcelRequire("gZ5Q1");

var $kiPKr = parcelRequire("kiPKr");
$e8f69d515cbf62c6$export$b3890eb0ae9dca99 = function(logLazyLoadModel, onElement) {
    // Add a caching function to the lazy load model.  This allows us to avoid
    // reloading of log details for completed nodes.
    logLazyLoadModel.cacheFunc = function(logDetails) {
        if (logDetails.nodeStatus === "SUCCESS") logLazyLoadModel.cachedObject = logDetails;
    };
    onElement.click(function() {
        logLazyLoadModel.getObject(function(lazyLoad) {
            var nodeLogDom = $kiPKr.apply("node-log", lazyLoad);
            var $ = $gZ5Q1.getJQuery();
            var logDetailsEl = $(".log-details", onElement);
            logDetailsEl.empty();
            logDetailsEl.append(nodeLogDom);
        });
    });
};

});


parcelRegister("C1XXF", function(module, exports) {

$parcel$export(module.exports, "getName", () => $07251327a3e7db62$export$7d9f7e9c1c02b41e, (v) => $07251327a3e7db62$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getModel", () => $07251327a3e7db62$export$289ca1c318c0384, (v) => $07251327a3e7db62$export$289ca1c318c0384 = v);
$parcel$export(module.exports, "getView", () => $07251327a3e7db62$export$513f42987b822fd7, (v) => $07251327a3e7db62$export$513f42987b822fd7 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $07251327a3e7db62$export$7d9f7e9c1c02b41e;
var $07251327a3e7db62$export$289ca1c318c0384;
var $07251327a3e7db62$export$513f42987b822fd7;

var $179tf = parcelRequire("179tf");

var $lFwj3 = parcelRequire("lFwj3");
$07251327a3e7db62$export$7d9f7e9c1c02b41e = function() {
    return "run-input-required";
};
$07251327a3e7db62$export$289ca1c318c0384 = function() {
    return $179tf;
};
$07251327a3e7db62$export$513f42987b822fd7 = function() {
    return $lFwj3;
};

});
parcelRegister("179tf", function(module, exports) {

$parcel$export(module.exports, "getModelData", () => $0cfdca98cc4f07a5$export$b077627fdbee10b0, (v) => $0cfdca98cc4f07a5$export$b077627fdbee10b0 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $0cfdca98cc4f07a5$export$b077627fdbee10b0;

var $d51jt = parcelRequire("d51jt");
$0cfdca98cc4f07a5$export$b077627fdbee10b0 = function(callback) {
    var pendingInputActions = this.requiredAttr("objectUrl");
    $d51jt.getPendingActions(pendingInputActions, function(pendingActions) {
        callback(pendingActions);
    });
};

});

parcelRegister("lFwj3", function(module, exports) {

$parcel$export(module.exports, "render", () => $fc667caddd693436$export$b3890eb0ae9dca99, (v) => $fc667caddd693436$export$b3890eb0ae9dca99 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $fc667caddd693436$export$b3890eb0ae9dca99;

var $gZ5Q1 = parcelRequire("gZ5Q1");

var $kiPKr = parcelRequire("kiPKr");

var $bhAAh = parcelRequire("bhAAh");

var $iKZD3 = parcelRequire("iKZD3");
var $fc667caddd693436$var$supportedInputTypes = {
    "BooleanParameterDefinition": true,
    "StringParameterDefinition": true,
    "TextParameterDefinition": true,
    "PasswordParameterDefinition": true,
    "ChoiceParameterDefinition": true
};
function $fc667caddd693436$var$allInputTypesSupported(inputs) {
    if (!inputs) // no inputs.
    return true;
    for(var i = 0; i < inputs.length; i++){
        if (!$fc667caddd693436$var$supportedInputTypes[inputs[i].type]) return false;
    }
    return true;
}
$fc667caddd693436$export$b3890eb0ae9dca99 = function(inputRequiredModel, onElement) {
    if ($fc667caddd693436$var$allInputTypesSupported(inputRequiredModel.inputs)) {
        var popoverDom = $kiPKr.apply("run-input-required", inputRequiredModel);
        var popover = $bhAAh.newPopover("run-input-required", popoverDom, onElement.parent(), {
            hoverBoth: true,
            namespace: "runInputRequired",
            placement: "left",
            hideDelay: 3000,
            onshow: function() {
                var $ = $gZ5Q1.getJQuery();
                var pendingActionsTable = $(".pending-input-actions", popoverDom);
                var abortUrl = inputRequiredModel.abortUrl;
                var proceedUrl = inputRequiredModel.proceedUrl;
                var proceedBtn = $(".proceed-button", popoverDom);
                var abortBtn = $(".abort-button", popoverDom);
                function disableButtons() {
                    proceedBtn.attr("disabled", true);
                    abortBtn.attr("disabled", true);
                }
                proceedBtn.click(function() {
                    disableButtons();
                    // Get all the inputs and POST them back tot he Run API.
                    var inputs = $(".inputs :input");
                    var inputNVPs = [];
                    inputs.each(function() {
                        var input = $(this);
                        var inputName = input.attr("name");
                        if (input.is(":checkbox")) // Convert the checkbox "on"/"off" value to a boolean.
                        inputNVPs.push({
                            name: inputName,
                            value: input.is(":checked")
                        });
                        else inputNVPs.push({
                            name: inputName,
                            value: input.val()
                        });
                    });
                    // Perform the POST. Needs to be encoded into a "json" parameter with an
                    // array object named "parameter" :)
                    var parameters = {
                        json: JSON.stringify({
                            parameter: inputNVPs
                        })
                    };
                    $iKZD3.jenkinsAjaxPOSTURLEncoded(proceedUrl, parameters, function() {
                        popover.hide();
                    });
                });
                abortBtn.click(function() {
                    disableButtons();
                    $iKZD3.jenkinsAjaxPOST(abortUrl, function() {
                        popover.hide();
                    });
                });
            }
        });
        popover.hover();
        // for testing...
        return popoverDom;
    } else {
        var popoverDom = $kiPKr.apply("run-input-required-redirect", inputRequiredModel);
        var popover = $bhAAh.newPopover("run-input-required", popoverDom, onElement.parent(), {
            hoverBoth: true,
            namespace: "runInputRequired",
            placement: "left"
        });
        popover.hover();
        // for testing...
        return popoverDom;
    }
};

});


parcelRegister("e2mdv", function(module, exports) {

$parcel$export(module.exports, "getName", () => $a3827c5fab2f03fb$export$7d9f7e9c1c02b41e, (v) => $a3827c5fab2f03fb$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getModel", () => $a3827c5fab2f03fb$export$289ca1c318c0384, (v) => $a3827c5fab2f03fb$export$289ca1c318c0384 = v);
$parcel$export(module.exports, "getView", () => $a3827c5fab2f03fb$export$513f42987b822fd7, (v) => $a3827c5fab2f03fb$export$513f42987b822fd7 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $a3827c5fab2f03fb$export$7d9f7e9c1c02b41e;
var $a3827c5fab2f03fb$export$289ca1c318c0384;
var $a3827c5fab2f03fb$export$513f42987b822fd7;

var $gyMcV = parcelRequire("gyMcV");

var $jcvzf = parcelRequire("jcvzf");
$a3827c5fab2f03fb$export$7d9f7e9c1c02b41e = function() {
    return "build-artifacts-popup";
};
$a3827c5fab2f03fb$export$289ca1c318c0384 = function() {
    return $gyMcV;
};
$a3827c5fab2f03fb$export$513f42987b822fd7 = function() {
    return $jcvzf;
};

});
parcelRegister("jcvzf", function(module, exports) {

$parcel$export(module.exports, "render", () => $dfa79ff17140a168$export$b3890eb0ae9dca99, (v) => $dfa79ff17140a168$export$b3890eb0ae9dca99 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $dfa79ff17140a168$export$b3890eb0ae9dca99;

var $gZ5Q1 = parcelRequire("gZ5Q1");

var $kiPKr = parcelRequire("kiPKr");

var $bhAAh = parcelRequire("bhAAh");
$dfa79ff17140a168$export$b3890eb0ae9dca99 = function(lazyLoadConfig, onElement) {
    var $ = $gZ5Q1.getJQuery();
    var popupEl = $('<div class="cbwf-build-artifacts"></div>');
    var popover = $bhAAh.newPopover("build-artifacts", popupEl, onElement, {
        placement: "right",
        hoverBoth: true,
        namespace: "build-artifacts",
        onshow: function() {
            lazyLoadConfig.getObject(function(lazyLoad) {
                var lazyLoadToDisplay = $kiPKr.apply("build-artifacts", lazyLoad);
                popupEl.empty().append(lazyLoadToDisplay);
                // need to reapply placement of the popover because:
                // 1. we have altered it's content, which possibly widened it
                // 2. it is positioned to the left and so, if widened, means it's positioning is off
                popover.applyPlacement();
            });
        }
    });
    popover.hover();
};

});


parcelRegister("fcpbd", function(module, exports) {

$parcel$export(module.exports, "getName", () => $b10b82380ae347ba$export$7d9f7e9c1c02b41e, (v) => $b10b82380ae347ba$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getModel", () => $b10b82380ae347ba$export$289ca1c318c0384, (v) => $b10b82380ae347ba$export$289ca1c318c0384 = v);
$parcel$export(module.exports, "getView", () => $b10b82380ae347ba$export$513f42987b822fd7, (v) => $b10b82380ae347ba$export$513f42987b822fd7 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $b10b82380ae347ba$export$7d9f7e9c1c02b41e;
var $b10b82380ae347ba$export$289ca1c318c0384;
var $b10b82380ae347ba$export$513f42987b822fd7;

var $lhGCe = parcelRequire("lhGCe");

var $jS51I = parcelRequire("jS51I");
$b10b82380ae347ba$export$7d9f7e9c1c02b41e = function() {
    return "run-changesets";
};
$b10b82380ae347ba$export$289ca1c318c0384 = function() {
    return $lhGCe;
};
$b10b82380ae347ba$export$513f42987b822fd7 = function() {
    return $jS51I;
};

});
parcelRegister("lhGCe", function(module, exports) {

$parcel$export(module.exports, "getModelData", () => $03ffae6ba3b47af8$export$b077627fdbee10b0, (v) => $03ffae6ba3b47af8$export$b077627fdbee10b0 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $03ffae6ba3b47af8$export$b077627fdbee10b0;

var $d51jt = parcelRequire("d51jt");
$03ffae6ba3b47af8$export$b077627fdbee10b0 = function(callback) {
    var objectUrl = this.requiredAttr("objectUrl");
    $d51jt.getObject(objectUrl, function(changesets) {
        var sumCommits = {
            commitCount: 0,
            commits: [],
            contributorCount: 0,
            contributors: [],
            kind: "multiple"
        };
        if (changesets.length > 0) sumCommits.consoleUrl = changesets[0].consoleUrl;
        // Go through each changeset and mine extra info
        for(var i = 0; i < changesets.length; i++){
            var changeset = changesets[i];
            var commits = changeset.commits;
            var contributorName = {};
            changeset.contributors = [];
            for(var ii = 0; ii < commits.length; ii++){
                var commit = commits[ii];
                // tag each changeset with the names of
                // the contributors to the commit list
                if (!contributorName[commit.authorJenkinsId]) {
                    contributorName[commit.authorJenkinsId] = "yes";
                    changeset.contributors.push({
                        authorJenkinsId: commit.authorJenkinsId
                    });
                }
                // Parse out the first line of the commit message
                commit.messageLine1 = commit.message.split(/\r?\n/)[0];
                if (changeset.kind === "git") commit.commitIdDisplay = commit.commitId.slice(0, 7);
                else commit.commitIdDisplay = commit.commitId;
                commit.kind = changeset.kind;
                sumCommits.commits.push(commit);
            }
            sumCommits.commitCount += changeset.commitCount;
            sumCommits.contributors = sumCommits.contributors.concat(changeset.contributors);
            sumCommits.contributorCount = sumCommits.contributors.length;
            if (changesets.length === 1) sumCommits.kind = changeset.kind;
            changeset.contributorCount = changeset.contributors.length;
        }
        return callback(sumCommits);
    });
};

});

parcelRegister("jS51I", function(module, exports) {

$parcel$export(module.exports, "render", () => $e776f5ae9f584f3f$export$b3890eb0ae9dca99, (v) => $e776f5ae9f584f3f$export$b3890eb0ae9dca99 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $e776f5ae9f584f3f$export$b3890eb0ae9dca99;

var $gZ5Q1 = parcelRequire("gZ5Q1");

var $kiPKr = parcelRequire("kiPKr");

var $bhAAh = parcelRequire("bhAAh");
$e776f5ae9f584f3f$export$b3890eb0ae9dca99 = function(changeSets, onElement) {
    var content = $kiPKr.apply("run-changesets", changeSets);
    var $ = $gZ5Q1.getJQuery();
    onElement.empty().append(content);
    $(".run-changeset", content).each(function() {
        var changesetWidget = $(this);
        var changeSetData = changeSets;
        var changesetPopout = $kiPKr.apply("run-changeset", changeSetData);
        var popover = $bhAAh.newPopover("run-changeset", changesetPopout, changesetWidget, {
            placement: "right",
            hoverBoth: true
        });
        popover.hover();
    });
};

});


parcelRegister("k7uzs", function(module, exports) {

$parcel$export(module.exports, "getName", () => $ea5c2cd81b9554b6$export$7d9f7e9c1c02b41e, (v) => $ea5c2cd81b9554b6$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getModel", () => $ea5c2cd81b9554b6$export$289ca1c318c0384, (v) => $ea5c2cd81b9554b6$export$289ca1c318c0384 = v);
$parcel$export(module.exports, "getView", () => $ea5c2cd81b9554b6$export$513f42987b822fd7, (v) => $ea5c2cd81b9554b6$export$513f42987b822fd7 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $ea5c2cd81b9554b6$export$7d9f7e9c1c02b41e;
var $ea5c2cd81b9554b6$export$289ca1c318c0384;
var $ea5c2cd81b9554b6$export$513f42987b822fd7;

var $51rjE = parcelRequire("51rjE");

var $8lffF = parcelRequire("8lffF");
$ea5c2cd81b9554b6$export$7d9f7e9c1c02b41e = function() {
    return "remove-sidepanel";
};
$ea5c2cd81b9554b6$export$289ca1c318c0384 = function() {
    return $51rjE;
};
$ea5c2cd81b9554b6$export$513f42987b822fd7 = function() {
    return $8lffF;
};

});
parcelRegister("51rjE", function(module, exports) {

$parcel$export(module.exports, "getModelData", () => $3a823c24aded093e$export$b077627fdbee10b0, (v) => $3a823c24aded093e$export$b077627fdbee10b0 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Empty model used for views that do not require a model.
 */ var $3a823c24aded093e$export$b077627fdbee10b0;
$3a823c24aded093e$export$b077627fdbee10b0 = function(callback) {
    callback({});
};

});

parcelRegister("8lffF", function(module, exports) {

$parcel$export(module.exports, "render", () => $612c1d8d97187c0d$export$b3890eb0ae9dca99, (v) => $612c1d8d97187c0d$export$b3890eb0ae9dca99 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2013-2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $612c1d8d97187c0d$export$b3890eb0ae9dca99;

var $gZ5Q1 = parcelRequire("gZ5Q1");
$612c1d8d97187c0d$export$b3890eb0ae9dca99 = function(message, onElement) {
    var $ = $gZ5Q1.getJQuery();
    $("div#side-panel").remove();
    $("div#main-panel").addClass("fullscreen");
};

});


parcelRegister("b3FBw", function(module, exports) {

var $2ZEsn = parcelRequire("2ZEsn");
module.exports = function isTestEnv() {
    if ($2ZEsn.getWindow() === undefined) return true;
    else if ($2ZEsn.getWindow().navigator === undefined) return true;
    else if ($2ZEsn.getWindow().navigator.userAgent === undefined) return true;
    else if ($2ZEsn.getWindow().navigator.userAgent.toLowerCase().indexOf("jsdom") !== -1) return true;
};

});

parcelRegister("2eByE", function(module, exports) {

$parcel$export(module.exports, "importModule", () => $1a0a05ce23756774$export$a3c2b6ac6b617c0e, (v) => $1a0a05ce23756774$export$a3c2b6ac6b617c0e = v);
$parcel$export(module.exports, "exportModule", () => $1a0a05ce23756774$export$3f3f9d32b953ea33, (v) => $1a0a05ce23756774$export$3f3f9d32b953ea33 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * What's the top level module/bundle name.
 * @param moduleQName The module QName.
 * @returns The module QName, or undefined if unknown.
 */ var $1a0a05ce23756774$export$533e55abf9329f7b;
/**
 * Asynchronously import/require a set of modules.
 *
 * <p>
 * Responsible for triggering the async loading of modules if a given module is not already loaded.
 *
 * @param moduleQNames... A list of module "qualified" names, each containing the module name prefixed with the namespace
 * and separated by a colon i.e. "<namespace>:<moduleName>" e.g. "jquery:jquery2".
 *
 * @return A Promise, allowing async load of all modules. The promise is only fulfilled when all modules are loaded.
 */ var $1a0a05ce23756774$export$a3c2b6ac6b617c0e;
/**
 * Synchronously "require" a module that it already loaded/registered.
 *
 * <p>
 * This function will throw an error if the module is not already loaded via an outer call to 'import'
 * (or 'import').
 *
 * @param moduleQName The module "qualified" name containing the module name prefixed with the namespace
 * separated by a colon i.e. "<namespace>:<moduleName>" e.g. "jquery:jquery2".
 *
 * @return The module.
 */ var $1a0a05ce23756774$export$a5e99ae7010041ac;
/**
 * Export a module.
 *
 * @param namespace The namespace in which the module resides, or "undefined" if the modules is in
 * the "global" module namespace e.g. a Jenkins core bundle.
 * @param moduleName The name of the module.
 * @param module The CommonJS style module, or "undefined" if we just want to notify other modules waiting on
 * the loading of this module.
 * @param onError On error callback;
 */ var $1a0a05ce23756774$export$3f3f9d32b953ea33;
/**
 * Add a resource resolver.
 * @param {ResourceLocationResolver} resourceLocationResolver The resource resolver.
 */ var $1a0a05ce23756774$export$679c881cd84d459c;
/**
 * Get the ResourceLocationResolver function for the supplied ModuleSpec.
 * @param {ModuleSpec} moduleSpec The ModuleSpec.
 * @returns {function} The ResourceLocationResolver function for the supplied
 * ModuleSpec, or null if none specified.
 */ var $1a0a05ce23756774$export$310752efb65e51ae;
/**
 * Add a module's CSS to the browser page.
 *
 * <p>
 * The assumption is that the CSS can be accessed at e.g.
 * {@code <rootURL>/plugin/<namespace>/jsmodules/<moduleName>/style.css} i.e.
 * the pluginId acts as the namespace.
 *
 * @param namespace The namespace in which the module resides.
 * @param moduleName The name of the module.
 * @param onError On error callback;
 */ var $1a0a05ce23756774$export$8897703fa2fe3d65;
/**
 * Add a plugin CSS file to the browser page.
 *
 * @param pluginName The Jenkins plugin in which the module resides.
 * @param cssPath The CSS path.
 * @param onError On error callback;
 */ var $1a0a05ce23756774$export$13107a9d62c48c2b;
/**
 * Create a js-modules CSS id that can be used to refer to a link element.
 * @param cssPath The CSS path/url.
 * @param namespace Optional namespace.
 */ var $1a0a05ce23756774$export$37fbb5ff1f488d94;
/**
 * Add CSS file to the browser page.
 *
 * @param cssPath The CSS path.
 * @param onError On error callback;
 */ var $1a0a05ce23756774$export$a56f602340b3b9fe;
/**
 * Add a javascript &lt;script&gt; element to the document &lt;head&gt;.
 * <p/>
 * Options:
 * <ul>
 *     <li><strong>scriptId</strong>: The script Id to use for the element. If not specified, one will be generated from the scriptSrc.</li>
 *     <li><strong>async</strong>: Asynchronous loading of the script. Default is 'true'.</li>
 *     <li><strong>success</strong>: An optional onload success function for the script element.</li>
 *     <li><strong>error</strong>: An optional onload error function for the script element. This is called if the .js file exists but there's an error evaluating the script. It is NOT called if the .js file doesn't exist (ala 404).</li>
 *     <li><strong>removeElementOnLoad</strong>: Remove the script element after loading the script. Default is 'false'.</li>
 * </ul>
 *
 * @param scriptSrc The script src.
 * @param options Optional script load options object. See above.
 */ var $1a0a05ce23756774$export$173938b5bdca3327;
/**
 * Set the module registration timeout i.e. the length of time to wait for a module to load before failing.
 *
 * @param timeout Millisecond duration before onRegister times out. Defaults to 10000 (10s) if not specified.
 */ var $1a0a05ce23756774$export$4e8ec2eedd2d1f64;
/**
 * Set the Jenkins root/base URL.
 *
 * @param rootUrl The root/base URL.
 */ var $1a0a05ce23756774$export$db5c67fb99bc21aa;
var $1a0a05ce23756774$export$506e4e5ef995299b;
var $1a0a05ce23756774$export$d64627a42097df53;
/**
 * Manually initialise the Jenkins Global.
 * <p>
 * This should only ever be called from a test environment.
 */ var $1a0a05ce23756774$export$8422005580f626fc;

var $8UsCq = parcelRequire("8UsCq");

var $eyaRm = parcelRequire("eyaRm");

var $2c8Sw = parcelRequire("2c8Sw");
var $1a0a05ce23756774$var$onRegisterTimeout;
var $1a0a05ce23756774$var$whoami;
$1a0a05ce23756774$export$533e55abf9329f7b = function(moduleQName) {
    if (moduleQName) {
        $1a0a05ce23756774$var$whoami = moduleQName;
        $8UsCq.whoami($1a0a05ce23756774$var$whoami);
    }
    return $1a0a05ce23756774$var$whoami;
};
$1a0a05ce23756774$export$a3c2b6ac6b617c0e = function() {
    if (arguments.length === 1) return $8UsCq.importModule(arguments[0], $1a0a05ce23756774$var$onRegisterTimeout);
    var moduleQNames = [];
    for(var i = 0; i < arguments.length; i++){
        var argument = arguments[i];
        if (typeof argument === "string") moduleQNames.push(argument);
    }
    if (moduleQNames.length == 0) throw new Error("No module names specified.");
    return $eyaRm.make(function(resolve, reject) {
        var fulfillments = [];
        function onFulfillment() {
            if (fulfillments.length === moduleQNames.length) {
                var modules = [];
                for(var i = 0; i < fulfillments.length; i++){
                    if (fulfillments[i].value) modules.push(fulfillments[i].value);
                    else // don't have everything yet so can't fulfill all.
                    return;
                }
                // If we make it here, then we have fulfilled all individual promises, which 
                // means we can now fulfill the top level import promise.
                resolve(modules);
            }
        }
        // doRequire for each module
        for(var i = 0; i < moduleQNames.length; i++){
            function doRequire(moduleQName) {
                var promise = $8UsCq.importModule(moduleQName, $1a0a05ce23756774$var$onRegisterTimeout);
                var fulfillment = {
                    promise: promise,
                    value: undefined
                };
                fulfillments.push(fulfillment);
                promise.onFulfilled(function(value) {
                    fulfillment.value = value;
                    onFulfillment();
                }).onRejected(function(error) {
                    reject(error);
                });
            }
            doRequire(moduleQNames[i]);
        }
    }).applyArgsOnFulfill();
};
$1a0a05ce23756774$export$a5e99ae7010041ac = function(moduleQName) {
    var parsedModuleName = new $2c8Sw(moduleQName);
    var module = $8UsCq.getModule(parsedModuleName);
    if (!module) throw new Error("Unable to perform synchronous 'require' for module '" + moduleQName + "'. This module is not pre-loaded. " + "The module needs to have been asynchronously pre-loaded via an outer call to 'import'.");
    return module.exports;
};
$1a0a05ce23756774$export$3f3f9d32b953ea33 = function(namespace, moduleName, module, onError) {
    try {
        var moduleQName = (namespace ? namespace + ":" : "") + moduleName;
        var moduleSpec = new $2c8Sw(moduleQName);
        var moduleNamespaceObj = $8UsCq.getModuleNamespaceObj(moduleSpec);
        var moduleLoadName = moduleSpec.getLoadBundleName();
        if (moduleNamespaceObj[moduleLoadName]) {
            if (namespace) console.debug("Jenkins plugin module '" + namespace + ":" + moduleName + "' already registered.");
            else console.debug("Jenkins global module '" + moduleName + "' already registered.");
            return;
        }
        if (!module) module = {
            exports: {}
        };
        else if (module.exports === undefined) module = {
            exports: module
        };
        moduleNamespaceObj[moduleLoadName] = module;
        // Notify all that the module has been registered. See internal.loadModule also.
        $8UsCq.notifyModuleExported(moduleSpec, module.exports);
    } catch (e) {
        console.error(e);
        if (onError) onError(e);
    }
};
$1a0a05ce23756774$export$679c881cd84d459c = function(resourceLocationResolver) {
    $8UsCq.addResourceLocationResolver(resourceLocationResolver);
};
$1a0a05ce23756774$export$310752efb65e51ae = function(moduleSpec) {
    if (typeof moduleSpec === "string") moduleSpec = new $2c8Sw(moduleSpec);
    var resolver = $8UsCq.getResourceLocationResolverFunc(moduleSpec);
    if (resolver) return function(resourcePath) {
        return resolver(moduleSpec, resourcePath);
    };
    return undefined;
};
$1a0a05ce23756774$export$8897703fa2fe3d65 = function(namespace, moduleName, onError) {
    try {
        $8UsCq.addModuleCSSToPage(namespace, moduleName);
    } catch (e) {
        console.error(e);
        if (onError) onError(e);
    }
};
$1a0a05ce23756774$export$13107a9d62c48c2b = function(pluginName, cssPath, onError) {
    try {
        $8UsCq.addPluginCSSToPage(pluginName, cssPath);
    } catch (e) {
        console.error(e);
        if (onError) onError(e);
    }
};
$1a0a05ce23756774$export$37fbb5ff1f488d94 = function(cssPath, namespace) {
    return $8UsCq.toCSSId(cssPath, namespace);
};
$1a0a05ce23756774$export$a56f602340b3b9fe = function(cssPath, onError) {
    try {
        if (cssPath.indexOf($8UsCq.getAdjunctURL()) === 0) $8UsCq.addCSSToPage(undefined, cssPath);
        else if (cssPath.indexOf("http://") === 0 || cssPath.indexOf("https://") === 0) // the css path is already fully qualified
        $8UsCq.addCSSToPage(undefined, cssPath);
        else $8UsCq.addCSSToPage(undefined, $8UsCq.getRootURL() + "/" + cssPath);
    } catch (e) {
        console.error(e);
        if (onError) onError(e);
    }
};
$1a0a05ce23756774$export$173938b5bdca3327 = function(scriptSrc, options) {
    $8UsCq.addScript(scriptSrc, options);
};
$1a0a05ce23756774$export$4e8ec2eedd2d1f64 = function(timeout) {
    $1a0a05ce23756774$var$onRegisterTimeout = timeout;
};
$1a0a05ce23756774$export$db5c67fb99bc21aa = function(rootUrl) {
    $8UsCq.setRootURL(rootUrl);
};
$1a0a05ce23756774$export$506e4e5ef995299b = $8UsCq.getRootURL;
$1a0a05ce23756774$export$d64627a42097df53 = $8UsCq.getAdjunctURL;
$1a0a05ce23756774$export$8422005580f626fc = function() {
    $8UsCq.initJenkinsGlobal();
};
$8UsCq.onJenkinsGlobalInit(function(jenkinsCIGlobal) {
    // For backward compatibility, we need to make some js-modules
    // functions globally available e.g. to allow legacy code wait for
    // certain modules to be loaded, as with legacy adjuncts.
    if (!jenkinsCIGlobal._internal) // Put the functions on an object called '_internal' as a way
    // of hinting to people to not use it.
    jenkinsCIGlobal._internal = {
        importModule: $1a0a05ce23756774$export$a3c2b6ac6b617c0e,
        addScript: $8UsCq.addScript
    };
});

});
parcelRegister("8UsCq", function(module, exports) {

$parcel$export(module.exports, "whoami", () => $67c9c0c6f5c9baeb$export$533e55abf9329f7b, (v) => $67c9c0c6f5c9baeb$export$533e55abf9329f7b = v);
$parcel$export(module.exports, "onJenkinsGlobalInit", () => $67c9c0c6f5c9baeb$export$97fa9fe85d407f12, (v) => $67c9c0c6f5c9baeb$export$97fa9fe85d407f12 = v);
$parcel$export(module.exports, "initJenkinsGlobal", () => $67c9c0c6f5c9baeb$export$8422005580f626fc, (v) => $67c9c0c6f5c9baeb$export$8422005580f626fc = v);
$parcel$export(module.exports, "addResourceLocationResolver", () => $67c9c0c6f5c9baeb$export$679c881cd84d459c, (v) => $67c9c0c6f5c9baeb$export$679c881cd84d459c = v);
$parcel$export(module.exports, "getJenkins", () => $67c9c0c6f5c9baeb$export$e5d1c7d2deccbc64, (v) => $67c9c0c6f5c9baeb$export$e5d1c7d2deccbc64 = v);
$parcel$export(module.exports, "getModuleNamespaceObj", () => $67c9c0c6f5c9baeb$export$e99043d7208a37d1, (v) => $67c9c0c6f5c9baeb$export$e99043d7208a37d1 = v);
$parcel$export(module.exports, "getNamespace", () => $67c9c0c6f5c9baeb$export$becf4f9e48e6290a, (v) => $67c9c0c6f5c9baeb$export$becf4f9e48e6290a = v);
$parcel$export(module.exports, "getGlobalModules", () => $67c9c0c6f5c9baeb$export$37fbe84302a34608, (v) => $67c9c0c6f5c9baeb$export$37fbe84302a34608 = v);
$parcel$export(module.exports, "getNamespaces", () => $67c9c0c6f5c9baeb$export$6ae36463c40ebe74, (v) => $67c9c0c6f5c9baeb$export$6ae36463c40ebe74 = v);
$parcel$export(module.exports, "importModule", () => $67c9c0c6f5c9baeb$export$a3c2b6ac6b617c0e, (v) => $67c9c0c6f5c9baeb$export$a3c2b6ac6b617c0e = v);
$parcel$export(module.exports, "getModule", () => $67c9c0c6f5c9baeb$export$90835e7e06f4e75b, (v) => $67c9c0c6f5c9baeb$export$90835e7e06f4e75b = v);
$parcel$export(module.exports, "loadModule", () => $67c9c0c6f5c9baeb$export$ebb47fdc8f2dbc6f, (v) => $67c9c0c6f5c9baeb$export$ebb47fdc8f2dbc6f = v);
$parcel$export(module.exports, "toModuleId", () => $67c9c0c6f5c9baeb$export$72acb38f1fcbaa87, (v) => $67c9c0c6f5c9baeb$export$72acb38f1fcbaa87 = v);
$parcel$export(module.exports, "toModuleSrc", () => $67c9c0c6f5c9baeb$export$3df5142b6082c7c3, (v) => $67c9c0c6f5c9baeb$export$3df5142b6082c7c3 = v);
$parcel$export(module.exports, "addScript", () => $67c9c0c6f5c9baeb$export$173938b5bdca3327, (v) => $67c9c0c6f5c9baeb$export$173938b5bdca3327 = v);
$parcel$export(module.exports, "getHeadElement", () => $67c9c0c6f5c9baeb$export$d3e228062407378c, (v) => $67c9c0c6f5c9baeb$export$d3e228062407378c = v);
$parcel$export(module.exports, "notifyModuleExported", () => $67c9c0c6f5c9baeb$export$9058991c7183b159, (v) => $67c9c0c6f5c9baeb$export$9058991c7183b159 = v);
$parcel$export(module.exports, "addModuleCSSToPage", () => $67c9c0c6f5c9baeb$export$8897703fa2fe3d65, (v) => $67c9c0c6f5c9baeb$export$8897703fa2fe3d65 = v);
$parcel$export(module.exports, "getModuleSpec", () => $67c9c0c6f5c9baeb$export$d4a65fc0e353ec50, (v) => $67c9c0c6f5c9baeb$export$d4a65fc0e353ec50 = v);
$parcel$export(module.exports, "addCSSToPage", () => $67c9c0c6f5c9baeb$export$a56f602340b3b9fe, (v) => $67c9c0c6f5c9baeb$export$a56f602340b3b9fe = v);
$parcel$export(module.exports, "addPluginCSSToPage", () => $67c9c0c6f5c9baeb$export$13107a9d62c48c2b, (v) => $67c9c0c6f5c9baeb$export$13107a9d62c48c2b = v);
$parcel$export(module.exports, "getPluginPath", () => $67c9c0c6f5c9baeb$export$ae9efcafc2d3ac35, (v) => $67c9c0c6f5c9baeb$export$ae9efcafc2d3ac35 = v);
$parcel$export(module.exports, "toCSSId", () => $67c9c0c6f5c9baeb$export$37fbb5ff1f488d94, (v) => $67c9c0c6f5c9baeb$export$37fbb5ff1f488d94 = v);
$parcel$export(module.exports, "getAdjunctJSModulesPath", () => $67c9c0c6f5c9baeb$export$f06facf81a2c60f8, (v) => $67c9c0c6f5c9baeb$export$f06facf81a2c60f8 = v);
$parcel$export(module.exports, "getPluginJSModulesPath", () => $67c9c0c6f5c9baeb$export$24c31d6a7c06406f, (v) => $67c9c0c6f5c9baeb$export$24c31d6a7c06406f = v);
$parcel$export(module.exports, "getCoreAssetsJSModulesPath", () => $67c9c0c6f5c9baeb$export$418e9f4cbd200e3c, (v) => $67c9c0c6f5c9baeb$export$418e9f4cbd200e3c = v);
$parcel$export(module.exports, "setRootURL", () => $67c9c0c6f5c9baeb$export$db5c67fb99bc21aa, (v) => $67c9c0c6f5c9baeb$export$db5c67fb99bc21aa = v);
$parcel$export(module.exports, "getResourceLocationResolverFunc", () => $67c9c0c6f5c9baeb$export$bcbf1861489efa87, (v) => $67c9c0c6f5c9baeb$export$bcbf1861489efa87 = v);
$parcel$export(module.exports, "getRootURL", () => $67c9c0c6f5c9baeb$export$506e4e5ef995299b, (v) => $67c9c0c6f5c9baeb$export$506e4e5ef995299b = v);
$parcel$export(module.exports, "getAdjunctURL", () => $67c9c0c6f5c9baeb$export$d64627a42097df53, (v) => $67c9c0c6f5c9baeb$export$d64627a42097df53 = v);
/*
 * The MIT License
 *
 * Copyright (c) 2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $67c9c0c6f5c9baeb$export$533e55abf9329f7b;
var $67c9c0c6f5c9baeb$export$97fa9fe85d407f12;
var $67c9c0c6f5c9baeb$export$8422005580f626fc;
var $67c9c0c6f5c9baeb$export$275f3ef30c3e5302;
var $67c9c0c6f5c9baeb$export$679c881cd84d459c;
var $67c9c0c6f5c9baeb$export$e5d1c7d2deccbc64;
var $67c9c0c6f5c9baeb$export$e99043d7208a37d1;
var $67c9c0c6f5c9baeb$export$becf4f9e48e6290a;
var $67c9c0c6f5c9baeb$export$a3c2b6ac6b617c0e;
var $67c9c0c6f5c9baeb$export$ebb47fdc8f2dbc6f;
var $67c9c0c6f5c9baeb$export$173938b5bdca3327;
var $67c9c0c6f5c9baeb$export$9058991c7183b159;
var $67c9c0c6f5c9baeb$export$8897703fa2fe3d65;
var $67c9c0c6f5c9baeb$export$13107a9d62c48c2b;
var $67c9c0c6f5c9baeb$export$37fbb5ff1f488d94;
var $67c9c0c6f5c9baeb$export$a56f602340b3b9fe;
var $67c9c0c6f5c9baeb$export$37fbe84302a34608;
var $67c9c0c6f5c9baeb$export$6ae36463c40ebe74;
var $67c9c0c6f5c9baeb$export$72acb38f1fcbaa87;
var $67c9c0c6f5c9baeb$export$3df5142b6082c7c3;
var $67c9c0c6f5c9baeb$export$f06facf81a2c60f8;
var $67c9c0c6f5c9baeb$export$24c31d6a7c06406f;
var $67c9c0c6f5c9baeb$export$418e9f4cbd200e3c;
var $67c9c0c6f5c9baeb$export$ae9efcafc2d3ac35;
var $67c9c0c6f5c9baeb$export$d3e228062407378c;
var $67c9c0c6f5c9baeb$export$db5c67fb99bc21aa;
var $67c9c0c6f5c9baeb$export$90835e7e06f4e75b;
var $67c9c0c6f5c9baeb$export$d4a65fc0e353ec50;
var $67c9c0c6f5c9baeb$export$bcbf1861489efa87;
var $67c9c0c6f5c9baeb$export$506e4e5ef995299b;
var $67c9c0c6f5c9baeb$export$d64627a42097df53;

var $eyaRm = parcelRequire("eyaRm");

var $2c8Sw = parcelRequire("2c8Sw");

var $6YIDE = parcelRequire("6YIDE");
var $67c9c0c6f5c9baeb$var$jenkinsCIGlobal;
var $67c9c0c6f5c9baeb$var$globalInitListeners = [];
var $67c9c0c6f5c9baeb$var$whoami;
$67c9c0c6f5c9baeb$export$533e55abf9329f7b = function(moduleQName) {
    if (moduleQName) {
        $67c9c0c6f5c9baeb$var$whoami = new $2c8Sw(moduleQName);
        $67c9c0c6f5c9baeb$var$whoami.nsProvider = $67c9c0c6f5c9baeb$var$getBundleNSProviderFromScriptElement($67c9c0c6f5c9baeb$var$whoami.namespace, $67c9c0c6f5c9baeb$var$whoami.moduleName);
    }
    return $67c9c0c6f5c9baeb$var$whoami;
};
$67c9c0c6f5c9baeb$export$97fa9fe85d407f12 = function(callback) {
    $67c9c0c6f5c9baeb$var$globalInitListeners.push(callback);
};
$67c9c0c6f5c9baeb$export$8422005580f626fc = function() {
    $67c9c0c6f5c9baeb$var$jenkinsCIGlobal = {};
    if ($67c9c0c6f5c9baeb$var$globalInitListeners) for(var i = 0; i < $67c9c0c6f5c9baeb$var$globalInitListeners.length; i++)$67c9c0c6f5c9baeb$var$globalInitListeners[i]($67c9c0c6f5c9baeb$var$jenkinsCIGlobal);
};
$67c9c0c6f5c9baeb$export$275f3ef30c3e5302 = function() {
    $67c9c0c6f5c9baeb$var$jenkinsCIGlobal = undefined;
    $67c9c0c6f5c9baeb$var$whoami = undefined;
};
$67c9c0c6f5c9baeb$export$679c881cd84d459c = function(resourceLocationResolver) {
    var resolvers = $67c9c0c6f5c9baeb$var$getResourceLocationResolvers();
    resolvers.push(resourceLocationResolver);
    $6YIDE.sort(resolvers);
};
$67c9c0c6f5c9baeb$export$e5d1c7d2deccbc64 = function() {
    if ($67c9c0c6f5c9baeb$var$jenkinsCIGlobal) return $67c9c0c6f5c9baeb$var$jenkinsCIGlobal;
    if (window.jenkinsCIGlobal) $67c9c0c6f5c9baeb$var$jenkinsCIGlobal = window.jenkinsCIGlobal;
    else {
        $67c9c0c6f5c9baeb$export$8422005580f626fc();
        $67c9c0c6f5c9baeb$var$jenkinsCIGlobal.rootURL = $67c9c0c6f5c9baeb$var$getRootURL();
        window.jenkinsCIGlobal = $67c9c0c6f5c9baeb$var$jenkinsCIGlobal;
    }
    return $67c9c0c6f5c9baeb$var$jenkinsCIGlobal;
};
$67c9c0c6f5c9baeb$export$e99043d7208a37d1 = function(moduleSpec) {
    if (moduleSpec.namespace) return $67c9c0c6f5c9baeb$export$becf4f9e48e6290a(moduleSpec.namespace);
    else return $67c9c0c6f5c9baeb$export$37fbe84302a34608();
};
$67c9c0c6f5c9baeb$export$becf4f9e48e6290a = function(namespaceName) {
    var namespaces = $67c9c0c6f5c9baeb$export$6ae36463c40ebe74();
    var namespace = namespaces[namespaceName];
    if (!namespace) {
        namespace = {
            globalNS: false
        };
        namespaces[namespaceName] = namespace;
    }
    return namespace;
};
$67c9c0c6f5c9baeb$export$a3c2b6ac6b617c0e = function(moduleQName, onRegisterTimeout) {
    return $eyaRm.make(function(resolve, reject) {
        var moduleSpec = new $2c8Sw(moduleQName);
        var module = $67c9c0c6f5c9baeb$export$90835e7e06f4e75b(moduleSpec);
        if (module) // module already loaded
        resolve(module.exports);
        else {
            if (onRegisterTimeout === 0) {
                if (moduleSpec.namespace) throw new Error("Module " + moduleSpec.namespace + ":" + moduleSpec.moduleName + " require failure. Async load mode disabled.");
                else throw new Error("Global module " + moduleSpec.moduleName + " require failure. Async load mode disabled.");
            }
            // module not loaded. Load async, fulfilling promise once registered
            $67c9c0c6f5c9baeb$export$ebb47fdc8f2dbc6f(moduleSpec, onRegisterTimeout).onFulfilled(function(moduleExports) {
                resolve(moduleExports);
            }).onRejected(function(error) {
                reject(error);
            });
        }
    });
};
$67c9c0c6f5c9baeb$export$ebb47fdc8f2dbc6f = function(moduleSpec, onRegisterTimeout) {
    var module = $67c9c0c6f5c9baeb$export$90835e7e06f4e75b(moduleSpec);
    if (module) {
        // Module already loaded. This prob shouldn't happen.
        console.log("Unexpected call to 'loadModule' for a module (" + moduleSpec.moduleName + ") that's already loaded.");
        return $eyaRm.make(function(resolve) {
            resolve(module.exports);
        });
    }
    function waitForRegistration(loadingModule, onRegisterTimeout) {
        return $eyaRm.make(function(resolve, reject) {
            if (typeof onRegisterTimeout !== "number") onRegisterTimeout = 10000;
            var timeoutObj = setTimeout(function() {
                // Timed out waiting on the module to load and register itself.
                if (!loadingModule.loaded) {
                    var moduleSpec = loadingModule.moduleSpec;
                    var errorDetail;
                    if (moduleSpec.namespace) errorDetail = "Timed out waiting on module '" + moduleSpec.namespace + ":" + moduleSpec.moduleName + "' to load.";
                    else errorDetail = "Timed out waiting on module '" + moduleSpec.moduleName + "' to load.";
                    console.error("Module load failure: " + errorDetail);
                    // Call the reject function and tell it we timed out
                    reject({
                        reason: "timeout",
                        detail: errorDetail
                    });
                }
            }, onRegisterTimeout);
            loadingModule.waitList.push({
                resolve: resolve,
                timeoutObj: timeoutObj
            });
        });
    }
    var loadVersion = moduleSpec.getLoadBundleVersion();
    var doScriptLoad = true;
    if (loadVersion) // If a version was specified then we only do the script load if a
    // specific version was provided i.e. loading does not get triggered
    // by imports that specify non-specific version numbers e.g. "any"
    // or "1.2.x". A specific version number would be e.g. "1.2.3" i.e.
    // fully qualified. When loading is not triggered, the import is depending
    // on another import (with a specific version) or on another bundle to do an
    // export of an internal dependency i.e. on another bundle "providing"
    // the module by exporting it.
    doScriptLoad = loadVersion.isSpecific();
    var loadingModule = $67c9c0c6f5c9baeb$var$getLoadingModule(moduleSpec);
    if (!loadingModule.waitList) loadingModule.waitList = [];
    loadingModule.moduleSpec = moduleSpec;
    loadingModule.loaded = false;
    try {
        return waitForRegistration(loadingModule, onRegisterTimeout);
    } finally{
        if (doScriptLoad && !loadingModule.loadedBy) {
            // Capture the name of the bundle that triggered importing/loading
            // of the bundle.
            loadingModule.loadedBy = $67c9c0c6f5c9baeb$var$whoami;
            var loadModuleName = moduleSpec.getLoadBundleName();
            var scriptId = $67c9c0c6f5c9baeb$export$72acb38f1fcbaa87(moduleSpec.namespace, loadModuleName) + ":js";
            var scriptSrc = $67c9c0c6f5c9baeb$export$3df5142b6082c7c3(moduleSpec, "js");
            var scriptEl = $67c9c0c6f5c9baeb$export$173938b5bdca3327(scriptSrc, {
                scriptId: scriptId,
                scriptSrcBase: ""
            });
            if (scriptEl) {
                // Set the module spec info on the <script> element. This allows us to resolve the
                // nsProvider for that bundle after 'whoami' is called for it (as it loads). whoami
                // is not called with the nsProvider info on it because a given bundle can
                // potentially be loaded from multiple different ns providers, so we only resole the provider
                // at load-time i.e. just after a bundle is loaded it calls 'whoami' for itself
                // and then this module magically works out where it was loaded from (it's nsProvider)
                // by locating the <script> element and using this information. For a module/bundle, knowing
                // where it was loaded from is important because it dictates where that module/bundle
                // should load it dependencies from. For example, the Bootstrap module/bundle depends on the
                // jQuery bundle. So, if the bootstrap bundle is loaded from the 'core-assets' namespace provider,
                // then that means the jQuery bundle should also be loaded from the 'core-assets'
                // namespace provider.
                // See getBundleNSProviderFromScriptElement.
                scriptEl.setAttribute("data-jenkins-module-nsProvider", moduleSpec.nsProvider);
                scriptEl.setAttribute("data-jenkins-module-namespace", moduleSpec.namespace);
                scriptEl.setAttribute("data-jenkins-module-moduleName", loadModuleName);
            } else loadingModule.loadedBy = undefined;
        }
    }
};
$67c9c0c6f5c9baeb$export$173938b5bdca3327 = function(scriptSrc, options) {
    if (!scriptSrc) {
        console.warn('Call to addScript with undefined "scriptSrc" arg.');
        return undefined;
    }
    var normalizedOptions;
    // If there's no options object, create it.
    if (typeof options === "object") normalizedOptions = options;
    else normalizedOptions = {};
    // May want to transform/map some urls.
    if (normalizedOptions.scriptSrcMap) {
        if (typeof normalizedOptions.scriptSrcMap === "function") scriptSrc = normalizedOptions.scriptSrcMap(scriptSrc);
        else if (Array.isArray(normalizedOptions.scriptSrcMap)) // it's an array of suffix mappings
        for(var i = 0; i < normalizedOptions.scriptSrcMap.length; i++){
            var mapping = normalizedOptions.scriptSrcMap[i];
            if (mapping.from && mapping.to) {
                if ($67c9c0c6f5c9baeb$var$endsWith(scriptSrc, mapping.from)) {
                    normalizedOptions.originalScriptSrc = scriptSrc;
                    scriptSrc = scriptSrc.replace(mapping.from, mapping.to);
                    break;
                }
            }
        }
    }
    normalizedOptions.scriptId = $67c9c0c6f5c9baeb$var$getScriptId(scriptSrc, options);
    // set some default options
    if (normalizedOptions.async === undefined) normalizedOptions.async = true;
    if (normalizedOptions.scriptSrcBase === undefined) normalizedOptions.scriptSrcBase = "@root";
    if (normalizedOptions.scriptSrcBase === "@root") normalizedOptions.scriptSrcBase = $67c9c0c6f5c9baeb$var$getRootURL() + "/";
    else if (normalizedOptions.scriptSrcBase === "@adjunct") normalizedOptions.scriptSrcBase = $67c9c0c6f5c9baeb$var$getAdjunctURL() + "/";
    var document = window.document;
    var head = $67c9c0c6f5c9baeb$export$d3e228062407378c();
    var script = document.getElementById(normalizedOptions.scriptId);
    if (script) {
        var replaceable = script.getAttribute("data-replaceable");
        if (replaceable && replaceable === "true") // This <script> element is replaceable. In this case, 
        // we remove the existing script element and add a new one of the
        // same id and with the specified src attribute.
        // Adding happens below.
        script.parentNode.removeChild(script);
        else return undefined;
    }
    script = $67c9c0c6f5c9baeb$var$createElement("script");
    // Parts of the following onload code were inspired by how the ACE editor does it,
    // as well as from the follow SO post: http://stackoverflow.com/a/4845802/1166986
    var onload = function(_, isAborted) {
        script.setAttribute("data-onload-complete", true);
        try {
            if (isAborted) console.warn("Script load aborted: " + scriptSrc);
            else if (!script.readyState || script.readyState === "loaded" || script.readyState === "complete") {
                // If the options contains an onload function, call it.
                if (typeof normalizedOptions.success === "function") normalizedOptions.success(script);
                return;
            }
            if (typeof normalizedOptions.error === "function") normalizedOptions.error(script, isAborted);
        } finally{
            if (normalizedOptions.removeElementOnLoad) head.removeChild(script);
            // Handle memory leak in IE
            script = script.onload = script.onreadystatechange = null;
        }
    };
    script.onload = onload;
    script.onreadystatechange = onload;
    script.setAttribute("id", normalizedOptions.scriptId);
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", normalizedOptions.scriptSrcBase + scriptSrc);
    if (normalizedOptions.originalScriptSrc) script.setAttribute("data-referrer", normalizedOptions.originalScriptSrc);
    if (normalizedOptions.async) script.setAttribute("async", normalizedOptions.async);
    head.appendChild(script);
    return script;
};
$67c9c0c6f5c9baeb$export$9058991c7183b159 = function(moduleSpec, moduleExports) {
    var loadingModule = $67c9c0c6f5c9baeb$var$getLoadingModule(moduleSpec);
    loadingModule.loaded = true;
    if (loadingModule.waitList) for(var i = 0; i < loadingModule.waitList.length; i++){
        var waiter = loadingModule.waitList[i];
        clearTimeout(waiter.timeoutObj);
        waiter.resolve(moduleExports);
    }
};
$67c9c0c6f5c9baeb$export$8897703fa2fe3d65 = function(namespace, moduleName) {
    var moduleSpec = $67c9c0c6f5c9baeb$export$d4a65fc0e353ec50(namespace + ":" + moduleName);
    var cssElId = $67c9c0c6f5c9baeb$export$72acb38f1fcbaa87(namespace, moduleName) + ":css";
    var cssPath = $67c9c0c6f5c9baeb$export$3df5142b6082c7c3(moduleSpec, "css");
    return $67c9c0c6f5c9baeb$export$a56f602340b3b9fe(namespace, cssPath, cssElId);
};
$67c9c0c6f5c9baeb$export$13107a9d62c48c2b = function(namespace, cssPath, cssElId) {
    var cssPath = $67c9c0c6f5c9baeb$export$ae9efcafc2d3ac35(namespace) + "/" + cssPath;
    return $67c9c0c6f5c9baeb$export$a56f602340b3b9fe(namespace, cssPath, cssElId);
};
$67c9c0c6f5c9baeb$export$37fbb5ff1f488d94 = function(cssPath, namespace) {
    return "jenkins-js-module:" + (namespace || "global") + ":css:" + cssPath;
};
$67c9c0c6f5c9baeb$export$a56f602340b3b9fe = function(namespace, cssPath, cssElId) {
    var document = window.document;
    if (cssElId === undefined) cssElId = $67c9c0c6f5c9baeb$export$37fbb5ff1f488d94(cssPath, namespace);
    var cssEl = document.getElementById(cssElId);
    if (cssEl) // already added to page
    return;
    var docHead = $67c9c0c6f5c9baeb$export$d3e228062407378c();
    cssEl = $67c9c0c6f5c9baeb$var$createElement("link");
    cssEl.setAttribute("id", cssElId);
    cssEl.setAttribute("type", "text/css");
    cssEl.setAttribute("rel", "stylesheet");
    cssEl.setAttribute("href", cssPath);
    docHead.appendChild(cssEl);
    return cssEl;
};
$67c9c0c6f5c9baeb$export$37fbe84302a34608 = function() {
    var jenkinsCIGlobal = $67c9c0c6f5c9baeb$export$e5d1c7d2deccbc64();
    if (!jenkinsCIGlobal.globals) jenkinsCIGlobal.globals = {
        globalNS: true
    };
    return jenkinsCIGlobal.globals;
};
$67c9c0c6f5c9baeb$export$6ae36463c40ebe74 = function() {
    var jenkinsCIGlobal = $67c9c0c6f5c9baeb$export$e5d1c7d2deccbc64();
    // The namespaces are stored in an object named "plugins". This is a legacy from the
    // time when all modules lived in plugins. By right we'd like to rename this, but
    // that would cause compatibility issues.
    if (!jenkinsCIGlobal.plugins) jenkinsCIGlobal.plugins = {
        __README__: 'This object holds namespaced JS modules/bundles, with the property names representing the module namespace. It\'s name ("plugins") is a legacy thing. Changing it to a better name (e.g. "namespaces") would cause compatibility issues.'
    };
    return jenkinsCIGlobal.plugins;
};
$67c9c0c6f5c9baeb$export$72acb38f1fcbaa87 = function(namespace, moduleName) {
    return "jenkins-js-module:" + (namespace ? namespace + ":" : "") + moduleName;
};
$67c9c0c6f5c9baeb$export$3df5142b6082c7c3 = function(moduleSpec, srcType) {
    var nsProvider = moduleSpec.nsProvider;
    // If a moduleSpec on a module/bundle import doesn't specify a namespace provider
    // (i.e. is of the form "a:b" and not "core-assets/a:b"),
    // then check "this" bundles module spec and see if it was imported from a specific
    // namespace. If it was (e.g. 'core-assets'), then import from that namespace.
    if (nsProvider === undefined) {
        nsProvider = $67c9c0c6f5c9baeb$var$thisBundleNamespaceProvider();
        if (nsProvider === undefined) nsProvider = "adjuncts";
        // Store the nsProvider back onto the moduleSpec.
        moduleSpec.nsProvider = nsProvider;
    }
    var srcPath = undefined;
    if (srcType === "js") srcPath = moduleSpec.getLoadBundleFileNamePrefix() + ".js";
    else if (srcType === "css") srcPath = moduleSpec.getLoadBundleFileNamePrefix() + "/style.css";
    else throw new Error('Unsupported srcType "' + srcType + '".');
    // Maybe there's a custom resource resolver for this resource.
    var resourceLocationResolverFunc = $67c9c0c6f5c9baeb$var$getResourceLocationResolverFunc(moduleSpec);
    if (resourceLocationResolverFunc) {
        var resourcePath = resourceLocationResolverFunc(moduleSpec, srcPath);
        if (resourcePath) return resourcePath;
    }
    // Default resource resolution ...
    if (nsProvider === "adjuncts") return $67c9c0c6f5c9baeb$export$f06facf81a2c60f8(moduleSpec.namespace) + "/" + srcPath;
    else if (nsProvider === "plugin") return $67c9c0c6f5c9baeb$export$24c31d6a7c06406f(moduleSpec.namespace) + "/" + srcPath;
    else if (nsProvider === "core-assets") return $67c9c0c6f5c9baeb$export$418e9f4cbd200e3c(moduleSpec.namespace) + "/" + srcPath;
    else throw new Error("Unsupported namespace provider: " + nsProvider);
};
$67c9c0c6f5c9baeb$export$f06facf81a2c60f8 = function(namespace) {
    if (namespace) return $67c9c0c6f5c9baeb$var$getAdjunctURL() + "/org/jenkins/ui/jsmodules/" + namespace;
    else return $67c9c0c6f5c9baeb$var$getAdjunctURL() + "/org/jenkins/ui/jsmodules";
};
$67c9c0c6f5c9baeb$export$24c31d6a7c06406f = function(pluginId) {
    return $67c9c0c6f5c9baeb$export$ae9efcafc2d3ac35(pluginId) + "/jsmodules";
};
$67c9c0c6f5c9baeb$export$418e9f4cbd200e3c = function(namespace) {
    return $67c9c0c6f5c9baeb$var$getRootURL() + "/assets/" + namespace + "/jsmodules";
};
$67c9c0c6f5c9baeb$export$ae9efcafc2d3ac35 = function(pluginId) {
    return $67c9c0c6f5c9baeb$var$getRootURL() + "/plugin/" + pluginId;
};
$67c9c0c6f5c9baeb$export$d3e228062407378c = function() {
    var docHead = window.document.getElementsByTagName("head");
    if (!docHead || docHead.length == 0) throw new Error("No head element found in document.");
    return docHead[0];
};
$67c9c0c6f5c9baeb$export$db5c67fb99bc21aa = function(url) {
    if (!$67c9c0c6f5c9baeb$var$jenkinsCIGlobal) $67c9c0c6f5c9baeb$export$8422005580f626fc();
    $67c9c0c6f5c9baeb$var$jenkinsCIGlobal.rootURL = url;
};
$67c9c0c6f5c9baeb$export$90835e7e06f4e75b = function(moduleSpec) {
    var namespace = $67c9c0c6f5c9baeb$export$e99043d7208a37d1(moduleSpec);
    if (!moduleSpec.moduleVersion) return namespace[moduleSpec.moduleName];
    else for(var i = 0; i < moduleSpec.moduleCompatVersions.length; i++){
        var moduleCompatVersion = moduleSpec.moduleCompatVersions[i];
        var module = namespace[moduleSpec.moduleName + "@" + moduleCompatVersion.raw];
        if (module) return module;
    }
    return undefined;
};
$67c9c0c6f5c9baeb$export$d4a65fc0e353ec50 = function(moduleQName) {
    var moduleSpec = new $2c8Sw(moduleQName);
    var moduleNamespaceObj = $67c9c0c6f5c9baeb$export$e99043d7208a37d1(moduleSpec);
    if (moduleNamespaceObj) {
        var loading = $67c9c0c6f5c9baeb$var$getLoadingModule(moduleSpec);
        if (loading && loading.moduleSpec) return loading.moduleSpec;
    }
    return moduleSpec;
};
function $67c9c0c6f5c9baeb$var$getResourceLocationResolvers() {
    var jenkinsCIGlobal = $67c9c0c6f5c9baeb$export$e5d1c7d2deccbc64();
    if (!jenkinsCIGlobal.resourceLocationResolvers) jenkinsCIGlobal.resourceLocationResolvers = [];
    return jenkinsCIGlobal.resourceLocationResolvers;
}
function $67c9c0c6f5c9baeb$var$getResourceLocationResolverFunc(moduleSpec) {
    var resolvers = $67c9c0c6f5c9baeb$var$getResourceLocationResolvers();
    for(var i = 0; i < resolvers.length; i++){
        var resolver = resolvers[i];
        if (resolver && resolver.canResolve(moduleSpec)) return resolver.resolverFunc;
    }
    // Failed to find a specific resolver for the supplied moduleSpec.
    // In this case, lets try the resolver used to load the bundle
    // that's currently loading this resource. Iow, resources should
    // be loaded from the same location as the bundle that's triggering
    // the loading of that resource. Obviously this is recursive up
    // through the "parents".
    var loadingModule = $67c9c0c6f5c9baeb$var$getLoadingModule(moduleSpec);
    if (loadingModule.loadedBy) return $67c9c0c6f5c9baeb$var$getResourceLocationResolverFunc(loadingModule.loadedBy);
    return undefined;
}
$67c9c0c6f5c9baeb$export$bcbf1861489efa87 = $67c9c0c6f5c9baeb$var$getResourceLocationResolverFunc;
function $67c9c0c6f5c9baeb$var$getScriptId(scriptSrc, config) {
    if (typeof config === "string") return config;
    else if (typeof config === "object" && config.scriptId) return config.scriptId;
    else return "jenkins-script:" + scriptSrc;
}
$67c9c0c6f5c9baeb$export$506e4e5ef995299b = $67c9c0c6f5c9baeb$var$getRootURL;
function $67c9c0c6f5c9baeb$var$getRootURL() {
    if ($67c9c0c6f5c9baeb$var$jenkinsCIGlobal && $67c9c0c6f5c9baeb$var$jenkinsCIGlobal.rootURL) return $67c9c0c6f5c9baeb$var$jenkinsCIGlobal.rootURL;
    var docHead = $67c9c0c6f5c9baeb$export$d3e228062407378c();
    var rootURL = $67c9c0c6f5c9baeb$var$getAttribute(docHead, "data-rooturl");
    if (rootURL === undefined || rootURL === null) {
        // Backward compatibility - used to use a 'resurl' attribute.
        rootURL = $67c9c0c6f5c9baeb$var$getAttribute(docHead, "resurl");
        if (rootURL === undefined || rootURL === null) throw new Error("Attribute 'data-rooturl' not defined on the document <head> element.");
    }
    if ($67c9c0c6f5c9baeb$var$jenkinsCIGlobal) $67c9c0c6f5c9baeb$var$jenkinsCIGlobal.rootURL = rootURL;
    return rootURL;
}
$67c9c0c6f5c9baeb$export$d64627a42097df53 = $67c9c0c6f5c9baeb$var$getAdjunctURL;
function $67c9c0c6f5c9baeb$var$getAdjunctURL() {
    if ($67c9c0c6f5c9baeb$var$jenkinsCIGlobal && $67c9c0c6f5c9baeb$var$jenkinsCIGlobal.adjunctURL) return $67c9c0c6f5c9baeb$var$jenkinsCIGlobal.adjunctURL;
    var docHead = $67c9c0c6f5c9baeb$export$d3e228062407378c();
    var adjunctURL = $67c9c0c6f5c9baeb$var$getAttribute(docHead, "data-adjuncturl");
    if (adjunctURL === undefined || adjunctURL === null) {
        // Backward compatibility - older Jenkins do not have the adjunct url on the
        // <head> element. Lets try getting the resurl (older jenkins) and patching it 
        // to be an adjunct url.
        adjunctURL = $67c9c0c6f5c9baeb$var$getAttribute(docHead, "resurl");
        if (adjunctURL === undefined || adjunctURL === null) throw new Error("Attribute 'data-adjuncturl' not defined on the document <head> element.");
        // Replace the first occurrence of 'static/' with 'adjuncts/' 
        adjunctURL = adjunctURL.replace("static/", "adjuncts/");
    }
    if ($67c9c0c6f5c9baeb$var$jenkinsCIGlobal) $67c9c0c6f5c9baeb$var$jenkinsCIGlobal.adjunctURL = adjunctURL;
    return adjunctURL;
}
function $67c9c0c6f5c9baeb$var$createElement(name) {
    var document = window.document;
    return document.createElement(name);
}
function $67c9c0c6f5c9baeb$var$getAttribute(element, attributeName) {
    var value = element.getAttribute(attributeName.toLowerCase());
    if (value) return value;
    else // try without lowercasing
    return element.getAttribute(attributeName);
}
function $67c9c0c6f5c9baeb$var$getLoadingModule(moduleSpec) {
    var moduleNamespaceObj = $67c9c0c6f5c9baeb$export$e99043d7208a37d1(moduleSpec);
    var moduleName = moduleSpec.getLoadBundleName();
    if (!moduleNamespaceObj.loadingModules) moduleNamespaceObj.loadingModules = {};
    if (!moduleNamespaceObj.loadingModules[moduleName]) moduleNamespaceObj.loadingModules[moduleName] = {};
    return moduleNamespaceObj.loadingModules[moduleName];
}
function $67c9c0c6f5c9baeb$var$endsWith(string, suffix) {
    return string.indexOf(suffix, string.length - suffix.length) !== -1;
}
function $67c9c0c6f5c9baeb$var$thisBundleNamespaceProvider() {
    if ($67c9c0c6f5c9baeb$var$whoami !== undefined) return $67c9c0c6f5c9baeb$var$whoami.nsProvider;
    return undefined;
}
function $67c9c0c6f5c9baeb$var$getBundleNSProviderFromScriptElement(namespace, moduleName) {
    var docHead = $67c9c0c6f5c9baeb$export$d3e228062407378c();
    var scripts = docHead.getElementsByTagName("script");
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        var elNamespace = script.getAttribute("data-jenkins-module-namespace");
        var elModuleName = script.getAttribute("data-jenkins-module-moduleName");
        if (elNamespace === namespace && elModuleName === moduleName) return script.getAttribute("data-jenkins-module-nsProvider");
    }
    return undefined;
}

});
parcelRegister("eyaRm", function(module, exports) {

$parcel$export(module.exports, "make", () => $a97caa26bb731dea$export$dd44f18ab656f3bb, (v) => $a97caa26bb731dea$export$dd44f18ab656f3bb = v);
/*
 * The MIT License
 *
 * Copyright (c) 2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /*
 * Very simple "Promise" impl.
 * <p>
 * Intentionally not using the "promise" module/polyfill because it will add a few Kb and we 
 * only need something very simple here. We really just want to follow the main pattern
 * and don't need some of the fancy stuff.
 * <p>
 * I think so long as we stick to same interface/interaction pattern as outlined in the link
 * below, then we can always switch to the "promise" module later without breaking anything.
 * <p>
 * See https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Promise
 */ var $a97caa26bb731dea$export$dd44f18ab656f3bb;
$a97caa26bb731dea$export$dd44f18ab656f3bb = function(executor) {
    var thePromise = new $a97caa26bb731dea$var$APromise();
    executor.call(thePromise, function(result) {
        thePromise.resolve(result);
    }, function(reason) {
        thePromise.reject(reason);
    });
    return thePromise;
};
function $a97caa26bb731dea$var$APromise() {
    this.state = "PENDING";
    this.whenFulfilled = undefined;
    this.whenRejected = undefined;
    this.applyFulfillArgs = false;
}
$a97caa26bb731dea$var$APromise.prototype.applyArgsOnFulfill = function() {
    this.applyFulfillArgs = true;
    return this;
};
$a97caa26bb731dea$var$APromise.prototype.resolve = function(result) {
    this.state = "FULFILLED";
    var thePromise = this;
    function doFulfill(whenFulfilled, result) {
        if (thePromise.applyFulfillArgs) whenFulfilled.apply(whenFulfilled, result);
        else whenFulfilled(result);
    }
    if (this.whenFulfilled) doFulfill(this.whenFulfilled, result);
    // redefine "onFulfilled" to call immediately
    this.onFulfilled = function(whenFulfilled) {
        if (whenFulfilled) doFulfill(whenFulfilled, result);
        return this;
    };
};
$a97caa26bb731dea$var$APromise.prototype.reject = function(reason) {
    this.state = "REJECTED";
    if (this.whenRejected) this.whenRejected(reason);
    // redefine "onRejected" to call immediately
    this.onRejected = function(whenRejected) {
        if (whenRejected) whenRejected(reason);
        return this;
    };
};
$a97caa26bb731dea$var$APromise.prototype.onFulfilled = function(whenFulfilled) {
    if (!whenFulfilled) throw new Error('Must provide an "whenFulfilled" callback.');
    this.whenFulfilled = whenFulfilled;
    return this;
};
$a97caa26bb731dea$var$APromise.prototype.onRejected = function(whenRejected) {
    if (whenRejected) this.whenRejected = whenRejected;
    return this;
};

});

parcelRegister("2c8Sw", function(module, exports) {
/*
 * The MIT License
 *
 * Copyright (c) 2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $eLSjP = parcelRequire("eLSjP");
function $199396d8a8a6a629$var$ModuleSpec(qName) {
    var qNameTokens = qName.split(":");
    if (qNameTokens.length === 2) {
        var namespace = qNameTokens[0].trim();
        var nsTokens = namespace.split("/");
        var namespaceProvider = undefined;
        if (nsTokens.length === 2) {
            namespaceProvider = nsTokens[0].trim();
            namespace = nsTokens[1].trim();
            if (namespaceProvider !== "plugin" && namespaceProvider !== "core-assets") {
                console.error('Unsupported module namespace provider "' + namespaceProvider + '". Setting to undefined.');
                namespaceProvider = undefined;
            }
        }
        var npmName = $199396d8a8a6a629$var$parseNPMName(qNameTokens[1].trim());
        this.nsProvider = namespaceProvider;
        this.namespace = namespace;
        this.moduleName = npmName.name;
        this.moduleVersion = npmName.version;
    } else {
        // The module/bundle is not in a namespace and doesn't
        // need to be loaded i.e. it will load itself and export.
        var npmName = $199396d8a8a6a629$var$parseNPMName(qNameTokens[0].trim());
        this.moduleName = npmName.name;
        this.moduleVersion = npmName.version;
    }
    // Attach version compatibility info
    var versions = [];
    if (this.moduleVersion) {
        var moduleVersionTokens = this.moduleVersion.split(/[,|]+/);
        for(var i = 0; i < moduleVersionTokens.length; i++){
            var moduleVersionToken = moduleVersionTokens[i].trim();
            var parsedVersion = new $eLSjP(moduleVersionToken);
            versions.push(parsedVersion);
        }
    }
    this.moduleCompatVersions = versions;
}
$199396d8a8a6a629$var$ModuleSpec.prototype.getLoadBundleVersion = function() {
    if (this.moduleCompatVersions.length === 0) // If no versions were specified on the name, then we
    // just return undefined.
    return undefined;
    // If a version is specified, we use the first "specific" version
    // e.g. "1.1.2" is specific while "1.1.x" and "any" are not.
    for(var i = 0; i < this.moduleCompatVersions.length; i++){
        var version = this.moduleCompatVersions[i];
        if (version.isSpecific()) return version;
    }
    // If there's no specific version then we return the first
    // version in the list.
    return this.moduleCompatVersions[0];
};
$199396d8a8a6a629$var$ModuleSpec.prototype.getLoadBundleName = function() {
    var version = this.getLoadBundleVersion();
    if (version) return this.moduleName + "@" + version.asBaseVersionString();
    else return this.moduleName;
};
$199396d8a8a6a629$var$ModuleSpec.prototype.importAs = function() {
    if (this.moduleName.charAt(0) === ".") return this.moduleName;
    var version = this.getLoadBundleVersion();
    var importName = $199396d8a8a6a629$var$normalizePackageName(this.moduleName);
    var importNS = this.namespace;
    if (!importNS) importNS = importName;
    var importAs = importNS + ":" + importName;
    if (this.nsProvider) importAs = this.nsProvider + "/" + importAs;
    if (version) importAs += "@" + version.asBaseVersionString();
    return importAs;
};
$199396d8a8a6a629$var$ModuleSpec.prototype.getLoadBundleFileNamePrefix = function() {
    var version = this.getLoadBundleVersion();
    var normalizedName = $199396d8a8a6a629$var$normalizePackageName(this.moduleName);
    if (version) {
        // If a version was specified then we only do the script load if a
        // specific version was provided i.e. loading does not get triggered
        // by imports that specify non-specific version numbers e.g. "any"
        // or "1.2.x". A specific version number would be e.g. "1.2.3" i.e.
        // fully qualified. When loading is not triggered, the import is depending
        // on another import (with a specific version) or on a bundle do an
        // export of an internal dependency i.e. on another bundle "providing"
        // the module be exporting it.
        if (version.isSpecific()) return normalizedName + "-" + version.asLoadVersionString();
        else return undefined;
    } else return normalizedName;
};
/**
 * Normalize an NPM package name by removing all non alpha numerics and replacing
 * with hyphens.
 * @param packageName The NPM package name.
 * @returns The normalized NPM package name.
 */ function $199396d8a8a6a629$var$normalizePackageName(packageName) {
    packageName = packageName.replace(/[^\w.]/g, "-"); // replace non alphanumerics.
    if (packageName.charAt(0) === "-") packageName = packageName.substring(1);
    return packageName;
}
function $199396d8a8a6a629$var$parseNPMName(resourceName) {
    if (resourceName.length > 1) {
        var npmName = {};
        var orgSlashIndex = resourceName.indexOf("/");
        if (resourceName.charAt(0) === "@" && orgSlashIndex > 0) {
            // It's an NPM org package. Strip off the org and package
            // and add it to the name. We'll get the rest then and parse
            // that.
            npmName.name = resourceName.substring(0, orgSlashIndex + 1);
            // Remove the org part from the name and continue parsing.
            resourceName = resourceName.substring(orgSlashIndex + 1);
        } else // Initialise it so we can append to it below.
        npmName.name = "";
        var versionIndex = resourceName.indexOf("@");
        if (versionIndex > 0) {
            npmName.name += resourceName.substring(0, versionIndex);
            npmName.version = resourceName.substring(versionIndex + 1);
        } else npmName.name += resourceName;
        return npmName;
    } else return {
        name: resourceName
    };
}
module.exports = $199396d8a8a6a629$var$ModuleSpec;

});
parcelRegister("eLSjP", function(module, exports) {
/*
 * The MIT License
 *
 * Copyright (c) 2016, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ function $ac0f97098875ea2f$var$Version(version) {
    this.raw = version;
    // Remove leading non alphanum chars e.g. to
    // convert "^1.2.3" to "1.2.3". If the version is something
    // like "any" then the string will be trimmed to nothing and
    // the next check catches it.
    version = version.replace(/^(\D)/, "");
    if (!version || version.length === 0) return;
    function normalizeToken(string) {
        // remove anything that's not a digit, a dot or an x.
        var normalized = string.replace(/[^\d]/g, "");
        if (normalized === "") return undefined;
        return normalized;
    }
    var versionTokens = version.split(".");
    this.prerelease = undefined;
    var patchAndPrerelease = "";
    for(var i = 2; i < versionTokens.length; i++){
        if (patchAndPrerelease.length > 0) patchAndPrerelease += ".";
        patchAndPrerelease += versionTokens[i];
        var separatorIdx = patchAndPrerelease.indexOf("-");
        if (separatorIdx !== -1) {
            this.patch = normalizeToken(patchAndPrerelease.substring(0, separatorIdx));
            this.prerelease = patchAndPrerelease.substring(separatorIdx + 1);
        } else this.patch = normalizeToken(patchAndPrerelease);
    }
    if (versionTokens.length >= 2) this.minor = normalizeToken(versionTokens[1]);
    if (versionTokens.length >= 1) this.major = normalizeToken(versionTokens[0]);
}
$ac0f97098875ea2f$var$Version.prototype.isSpecific = function() {
    return this.major !== undefined && this.minor !== undefined && this.patch !== undefined;
};
/**
 * Get the "base" version string for this version number.
 * <p/>
 * This string should only ever include the major, minor and patch tokens
 * of the version i.e. should never include a prerelease tag.
 * @returns {string}
 */ $ac0f97098875ea2f$var$Version.prototype.asBaseVersionString = function(separator) {
    separator = separator ? separator : ".";
    if (!this.major || this.major === "x") {
        if (this.raw === "any") return this.raw;
        else return undefined;
    } else if (!this.minor || this.minor === "x") return this.major + separator + "x";
    else if (!this.patch || this.patch === "x") return this.major + separator + this.minor + separator + "x";
    else return this.major + separator + this.minor + separator + this.patch;
};
/**
 * Get the load version string for this version number.
 * <p/>
 * This string should only ever include the major, minor and patch tokens
 * of the version i.e. should never include a prerelease tag. This function
 * just calls <code>asBaseVersionString</code>, supplying a hyphen as the
 * separator.
 * @returns {string}
 */ $ac0f97098875ea2f$var$Version.prototype.asLoadVersionString = function() {
    return this.asBaseVersionString("-");
};
module.exports = $ac0f97098875ea2f$var$Version;

});


parcelRegister("6YIDE", function(module, exports) {
/*
 * The MIT License
 *
 * Copyright (c) 2017, CloudBees, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ function $514af8f1e27dde88$var$ResourceLocationResolver(canResolveFunc, resolverFunc, ordinal) {
    this.canResolveFunc = canResolveFunc;
    this.resolverFunc = resolverFunc;
    // Use an ordinal for crude ordering
    if (typeof ordinal === "number") this.ordinal = ordinal;
    else this.ordinal = Number.MAX_VALUE;
}
$514af8f1e27dde88$var$ResourceLocationResolver.prototype.canResolve = function(moduleSpec) {
    return this.canResolveFunc(moduleSpec);
};
$514af8f1e27dde88$var$ResourceLocationResolver.sort = function(resolvers) {
    resolvers.sort(function(r1, r2) {
        return r2.ordinal - r1.ordinal;
    });
};
module.exports = $514af8f1e27dde88$var$ResourceLocationResolver;

});





parcelRequire("78SJf");
})();
//# sourceMappingURL=stageview.js.map
